require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/05ad25195e82e0f3f5550e8c2e7ff8a1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_05ad25195e82e0f3f5550e8c2e7ff8a1'] = async function fn_05ad25195e82e0f3f5550e8c2e7ff8a1(text) {
var text;


  text = text;
  if (text.indexOf('’') !== -1) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('in if');
    text = (text.replace((new RegExp('[’\']', 'g')), '\'\''));
  } else if (text.indexOf('\'') !== -1) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('in else if');
    text = (text.replace((new RegExp('["\']', 'g')), '\'\''));
  }

return text
}

})
define('./functions/123f917f708ba155fa5e7d62e17cbe75/code.js', () => { 

BackendlessUI.Functions.Custom['fn_123f917f708ba155fa5e7d62e17cbe75'] = async function fn_123f917f708ba155fa5e7d62e17cbe75(shortId, nextSteps, tableName) {
var nextSteps, exampleRecord;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  exampleRecord = (await Backendless.Data.of(tableName).save( ({ 'product_name': 'Example','active': false,'carton_barcode': '334433','dealer_cost': 10,'DT_cost': 10,'items_per_carton': 0,'lockProductEdit': false,'price_to_customer': 10,'product_barcode': '334433','RDG_cost': 10,'sn_required': false }) ));
  addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'associated_office','type': String('data relation -- 1:1 with ') + String('Offices') }), ({ 'fieldName': 'date_of_last_inventory','type': 'datetime' }), null] }));

return nextSteps
}

})
define('./functions/14813796fd915e5c4afdbe592ddb3164/code.js', () => { 

BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164'] = async function fn_14813796fd915e5c4afdbe592ddb3164(locationId, officeObjId, productId) {
var itemCount;


  if (locationId == officeObjId) {
    itemCount = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', officeObjId, null))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['link_location.isTracked=',true,' AND link_product.objectId=\'',productId,'\''].join('')))));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('sn count for office is: ') + String(itemCount)));
  } else {
    itemCount = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', officeObjId, null))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['link_location.objectId=\'',locationId,'\' AND link_product.objectId=\'',productId,'\''].join('')))));
  }

return itemCount
}

})
define('./functions/14b6721c0c625937cb12db1e89df10c6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6'] = async function fn_14b6721c0c625937cb12db1e89df10c6(payperiod) {
var transactions;


  transactions = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['pay_date=\'',payperiod,'\''].join(''))).setPageSize(100)));

return transactions
}

})
define('./functions/1604b5d744583afc7cea9ac8d575a13d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1604b5d744583afc7cea9ac8d575a13d'] = async function fn_1604b5d744583afc7cea9ac8d575a13d(location, product) {
var itemCount, j, movedOut, movedIn, item, inventory;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  inventory = (await Backendless.Data.of('Transaction_record').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'productTransaction_table'))).setRelationsDepth(1).setSortBy('transaction_date DESC').setPageSize(100)));
  movedIn = (await asyncListFilter(inventory, async (item) => {


   return (location == (getObjectProperty(item, 'link_to_moved_to.name')) && product == (getObjectProperty(item, 'link_to_product')));
  }));
  movedOut = (await asyncListFilter(inventory, async (item) => {


   return (location == (getObjectProperty(item, 'link_to_moved_from.name')) && product == (getObjectProperty(item, 'link_to_product')));
  }));
  itemCount = 0;
  for (var j_index in movedIn) {
    j = movedIn[j_index];
    itemCount = (typeof itemCount == 'number' ? itemCount : 0) + (getObjectProperty(j, 'num_items'));
  }
  for (var j_index2 in movedOut) {
    j = movedOut[j_index2];
    itemCount = itemCount - (getObjectProperty(j, 'num_items'));
  }

return itemCount
}

})
define('./functions/163f6bc444576c5c6a86a4b3c4a746a2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_163f6bc444576c5c6a86a4b3c4a746a2'] = async function fn_163f6bc444576c5c6a86a4b3c4a746a2(SN, newLocationId, productId, transactionId, officeRecord) {
var error, officeRecord, trackingRecord, serialNumber, productRecord, locationRecord, transactionRecord, tableName, SN_record, match;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start update_SN_tracking. ');
  if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  }
  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', null, officeRecord));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](newLocationId);
  locationRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'location_table'))).findById(newLocationId, ));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](productId);
  productRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'product_table'))).findById(productId, ));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](transactionId);
  transactionRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'productTransaction_table'))).findById(transactionId, ));
  for (var serialNumber_index in SN) {
    serialNumber = SN[serialNumber_index];
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](serialNumber);
    match = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause((['serial_number=\'',serialNumber,'\''].join(''))).setPageSize(10)));
    if (match.length >= 1) {
      SN_record = match[0];
      SN_record['location'] = (getObjectProperty(locationRecord, 'name'));
      if ((getObjectProperty(SN_record, 'last_moved')) <= (getObjectProperty(transactionRecord, 'transaction_date'))) {
        SN_record['last_moved'] = (getObjectProperty(transactionRecord, 'transaction_date'));
        SN_record['link_location'] = locationRecord;
        SN_record['link_transactions'] = [transactionRecord];
        trackingRecord = (await Backendless.Data.of(tableName).deepSave( SN_record ));
      } else {
        trackingRecord = SN_record;
      }
    } else {
      trackingRecord = (await Backendless.Data.of(tableName).deepSave( ({ 'serial_number': serialNumber,'location': (getObjectProperty(locationRecord, 'name')),'product': (getObjectProperty(productRecord, 'product_name')),'last_moved': (getObjectProperty(transactionRecord, 'transaction_date')),'link_product': productRecord,'link_location': locationRecord,'link_transactions': [transactionRecord] }) ));
    }
    ;(async () => {
        try {
        await Backendless.Request.post(`${Backendless.appPath}/services/webhookToCognito/sendWebhook`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'newLocation': (getObjectProperty(locationRecord, 'name')),'product': (getObjectProperty(productRecord, 'product_name')),'cognitoID': (getObjectProperty(trackingRecord, 'cognito_id')),'office': (getObjectProperty(officeRecord, 'office_name')),'serialNumber': serialNumber,'objectId': (getObjectProperty(trackingRecord, 'objectId')),'tableName': (getObjectProperty(officeRecord, 'SN_tracking_table')) });

      } catch (error) {
        await Backendless.Messaging.sendEmail('Issue with webhook to cognito', new Backendless.Bodyparts({ textmessage: (['error: ',error,'inputs: ',(getObjectProperty(locationRecord, 'name')),'\n',(getObjectProperty(productRecord, 'product_name')),'\n',(getObjectProperty(trackingRecord, 'cognito_id')),'\n',(getObjectProperty(officeRecord, 'office_name')),'\n',serialNumber,'\n',(getObjectProperty(trackingRecord, 'objectId')),'\n',(getObjectProperty(officeRecord, 'SN_tracking_table')),'\n',(getObjectProperty(officeRecord, 'checklist_inventory.cognitoSNtable'))].join('')) }), ensureArray('alysha.reinard@gmail.com'), undefined);
        console.log(error);

      }

    })();
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end update_SN_tracking');

return 
}

})
define('./functions/177f043f238da488ad6d782f16e299c9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_177f043f238da488ad6d782f16e299c9'] = async function fn_177f043f238da488ad6d782f16e299c9(selectedSale) {
var error, selectedPayDate, commissions_object, i, DObject, link_to_closed_payroll, RecruitedBy, link_to_payroll;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting FMsaveUpdate');
  try {
    commissions_object = ({ 'temp': undefined });
    for (i = 1; i <= 6; i++) {
      commissions_object[(String('D') + String(i))] = (getObjectProperty(selectedSale, (['D',i,'info'].join(''))));
    }
    delete commissions_object['temp'];
    if ((getObjectProperty(selectedSale, 'ok2pay')) == true) {
      selectedPayDate = (getObjectProperty(selectedSale, 'currentPayDate'));
      for (i = 1; i <= 6; i++) {
        if ((getObjectProperty(selectedSale, (['D',i,'info.amount'].join('')))) > 0) {
          await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(selectedSale, (['D',i,'info'].join('')))));
          link_to_payroll = (await BackendlessUI.Functions.Custom['fn_557ac3da694fa8f4649d4e7a6cf17fe1']((getObjectProperty(selectedSale, (['D',i,'info'].join('')))), (getObjectProperty(selectedSale, 'D1info.saleType')), (getObjectProperty(selectedSale, 'calcObjectId')), (getObjectProperty(selectedSale, 'orderNumber')), (getObjectProperty(selectedSale, 'custFname')), (getObjectProperty(selectedSale, 'custLname')), selectedPayDate, (getObjectProperty(selectedSale, (['link_to_D',i,'_payroll'].join(''))))));
          if (link_to_payroll !== null && !Array.isArray(link_to_payroll) && (typeof link_to_payroll === 'object')) {
            await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'salesCalculations_table'))).setRelation((getObjectProperty(selectedSale, 'calcObjectId')), (['link_to_D',i,'_payroll'].join('')), [(getObjectProperty(link_to_payroll, 'objectId'))]);
          }
        }
      }
    } else {
      selectedPayDate = null;
      for (i = 1; i <= 6; i++) {
        DObject = ['D',i,'info'].join('');
        await BackendlessUI.Functions.Custom['fn_2a647068837845a4d6b52bb86bc41f8c']((getObjectProperty(selectedSale, (['link_to_D',i,'link_to_D_payroll'].join('')))), (getObjectProperty(selectedSale, 'calcObjectId')));
        await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'salesCalculations_table'))).setRelation((getObjectProperty(selectedSale, 'calcObjectId')), (['link_to_D',i,'_payroll'].join('')), []);
      }
    }
    await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'salesCalculations_table'))).save(({ 'finance_company': (getObjectProperty(selectedSale, 'financeCompany')),'bump_percentage': (getObjectProperty(selectedSale, 'bumpPercentage')),'bump_amount': (getObjectProperty(selectedSale, 'bumpAmount')),'received_payment': (getObjectProperty(selectedSale, 'receivedPayment')),'date_received_payment': (getObjectProperty(selectedSale, 'dateReceivedPayment')),'objectId': (getObjectProperty(selectedSale, 'calcObjectId')),'received_down': (getObjectProperty(selectedSale, 'receivedDown')),'received_finance': (getObjectProperty(selectedSale, 'receivedFinance')),'date_received_down': (getObjectProperty(selectedSale, 'dateReceivedDown')),'date_received_finance': (getObjectProperty(selectedSale, 'dateReceivedFinance')),'paidPercentage': (getObjectProperty(selectedSale, 'paidPercentage')),'finance_fees_detail': (getObjectProperty(selectedSale, 'financeFees')),'commissions_detail': commissions_object,'commissionsTotal': undefined,'who_closed_commission': undefined,'setby_commission': undefined,'ok2pay': (getObjectProperty(selectedSale, 'ok2pay')),'netTotal': (getObjectProperty(selectedSale, 'netSaleTotalNum')),'sale_type': (getObjectProperty(selectedSale, 'D1info.saleType')),'deferred_fee': (getObjectProperty(selectedSale, 'deferredFee')),'num_payments': (getObjectProperty(selectedSale, 'numPayments')),'monthly_payment_amount': (getObjectProperty(selectedSale, 'monthlyPaymentAmount')),'APR': (getObjectProperty(selectedSale, 'APR')),'finance_fees_total': (getObjectProperty(selectedSale, 'totalFinanceFee')),'payperiod': selectedPayDate,'first_payment_due': (getObjectProperty(selectedSale, 'firstPaymentDue')) }), true);
    await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'salesInvoice_table'))).save(({ 'objectId': (getObjectProperty(selectedSale, 'invoiceObjectId')),'product_cost': (getObjectProperty(selectedSale, 'productCost')),'payment_amount': (getObjectProperty(selectedSale, 'paymentAmount')),'down_total': (getObjectProperty(selectedSale, 'downTotal')),'cust_fname': (getObjectProperty(selectedSale, 'custFname')),'cust_lname': (getObjectProperty(selectedSale, 'custLname')),'cancel_date': (getObjectProperty(selectedSale, 'cancelDate')),'manager_name': undefined,'dealer_name': undefined,'setby_name': undefined,'sale_cancelled': (getObjectProperty(selectedSale, 'sale_cancelled')),'who_closed_sale': (getObjectProperty(selectedSale, 'whoClosedName')),'rainbow_price': (getObjectProperty(selectedSale, 'rainbowPrice')),'add_products_total': (getObjectProperty(selectedSale, 'addonPrice')),'payment_method': (getObjectProperty(selectedSale, 'paymentMethod')),'down_method': (getObjectProperty(selectedSale, 'downMethod')) }), true);

  } catch (error) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('issue--report', ({ 'bugReport': ({ 'reportBug--name': 'Modal Save Failed','reportBug--sourcePage': 'FMsaveUpdate function','reportBug--errorCode': [(getObjectProperty(error, 'code')),' ',(getObjectProperty(error, 'message'))].join(''),'reportBug--fullError': error }) }));

  }

return 
}

})
define('./functions/1b0d49cd46fc36e3dbf9253e049a28be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1b0d49cd46fc36e3dbf9253e049a28be'] = async function fn_1b0d49cd46fc36e3dbf9253e049a28be(startDate, officeObjId, endDate) {
var new_inventory_values, inventory, j, locationTable, numberRemoved, numberAdded, k, snRecord, sn, snTrackRecord, snTrackingTable, item, snTracking, recordsAdded, recordsRemoved, transactions, products, locations, productTable, transactionTable, officeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  productTable = (getObjectProperty(officeRecord, 'product_table'));
  transactionTable = (getObjectProperty(officeRecord, 'productTransaction_table'));
  snTrackingTable = (getObjectProperty(officeRecord, 'SN_tracking_table'));
  transactions = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](transactionTable, (['transaction_date>',startDate,'',''].join('')), null, null, null, ['link_product', 'link_moved_from', 'link_moved_to']));
  locations = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](locationTable, (['active=TRUE AND associated_office = \'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join('')), null, null, null, null));
  products = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](productTable, (['active=TRUE AND associated_office = \'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join('')), null, null, null, null));
  snTracking = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](snTrackingTable, null, null, null, null, null));
  console.log('added all links, now on to inventory');
  new_inventory_values = [];
  for (var j_index in locations) {
    j = locations[j_index];
    inventory = [];
    for (var k_index in products) {
      k = products[k_index];
      recordsAdded = (await asyncListFilter(transactions, async (item) => {


       return ((getObjectProperty(item, 'link_product.objectId')) == (getObjectProperty(k, 'objectId')) && (getObjectProperty(item, 'link_moved_to.objectId')) == (getObjectProperty(j, 'objectId')));
      }));
      recordsRemoved = (await asyncListFilter(transactions, async (item) => {


       return ((getObjectProperty(item, 'link_product.objectId')) == (getObjectProperty(k, 'objectId')) && (getObjectProperty(item, 'link_moved_from.objectId')) == (getObjectProperty(j, 'objectId')));
      }));
      console.log('records added:');
      console.log(recordsAdded);
      if (recordsAdded.length >= 1) {
        numberAdded = (await Promise.all(recordsAdded.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
      } else {
        numberAdded = 0;
      }
      if (recordsRemoved.length >= 1) {
        numberRemoved = (await Promise.all(recordsRemoved.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
      } else {
        numberRemoved = 0;
      }
      if (getObjectProperty(k, 'sn_required')) {
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('sn required');
        snRecord = null;
        for (var snRecord_index in recordsAdded) {
          snRecord = recordsAdded[snRecord_index];
          await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('after sn record');
          var sn_list = (getObjectProperty(snRecord, 'serial_numbers'));
          for (var sn_index in sn_list) {
            sn = sn_list[sn_index];
            snTrackRecord = (await asyncListFilter(snTracking, async (item) => {


             return ((getObjectProperty(item, 'serial_number')) == sn);
            }))[0];
            if (snTrackRecord) {
              await Backendless.Data.of(snTrackingTable).addRelation(snTrackRecord, 'link_transactions', [(getObjectProperty(snRecord, 'objectId'))]);
              if (!(getObjectProperty(snTrackRecord, 'last_moved')) || (getObjectProperty(snRecord, 'transaction_date')) > (getObjectProperty(snTrackRecord, 'last_moved'))) {
                await Backendless.Data.of(snTrackingTable).save(({ 'objectId': (getObjectProperty(snTrackRecord, 'objectId')),'location': (getObjectProperty(snRecord, 'moved_to')),'last_moved': (getObjectProperty(snRecord, 'transaction_date')) }), true);
                await Backendless.Data.of(snTrackingTable).addRelation(snTrackRecord, 'link_product', [(getObjectProperty(snRecord, 'link_product'))]);
                await Backendless.Data.of(snTrackingTable).setRelation(snTrackRecord, 'link_location', [(getObjectProperty(snRecord, 'link_moved_to'))]);
              }
            } else {
              await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('serial number not found in tracker table: ') + String(sn)));
            }
          }
        }
      } else {
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('sn NOT required');
      }
      addItemToList(inventory, ({ 'productName': (getObjectProperty(k, 'product_name')),'productObjId': (getObjectProperty(k, 'objectId')),'totalItems': (getObjectProperty(k, 'sn_required')) && snRecord ? (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164']((getObjectProperty(snRecord, 'link_moved_to.objectId')), officeObjId, (getObjectProperty(k, 'objectId')))) : numberAdded - numberRemoved,'serialNumber': [] }));
    }
    j['inventory'] = inventory;
    await Backendless.Data.of(locationTable).save(j, true);
    addItemToList(new_inventory_values, ({ 'location': (getObjectProperty(j, 'name')),'locationId': (getObjectProperty(j, 'objectId')),'inventory': inventory }));
  }
  console.log(new_inventory_values);
  await BackendlessUI.Functions.Custom['fn_faed4cde7b0fc86b7964d807c2edf9d6'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null);

return 
}

})
define('./functions/1baceb836bea7c191ce442b123f6b177/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1baceb836bea7c191ce442b123f6b177'] = async function fn_1baceb836bea7c191ce442b123f6b177(dealerName, SalesObjects) {
var commissionInfo, totalCommission, listOfCommissions, payItem, sale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  listOfCommissions = [];
  totalCommission = 0;
  for (var payItem_index in SalesObjects) {
    payItem = SalesObjects[payItem_index];
    sale = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).findById((getObjectProperty(payItem, 'invoiceObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    addItemToList(listOfCommissions, ({ 'role': (getObjectProperty(payItem, 'role')),'amount': (getObjectProperty(payItem, 'amount')),'orderNumber': (getObjectProperty(sale, 'order_number')),'customer': (getObjectProperty(sale, 'cust_name')),'saleType': (getObjectProperty((getObjectProperty(sale, 'link_to_calculations')), 'sale_type')) }));
    totalCommission = (typeof totalCommission == 'number' ? totalCommission : 0) + (getObjectProperty(payItem, 'amount'));
  }
  commissionInfo = ({ 'listOfCommissions': listOfCommissions,'totalCommission': totalCommission });

return commissionInfo
}

})
define('./functions/21bc4232922e725addab6b1fcbae1aa7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_21bc4232922e725addab6b1fcbae1aa7'] = async function fn_21bc4232922e725addab6b1fcbae1aa7(productIds, locationIds, officeObjId, recalculate, officeRecord) {
var totalInventory, j, officeRecord, officeId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start getInventoryTotal');
  officeId = officeObjId;
  if (officeRecord) {
    officeRecord = officeRecord;
  } else if (officeObjId) {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('still using OfficeObjId');
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  } else {
    officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  }
  if (!(Array.isArray((getObjectProperty(officeRecord, 'inventory')))) || recalculate || (getObjectProperty(officeRecord, 'inventory')).length == 0) {
    totalInventory = (await BackendlessUI.Functions.Custom['fn_faed4cde7b0fc86b7964d807c2edf9d6'](null, officeRecord));
  } else {
    totalInventory = (getObjectProperty(officeRecord, 'inventory'));
  }
  for (var j_index in totalInventory) {
    j = totalInventory[j_index];
    j['location'] = 'Total';
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end getInventoryTotal');

return totalInventory
}

})
define('./functions/22ab5afbe30d5b21d42e805c9f24314d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_22ab5afbe30d5b21d42e805c9f24314d'] = async function fn_22ab5afbe30d5b21d42e805c9f24314d(property_name, table, object_id) {
var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof object_id === 'undefined') {
    value = '';
  } else {
    value = (getObjectProperty((await Backendless.Data.of(table).findById(object_id, )), property_name));
  }

return value
}

})
define('./functions/2385e1f7a515353f3439ad6f663dc5cf/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'] = async function fn_2385e1f7a515353f3439ad6f663dc5cf(date) {
return ([(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd']((new Date(date).getMonth() + 1))),' ',(new Date(date).getDate())].join(''))
}

})
define('./functions/250c3a42f9a12775f2b15a63f7c809fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_250c3a42f9a12775f2b15a63f7c809fc'] = async function fn_250c3a42f9a12775f2b15a63f7c809fc(productName, officeObjId) {
var productRecord;


  productRecord = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['associated_office.objectId=\'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\' AND product_name=\'',productName,'\''].join(''))).setPageSize(10)));

return (productRecord == 1 ? productRecord[0] : null)
}

})
define('./functions/252a8f4924563ffa037cf4422bcbc08a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_252a8f4924563ffa037cf4422bcbc08a'] = async function fn_252a8f4924563ffa037cf4422bcbc08a(startDate) {
var officeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  if (getObjectProperty(officeRecord, 'inventory_historical')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('inventory_historical already exists for this office');
  } else {
    officeRecord['inventory_historical'] = [({ 'date': startDate,'inventory': [] })];
  }

return 
}

})
define('./functions/2605a3d4b683f8d1225355d4b737f1fd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2605a3d4b683f8d1225355d4b737f1fd'] = function fn_2605a3d4b683f8d1225355d4b737f1fd(serialNumber) {
return true
}

})
define('./functions/2712b5e25d0111028c99b3af654e562d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d'] = async function fn_2712b5e25d0111028c99b3af654e562d(requiredSection, requiredSubsection, isElement) {
var userRecord, sectionAccessVals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting checkPermissions');
  if (!(Backendless.getCurrentUserToken())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  userRecord = (await Backendless.UserService.getCurrentUser(true));
  if ((getObjectProperty(userRecord, 'sectionAccess.admin')) && ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('viewAs'))) {
    userRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('viewAsRecord'));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('viewing page as ') + String(getObjectProperty(userRecord, 'name'))));
  }
  if (!requiredSection) {
    return true;
  }
  if (!(getObjectProperty(userRecord, 'sectionAccess'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('accessDenied', ({ 'requiredAccess': requiredSection }));
  }
  sectionAccessVals = (Object.keys((getObjectProperty(userRecord, 'sectionAccess'))));
  if (!(sectionAccessVals.includes(requiredSection)) || !(getObjectProperty((getObjectProperty(userRecord, 'sectionAccess')), requiredSection))) {
    if (isElement) {
      return false;
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('accessDenied', ({ 'requiredAccess': requiredSection }));
    }
  }
  if (!requiredSubsection) {
    return true;
  }
  if (!(getObjectProperty(userRecord, (String('sectionAccess_') + String(requiredSection))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('accessDenied', ({ 'requiredAccess': requiredSection }));
  }
  sectionAccessVals = (Object.keys((getObjectProperty(userRecord, (String('sectionAccess_') + String(requiredSection))))));
  if (!(sectionAccessVals.includes(requiredSubsection)) || !(getObjectProperty((getObjectProperty(userRecord, (String('sectionAccess_') + String(requiredSection)))), requiredSubsection))) {
    if (isElement) {
      return false;
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('accessDenied', ({ 'requiredAccess': requiredSubsection }));
    }
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('ending checkPermissions');

return true
}

})
define('./functions/27f244a375346731e998cec94022c87d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d'] = async function fn_27f244a375346731e998cec94022c87d(selectedRecord) {
var updatedRecord, percentageCovered, var2, financedAmount, netSale, totalFee, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  updatedRecord = selectedRecord;
  totalFee = 0;
  var j_list = (getObjectProperty(selectedRecord, 'financeFees'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    totalFee = (typeof totalFee == 'number' ? totalFee : 0) + (getObjectProperty(j, 'feeAmount'));
  }
  totalFee = totalFee - (getObjectProperty(selectedRecord, 'bumpAmount'));
  updatedRecord['totalFinanceFee'] = (Math.round(totalFee * 100) / 100);
  updatedRecord['totalFinanceFeeNum'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b'](totalFee));
  financedAmount = (getObjectProperty(selectedRecord, 'financeAmount'));
  netSale = financedAmount - (await BackendlessUI.Functions.Custom['fn_884bd43441923ffdbc69ddfef4eb3f85'](updatedRecord));
  updatedRecord['totalAfterCosts'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b'](netSale));
  percentageCovered = 100 * (netSale / financedAmount);
  updatedRecord['paidPercentage'] = percentageCovered;

return updatedRecord
}

})
define('./functions/28d64cea9a03167e67c1c5c26fde2bc4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_28d64cea9a03167e67c1c5c26fde2bc4'] = async function fn_28d64cea9a03167e67c1c5c26fde2bc4(salesInvoiceObjectId) {
var addonRev, mainSaleRev, addonTotal, productTotal, j, otherSale, salesInvoiceRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function(){ try { return JSON.parse(localStorage.getItem('debug')) } catch(e){ return null }})()) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('starting calculateProductAddonCost');
  }
  salesInvoiceRecord = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null))).findById(salesInvoiceObjectId, Backendless.DataQueryBuilder.create().setRelated(['link_to_transactions', 'link_to_other_sales']).setRelationsDepth(2)));
  productTotal = 0;
  mainSaleRev = (getObjectProperty(salesInvoiceRecord, 'sale_total_wo_tax'));
  var j_list = (getObjectProperty(salesInvoiceRecord, 'link_to_transactions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    productTotal = (typeof productTotal == 'number' ? productTotal : 0) + (getObjectProperty(j, 'RDG_cost'));
  }
  addonTotal = 0;
  addonRev = 0;
  if (((getObjectProperty(salesInvoiceRecord, 'link_to_other_sales'))[0]) !== null && !Array.isArray(((getObjectProperty(salesInvoiceRecord, 'link_to_other_sales'))[0])) && (typeof ((getObjectProperty(salesInvoiceRecord, 'link_to_other_sales'))[0]) === 'object')) {
    var otherSale_list = (getObjectProperty(salesInvoiceRecord, 'link_to_other_sales'));
    for (var otherSale_index in otherSale_list) {
      otherSale = otherSale_list[otherSale_index];
      addonRev = (typeof addonRev == 'number' ? addonRev : 0) + (Number((getObjectProperty(otherSale, 'total_amount'))));
      var j_list2 = (getObjectProperty(otherSale, 'link_to_transactions'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        addonTotal = (typeof addonTotal == 'number' ? addonTotal : 0) + (getObjectProperty(j, 'RDG_cost'));
      }
    }
  }
  if ((function(){ try { return JSON.parse(localStorage.getItem('debug')) } catch(e){ return null }})()) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('ending calculateProductAddonCost');
  }

return ({ 'mainSaleProdCost': (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](productTotal)),'addonProdCost': (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](addonTotal)),'totalProductCost': (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((productTotal + addonTotal))),'mainSaleRev': mainSaleRev,'addonRev': addonRev,'totalRev': (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((mainSaleRev + addonRev))) })
}

})
define('./functions/2a647068837845a4d6b52bb86bc41f8c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a647068837845a4d6b52bb86bc41f8c'] = async function fn_2a647068837845a4d6b52bb86bc41f8c(payrollTransactionID, sale) {
var new_commission_detail, new_payroll_record, item, existing_commission_detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (payrollTransactionID == null) {
    return ;
  }
  existing_commission_detail = (getObjectProperty(payrollTransactionID, 'commissions_detail'));
  if (existing_commission_detail !== null && !Array.isArray(existing_commission_detail) && (typeof existing_commission_detail === 'object')) {
    existing_commission_detail = [existing_commission_detail];
    new_commission_detail = (await asyncListFilter(existing_commission_detail, async (item) => {


     return ((getObjectProperty(item, 'sale')) != sale);
    }));
    new_payroll_record = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(({ 'objectId': payrollTransactionID,'commissions_detail': new_commission_detail }), true));
  }

return 
}

})
define('./functions/2fc90a07a7a5c1e6752cca55424524f1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2fc90a07a7a5c1e6752cca55424524f1'] = async function fn_2fc90a07a7a5c1e6752cca55424524f1(dateList) {
var niceDates, j;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  niceDates = [];
  for (var j_index in dateList) {
    j = dateList[j_index];
    addItemToList(niceDates, (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](j)));
  }

return niceDates
}

})
define('./functions/333f6c836f2fd90c80c308a8f5760673/code.js', () => { 

BackendlessUI.Functions.Custom['fn_333f6c836f2fd90c80c308a8f5760673'] = async function fn_333f6c836f2fd90c80c308a8f5760673(name, role) {
var sales, whereClause;


  if (role == 'dealer') {
    whereClause = ['dealer_name=\'',name,'\''].join('');
  }
  if (role == 'manager') {
    whereClause = ['manager_name=\'',name,'\''].join('');
  }
  if (role == 'closed') {
    whereClause = ['who_closed_sale=\'',name,'\''].join('');
  }
  if (role == 'setBy') {
    whereClause = ['set_by=\'',name,'\''].join('');
  }
  sales = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findSalesWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(whereClause)));

return sales
}

})
define('./functions/39c8388efde660a8fac97b5c2e8ea5a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_39c8388efde660a8fac97b5c2e8ea5a6'] = async function fn_39c8388efde660a8fac97b5c2e8ea5a6(PageData) {
var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, item, officeScoreList, k, l, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  PageData['monthlyScoresLoading'] = true;
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  PageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(PageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(PageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['relatedDealers'] = (await Backendless.Data.of((getObjectProperty(PageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  }
  PageData['monthlyScores'] = null;
  var j_list2 = (getObjectProperty(PageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(PageData, 'currentMonthYear'))));
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(PageData, 'currentMonthYear'))));
          }));
        }
      }
      if (getObjectProperty(PageData, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(PageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(PageData, 'currentMonthYear'))));
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          PageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(PageData, 'currentMonthYear'))));
          }));
        }
      }
    }
  }
  var j_list3 = (getObjectProperty(PageData, 'relatedOffices'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  officeScoreList = (getObjectProperty(PageData, 'relatedOffices'));
  PageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  PageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  PageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  PageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  PageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list4 = (getObjectProperty(PageData, 'monthlyScores'));
  for (var j_index4 in j_list4) {
    j = j_list4[j_index4];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  PageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  PageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  PageData['dealerTotalSale'] = thisMonthsSalesTotal;
  PageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  PageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  if (thisMonthsSalesTotal != 0) {
    PageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  } else {
    PageData['dealerClosingAverage'] = 0;
  }
  PageData['monthlyScoresLoading'] = false;

return 
}

})
define('./functions/3b9b17025a262ba71d93f31226730135/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b9b17025a262ba71d93f31226730135'] = async function fn_3b9b17025a262ba71d93f31226730135(shortId, nextSteps, tableName, productTableName, locationTableName, transactionTableName) {
var nextSteps;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of(tableName).save( ({ 'location': 'new Product','product': 'new Product','serial_number': 'new Product','cognito_id': 'new Product' }) );
  addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'last_moved','type': 'datetime' }), ({ 'fieldName': 'link_location','type': String('data relation -- 1:1 with ') + String(locationTableName) }), ({ 'fieldName': 'link_product','type': String('data relation -- 1:1 with ') + String(productTableName) }), ({ 'fieldName': 'link_transactions','type': String('data relation -- 1:many with ') + String(transactionTableName) })] }));

return nextSteps
}

})
define('./functions/4132f1a1c82fb0e3740b9cafd68e4732/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'] = async function fn_4132f1a1c82fb0e3740b9cafd68e4732(selectedRecord) {
var returnObject, val, totalAfterCosts, allCosts, item, currentPayDate, payDates, j, link_to_D3_payroll, link_to_D4_payroll, link_to_D2_payroll, link_to_D1_payroll, productAddonCosts, commissionsDetail, payMatrixRoles, i, link_to_D6_payroll, calc_record, link_to_D5_payroll, created_object;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting FM initialize');
  await Backendless.Data.of('Sales_invoice_version_history').save(selectedRecord, true);
  // There should always be an associated "link_to_calculations"
  // record, but if not, one is created and linked here
  if ((getObjectProperty(selectedRecord, 'link_to_calculations')) == null) {
    created_object = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesCalculations_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).save(({ 'Order_number': (getObjectProperty(selectedRecord, 'order_number')) }), true));
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).setRelation((getObjectProperty(selectedRecord, 'objectId')), 'link_to_calculations', [(getObjectProperty(created_object, 'objectId'))]);
    calc_record = created_object;
  } else {
    calc_record = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesCalculations_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).findById((getObjectProperty(selectedRecord, 'link_to_calculations.objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(1)));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesCalculations_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')))));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](calc_record);
    await Backendless.Data.of('Sales_calculations_version_history').save(calc_record, true);
  }
  if ((getObjectProperty(calc_record, 'link_to_D1_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D1_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D1_payroll')) === 'object')) {
    link_to_D1_payroll = (getObjectProperty(calc_record, 'link_to_D1_payroll.objectId'));
  } else {
    link_to_D1_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D2_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D2_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D2_payroll')) === 'object')) {
    link_to_D2_payroll = (getObjectProperty(calc_record, 'link_to_D2_payroll.objectId'));
  } else {
    link_to_D2_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D4_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D4_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D4_payroll')) === 'object')) {
    link_to_D4_payroll = (getObjectProperty(calc_record, 'link_to_D4_payroll.objectId'));
  } else {
    link_to_D4_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D3_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D3_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D3_payroll')) === 'object')) {
    link_to_D3_payroll = (getObjectProperty(calc_record, 'link_to_D3_payroll.objectId'));
  } else {
    link_to_D3_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D5_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D5_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D5_payroll')) === 'object')) {
    link_to_D5_payroll = (getObjectProperty(calc_record, 'link_to_D5_payroll.objectId'));
  } else {
    link_to_D5_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D6_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D6_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D6_payroll')) === 'object')) {
    link_to_D6_payroll = (getObjectProperty(calc_record, 'link_to_D6_payroll.objectId'));
  } else {
    link_to_D6_payroll = null;
  }
  productAddonCosts = (await BackendlessUI.Functions.Custom['fn_28d64cea9a03167e67c1c5c26fde2bc4']((getObjectProperty(selectedRecord, 'objectId'))));
  if (((getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail')) !== null && !Array.isArray((getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail'))) && (typeof (getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail')) === 'object')) && ((getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail.D1')) !== null && !Array.isArray((getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail.D1'))) && (typeof (getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail.D1')) === 'object'))) {
    commissionsDetail = (getObjectProperty(selectedRecord, 'link_to_calculations.commissions_detail'));
  } else {
    payMatrixRoles = (getObjectProperty((await Backendless.Data.of('Offices').findById(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), )), 'payMatrixRoles'));
    commissionsDetail = ({ 'temp': undefined });
    commissionsDetail['D1'] = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9'](({ 'systemRole': 'D1','roleTitle': undefined,'amount': 0,'name': (getObjectProperty(selectedRecord, 'dealer_name')) }), (getObjectProperty(selectedRecord, 'rainbow_count')))), 100));
    delete commissionsDetail['temp'];
    for (i = 2; i <= 6; i++) {
      commissionsDetail[(String('D') + String(i))] = ({ 'systemRole': String('D') + String(i),'roleTitle': (getObjectProperty(payMatrixRoles, (String('D') + String(i)))),'amount': 0,'name': '' });
    }
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('after if/else');
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](commissionsDetail);
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'objectId')) == '4FB81D20-3A72-4FDA-BADA-9A829BF2E585') {
      commissionsDetail = (await BackendlessUI.Functions.Custom['fn_7b1eab948c3c495af7ffb9a821334d08'](commissionsDetail, payMatrixRoles));
    }
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('after loop/creation');
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](commissionsDetail);
  returnObject = ({ 'D1info': (getObjectProperty(commissionsDetail, 'D1')),'D2info': (getObjectProperty(commissionsDetail, 'D2')),'D3info': (getObjectProperty(commissionsDetail, 'D3')),'D4info': (getObjectProperty(commissionsDetail, 'D4')),'D5info': (getObjectProperty(commissionsDetail, 'D5')),'D6info': (getObjectProperty(commissionsDetail, 'D6')),'numRainbows': (getObjectProperty(selectedRecord, 'rainbow_count')),'saleType': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'sale_type')),'paymentAmount': (getObjectProperty(selectedRecord, 'payment_amount')),'financeCompany': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_company')),'salesTaxPerc': (getObjectProperty(selectedRecord, 'sales_tax_percent')),'dateOfSale': (getObjectProperty(selectedRecord, 'sales_date')),'bumpPercentage': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'bump_percentage')),'bumpAmount': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'bump_amount')),'receivedPayment': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'received_payment')),'dateReceivedPayment': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'date_received_payment')),'downMethod': (getObjectProperty(selectedRecord, 'down_method')),'paymentMethod': (getObjectProperty(selectedRecord, 'payment_method')),'ccfee': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'creditcard_Fee')),'receivedDown': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'received_down')),'dateReceivedDown': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'date_received_down')),'dateReceivedFinance': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'date_received_finance')),'receivedFinance': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'received_finance')),'needPayment': (getObjectProperty(selectedRecord, 'payment_amount')) > 0,'needDown': (getObjectProperty(selectedRecord, 'down_total')) > 0,'needFinance': (getObjectProperty(selectedRecord, 'finance_amount')) > 0,'custFname': (getObjectProperty(selectedRecord, 'cust_fname')),'custLname': (getObjectProperty(selectedRecord, 'cust_lname')),'rainbowPrice': (getObjectProperty(selectedRecord, 'rainbow_price')),'additionalProducts': (getObjectProperty(selectedRecord, 'add_products_total')),'addonPrice': (getObjectProperty(productAddonCosts, 'addonRev')),'total_wo_tax': (getObjectProperty(selectedRecord, 'sale_total_wo_tax')),'salesTax': (getObjectProperty(selectedRecord, 'sales_tax')),'total_w_tax': (getObjectProperty(selectedRecord, 'sale_total_with_tax')),'downTotal': (getObjectProperty(selectedRecord, 'down_total')),'financeAmount': (getObjectProperty(selectedRecord, 'finance_amount')),'payDate': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'payperiod')) != null ? (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'payperiod')))) : null,'ok2pay_original': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'ok2pay')),'ok2pay': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'ok2pay')),'productCost': (getObjectProperty(productAddonCosts, 'totalProductCost')),'numPayments': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'num_payments')),'firstPaymentDue': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'first_payment_due')),'monthlyPaymentAmount': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'monthly_payment_amount')),'APR': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'APR')),'deferredFee': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'deferred_fee')),'totalFinanceFee': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_fees_total')),'calcObjectId': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'objectId')),'invoiceObjectId': (getObjectProperty(selectedRecord, 'objectId')),'link_to_D1_payroll': link_to_D1_payroll,'link_to_D2_payroll': link_to_D2_payroll,'link_to_D3_payroll': link_to_D4_payroll,'link_to_D4_payroll': link_to_D3_payroll,'orderNumber': (getObjectProperty(selectedRecord, 'order_number')),'payment_method': (getObjectProperty(selectedRecord, 'payment_method')),'cancel_date': (getObjectProperty(selectedRecord, 'cancel_date')),'sale_cancelled': (getObjectProperty(selectedRecord, 'sale_cancelled')),'paymentReceived': (getObjectProperty(selectedRecord, 'payment_method')) == 'Check' || (getObjectProperty(selectedRecord, 'payment_method')) == 'Cash' || (getObjectProperty(selectedRecord, 'payment_method')) == 'Credit Card' });
  returnObject['paidPercentage'] = (getObjectProperty(selectedRecord, 'link_to_calculations.paidPercentage'));
  if ((getObjectProperty(returnObject, 'payDate')) != null) {
    returnObject['currentPaydateExists'] = true;
  } else {
    returnObject['currentPaydateExists'] = false;
  }
  if (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_fees_detail')) {
    returnObject['financeFees'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_fees_detail'));
    returnObject['netSaleTotal'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'netTotal'));
    returnObject['ok2pay'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'ok2pay'));
    returnObject['payDate'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'payperiod'));
    returnObject['financeCompany'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_company'));
  } else {
    returnObject['financeFees'] = [];
    returnObject['netSaleTotal'] = (getObjectProperty(selectedRecord, 'finance_amount'));
  }
  if (typeof (getObjectProperty(selectedRecord, 'paidPercentage')) === 'number' && !isNaN((getObjectProperty(selectedRecord, 'paidPercentage')))) {
    returnObject['paidPercentage'] = (getObjectProperty(selectedRecord, 'paidPercentage'));
  } else {
    returnObject['paidPercentage'] = 100;
  }
  returnObject['netSaleMinusTax'] = ((getObjectProperty(returnObject, 'netSaleTotal')) - (getObjectProperty(returnObject, 'salesTax')));
  payDates = [];
  var j_list = (await BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091']((['pay_date>\'',((new Date((new Date()).getTime() - ((1 * 86400) * 1000))).valueOf()),'\''].join(''))));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(payDates, ({ 'value': (Number((getObjectProperty(j, 'payDate')))),'label': (getObjectProperty(j, 'payDateDisplay')) }));
  }
  currentPayDate = (await asyncListFilter(payDates, async (item) => {


   return ((getObjectProperty(item, 'value')) == (getObjectProperty(returnObject, 'payDate')));
  }));
  if (currentPayDate.length == 0) {
    currentPayDate = (getObjectProperty((payDates[0]), 'value'));
  } else {
    currentPayDate = (getObjectProperty((currentPayDate[0]), 'value'));
  }
  returnObject['payDates'] = payDates;
  returnObject['currentPayDate'] = currentPayDate;
  returnObject['message'] = '';
  returnObject['financeCompanyOptions'] = (await Promise.all((await Backendless.Data.of('Finance_fees').find(Backendless.DataQueryBuilder.create().setWhereClause((String('Active = True'))).setGroupBy('Company').setPageSize(10))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Company')),'value': (getObjectProperty(item, 'Company')) });})));
  returnObject['financeTermsOptions'] = [];
  totalAfterCosts = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'total_after_costs'));
  if (totalAfterCosts == 0) {
    allCosts = (await BackendlessUI.Functions.Custom['fn_884bd43441923ffdbc69ddfef4eb3f85'](returnObject));
    if ((getObjectProperty(selectedRecord, 'finance_amount')) != 0) {
      totalAfterCosts = ((getObjectProperty(selectedRecord, 'finance_amount')) + (Number((getObjectProperty(selectedRecord, 'down_total'))))) - allCosts;
    } else {
      totalAfterCosts = (getObjectProperty(selectedRecord, 'payment_amount')) - allCosts;
    }
  }
  returnObject['totalAfterCosts'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b'](totalAfterCosts));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((getObjectProperty(selectedRecord, 'finance_amount')));
  if ((getObjectProperty(selectedRecord, 'finance_amount')) == 0) {
    returnObject['saleType'] = 'A-sale';
    returnObject['displayFinance'] = false;
  } else {
    returnObject['displayFinance'] = true;
  }
  val = true;
  if ((getObjectProperty(returnObject, 'needFinance')) && !(getObjectProperty(returnObject, 'receivedFinance'))) {
    val = false;
  }
  if ((getObjectProperty(returnObject, 'needDown')) && !(getObjectProperty(returnObject, 'receivedDown'))) {
    val = false;
  }
  if ((getObjectProperty(returnObject, 'needPayment')) && !(getObjectProperty(returnObject, 'receivedPayment'))) {
    val = false;
  }
  returnObject['allowOk'] = (!val);
  if ((getObjectProperty(returnObject, 'sale_cancelled')) == true) {
    returnObject['displayCancelledSale'] = true;
  } else {
    returnObject['displayCancelledSale'] = false;
  }
  returnObject['lockSalesEdit'] = true;
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end FMinitialize');

return returnObject
}

})
define('./functions/413437279b2503eebc95c8920f79642e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_413437279b2503eebc95c8920f79642e'] = async function fn_413437279b2503eebc95c8920f79642e(payrollTransactionRecord, commissionInfo) {
var new_payroll_record, new_commission_detail, total_comm, total_payment, item, found_record, j, existing_commission_detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting updateCommissionInPayrollTransaction');
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](payrollTransactionRecord);
  existing_commission_detail = (getObjectProperty(payrollTransactionRecord, 'commissions_detail'));
  if (existing_commission_detail !== null && !Array.isArray(existing_commission_detail) && (typeof existing_commission_detail === 'object')) {
    existing_commission_detail = [existing_commission_detail];
  }
  new_commission_detail = [];
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](existing_commission_detail);
  for (var j_index in existing_commission_detail) {
    j = existing_commission_detail[j_index];
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('j (existing_commission_detail): ');
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](j);
    if ((getObjectProperty(j, 'sale')) == (getObjectProperty(commissionInfo, 'sale')) && (getObjectProperty(j, 'systemRole')) == (getObjectProperty(commissionInfo, 'systemRole'))) {
      if ((getObjectProperty(j, 'amount')) != (getObjectProperty(commissionInfo, 'amount'))) {
        new_commission_detail = (new_commission_detail.concat([commissionInfo]));
      } else {
        new_commission_detail = (new_commission_detail.concat(j));
      }
      found_record = true;
    } else {
      new_commission_detail = (new_commission_detail.concat(j));
    }
  }
  if (!found_record) {
    new_commission_detail = (new_commission_detail.concat([commissionInfo]));
  }
  total_comm = (await Promise.all(new_commission_detail.map(async item => {; return (getObjectProperty(item, 'amount'));}))).reduce(function(x, y) {return x + y;});
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('in update commission in payroll transaction. UPSERTING:');
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](({ 'objectId': (getObjectProperty(payrollTransactionRecord, 'objectId')),'commissions_total': total_comm,'commissions_detail': new_commission_detail }));
  new_payroll_record = (await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'payrollTransaction_table'))).save(({ 'objectId': (getObjectProperty(payrollTransactionRecord, 'objectId')),'commissions_total': total_comm,'commissions_detail': new_commission_detail }), true));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end updateCommissionInPayrollTransaction');

return new_payroll_record
}

})
define('./functions/4204bf1a26e43ef7b1743ab56ce34a8e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4204bf1a26e43ef7b1743ab56ce34a8e'] = async function fn_4204bf1a26e43ef7b1743ab56ce34a8e() {
var dealerSalaries, j, weeklySalary, activeDealers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  activeDealers = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (String('dealer_active=') + String(true)), null, null, 2, 100, null, null));
  dealerSalaries = [];
  for (var j_index in activeDealers) {
    j = activeDealers[j_index];
    weeklySalary = (getObjectProperty(j, 'salary_amount'));
    if ((typeof weeklySalary === 'number' && !isNaN(weeklySalary)) && weeklySalary > 0) {
      addItemToList(dealerSalaries, ({ 'dealer_name': (getObjectProperty(j, 'dealer_name')),'salary': weeklySalary,'objectId': (getObjectProperty(j, 'objectId')) }));
    }
  }

return dealerSalaries
}

})
define('./functions/42acfa086f4f063596c721e72a65dc1b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b'] = function fn_42acfa086f4f063596c721e72a65dc1b(x) {
return (String('$') + String((String(Math.round(x * 100) / 100)).replace((new RegExp('(\\d)(?=(\\d{3})+(?!\\d))', 'g')), '$1,')))
}

})
define('./functions/4757c24166a2324905bc73c7c0a4a3b8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'] = async function fn_4757c24166a2324905bc73c7c0a4a3b8(text) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'sectionAccess.admin')) {
    if (text !== null && !Array.isArray(text) && (typeof text === 'object')) {
      console.log(JSON.stringify(text));
    } else {
      console.log(text);
    }
  }

}

})
define('./functions/48214b3dba69d407662dad08cbe2fad4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_48214b3dba69d407662dad08cbe2fad4'] = async function fn_48214b3dba69d407662dad08cbe2fad4(selectedSale) {
var error, selectedPayDate, commissions_object, link_to_dealer_payroll, link_to_manager_payroll, link_to_closed_payroll, link_to_setby_payroll;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(selectedSale, 'ok2pay')) == true) {
      selectedPayDate = (getObjectProperty(selectedSale, 'currentPayDate'));
      link_to_dealer_payroll = (await BackendlessUI.Functions.Custom['fn_a3b48c95568c3e451a6f8842f9637ed7']((getObjectProperty(selectedSale, 'dealerName')), 'Dealer', (getObjectProperty(selectedSale, 'dealerCommission')), (getObjectProperty(selectedSale, 'calcObjectId')), (getObjectProperty(selectedSale, 'link_to_dealer_payroll')), (getObjectProperty(selectedSale, 'ok2pay')), selectedPayDate, (getObjectProperty(selectedSale, 'saleType')), (getObjectProperty(selectedSale, 'custFname')), (getObjectProperty(selectedSale, 'custLname')), (getObjectProperty(selectedSale, 'orderNumber'))));
      if (link_to_dealer_payroll !== null && !Array.isArray(link_to_dealer_payroll) && (typeof link_to_dealer_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').setRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_dealer_payroll', [(getObjectProperty(link_to_dealer_payroll, 'objectId'))]);
      }
      link_to_manager_payroll = (await BackendlessUI.Functions.Custom['fn_a3b48c95568c3e451a6f8842f9637ed7']((getObjectProperty(selectedSale, 'managerName')), 'Manager', (getObjectProperty(selectedSale, 'managerCommission')), (getObjectProperty(selectedSale, 'calcObjectId')), (getObjectProperty(selectedSale, 'link_to_manager_payroll')), (getObjectProperty(selectedSale, 'ok2pay')), selectedPayDate, (getObjectProperty(selectedSale, 'sale_type')), (getObjectProperty(selectedSale, 'custFname')), (getObjectProperty(selectedSale, 'custLname')), (getObjectProperty(selectedSale, 'orderNumber'))));
      if (link_to_manager_payroll !== null && !Array.isArray(link_to_manager_payroll) && (typeof link_to_manager_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').setRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_manager_payroll', [(getObjectProperty(link_to_manager_payroll, 'objectId'))]);
      }
      link_to_closed_payroll = (await BackendlessUI.Functions.Custom['fn_a3b48c95568c3e451a6f8842f9637ed7']((getObjectProperty(selectedSale, 'whoClosedName')), 'Closed', (getObjectProperty(selectedSale, 'whoClosedCommission')), (getObjectProperty(selectedSale, 'calcObjectId')), (getObjectProperty(selectedSale, 'link_to_closed_payroll')), (getObjectProperty(selectedSale, 'ok2pay')), selectedPayDate, (getObjectProperty(selectedSale, 'saleType')), (getObjectProperty(selectedSale, 'custFname')), (getObjectProperty(selectedSale, 'custLname')), (getObjectProperty(selectedSale, 'orderNumber'))));
      if (link_to_closed_payroll !== null && !Array.isArray(link_to_closed_payroll) && (typeof link_to_closed_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').setRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_closed_payroll', [(getObjectProperty(link_to_closed_payroll, 'objectId'))]);
      }
      link_to_setby_payroll = (await BackendlessUI.Functions.Custom['fn_a3b48c95568c3e451a6f8842f9637ed7']((getObjectProperty(selectedSale, 'setbyName')), 'Setby', (getObjectProperty(selectedSale, 'setbyCommission')), (getObjectProperty(selectedSale, 'calcObjectId')), (getObjectProperty(selectedSale, 'link_to_setby_payroll')), (getObjectProperty(selectedSale, 'ok2pay')), selectedPayDate, (getObjectProperty(selectedSale, 'saleType')), (getObjectProperty(selectedSale, 'custFname')), (getObjectProperty(selectedSale, 'custLname')), (getObjectProperty(selectedSale, 'orderNumber'))));
      if (link_to_setby_payroll !== null && !Array.isArray(link_to_setby_payroll) && (typeof link_to_setby_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').setRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_setby_payroll', [(getObjectProperty(link_to_setby_payroll, 'objectId'))]);
      }
    } else {
      selectedPayDate = null;
      link_to_setby_payroll = (await BackendlessUI.Functions.Custom['fn_2a647068837845a4d6b52bb86bc41f8c']((getObjectProperty(selectedSale, 'link_to_setby_payroll')), (getObjectProperty(selectedSale, 'calcObjectId'))));
      if (link_to_setby_payroll !== null && !Array.isArray(link_to_setby_payroll) && (typeof link_to_setby_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').deleteRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_setby_payroll', [(getObjectProperty(link_to_setby_payroll, 'objectId'))]);
      }
      link_to_closed_payroll = (await BackendlessUI.Functions.Custom['fn_2a647068837845a4d6b52bb86bc41f8c']((getObjectProperty(selectedSale, 'link_to_closed_payroll')), (getObjectProperty(selectedSale, 'calcObjectId'))));
      if (link_to_closed_payroll !== null && !Array.isArray(link_to_closed_payroll) && (typeof link_to_closed_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').deleteRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_closed_payroll', [(getObjectProperty(link_to_closed_payroll, 'objectId'))]);
      }
      link_to_manager_payroll = (await BackendlessUI.Functions.Custom['fn_2a647068837845a4d6b52bb86bc41f8c']((getObjectProperty(selectedSale, 'link_to_manager_payroll')), (getObjectProperty(selectedSale, 'calcObjectId'))));
      if (link_to_manager_payroll !== null && !Array.isArray(link_to_manager_payroll) && (typeof link_to_manager_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').deleteRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_manager_payroll', [(getObjectProperty(link_to_manager_payroll, 'objectId'))]);
      }
      link_to_dealer_payroll = (await BackendlessUI.Functions.Custom['fn_2a647068837845a4d6b52bb86bc41f8c']((getObjectProperty(selectedSale, 'link_to_dealer_payroll')), (getObjectProperty(selectedSale, 'calcObjectId'))));
      if (link_to_dealer_payroll !== null && !Array.isArray(link_to_dealer_payroll) && (typeof link_to_dealer_payroll === 'object')) {
        await Backendless.Data.of('Sales_calculations').deleteRelation((getObjectProperty(selectedSale, 'calcObjectId')), 'link_to_dealer_payroll', [(getObjectProperty(link_to_dealer_payroll, 'objectId'))]);
      }
    }
    commissions_object = [({ 'role': 'Dealer','dealer_name': (getObjectProperty(selectedSale, 'dealerName')),'amount': (getObjectProperty(selectedSale, 'dealerCommission')) }), ({ 'role': 'Manager','dealer_name': (getObjectProperty(selectedSale, 'managerName')),'amount': (getObjectProperty(selectedSale, 'managerCommission')) }), ({ 'role': 'Closed','dealer_name': (getObjectProperty(selectedSale, 'whoClosedName')),'amount': (getObjectProperty(selectedSale, 'whoClosedCommission')) }), ({ 'role': 'setby','dealer_name': (getObjectProperty(selectedSale, 'setbyName')),'amount': (getObjectProperty(selectedSale, 'setbyCommission')) })];
    await Backendless.Data.of('Sales_calculations').save(({ 'finance_company': (getObjectProperty(selectedSale, 'financeCompany')),'bump_percentage': (getObjectProperty(selectedSale, 'bumpPercentage')),'bump_amount': (getObjectProperty(selectedSale, 'bumpAmount')),'received_payment': (getObjectProperty(selectedSale, 'receivedPayment')),'date_received_payment': (getObjectProperty(selectedSale, 'dateReceivedPayment')),'objectId': (getObjectProperty(selectedSale, 'calcObjectId')),'received_down': (getObjectProperty(selectedSale, 'receivedDown')),'received_finance': (getObjectProperty(selectedSale, 'receivedFinance')),'date_received_down': (getObjectProperty(selectedSale, 'dateReceivedDown')),'date_received_finance': (getObjectProperty(selectedSale, 'dateReceivedFinance')),'dealer_commission': (Number((getObjectProperty(selectedSale, 'dealerCommission')))),'finance_fees_detail': (getObjectProperty(selectedSale, 'financeFees')),'commissions_detail': commissions_object,'manager_commission': (Number((getObjectProperty(selectedSale, 'managerCommission')))),'who_closed_commission': (Number((getObjectProperty(selectedSale, 'whoClosedCommission')))),'setby_commission': (Number((getObjectProperty(selectedSale, 'setbyCommission')))),'ok2pay': (getObjectProperty(selectedSale, 'ok2pay')),'netTotal': (getObjectProperty(selectedSale, 'netSaleTotalNum')),'sale_type': (getObjectProperty(selectedSale, 'saleType')),'deferred_fee': (getObjectProperty(selectedSale, 'deferredFee')),'num_payments': (getObjectProperty(selectedSale, 'numPayments')),'monthly_payment_amount': (getObjectProperty(selectedSale, 'monthlyPaymentAmount')),'APR': (getObjectProperty(selectedSale, 'APR')),'finance_fees_total': (getObjectProperty(selectedSale, 'totalFinanceFee')),'payperiod': selectedPayDate,'first_payment_due': (getObjectProperty(selectedSale, 'firstPaymentDue')) }), true);
    await Backendless.Data.of('Sales_invoice').save(({ 'objectId': (getObjectProperty(selectedSale, 'invoiceObjectId')),'product_cost': (getObjectProperty(selectedSale, 'productCost')),'payment_amount': (getObjectProperty(selectedSale, 'paymentAmount')),'down_total': (getObjectProperty(selectedSale, 'downTotal')),'cust_fname': (getObjectProperty(selectedSale, 'custFname')),'cust_lname': (getObjectProperty(selectedSale, 'custLname')),'cancel_date': (getObjectProperty(selectedSale, 'cancelDate')),'manager_name': (getObjectProperty(selectedSale, 'managerName')),'dealer_name': (getObjectProperty(selectedSale, 'dealerName')),'setby_name': (getObjectProperty(selectedSale, 'setbyName')),'sale_cancelled': (getObjectProperty(selectedSale, 'sale_cancelled')),'who_closed_sale': (getObjectProperty(selectedSale, 'whoClosedName')),'rainbow_price': (getObjectProperty(selectedSale, 'rainbowPrice')),'add_products_total': (getObjectProperty(selectedSale, 'addonPrice')),'payment_method': (getObjectProperty(selectedSale, 'paymentMethod')),'down_method': (getObjectProperty(selectedSale, 'downMethod')) }), true);

  } catch (error) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('issue--report', ({ 'bugReport': ({ 'reportBug--name': 'Modal Save Failed','reportBug--sourcePage': 'financeModalSaveUpdate function','reportBug--errorCode': [(getObjectProperty(error, 'code')),' ',(getObjectProperty(error, 'message'))].join(''),'reportBug--fullError': error }) }));

  }

return true
}

})
define('./functions/4a82504ac5a365b515498484f6caee02/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'] = async function fn_4a82504ac5a365b515498484f6caee02(tableName, whereClause, propertiesToInclude, propertiesToExclude, propertiesToSortBy, relations) {
var allCustomers, loading, currentBatch, offset;


  loading = true;
  allCustomers = [];
  offset = 0;
  while (loading) {
    currentBatch = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties(propertiesToInclude).excludeProperties(propertiesToExclude).setRelated(relations).setSortBy(propertiesToSortBy).setPageSize(100).setOffset(offset)));
    allCustomers = (allCustomers.concat(currentBatch));
    offset = offset + 100;
    if (currentBatch.length < 100) {
      loading = false;
    }
  }

return allCustomers
}

})
define('./functions/4d936d77c3b5ec66207f8e6bed44a3cd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'] = function fn_4d936d77c3b5ec66207f8e6bed44a3cd(month_num) {
var month_name;


  if (month_num == 1) {
    month_name = 'January';
  } else if (month_num == 2) {
    month_name = 'February';
  } else if (month_num == 3) {
    month_name = 'March';
  } else if (month_num == 4) {
    month_name = 'April';
  } else if (month_num == 5) {
    month_name = 'May';
  } else if (month_num == 6) {
    month_name = 'June';
  } else if (month_num == 7) {
    month_name = 'July';
  } else if (month_num == 8) {
    month_name = 'August';
  } else if (month_num == 9) {
    month_name = 'September';
  } else if (month_num == 10) {
    month_name = 'October';
  } else if (month_num == 11) {
    month_name = 'November';
  } else if (month_num == 12) {
    month_name = 'December';
  }

return month_name
}

})
define('./functions/507d7b8d0bd1aa8d56994bedecaf4986/code.js', () => { 

BackendlessUI.Functions.Custom['fn_507d7b8d0bd1aa8d56994bedecaf4986'] = async function fn_507d7b8d0bd1aa8d56994bedecaf4986(officeRecord, startDate, endDate, productList, locationList) {
var inventoryCount, inventoryHistorical, inventory_historical, j, locationTable, newRecord, k, startDate, currentCount, currentRecord, item, currentInventory, products, mostRecentInventory, pastInventories, locations, productTable, transactionTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting update_histInventory');
  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  productTable = (getObjectProperty(officeRecord, 'product_table'));
  transactionTable = (getObjectProperty(officeRecord, 'productTransaction_table'));
  if (productList) {
    products = productList;
  } else {
    products = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](productTable, (['active=TRUE AND associated_office = \'',(getObjectProperty(officeRecord, 'objectId')),'\' AND sn_required != TRUE'].join('')), null, null, null, null));
  }
  if (locationList) {
    locations = locationList;
  } else {
    locations = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](locationTable, (['active=TRUE and isTracked=TRUE AND associated_office = \'',(getObjectProperty(officeRecord, 'objectId')),'\''].join('')), null, null, null, null));
  }
  for (var j_index in locations) {
    j = locations[j_index];
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(j, 'name')));
    if ((getObjectProperty(j, 'inventory_historical')) && (getObjectProperty(j, 'inventory_historical')).length > 0) {
      inventory_historical = (getObjectProperty(j, 'inventory_historical'));
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](inventory_historical);
      pastInventories = (await asyncListFilter(inventory_historical, async (item) => {
         await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(item, 'asOfDate')));


       return ((getObjectProperty(item, 'asOfDate')) <= startDate);
      }));
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](pastInventories);
      mostRecentInventory = (await asyncListFilter(pastInventories, async (item) => {
         await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(item, 'asOfDate')));


       return ((getObjectProperty(item, 'asOfDate')) == startDate);
      }));
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](mostRecentInventory);
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](startDate);
      if (mostRecentInventory.length == 0) {
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('time range doesn\'t match prior inventories');
        return 'time range doesn\'t match prior inventories';
      }
      currentInventory = (getObjectProperty((mostRecentInventory[0]), 'inventory'));
    } else {
      inventory_historical = [];
      currentInventory = [];
      startDate = startDate;
    }
    inventoryCount = [];
    for (var k_index in products) {
      k = products[k_index];
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(k, 'product_name')));
      currentRecord = (await asyncListFilter(currentInventory, async (item) => {


       return ((getObjectProperty(item, 'productId')) == (getObjectProperty(k, 'objectId')));
      }));
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('current Record');
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](currentRecord);
      if (currentRecord.length > 0) {
        currentCount = (getObjectProperty((currentRecord[0]), 'count'));
      } else {
        currentCount = 0;
      }
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](currentCount);
      newRecord = ({ 'productId': (getObjectProperty(k, 'objectId')),'productName': (getObjectProperty(k, 'product_name')),'count': currentCount + (await BackendlessUI.Functions.Custom['fn_8a860b7f0f29d23441012eeacee82a9f'](startDate, null, (getObjectProperty(j, 'objectId')), (getObjectProperty(k, 'objectId')), officeRecord, endDate)) });
      addItemToList(inventoryCount, newRecord);
    }
    j['inventory_historical'] = (addItemToList(inventory_historical, ({ 'asOfDate': endDate,'inventory': inventoryCount })));
    await Backendless.Data.of(locationTable).save(j, true);
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('added new inventory: ');
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](inventory_historical);
  }
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('Done with count');
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end update_histInventory');

return 
}

})
define('./functions/516aabba24b47ac35f9c6b9e105863cd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_516aabba24b47ac35f9c6b9e105863cd'] = function fn_516aabba24b47ac35f9c6b9e105863cd(repeater_item, property_name) {
var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (repeater_item) {
    value = (getObjectProperty(repeater_item, property_name));
  } else {
    value = null;
  }

return value
}

})
define('./functions/53e5e80f02717a127926d3e322ca9229/code.js', () => { 

BackendlessUI.Functions.Custom['fn_53e5e80f02717a127926d3e322ca9229'] = async function fn_53e5e80f02717a127926d3e322ca9229(locationTable, locationObjId, productObjId, numItems, snRequired, officeObjId, transactionDate) {
var totalItems, response, error, itemMatch, movedFromRecord, inventoryMovedFrom, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('in remove from inventory');
  movedFromRecord = (await Backendless.Data.of(locationTable).findById(locationObjId, ));
  if (Array.isArray((getObjectProperty(movedFromRecord, 'inventory')))) {
    inventoryMovedFrom = (getObjectProperty(movedFromRecord, 'inventory'));
  } else {
    inventoryMovedFrom = [];
  }
  itemMatch = (await asyncListFilter(inventoryMovedFrom, async (item) => {


   return ((getObjectProperty(item, 'productObjId')) == productObjId);
  }));
  if (itemMatch.length == 1) {
    itemMatch = itemMatch[0];
    totalItems = (getObjectProperty(itemMatch, 'totalItems')) - numItems;
    // Select everything except the one we're changing
    inventoryMovedFrom = (await asyncListFilter(inventoryMovedFrom, async (item) => {


     return ((getObjectProperty(item, 'productObjId')) != productObjId);
    }));
  } else if (itemMatch.length == 0) {
    totalItems = 0 - numItems;
  } else {
    response = [locationObjId,' has multiple instances of',productObjId,'Contact support'].join('');
    return response;
  }
  if (totalItems < 0) {
    response = [locationObjId,' does not have enough items of type ',productObjId].join('');
  }
  if (snRequired) {
    totalItems = (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164'](locationObjId, officeObjId, productObjId));
  }
  addItemToList(inventoryMovedFrom, ({ 'productObjId': productObjId,'productName': (getObjectProperty(itemMatch, 'productName')),'serialNumber': undefined,'totalItems': totalItems }));
  await Backendless.Data.of(locationTable).save(({ 'objectId': locationObjId,'inventory': inventoryMovedFrom }), true);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('done with remove from inventory');

return ({ 'response': response,'newTotal': totalItems })
}

})
define('./functions/554407add264c20230a69c383ca4ee9c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_554407add264c20230a69c383ca4ee9c'] = async function fn_554407add264c20230a69c383ca4ee9c() {
return (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('notifications', (['show=',true,'','','','','','',''].join('')), null, null, null, null))
}

})
define('./functions/557ac3da694fa8f4649d4e7a6cf17fe1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_557ac3da694fa8f4649d4e7a6cf17fe1'] = async function fn_557ac3da694fa8f4649d4e7a6cf17fe1(commissionInfo, saleType, saleRecordId, orderNumber, customerFname, customerLname, paydate, link_payroll) {
var new_payroll_record, commissionsObject, existing_payroll_record, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting FMupdatePayrollRecordonSave');
  if (!(commissionInfo !== null && !Array.isArray(commissionInfo) && (typeof commissionInfo === 'object'))) {
    return null;
  }
  if ((getObjectProperty(commissionInfo, 'amount')) == 0 || ((getObjectProperty(commissionInfo, 'name')).indexOf('Not in system') !== -1) || (getObjectProperty(commissionInfo, 'name')).length < 4) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((['skipping payroll record for ',(getObjectProperty(commissionInfo, 'name')),' and ',(getObjectProperty(commissionInfo, 'systemRole'))].join('')));
    return null;
  }
  commissionsObject = [({ 'systemRole': (getObjectProperty(commissionInfo, 'systemRole')),'roleTitle': (getObjectProperty(commissionInfo, 'roleTitle')),'amount': (getObjectProperty(commissionInfo, 'amount')),'sale': saleRecordId,'customer': [customerFname,' ',customerLname].join(''),'saleType': saleType,'orderNumber': orderNumber })];
  if (link_payroll == null) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('looking for matching payroll');
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((['dealer_name=\'',(getObjectProperty(commissionInfo, 'name')),'\' and pay_date=\'',paydate,'\''].join('')));
    // Look for an existing record for this dealer and paydate
    existing_payroll_record = (await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'payrollTransaction_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name=\'',(getObjectProperty(commissionInfo, 'name')),'\' and pay_date=\'',paydate,'\''].join(''))).setPageSize(10)));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](existing_payroll_record);
    if (existing_payroll_record.length == 0) {
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('no existing payroll, creating new');
      // Create a new payroll record
      new_payroll_record = (await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'payrollTransaction_table'))).save( ({ 'dealer_name': (getObjectProperty(commissionInfo, 'name')),'pay_date': paydate,'commissions_total': (await Promise.all(commissionsObject.map(async item => {; return (getObjectProperty(item, 'amount'));}))).reduce(function(x, y) {return x + y;}),'commissions_detail': [commissionsObject],'reductions_detail': [],'additions_detail': [],'payroll_ID': (await BackendlessUI.Functions.Custom['fn_dfde89045fdd53560e581c5cc2bd3889'](((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')))) }) ));
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](new_payroll_record);
    } else if (existing_payroll_record.length == 1) {
      new_payroll_record = (await BackendlessUI.Functions.Custom['fn_413437279b2503eebc95c8920f79642e']((existing_payroll_record[0]), commissionsObject));
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](new_payroll_record);
    } else {
      console.log('issue with payroll record -- too many exist for dealer');
      console.log(commissionInfo);
      console.log('issue with payroll record -- too many exist for dealer');
    }
  } else if (link_payroll != null) {
    new_payroll_record = (await BackendlessUI.Functions.Custom['fn_413437279b2503eebc95c8920f79642e'](link_payroll, commissionsObject));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('link points here: ');
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](new_payroll_record);
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end FMupdatePayrollRecordonSave');

return new_payroll_record
}

})
define('./functions/57eee5b8f873bb91e844e66589ed7d8a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'] = function fn_57eee5b8f873bb91e844e66589ed7d8a(value) {
return (Math.round(value * 100) / 100)
}

})
define('./functions/59d3d06f0c9c55552969b0b5d709a461/code.js', () => { 

BackendlessUI.Functions.Custom['fn_59d3d06f0c9c55552969b0b5d709a461'] = async function fn_59d3d06f0c9c55552969b0b5d709a461(locationTable, locationObjId, productObjId, numItems, serialNumber) {
var totalItems, response, inventoryMovedFrom, snAvailable, itemMatch, item, snToRemove, movedFromRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  movedFromRecord = (await Backendless.Data.of(locationTable).findById(locationObjId, ));
  if (Array.isArray((getObjectProperty(movedFromRecord, 'inventory')))) {
    inventoryMovedFrom = (getObjectProperty(movedFromRecord, 'inventory'));
  } else {
    inventoryMovedFrom = [];
  }
  itemMatch = (await asyncListFilter(inventoryMovedFrom, async (item) => {


   return ((getObjectProperty(item, 'productObjId')) == productObjId);
  }));
  if (itemMatch.length == 1) {
    itemMatch = itemMatch[0];
    snAvailable = (getObjectProperty(itemMatch, 'serialNumber'));
    for (var snToRemove_index in serialNumber) {
      snToRemove = serialNumber[snToRemove_index];
      if ((await asyncListFilter(snAvailable, async (item) => {


       return (item == snToRemove);
      })).length == 1) {
        snAvailable = (await asyncListFilter(snAvailable, async (item) => {


         return (item != snToRemove);
        }));
      } else {
        response = [snToRemove,' not present in ',locationObjId,''].join('');
        return response;
      }
    }
    totalItems = snAvailable.length;
    // Select everything except the one we're changing
    inventoryMovedFrom = (await asyncListFilter(inventoryMovedFrom, async (item) => {


     return ((getObjectProperty(item, 'productObjId')) != productObjId);
    }));
  } else if (itemMatch.length == 0) {
    response = [productObjId,' not present in ',locationObjId,''].join('');
    return response;
  } else {
    response = [locationObjId,' has multiple instances of',productObjId,'Contact support'].join('');
    return response;
  }
  addItemToList(inventoryMovedFrom, ({ 'productObjId': productObjId,'productName': (getObjectProperty(itemMatch, 'productName')),'serialNumber': snAvailable,'totalItems': totalItems }));
  await Backendless.Data.of(locationTable).save(({ 'objectId': locationObjId,'inventory': inventoryMovedFrom }), true);

return ({ 'response': response,'newTotal': totalItems })
}

})
define('./functions/5afd83f294c94eeb02835b794335fc31/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5afd83f294c94eeb02835b794335fc31'] = async function fn_5afd83f294c94eeb02835b794335fc31(tableName) {
var nextSteps;


  await Backendless.Data.of(tableName).remove( (await Backendless.Data.of(tableName).save( ({ 'dealer_name': 'dealer_name','payroll_ID': 5.6,'payperiod_end': 'dealer_name','payperiod_start': 'dealer_name','additions_total': 5.6,'commissions_total': 5.6,'payment_total': 5.6,'reductions_total': 5.6,'salary_total': 5.6 }) )) );

return 
}

})
define('./functions/5d07d9d2a493b02f176e1a2159aaddd2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5d07d9d2a493b02f176e1a2159aaddd2'] = async function fn_5d07d9d2a493b02f176e1a2159aaddd2(productIds, locationIds, officeObjId, recalculate, officeRecord) {
var totalInventory;


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start get_inventoryTotal');
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end get_inventoryTotal');

return totalInventory
}

})
define('./functions/6296e95f46330fa713016952066db68e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6296e95f46330fa713016952066db68e'] = async function fn_6296e95f46330fa713016952066db68e(officeRecord, transactionDate, locationRecord, productId, numItems, productName) {
var locationRecord, locationTable, inventory_historical, mostRecentInventory, currentInventory, currentRecord, item, inventoryHistorical, pastInventories;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('in add_transactionHistInventory');
  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  if ((getObjectProperty(locationRecord, 'inventory_historical')) && (getObjectProperty(locationRecord, 'inventory_historical')).length > 0) {
    inventory_historical = (getObjectProperty(locationRecord, 'inventory_historical'));
    pastInventories = (await asyncListFilter(inventory_historical, async (item) => {
       await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(item, 'asOfDate')));


     return ((getObjectProperty(item, 'asOfDate')) <= transactionDate);
    }));
    // This is a post-dated transaction, inventory needs to be recalculated
    //
    // Else -- we just add this value to the inventory
    if (pastInventories.length < inventory_historical.length) {
      mostRecentInventory = pastInventories.slice(-1)[0];
    } else {
      mostRecentInventory = inventoryHistorical.slice(-1)[0];
      currentInventory = (getObjectProperty((mostRecentInventory[0]), 'inventory'));
      currentRecord = (await asyncListFilter(currentInventory, async (item) => {


       return ((getObjectProperty(item, 'productId')) == productId);
      }))[0];
      if (currentRecord) {
        currentRecord['count'] = ((getObjectProperty(currentRecord, 'count')) + numItems);
        currentRecord['asOfDate'] = (getObjectProperty(transactionDate, 'transaction_date'));
      } else {
        addItemToList(currentInventory, ({ 'productId': productId,'productName': productName,'count': numItems }));
      }
      inventory_historical = [inventory_historical.slice(0, inventory_historical.length - 0), mostRecentInventory];
      locationRecord['inventory_historical'] = inventory_historical;
      await Backendless.Data.of(locationTable).save(locationRecord, true);
    }
  } else {
    await BackendlessUI.Functions.Custom['fn_f3f49dcb24e9c0e61dbf2c232cce7c74'](officeRecord, (getObjectProperty(officeRecord, 'inventory_start_date')));
  }

return 
}

})
define('./functions/63982c1ae3dbd4d57b645661584b971d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_63982c1ae3dbd4d57b645661584b971d'] = async function fn_63982c1ae3dbd4d57b645661584b971d(officeObjId, whereClause, sortBy, relations, relationDepth, pageSize, pageOffset, getAll, groupBy, officeRecord) {
var discrepancies, pageSize, tableName, i, count;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (officeRecord) {
    tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('discrepancy_table', null, officeRecord));
  } else {
    tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('discrepancy_table', officeObjId, null));
  }
  if (!pageSize) {
    pageSize = 100;
  } else {
    pageSize = pageSize;
  }
  if (getAll == true) {
    count = (await Backendless.Data.of(tableName).getObjectCount());
    discrepancies = [];
    var i_end = Math.ceil(count / 100);
    var i_inc = 1;
    if (0 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 0; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      addItemToList(discrepancies, (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setRelated(relations).setRelationsDepth(relationDepth).setSortBy(sortBy).setGroupBy(groupBy).setPageSize(pageSize).setOffset((i * 100)))));
    }
  } else {
    discrepancies = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setRelated(relations).setRelationsDepth(relationDepth).setSortBy(sortBy).setGroupBy(groupBy).setPageSize(pageSize).setOffset(pageOffset)));
  }

return discrepancies
}

})
define('./functions/63bfc57b5762d36e79456fc928d87efe/code.js', () => { 

BackendlessUI.Functions.Custom['fn_63bfc57b5762d36e79456fc928d87efe'] = async function fn_63bfc57b5762d36e79456fc928d87efe(startDate, endDate, officeRecord) {
var inventoryCounts, newRecord, k, j, products, inventory, locations, snTrackingTable, snTracking, productTable, locationTable, transactionTable, transactions;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  productTable = (getObjectProperty(officeRecord, 'product_table'));
  transactionTable = (getObjectProperty(officeRecord, 'productTransaction_table'));
  snTrackingTable = (getObjectProperty(officeRecord, 'SN_tracking_table'));
  locations = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](locationTable, (['active=TRUE and isTracked=TRUE AND associated_office = \'',(getObjectProperty(officeRecord, 'objectId')),'\''].join('')), null, null, null, null));
  products = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](productTable, (['active=TRUE AND associated_office = \'',(getObjectProperty(officeRecord, 'objectId')),'\''].join('')), null, null, null, null));
  snTracking = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](snTrackingTable, null, null, null, null, null));
  inventoryCounts = [];
  for (var j_index in locations) {
    j = locations[j_index];
    inventory = [];
    for (var k_index in products) {
      k = products[k_index];
      newRecord = ({ 'locationId': (getObjectProperty(j, 'objectId')),'locationName': (getObjectProperty(j, 'name')),'productId': (getObjectProperty(k, 'objectId')),'productName': (getObjectProperty(k, 'product_name')),'count': (await BackendlessUI.Functions.Custom['fn_8a860b7f0f29d23441012eeacee82a9f'](startDate, null, (getObjectProperty(j, 'objectId')), (getObjectProperty(k, 'objectId')), officeRecord, endDate)) });
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](newRecord);
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((await BackendlessUI.Functions.Custom['fn_dab32c1a59815cb1bb01bf3c96e663ee'](startDate, null, (getObjectProperty(j, 'objectId')), (getObjectProperty(k, 'objectId')), officeRecord, endDate)));
      addItemToList(inventoryCounts, newRecord);
    }
  }

return ({ 'startDate': startDate,'endDate': endDate,'inventoryCount': inventoryCounts })
}

})
define('./functions/642965abd54d833d81bfa3f755fac658/code.js', () => { 

BackendlessUI.Functions.Custom['fn_642965abd54d833d81bfa3f755fac658'] = function fn_642965abd54d833d81bfa3f755fac658(serialNumbers) {
var processedSerialNums, i, range, j;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (serialNumbers.indexOf(',') !== -1) {
    processedSerialNums = [];
    var j_list = serialNumbers.split(',');
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(processedSerialNums, (j.trim()));
    }
  } else if (serialNumbers.indexOf('-') !== -1) {
    processedSerialNums = [];
    range = serialNumbers.split('-');
    var i_start = (Number((range[0])));
    var i_end = (Number((range.slice(-1)[0])));
    var i_inc = 1;
    if (i_start > i_end) {
      i_inc = -i_inc;
    }
    for (i = i_start; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      addItemToList(processedSerialNums, i);
    }
  } else {
    processedSerialNums = [serialNumbers];
  }

return processedSerialNums
}

})
define('./functions/6864cf32f303c81f8dd5e9e784d39d7d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6864cf32f303c81f8dd5e9e784d39d7d'] = async function fn_6864cf32f303c81f8dd5e9e784d39d7d(role, name, currentVal, numberOfRainbows) {
var commissionInfo, commAB, commC, numRainbows, name2;


  if (typeof numberOfRainbows === 'number' && !isNaN(numberOfRainbows)) {
    numRainbows = numberOfRainbows;
  } else {
    numRainbows = 1;
  }
  commissionInfo = ({ 'current': currentVal });
  if ((typeof name === 'string') && (name.indexOf('Not in system') !== -1)) {
    name2 = name.slice(0, name.indexOf(' - Not in system') + 1).trim();
    commissionInfo['name'] = name2;
  } else {
    name2 = name;
  }
  if (role == 'closed') {
    commAB = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, 'override_whoclosedbonus'));
    commC = commAB;
  } else if (role == 'manager') {
    commAB = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, 'manager_commission_on_AB_sale'));
    commC = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, 'manager_commission_on_C_sale'));
  } else if (role == 'dealer') {
    commAB = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, 'dealer_commission_on_AB_sale'));
    commC = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, 'dealer_commission_on_C_sale'));
  } else if (role == 'setby') {
    commAB = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, 'setby_commission'));
    commC = commAB;
  }
  if (commAB == 'Not in system') {
    commissionInfo['name'] = (String(name2) + String(' - Not in system'));
    commissionInfo['AB'] = 0;
    commissionInfo['C'] = 0;
    commissionInfo['current'] = 0;
  } else if (commAB == '') {
    commissionInfo['name'] = name2;
    commissionInfo['AB'] = 0;
    commissionInfo['C'] = 0;
    commissionInfo['current'] = 0;
  } else {
    commissionInfo['name'] = name2;
    if (role == 'dealer') {
      commAB = commAB * numRainbows;
      commC = commC * numRainbows;
      commissionInfo['AB'] = commAB;
      commissionInfo['C'] = commC;
    } else {
      commissionInfo['AB'] = commAB;
      commissionInfo['C'] = commC;
    }
    if (currentVal == null || currentVal == -1) {
      commissionInfo['current'] = commAB;
    } else {
      commissionInfo['current'] = currentVal;
    }
  }
  if (currentVal > 0) {
    commissionInfo['current'] = currentVal;
  }

return commissionInfo
}

})
define('./functions/69b6270c3b58921aacf2640ade249787/code.js', () => { 

BackendlessUI.Functions.Custom['fn_69b6270c3b58921aacf2640ade249787'] = async function fn_69b6270c3b58921aacf2640ade249787(selectedSale) {
var salesTaxPerc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  selectedSale['sale_total_wo_tax'] = ((Number((getObjectProperty(selectedSale, 'rainbowPrice')))) + (Number((getObjectProperty(selectedSale, 'addonPrice')))));
  salesTaxPerc = (Number((subsequenceFirstFromEnd((getObjectProperty(selectedSale, 'salesTaxPerc')), 1))));
  selectedSale['salesTax'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((((getObjectProperty(selectedSale, 'sale_total_wo_tax')) * salesTaxPerc) / 100)));
  selectedSale['sale_total_w_tax'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](((getObjectProperty(selectedSale, 'sale_total_wo_tax')) + (getObjectProperty(selectedSale, 'salesTax')))));
  selectedSale['financeAmount'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](((getObjectProperty(selectedSale, 'sale_total_w_tax')) - (Number((getObjectProperty(selectedSale, 'downTotal')))))));
  selectedSale['totalAfterCosts'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](((getObjectProperty(selectedSale, 'sale_total_w_tax')) - (await BackendlessUI.Functions.Custom['fn_884bd43441923ffdbc69ddfef4eb3f85'](selectedSale)))));

return selectedSale
}

})
define('./functions/6cb2904b74d2fbb8562279f3de2bcbdf/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6cb2904b74d2fbb8562279f3de2bcbdf'] = async function fn_6cb2904b74d2fbb8562279f3de2bcbdf(tableName, nextSteps, dealerTableName) {
var nextSteps, locationObject;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('start addTable_locations');
  if (!((await Backendless.Data.describe( tableName )) !== null && !Array.isArray((await Backendless.Data.describe( tableName ))) && (typeof (await Backendless.Data.describe( tableName )) === 'object'))) {
    locationObject = (await Backendless.Data.of(tableName).save( ({ 'name': 'Example','active': false,'isTracked': false,'type': 'Dealer' }) ));
    await Backendless.Data.of(tableName).remove( locationObject );
    addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'inventory','type': 'json' }), ({ 'fieldName': 'associated_office','type': String('data relation -- 1:1 with ') + String('Offices') }), ({ 'fieldName': 'link_dealer','type': String('data relation -- 1:1 with ') + String(dealerTableName) })] }));
  }
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('end addTable_locations');

return 
}

})
define('./functions/6ced27bc6ce9165697ec7b45cf6aba85/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6ced27bc6ce9165697ec7b45cf6aba85'] = async function fn_6ced27bc6ce9165697ec7b45cf6aba85(shortId, nextSteps, tableName, productTableName, locationTableName) {
var nextSteps;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of(tableName).save( ({ 'order_number': 'new Product','APR': 5.6,'bump_amount': 5.6,'bump_percentage': 5.6,'company_profit': 5.6,'creditcard_Fee': 5.6,'dealer_commission': 5.6,'deferred_fee': 5.6,'finance_company': '2d9102','finance_fees_total': 5.6,'monthly_payment_amount': 5.6,'netTotal': 5.6,'num_payments': 7,'ok2pay': true,'paidPercentage': 5.6,'product_cost': 5.6,'received_down': true,'received_finance': true,'received_payment': true,'red_flag': true,'sale_total': 5.6,'sale_type': 'charlie','total_after_costs': 5.6 }) );
  addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'commissions_detail','type': 'json' }), ({ 'fieldName': 'finance_fees_detail','type': 'json' }), ({ 'fieldName': 'first_payment_due','type': 'datetime' }), ({ 'fieldName': 'payperiod','type': 'datetime' }), ({ 'fieldName': 'date_received_down','type': 'datetime' }), ({ 'fieldName': 'date_received_finance','type': 'datetime' }), ({ 'fieldName': 'date_received_payment','type': 'datetime' })] }));

return nextSteps
}

})
define('./functions/6fac9f86faac3c0d1045bb024aeba0bc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'] = async function fn_6fac9f86faac3c0d1045bb024aeba0bc(name, field) {
var value, object;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start getPayMatrix');
  if (name == null) {
    value = '';
  } else {
    try {
      object = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name=\'',name,'\''].join(''))).setRelated('current_matrix_level').setPageSize(1)))[0];
      value = (getObjectProperty((getObjectProperty(object, 'current_matrix_level')), field));

    } catch (error) {
      if (name.indexOf('Not in system') !== -1) {
        value = '';
      } else {
        value = 'Not in system';
      }

    }
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end getPayMatrix');

return value
}

})
define('./functions/6fc9e39e65d8fbfb6dc2f45e1136fc52/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6fc9e39e65d8fbfb6dc2f45e1136fc52'] = async function fn_6fc9e39e65d8fbfb6dc2f45e1136fc52(shortId, nextSteps, tableName, productTableName, locationTableName) {
var nextSteps;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of(tableName).remove( (await Backendless.Data.of(tableName).save( ({ 'product_name': 'Test','num_items': 0,'moved_to': 'Test','moved_from': 'Test','serial_number': 'Test','order_number': 'Test','price': 'Test','responsible_person': 'Test','timestamp': 'Test','serial_number_display': 'Test','RDG_cost': 1.1,'notes': 'Test' }) )) );
  addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'transaction_date','type': 'datetime' }), ({ 'fieldName': 'product_photo','type': 'file reference' }), ({ 'fieldName': 'signature_file','type': 'file reference' }), ({ 'fieldName': 'serial_numbers','type': 'json' }), ({ 'fieldName': 'link_moved_from','type': String('data relation -- 1:1 with ') + String(locationTableName) }), ({ 'fieldName': 'link_moved_to','type': String('data relation -- 1:1 with ') + String(locationTableName) }), ({ 'fieldName': 'link_product','type': String('data relation -- 1:1 with ') + String(productTableName) })] }));

return nextSteps
}

})
define('./functions/728115de6413fe6895d592ebe63d687b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b'] = async function fn_728115de6413fe6895d592ebe63d687b(table, officeId, officeRecord) {
var tableName, officeRecord, officeId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (officeRecord && (officeRecord !== null && !Array.isArray(officeRecord) && (typeof officeRecord === 'object'))) {
    tableName = (getObjectProperty(officeRecord, table));
  } else if (officeId && (typeof officeId === 'string')) {
    officeId = officeId;
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('STILL using officeId');
    officeRecord = (await Backendless.Data.of('Offices').findById(officeId, ));
    tableName = (getObjectProperty(officeRecord, table));
  } else {
    if (Backendless.getCurrentUserToken()) {
      officeRecord = ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})());
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
    tableName = (getObjectProperty(officeRecord, table));
  }

return tableName
}

})
define('./functions/755cdc7d96ebc637b633759559383b95/code.js', () => { 

BackendlessUI.Functions.Custom['fn_755cdc7d96ebc637b633759559383b95'] = function fn_755cdc7d96ebc637b633759559383b95(x) {
return ((typeof x === 'number' && !isNaN(x)) ? x : 0)
}

})
define('./functions/7a94cfbce49a1c6602cc208d1acada83/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7a94cfbce49a1c6602cc208d1acada83'] = async function fn_7a94cfbce49a1c6602cc208d1acada83(tableName, nextSteps, shortCode, locationTableName, productTableName) {
var nextSteps, tablesNeeded;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('start addTable_discrepancies');
  await Backendless.Data.of(tableName).remove( (await Backendless.Data.of(tableName).save( ({ 'manual_count': 0,'locationId': 'Test','cost': 1.1,'isSN': true,'diff': 1.1,'firstValue': 1.1,'totalCost': 1.1,'showDiff': true,'firstTitle': 'Test','secondTitle': 'Test','secondValue': 1.1,'notes': 'Test','productId': 0,'resolution': 'Test','resolved': true,'supervisor_name': 'Test','system_count': 0 }) )) );
  addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'link_location','type': String('data relation -- 1:1 with ') + String(locationTableName) }), ({ 'fieldName': 'link_product','type': String('data relation -- 1:1 with ') + String(productTableName) }), ({ 'fieldName': 'date_of_count','type': 'datetime' }), ({ 'fieldName': 'date_of_resolution','type': 'datetime' })] }));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('end addTable_discrepancies');

return nextSteps
}

})
define('./functions/7b1eab948c3c495af7ffb9a821334d08/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7b1eab948c3c495af7ffb9a821334d08'] = async function fn_7b1eab948c3c495af7ffb9a821334d08(commissions, payMatrixRoles) {
var dealerObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting harrisonburgMatrixLogicFeb2023');
  dealerObject = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name=\'',(getObjectProperty(commissions, 'D1.name')),'\''].join(''))).setRelated('current_matrix_level').setRelationsDepth(1).setPageSize(1)))[0];
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](payMatrixRoles);
  if (!dealerObject) {
  } else if (!(getObjectProperty(dealerObject, 'is_team_leader')) && (!(typeof (getObjectProperty(dealerObject, 'teamLeaderObjId')) === 'string') || (getObjectProperty(dealerObject, 'teamLeaderObjId')).length < 5)) {
  } else if ((getObjectProperty(dealerObject, 'is_team_leader')) || (getObjectProperty(dealerObject, 'teamLeaderObjId')) == (getObjectProperty(dealerObject, 'objectId'))) {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('is team leader');
    commissions['D2'] = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9'](({ 'systemRole': 'D2','roleTitle': (getObjectProperty(payMatrixRoles, 'D5')),'amount': 0,'name': (getObjectProperty(commissions, 'D1.name')) }), (getObjectProperty(commissions, 'D1.numRainbows')))), 100));
    (getObjectProperty(commissions, 'D2'))['roleTitle'] = 'Personal Sale bonus';
  } else {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('is not team leader');
    commissions['D2'] = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9'](({ 'systemRole': 'D2','roleTitle': (getObjectProperty(payMatrixRoles, 'D2')),'amount': 100,'name': (getObjectProperty((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).findById((getObjectProperty(dealerObject, 'teamLeaderObjId')), )), 'dealer_name')) }), (getObjectProperty(commissions, 'D1.numRainbows')))), 100));
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end harrisonburgMatrixLogicFeb2023');

return commissions
}

})
define('./functions/830138742c16fc44bbfbebea238e3e19/code.js', () => { 

BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'] = async function fn_830138742c16fc44bbfbebea238e3e19(earliestDate, startDate, endDate, payDate) {
var unapproved_sales, approved_sales, all_sales, item, verdict, itemPaydate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  all_sales = (await Backendless.Data.of('Sales_invoice').find(Backendless.DataQueryBuilder.create().setWhereClause((['sales_date >\'',earliestDate,'\' AND sales_date <\'',endDate,'\''].join(''))).setRelated('link_to_calculations').setSortBy('sales_date DESC').setPageSize(100)));
  approved_sales = (await asyncListFilter(all_sales, async (item) => {
     verdict = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay'));
    itemPaydate = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'payperiod'));
    if ((itemPaydate === null) || (verdict === null)) {
      verdict = false;
    } else {
      if (itemPaydate != payDate) {
        verdict = false;
      }
    }


   return verdict;
  }));
  unapproved_sales = (await asyncListFilter(all_sales, async (item) => {


   return (!(getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay')));
  }));

return ({ 'allSales': all_sales,'approvedSales': approved_sales,'unapprovedSales': unapproved_sales })
}

})
define('./functions/8405d74e154be67776e70bfde74dbca2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8405d74e154be67776e70bfde74dbca2'] = async function fn_8405d74e154be67776e70bfde74dbca2() {
var currentPayrollDates, j, index;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  index = 0;
  var j_list = (await BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091'](null));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'endDate')) <= ((new Date()).valueOf()) && (getObjectProperty(j, 'payDate')) >= ((new Date()).valueOf())) {
      currentPayrollDates = j;
      currentPayrollDates['index'] = (index + 1);
      break;
    }
    index = (typeof index == 'number' ? index : 0) + 1;
    currentPayrollDates = j;
  }

return currentPayrollDates
}

})
define('./functions/840a0634a41a4e1b55691e3c685386ae/code.js', () => { 

BackendlessUI.Functions.Custom['fn_840a0634a41a4e1b55691e3c685386ae'] = async function fn_840a0634a41a4e1b55691e3c685386ae(shortId, nextSteps, tableName, calcTableName, transactionTableName, dealerTableName) {
var nextSteps;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of(tableName).save( ({ 'add_products_total': 'new Product','cancel_date_str': 'charlie','check_number': 'bob','co_fname': 'charlie','co_lname': '2d9102','co_phone': '2d9102','CRF_num': '2d9102','cust_address': '2d9102','cust_city': '2d9102','cust_email': '2d9102','cust_fname': 'charlie','cust_lname': 'charlie','cust_name': 'charlie','cust_phone': 'charlie','cust_state': 'charlie','cust_zip': 'charlie','dealer_name': 'charlie','down_method': 'charlie','down_total': 0,'finance_amount': 0,'manager_name': 'charlie','order_number': 'charlie','payment_amount': 0,'payment_method': 'charlie','product_cost': 0,'rainbow_count': 0,'rainbow_price': 0,'ride_along_name': 'charlie','sale_cancelled': true,'sale_total_with_tax': 0,'sale_total_wo_tax': 0,'sales_date_str': 'charlie','sales_tax': 0,'sales_tax_percent': 'charlie','setby_name': 'charlie','who_closed_sale': 'charlie' }) );
  addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'cancel_date','type': 'datetime' }), ({ 'fieldName': 'payment_details','type': 'json' }), ({ 'fieldName': 'sales_date','type': 'datetime' }), ({ 'fieldName': 'link_to_calculations','type': String('data relation -- 1:1 with ') + String(calcTableName) }), ({ 'fieldName': 'link_to_transactions','type': String('data relation -- 1:many with ') + String(transactionTableName) }), ({ 'fieldName': 'link_dealer','type': String('data relation -- 1:1 with ') + String(dealerTableName) })] }));

return nextSteps
}

})
define('./functions/8565790ce8fa447da5694ae7980329cd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8565790ce8fa447da5694ae7980329cd'] = async function fn_8565790ce8fa447da5694ae7980329cd(officeRecord) {
var passedCheck, response, table, j, matchingField, item, schema, requiredFields, comparisonOffice, tablesToCheck, checklist_payroll;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  checklist_payroll = (getObjectProperty(officeRecord, 'checklist_payroll'));
  response = '';
  tablesToCheck = ['payrollTransaction_table', 'product_table', 'productTransaction_table', 'salesInvoice_table', 'salesCalculations_table'];
  comparisonOffice = (await Backendless.Data.of('Offices').findById('4FB81D20-3A72-4FDA-BADA-9A829BF2E585', ));
  for (var table_index in tablesToCheck) {
    table = tablesToCheck[table_index];
    if (getObjectProperty(officeRecord, table)) {
      schema = (await Backendless.Data.describe( (getObjectProperty(officeRecord, table)) ));
      requiredFields = (await Backendless.Data.describe( (getObjectProperty(comparisonOffice, table)) ));
      for (var j_index in requiredFields) {
        j = requiredFields[j_index];
        matchingField = (await asyncListFilter(schema, async (item) => {


         return ((getObjectProperty(item, 'name')) == (getObjectProperty(j, 'name')));
        }));
        if (matchingField.length == 1) {
          if ((getObjectProperty((matchingField[0]), 'type')) != (getObjectProperty(j, 'type'))) {
            response = [response,'<br/>','field ','',(getObjectProperty(j, 'name')),'',' should be of type ',(getObjectProperty(j, 'type')),' in table ',(getObjectProperty(officeRecord, table))].join('');
          }
        } else {
          response = [response,'<br/>',(getObjectProperty(officeRecord, table)),' is missing field ','<em>',(getObjectProperty(j, 'name')),'</em>',' with type ',(getObjectProperty(j, 'type'))].join('');
        }
      }
    } else {
      response = [response,'<br/>',table,' is missing'].join('');
    }
  }
  if (response == '') {
    response = 'Tables are set up correctly';
    passedCheck = true;
  } else {
    passedCheck = false;
  }

return ({ 'response': response,'passedCheck': passedCheck })
}

})
define('./functions/884bd43441923ffdbc69ddfef4eb3f85/code.js', () => { 

BackendlessUI.Functions.Custom['fn_884bd43441923ffdbc69ddfef4eb3f85'] = function fn_884bd43441923ffdbc69ddfef4eb3f85(selectedSale) {
var total_costs, sales_tax, product_costs, finance_fee, deferred_fee;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  deferred_fee = (getObjectProperty(selectedSale, 'deferredFee'));
  finance_fee = (getObjectProperty(selectedSale, 'totalFinanceFee'));
  product_costs = (getObjectProperty(selectedSale, 'productCost')) + (getObjectProperty(selectedSale, 'addonPrice'));
  sales_tax = (getObjectProperty(selectedSale, 'salesTax'));
  total_costs = deferred_fee + finance_fee + product_costs + sales_tax;

return total_costs
}

})
define('./functions/8942906e3188e54314e1b16ad2ddbe7c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8942906e3188e54314e1b16ad2ddbe7c'] = async function fn_8942906e3188e54314e1b16ad2ddbe7c(pay_date) {
var selectedPayrollDates, j, index;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  index = 0;
  var j_list = (await BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091'](null));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'payDate')) == (pay_date.valueOf())) {
      selectedPayrollDates = j;
      selectedPayrollDates['index'] = (index + 1);
      break;
    }
    index = (typeof index == 'number' ? index : 0) + 1;
    selectedPayrollDates = j;
  }

return selectedPayrollDates
}

})
define('./functions/8a860b7f0f29d23441012eeacee82a9f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8a860b7f0f29d23441012eeacee82a9f'] = async function fn_8a860b7f0f29d23441012eeacee82a9f(startDate, officeObjId, locationId, productId, officeRecord, endDate) {
var count, numberRemoved, numberAdded, snRecord, productRecord, new_inventory_values, sn, snTrackRecord, snTrackingTable, item, snTracking, recordsAdded, recordsRemoved, transactions, locationRecord, productTable, endDate, startDate, transactionTable, locationTable, officeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start getInventoryCount_locationProduct');
  if (endDate) {
    endDate = endDate;
  } else {
    endDate = ((new Date()).valueOf());
  }
  if (startDate) {
    startDate = startDate;
  } else {
    startDate = 1679382000000;
  }
  if (officeObjId) {
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  } else if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  }
  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  productTable = (getObjectProperty(officeRecord, 'product_table'));
  transactionTable = (getObjectProperty(officeRecord, 'productTransaction_table'));
  snTrackingTable = (getObjectProperty(officeRecord, 'SN_tracking_table'));
  locationRecord = (await Backendless.Data.of(locationTable).findById(locationId, ));
  if (!(getObjectProperty(locationRecord, 'isTracked'))) {
    return ;
  }
  transactions = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](transactionTable, (['transaction_date>',startDate,' AND transaction_date <= ',endDate,' AND link_product = \'',productId,'\' AND (link_moved_from.objectId=\'',locationId,'\' OR link_moved_to.objectId=\'',locationId,'\')'].join('')), null, null, null, ['link_product', 'link_moved_from', 'link_moved_to']));
  productRecord = (await Backendless.Data.of(productTable).findById(productId, ));
  new_inventory_values = (await asyncListFilter((getObjectProperty(locationRecord, 'inventory')), async (item) => {


   return ((getObjectProperty(item, 'productObjId')) != productId);
  }));
  recordsAdded = (await asyncListFilter(transactions, async (item) => {


   return ((getObjectProperty(item, 'link_product.objectId')) == productId && (getObjectProperty(item, 'link_moved_to.objectId')) == locationId);
  }));
  recordsRemoved = (await asyncListFilter(transactions, async (item) => {


   return ((getObjectProperty(item, 'link_product.objectId')) == productId && (getObjectProperty(item, 'link_moved_from.objectId')) == locationId);
  }));
  if (recordsAdded.length >= 1) {
    numberAdded = (await Promise.all(recordsAdded.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
  } else {
    numberAdded = 0;
  }
  if (recordsRemoved.length >= 1) {
    numberRemoved = (await Promise.all(recordsRemoved.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
  } else {
    numberRemoved = 0;
  }
  if (getObjectProperty(productRecord, 'sn_required')) {
    snTracking = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](snTrackingTable, null, null, null, null, null));
    snRecord = null;
    for (var snRecord_index in recordsAdded) {
      snRecord = recordsAdded[snRecord_index];
      var sn_list = (getObjectProperty(snRecord, 'serial_numbers'));
      for (var sn_index in sn_list) {
        sn = sn_list[sn_index];
        snTrackRecord = (await asyncListFilter(snTracking, async (item) => {


         return ((getObjectProperty(item, 'serial_number')) == sn);
        }))[0];
        if (snTrackRecord) {
          await Backendless.Data.of(snTrackingTable).addRelation(snTrackRecord, 'link_transactions', [(getObjectProperty(snRecord, 'objectId'))]);
          if (!(getObjectProperty(snTrackRecord, 'last_moved')) || (getObjectProperty(snRecord, 'transaction_date')) > (getObjectProperty(snTrackRecord, 'last_moved'))) {
            await Backendless.Data.of(snTrackingTable).save(({ 'objectId': (getObjectProperty(snTrackRecord, 'objectId')),'location': (getObjectProperty(snRecord, 'moved_to')),'last_moved': (getObjectProperty(snRecord, 'transaction_date')) }), true);
            await Backendless.Data.of(snTrackingTable).addRelation(snTrackRecord, 'link_product', [(getObjectProperty(snRecord, 'link_product'))]);
            await Backendless.Data.of(snTrackingTable).setRelation(snTrackRecord, 'link_location', [(getObjectProperty(snRecord, 'link_moved_to'))]);
          }
        } else {
          await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('serial number not found in tracker table: ') + String(sn)));
        }
      }
    }
  } else {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('sn NOT required');
  }
  count = (getObjectProperty(productRecord, 'sn_required')) && snRecord ? (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164']((getObjectProperty(snRecord, 'link_moved_to.objectId')), officeObjId, productId)) : numberAdded - numberRemoved;
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('added ') + String(numberAdded)));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('removed ') + String(numberRemoved)));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('count is: ') + String(count)));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end getInventoryCount_locationProduct');

return count
}

})
define('./functions/90fb765ea35541d287fb79730556c53a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'] = async function fn_90fb765ea35541d287fb79730556c53a(startDate, officeObjId, locationId, productId, officeRecord, endDate) {
var locationRecord, locationTable, new_inventory_values, numberRemoved, numberAdded, snRecord, productRecord, sn, snTrackRecord, snTrackingTable, item, snTracking, recordsAdded, recordsRemoved, transactions, productTable, endDate, startDate, transactionTable, officeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start recalculateInventory_locationProduct');
  if (endDate) {
    endDate = endDate;
  } else {
    endDate = ((new Date()).valueOf());
  }
  if (startDate) {
    startDate = startDate;
  } else {
    startDate = 1679382000000;
  }
  if (officeObjId) {
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  } else if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  }
  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  productTable = (getObjectProperty(officeRecord, 'product_table'));
  transactionTable = (getObjectProperty(officeRecord, 'productTransaction_table'));
  snTrackingTable = (getObjectProperty(officeRecord, 'SN_tracking_table'));
  locationRecord = (await Backendless.Data.of(locationTable).findById(locationId, ));
  if (!(getObjectProperty(locationRecord, 'isTracked'))) {
    return ;
  }
  transactions = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](transactionTable, (['transaction_date>',startDate,' AND transaction_date <= ',endDate,' AND link_product = \'',productId,'\' AND (link_moved_from.objectId=\'',locationId,'\' OR link_moved_to.objectId=\'',locationId,'\')'].join('')), null, null, 'transaction_date', ['link_product', 'link_moved_from', 'link_moved_to']));
  productRecord = (await Backendless.Data.of(productTable).findById(productId, ));
  new_inventory_values = (await asyncListFilter((getObjectProperty(locationRecord, 'inventory')), async (item) => {


   return ((getObjectProperty(item, 'productObjId')) != productId);
  }));
  recordsAdded = (await asyncListFilter(transactions, async (item) => {


   return ((getObjectProperty(item, 'link_product.objectId')) == productId && (getObjectProperty(item, 'link_moved_to.objectId')) == locationId);
  }));
  recordsRemoved = (await asyncListFilter(transactions, async (item) => {


   return ((getObjectProperty(item, 'link_product.objectId')) == productId && (getObjectProperty(item, 'link_moved_from.objectId')) == locationId);
  }));
  if (recordsAdded.length >= 1) {
    numberAdded = (await Promise.all(recordsAdded.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
  } else {
    numberAdded = 0;
  }
  if (recordsRemoved.length >= 1) {
    numberRemoved = (await Promise.all(recordsRemoved.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
  } else {
    numberRemoved = 0;
  }
  if (getObjectProperty(productRecord, 'sn_required')) {
    snTracking = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](snTrackingTable, null, null, null, null, null));
    snRecord = null;
    for (var snRecord_index in recordsAdded) {
      snRecord = recordsAdded[snRecord_index];
      var sn_list = (getObjectProperty(snRecord, 'serial_numbers'));
      for (var sn_index in sn_list) {
        sn = sn_list[sn_index];
        snTrackRecord = (await asyncListFilter(snTracking, async (item) => {


         return ((getObjectProperty(item, 'serial_number')) == sn);
        }))[0];
        if (snTrackRecord) {
          await Backendless.Data.of(snTrackingTable).addRelation(snTrackRecord, 'link_transactions', [(getObjectProperty(snRecord, 'objectId'))]);
          if (!(getObjectProperty(snTrackRecord, 'last_moved')) || (getObjectProperty(snRecord, 'transaction_date')) > (getObjectProperty(snTrackRecord, 'last_moved'))) {
            await Backendless.Data.of(snTrackingTable).save(({ 'objectId': (getObjectProperty(snTrackRecord, 'objectId')),'location': (getObjectProperty(snRecord, 'moved_to')),'last_moved': (getObjectProperty(snRecord, 'transaction_date')) }), true);
            await Backendless.Data.of(snTrackingTable).addRelation(snTrackRecord, 'link_product', [(getObjectProperty(snRecord, 'link_product'))]);
            await Backendless.Data.of(snTrackingTable).setRelation(snTrackRecord, 'link_location', [(getObjectProperty(snRecord, 'link_moved_to'))]);
          }
        } else {
          await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('serial number not found in tracker table: ') + String(sn)));
        }
      }
    }
  } else {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('sn NOT required');
  }
  addItemToList(new_inventory_values, ({ 'productName': (getObjectProperty(productRecord, 'product_name')),'productObjId': productId,'totalItems': (getObjectProperty(productRecord, 'sn_required')) && snRecord ? (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164']((getObjectProperty(snRecord, 'link_moved_to.objectId')), officeObjId, productId)) : numberAdded - numberRemoved,'serialNumber': [] }));
  locationRecord['inventory'] = new_inventory_values;
  await Backendless.Data.of(locationTable).save(locationRecord, true);
  await BackendlessUI.Functions.Custom['fn_faed4cde7b0fc86b7964d807c2edf9d6'](null, officeRecord);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end recalculateInventory_locationProduct');

return 
}

})
define('./functions/939a67e91974f05cf52d3312ed768bb9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_939a67e91974f05cf52d3312ed768bb9'] = function fn_939a67e91974f05cf52d3312ed768bb9(totalCommissions, totalSalary, totalAdditions, totalSubtractions) {
return (totalCommissions + totalSalary + (totalAdditions - totalSubtractions))
}

})
define('./functions/9708d434efe47e9e1dbef3aad1bdef5b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9708d434efe47e9e1dbef3aad1bdef5b'] = async function fn_9708d434efe47e9e1dbef3aad1bdef5b(tableName, whereClause) {
var data, error;


  try {
    data = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setRelationsDepth(2).setPageSize(100)));

  } catch (error) {
    console.log(error);

  }

return data
}

})
define('./functions/9b1ead8d38642b24f233555a576b4ba9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9'] = async function fn_9b1ead8d38642b24f233555a576b4ba9(commissionCurrent, numRainbows) {
var commissionInfo, numRainbows, payMatrix, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting FMgetMatrix');
  commissionInfo = commissionCurrent;
  if ((typeof (getObjectProperty(commissionInfo, 'name')) === 'string') && ((getObjectProperty(commissionInfo, 'name')).indexOf('Not in system') !== -1)) {
    name2 = (getObjectProperty(commissionInfo, 'name')).slice(0, (getObjectProperty(commissionInfo, 'name')).indexOf(' - Not in system') + 1).trim();
    commissionInfo['name'] = name2;
  } else {
    name2 = (getObjectProperty(commissionInfo, 'name')).trim();
  }
  payMatrix = (await BackendlessUI.Functions.Custom['fn_6fac9f86faac3c0d1045bb024aeba0bc'](name2, (String(getObjectProperty(commissionInfo, 'systemRole')) + String('_commission'))));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](payMatrix);
  commissionInfo['payMatrix'] = payMatrix;
  if (payMatrix && payMatrix.length > 0) {
    commissionInfo['roleTitle'] = (getObjectProperty((payMatrix[0]), 'title'));
  } else {
    commissionInfo['roleTitle'] = 'UNKNOWN for this pay matrix';
  }
  if (typeof numRainbows === 'number' && !isNaN(numRainbows)) {
    numRainbows = numRainbows;
  } else {
    numRainbows = 1;
  }
  commissionInfo['numRainbows'] = numRainbows;
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end FMgetMatrix');

return commissionInfo
}

})
define('./functions/9bda0c6ad7532ccffbe898ca6634d14e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'] = async function fn_9bda0c6ad7532ccffbe898ca6634d14e(officeObjId, whereClause, sortBy, officeRecord) {
var responseObject, products, officeObjId, item, tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', officeObjId, officeRecord));
  products = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](tableName, whereClause, null, null, sortBy, 'associated_office'));
  if (typeof officeObjId === 'string') {
    responseObject = (await asyncListFilter(products, async (item) => {


     return ((getObjectProperty(item, 'associated_office.objectId')) == officeObjId);
    }));
  } else if ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()) {
    officeObjId = (getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'objectId'));
    responseObject = (await asyncListFilter(products, async (item) => {


     return ((getObjectProperty(item, 'associated_office.objectId')) == officeObjId);
    }));
  } else {
    responseObject = products;
  }

return responseObject
}

})
define('./functions/9e29f901341de3683ddee8d7cd24ae43/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9e29f901341de3683ddee8d7cd24ae43'] = async function fn_9e29f901341de3683ddee8d7cd24ae43(locationTable, locationObjId, productObjId, productName, numItems, serialNumber, serialNumberRequired, officeObjId, transactionDate) {
var totalItems, response, error, movedToRecord, inventoryMovedTo, serialNumbers, numItems, itemMatch, item, newTotalMovedTo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting addToInventory');
  movedToRecord = (await Backendless.Data.of(locationTable).findById(locationObjId, ));
  if (Array.isArray((getObjectProperty(movedToRecord, 'inventory')))) {
    inventoryMovedTo = (getObjectProperty(movedToRecord, 'inventory'));
  } else {
    inventoryMovedTo = [];
  }
  itemMatch = (await asyncListFilter(inventoryMovedTo, async (item) => {


   return ((getObjectProperty(item, 'productObjId')) == productObjId);
  }));
  if (itemMatch.length == 1) {
    itemMatch = itemMatch[0];
    newTotalMovedTo = (getObjectProperty(itemMatch, 'totalItems')) + numItems;
    inventoryMovedTo = (await asyncListFilter(inventoryMovedTo, async (item) => {


     return ((getObjectProperty(item, 'productObjId')) != productObjId);
    }));
    if (serialNumberRequired) {
      totalItems = (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164'](locationObjId, officeObjId, productObjId));
    } else {
      totalItems = (getObjectProperty(itemMatch, 'totalItems')) + numItems;
    }
    addItemToList(inventoryMovedTo, ({ 'productObjId': productObjId,'productName': productName,'serialNumber': undefined,'totalItems': totalItems }));
  } else if (itemMatch.length == 0) {
    totalItems = numItems;
    if (serialNumberRequired) {
      totalItems = (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164'](locationObjId, officeObjId, productObjId));
    } else {
      totalItems = numItems;
    }
    addItemToList(inventoryMovedTo, ({ 'productObjId': productObjId,'productName': productName,'serialNumber': undefined,'totalItems': totalItems }));
  } else {
    response = [locationObjId,' has multiple instances of',productObjId,'Contact support'].join('');
    return response;
  }
  await Backendless.Data.of(locationTable).save(({ 'objectId': locationObjId,'inventory': inventoryMovedTo }), true);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('ending addToInventory');

return ({ 'response': response,'newTotal': totalItems })
}

})
define('./functions/a0837f297641414fd0bcf123e39278df/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a0837f297641414fd0bcf123e39278df'] = function fn_a0837f297641414fd0bcf123e39278df(feePercent, selectedTerm, selectedRecord) {
var updatedFees, feeCalculation, financeFees, totalSale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  financeFees = (getObjectProperty(selectedRecord, 'financeFees'));
  totalSale = (getObjectProperty(selectedRecord, 'financeAmount'));
  feeCalculation = Math.round(feePercent * totalSale) / 100;
  if (financeFees.length > 0) {
    updatedFees = (financeFees.concat([({ 'feeName': selectedTerm,'feeAmount': feeCalculation })]));
  } else {
    updatedFees = [({ 'feeName': selectedTerm,'feeAmount': feeCalculation })];
  }

return updatedFees
}

})
define('./functions/a3b48c95568c3e451a6f8842f9637ed7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a3b48c95568c3e451a6f8842f9637ed7'] = async function fn_a3b48c95568c3e451a6f8842f9637ed7(dealerName, role, amount, salesRecordId, link_to_payroll, ok2pay, paydate, saleType, customerFirstName, customerLastName, orderNumber) {
var new_payroll_record, commissionsObject, existing_payroll_record;


  commissionsObject = ({ 'role': role,'amount': amount,'sale': salesRecordId,'customer': [customerFirstName,' ',customerLastName].join(''),'saleType': saleType,'orderNumber': orderNumber });
  if (amount > 0 && !(dealerName.indexOf('Not in system') !== -1) && (typeof dealerName === 'string')) {
    if (link_to_payroll == null && ok2pay == true) {
      // Look for an existing record for this dealer and paydate
      existing_payroll_record = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name=\'',dealerName,'\' and pay_date=\'',paydate,'\''].join(''))).setPageSize(10)));
      if (existing_payroll_record.length == 0) {
        // Create a new payroll record
        new_payroll_record = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save( ({ 'dealer_name': dealerName,'pay_date': paydate,'commissions_total': amount,'commissions_detail': [commissionsObject],'reductions_detail': [],'additions_detail': [],'payroll_ID': (await BackendlessUI.Functions.Custom['fn_dfde89045fdd53560e581c5cc2bd3889'](null)) }) ));
      } else if (existing_payroll_record.length == 1) {
        new_payroll_record = (await BackendlessUI.Functions.Custom['fn_413437279b2503eebc95c8920f79642e']((existing_payroll_record[0]), commissionsObject));
      } else {
        console.log('issue with payroll record -- too many exist for dealer');
        console.log(dealerName);
        console.log(paydate);
      }
    } else if (link_to_payroll != null && ok2pay == true) {
      new_payroll_record = (await BackendlessUI.Functions.Custom['fn_413437279b2503eebc95c8920f79642e'](link_to_payroll, commissionsObject));
    }
  } else {
    console.log(['skipping payroll record for ',dealerName,' and ',amount].join(''));
  }

return new_payroll_record
}

})
define('./functions/aec65d423c67f1aafe1934852e0c9d6a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_aec65d423c67f1aafe1934852e0c9d6a'] = async function fn_aec65d423c67f1aafe1934852e0c9d6a(officeRecord) {
var passedCheck, response, table, j, matchingField, item, schema, requiredFields, comparisonOffice, tablesToCheck, checklist_inventory;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  checklist_inventory = (getObjectProperty(officeRecord, 'checklist_inventory'));
  response = '';
  tablesToCheck = ['location_table', 'product_table', 'productTransaction_table', 'SN_tracking_table', 'discrepancy_table', 'salesInvoice_table', 'salesCalculations_table'];
  comparisonOffice = (await Backendless.Data.of('Offices').findById('5725271F-D1C9-4A34-8C64-A01A5D67E1A7', ));
  for (var table_index in tablesToCheck) {
    table = tablesToCheck[table_index];
    if (getObjectProperty(officeRecord, table)) {
      schema = (await Backendless.Data.describe( (getObjectProperty(officeRecord, table)) ));
      requiredFields = (await Backendless.Data.describe( (getObjectProperty(comparisonOffice, table)) ));
      for (var j_index in requiredFields) {
        j = requiredFields[j_index];
        matchingField = (await asyncListFilter(schema, async (item) => {


         return ((getObjectProperty(item, 'name')) == (getObjectProperty(j, 'name')));
        }));
        if (matchingField.length == 1) {
          if ((getObjectProperty((matchingField[0]), 'type')) != (getObjectProperty(j, 'type'))) {
            response = [response,'<br/>','field ','',(getObjectProperty(j, 'name')),'',' should be of type ',(getObjectProperty(j, 'type')),' in table ',(getObjectProperty(officeRecord, table))].join('');
          }
        } else {
          response = [response,'<br/>',(getObjectProperty(officeRecord, table)),' is missing field ','<em>',(getObjectProperty(j, 'name')),'</em>',' with type ',(getObjectProperty(j, 'type'))].join('');
        }
      }
    } else {
      response = [response,'<br/>',table,' is missing'].join('');
    }
  }
  if (response == '') {
    response = 'Tables are set up correctly';
    passedCheck = true;
  } else {
    passedCheck = false;
  }

return ({ 'response': response,'passedCheck': passedCheck })
}

})
define('./functions/afc28d72ffbe4d877f09ad3d7ab58e88/code.js', () => { 

BackendlessUI.Functions.Custom['fn_afc28d72ffbe4d877f09ad3d7ab58e88'] = async function fn_afc28d72ffbe4d877f09ad3d7ab58e88(tableName, nextSteps) {
var nextSteps, exampleToCreateTable;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('start addTable_dealers');
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](tableName);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((await Backendless.Data.describe( tableName )));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](((await Backendless.Data.describe( tableName )) !== null && !Array.isArray((await Backendless.Data.describe( tableName ))) && (typeof (await Backendless.Data.describe( tableName )) === 'object')));
  if (!((await Backendless.Data.describe( tableName )) !== null && !Array.isArray((await Backendless.Data.describe( tableName ))) && (typeof (await Backendless.Data.describe( tableName )) === 'object'))) {
    exampleToCreateTable = (await Backendless.Data.of(tableName).save( ({ 'dealer_nameFirst': 'Example','dealer_active': false,'dealer_nameLast': 'Dealer','is_team_leader': false,'dealer_email': 'example@example.com','dealer_name': 'Example','dealer_id': 'example@example.com','office': undefined }) ));
    await Backendless.Data.of(tableName).remove( exampleToCreateTable );
    addItemToList(nextSteps, ({ 'tableName': tableName,'instructions': [({ 'fieldName': 'associated_office','type': 'data relation -- 1:1 with Offices' }), ({ 'fieldName': 'current_matrix_level','type': 'data relation 1:1 with Payroll_matrix or similar' })] }));
  }
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('end addTable_dealers');

return nextSteps
}

})
define('./functions/b1613dddc54e5673f11e27957ab79d26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b1613dddc54e5673f11e27957ab79d26'] = async function fn_b1613dddc54e5673f11e27957ab79d26(locationId, productIds, locationTableName) {
var response, j, productList, inventoryRecord, item, inventory, locationTable, numItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  numItems = 0;
  locationTable = (typeof locationTableName === 'string') ? locationTableName : 'Locations';
  productList = (Array.isArray(productIds)) ? productIds : [productIds];
  inventory = (getObjectProperty((await Backendless.Data.of(locationTable).findById(locationId, )), 'inventory'));
  response = [];
  if (inventory != null) {
    for (var j_index in productList) {
      j = productList[j_index];
      inventoryRecord = (await asyncListFilter(inventory, async (item) => {


       return ((getObjectProperty(item, 'productObjId')) == j);
      }));
      if (inventoryRecord != null && inventoryRecord.length == 1) {
        addItemToList(response, ({ 'productName': (getObjectProperty(inventoryRecord, 'productName')),'productId': j,'numItems': (getObjectProperty((inventoryRecord[0]), 'totalItems')) }));
      } else {
        addItemToList(response, ({ 'productName': undefined,'productId': j,'numItems': 0 }));
      }
    }
  } else {
    for (var j_index2 in productList) {
      j = productList[j_index2];
      addItemToList(response, ({ 'productName': undefined,'productObjId': j,'numItems': 0 }));
    }
  }

return response
}

})
define('./functions/b2ee32db10714ec4625687ae269b7496/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496'] = function fn_b2ee32db10714ec4625687ae269b7496() {

}

})
define('./functions/b40438df16512717d48fd803581b8e33/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b40438df16512717d48fd803581b8e33'] = async function fn_b40438df16512717d48fd803581b8e33(movedFromInventory, movedToInventory, serialNumRequired, serialNum, numItems, trackFrom, trackTo, productName, productObjId, movedFromName, movedToName, debug) {
var response, itemMatch, item, inventoryMovedTo, numItems, sn, serialNumTrackingRecord, availableSns, inventoryMovedFrom;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting checkInventoryMovement');
  if (serialNumRequired && serialNum == null) {
    response = 'Serial Number required for this item';
    return response;
  }
  response = '';
  if (!trackFrom) {
    return response;
  }
  numItems = numItems;
  if (typeof numItems === 'string') {
    numItems = (Number(numItems));
  }
  if (Array.isArray(movedFromInventory)) {
    inventoryMovedFrom = movedFromInventory;
  } else {
    inventoryMovedFrom = [];
  }
  if (serialNumRequired) {
    if (!(await BackendlessUI.Functions.Custom['fn_2605a3d4b683f8d1225355d4b737f1fd'](serialNum))) {
      response = 'Invalid serial number';
      return response;
    }
    if (trackFrom) {
      for (var sn_index in serialNum) {
        sn = serialNum[sn_index];
        if ((await Backendless.Data.of((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'SN_tracking_table'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['location=\'',movedFromName,'\' AND serial_number = \'',sn.trim(),'\''].join(''))))) == 0) {
          response = [response,'Serial Number ',sn,' not found in ',movedFromName,''].join('');
        }
      }
    }
  } else {
    if (trackFrom) {
      itemMatch = (await asyncListFilter(movedFromInventory, async (item) => {


       return ((getObjectProperty(item, 'productObjId')) == productObjId);
      }));
      if (itemMatch.length == 1) {
        itemMatch = itemMatch[0];
        if ((getObjectProperty(itemMatch, 'totalItems')) < numItems) {
          response = [movedFromName,' only has ',(getObjectProperty(itemMatch, 'totalItems')),' ',productName].join('');
          return response;
        }
      } else if (itemMatch.length == 0) {
        response = [movedFromName,' has no items of type ',productName].join('');
        return response;
      } else {
        response = [movedFromName,' has multiple instances of ',productName,' Contact support'].join('');
        return response;
      }
    }
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('ending checkInventoryMovement');

return response
}

})
define('./functions/b63225430b312e4ac3cc4779a9f22a4d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b63225430b312e4ac3cc4779a9f22a4d'] = async function fn_b63225430b312e4ac3cc4779a9f22a4d(startDate, endDate, payDate, dealerName) {
var returnData, approvedForDealerPage, asSetby, asClosed, asManager, asDealer, item, all_sales, j, approved_sales, verdict, itemPaydate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  returnData = [];
  all_sales = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findSalesWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((['(sales_date >\'',startDate,'\' AND sales_date <\'',endDate,'\') OR link_to_calculations.payperiod = \'',payDate,'\''].join('')))));
  approved_sales = (await asyncListFilter(all_sales, async (item) => {
     verdict = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay'));
    itemPaydate = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'payperiod'));
    if ((itemPaydate === null) || (verdict === null)) {
      verdict = false;
    } else {
      if (itemPaydate != payDate) {
        verdict = false;
      }
    }


   return verdict;
  }));
  approvedForDealerPage = [];
  asDealer = (await Promise.all((await asyncListFilter(approved_sales, async (item) => {


   return ((getObjectProperty(item, 'dealer_name')) == dealerName);
  })).map(async item => {  item['role'] = 'Dealer';
    item['commission'] = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'dealer_commission'));
  ; return item;})));
  for (var j_index in asDealer) {
    j = asDealer[j_index];
    addItemToList(approvedForDealerPage, ({ 'dateOfSale': (getObjectProperty(j, 'Sales_date_str')),'customer': (getObjectProperty(j, 'cust_name')),'orderNumber': (getObjectProperty(j, 'order_number')),'totalSale': (getObjectProperty(j, 'sale_total_with_tax')),'financedAmount': (getObjectProperty(j, 'finance_amount')),'financeFee': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'finance_fees_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_type')),'amount': (getObjectProperty(j, 'commission')),'role': (getObjectProperty(j, 'role')),'invoiceObjectId': (getObjectProperty(j, 'objectId')) }));
  }
  asManager = (await Promise.all((await asyncListFilter(approved_sales, async (item) => {


   return ((getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'manager_commission')) > 0 && (getObjectProperty(item, 'manager_name')) == dealerName);
  })).map(async item => {  item['role'] = 'Manager';
    item['commission'] = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'manager_commission'));
  ; return item;})));
  for (var j_index2 in asManager) {
    j = asManager[j_index2];
    addItemToList(approvedForDealerPage, ({ 'dateOfSale': (getObjectProperty(j, 'Sales_date_str')),'customer': (getObjectProperty(j, 'cust_name')),'orderNumber': (getObjectProperty(j, 'order_number')),'totalSale': (getObjectProperty(j, 'sale_total_with_tax')),'financedAmount': (getObjectProperty(j, 'finance_amount')),'financeFee': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'finance_fees_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_type')),'amount': (getObjectProperty(j, 'commission')),'role': (getObjectProperty(j, 'role')),'invoiceObjectId': (getObjectProperty(j, 'objectId')) }));
  }
  asClosed = (await Promise.all((await asyncListFilter(approved_sales, async (item) => {


   return ((getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'who_closed_commission')) > 0 && (getObjectProperty(item, 'who_closed_sale')) == dealerName);
  })).map(async item => {  item['role'] = 'Closed';
    item['commission'] = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'who_closed_commission'));
  ; return item;})));
  for (var j_index3 in asClosed) {
    j = asClosed[j_index3];
    addItemToList(approvedForDealerPage, ({ 'dateOfSale': (getObjectProperty(j, 'Sales_date_str')),'customer': (getObjectProperty(j, 'cust_name')),'orderNumber': (getObjectProperty(j, 'order_number')),'totalSale': (getObjectProperty(j, 'sale_total_with_tax')),'financedAmount': (getObjectProperty(j, 'finance_amount')),'financeFee': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'finance_fees_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_type')),'amount': (getObjectProperty(j, 'commission')),'role': (getObjectProperty(j, 'role')),'invoiceObjectId': (getObjectProperty(j, 'objectId')) }));
  }
  asSetby = (await Promise.all((await asyncListFilter(approved_sales, async (item) => {


   return ((getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'setby_commission')) > 0 && (getObjectProperty(item, 'setby_name')) == dealerName);
  })).map(async item => {  item['role'] = 'Setby';
    item['commission'] = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'setby_commission'));
  ; return item;})));
  for (var j_index4 in asSetby) {
    j = asSetby[j_index4];
    addItemToList(approvedForDealerPage, ({ 'dateOfSale': (getObjectProperty(j, 'Sales_date_str')),'customer': (getObjectProperty(j, 'cust_name')),'orderNumber': (getObjectProperty(j, 'order_number')),'totalSale': (getObjectProperty(j, 'sale_total_with_tax')),'financedAmount': (getObjectProperty(j, 'finance_amount')),'financeFee': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'finance_fees_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_type')),'amount': (getObjectProperty(j, 'commission')),'role': (getObjectProperty(j, 'role')),'invoiceObjectId': (getObjectProperty(j, 'objectId')) }));
  }
  returnData['unapprovedSales'] = (await asyncListFilter(all_sales, async (item) => {


   return ((getObjectProperty(item, 'dealer_name')) == dealerName && !(getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay')));
  }));
  returnData['approvedSales'] = approvedForDealerPage;
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();

return returnData
}

})
define('./functions/be1ad52fd21ec3d76e23635da0e6aca6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6'] = function fn_be1ad52fd21ec3d76e23635da0e6aca6(objList2convert, valueField, labelField) {
var selectorObject, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  selectorObject = [];
  for (var j_index in objList2convert) {
    j = objList2convert[j_index];
    addItemToList(selectorObject, ({ 'label': (getObjectProperty(j, labelField)),'value': (getObjectProperty(j, valueField)) }));
  }

return selectorObject
}

})
define('./functions/c0128ed7920ab883576b8d79a0dac2cb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb'] = async function fn_c0128ed7920ab883576b8d79a0dac2cb(date) {
return ([(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd']((new Date(date).getMonth() + 1))),' ',(new Date(date).getDate()),', ',(new Date(date).getFullYear())].join(''))
}

})
define('./functions/c65b588280452c4e9eb6152982cbb2cb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c65b588280452c4e9eb6152982cbb2cb'] = async function fn_c65b588280452c4e9eb6152982cbb2cb(selectedRecord) {
var returnObject, val, totalAfterCosts, allCosts, item, currentPayDate, payDates, j, link_to_D3_payroll, link_to_D4_payroll, link_to_D2_payroll, link_to_D1_payroll, productAddonCosts, setbyCommission, closedCommission, dealerCommission, managerCommission, whoClosedName, link_to_D6_payroll, calc_record, link_to_D5_payroll, created_object;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await Backendless.Data.of('Sales_invoice_version_history').save(selectedRecord, true);
  // There should always be an associated "link_to_calculations"
  // record, but if not, one is created and linked here
  if ((getObjectProperty(selectedRecord, 'link_to_calculations')) == null) {
    ;(async () => {
        created_object = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesCalculations_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(({ 'Order_number': (getObjectProperty(selectedRecord, 'order_number')) }), true));
      await Backendless.Data.of('Sales_invoice').addRelation((getObjectProperty(selectedRecord, 'objectId')), 'link_to_calculations', [(getObjectProperty(created_object, 'objectId'))]);

    })();
  } else {
    calc_record = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesCalculations_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).findById((getObjectProperty(selectedRecord, 'link_to_calculations.objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(1)));
    await Backendless.Data.of('Sales_calculations_version_history').save(calc_record, true);
  }
  if ((getObjectProperty(calc_record, 'link_to_D1_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D1_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D1_payroll')) === 'object')) {
    link_to_D1_payroll = (getObjectProperty((getObjectProperty(calc_record, 'link_to_D1_payroll')), 'objectId'));
  } else {
    link_to_D1_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D2_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D2_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D2_payroll')) === 'object')) {
    link_to_D2_payroll = (getObjectProperty((getObjectProperty(calc_record, 'link_to_D2_payroll')), 'objectId'));
  } else {
    link_to_D2_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D4_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D4_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D4_payroll')) === 'object')) {
    link_to_D4_payroll = (getObjectProperty((getObjectProperty(calc_record, 'link_to_D4_payroll')), 'objectId'));
  } else {
    link_to_D4_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D3_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D3_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D3_payroll')) === 'object')) {
    link_to_D3_payroll = (getObjectProperty((getObjectProperty(calc_record, 'link_to_D3_payroll')), 'objectId'));
  } else {
    link_to_D3_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D5_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D5_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D5_payroll')) === 'object')) {
    link_to_D5_payroll = (getObjectProperty((getObjectProperty(calc_record, 'link_to_D5_payroll')), 'objectId'));
  } else {
    link_to_D5_payroll = null;
  }
  if ((getObjectProperty(calc_record, 'link_to_D6_payroll')) !== null && !Array.isArray((getObjectProperty(calc_record, 'link_to_D6_payroll'))) && (typeof (getObjectProperty(calc_record, 'link_to_D6_payroll')) === 'object')) {
    link_to_D6_payroll = (getObjectProperty((getObjectProperty(calc_record, 'link_to_D6_payroll')), 'objectId'));
  } else {
    link_to_D6_payroll = null;
  }
  productAddonCosts = (await BackendlessUI.Functions.Custom['fn_28d64cea9a03167e67c1c5c26fde2bc4']((getObjectProperty(selectedRecord, 'objectId'))));
  whoClosedName = (getObjectProperty(selectedRecord, 'who_closed_sale'));
  closedCommission = (await BackendlessUI.Functions.Custom['fn_6864cf32f303c81f8dd5e9e784d39d7d']('closed', (getObjectProperty(selectedRecord, 'who_closed_sale')), (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'who_closed_commission')), (getObjectProperty(selectedRecord, 'rainbow_count'))));
  dealerCommission = (await BackendlessUI.Functions.Custom['fn_6864cf32f303c81f8dd5e9e784d39d7d']('dealer', (getObjectProperty(selectedRecord, 'dealer_name')), (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'dealer_commission')), (getObjectProperty(selectedRecord, 'rainbow_count'))));
  managerCommission = (await BackendlessUI.Functions.Custom['fn_6864cf32f303c81f8dd5e9e784d39d7d']('manager', (getObjectProperty(selectedRecord, 'manager_name')), (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'manager_commission')), (getObjectProperty(selectedRecord, 'rainbow_count'))));
  setbyCommission = (await BackendlessUI.Functions.Custom['fn_6864cf32f303c81f8dd5e9e784d39d7d']('setby', (getObjectProperty(selectedRecord, 'setby_name')), (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'setby_commission')), (getObjectProperty(selectedRecord, 'rainbow_count'))));
  returnObject = ({ 'dealerName': (getObjectProperty(dealerCommission, 'name')),'managerName': (getObjectProperty(managerCommission, 'name')),'whoClosedName': (getObjectProperty(closedCommission, 'name')),'setbyName': (getObjectProperty(setbyCommission, 'name')),'dealerCommission': (getObjectProperty(dealerCommission, 'current')),'dealerCommissionAB': (getObjectProperty(dealerCommission, 'AB')),'dealerCommissionC': (getObjectProperty(dealerCommission, 'C')),'managerCommission': (getObjectProperty(managerCommission, 'current')),'managerCommissionAB': (getObjectProperty(managerCommission, 'AB')),'managerCommissionC': (getObjectProperty(managerCommission, 'C')),'whoClosedCommission': (getObjectProperty(closedCommission, 'name')) == (getObjectProperty(dealerCommission, 'name')) ? 0 : (getObjectProperty(closedCommission, 'current')),'setbyCommission': (getObjectProperty(setbyCommission, 'current')),'saleType': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'sale_type')),'paymentAmount': (getObjectProperty(selectedRecord, 'payment_amount')),'financeCompany': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_company')),'salesTaxPerc': (getObjectProperty(selectedRecord, 'sales_tax_percent')),'dateOfSale': (getObjectProperty(selectedRecord, 'sales_date')),'bumpPercentage': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'bump_percentage')),'bumpAmount': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'bump_amount')),'receivedPayment': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'received_payment')),'dateReceivedPayment': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'date_received_payment')),'downMethod': (getObjectProperty(selectedRecord, 'down_method')),'paymentMethod': (getObjectProperty(selectedRecord, 'payment_method')),'ccfee': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'creditcard_Fee')),'receivedDown': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'received_down')),'dateReceivedDown': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'date_received_down')),'dateReceivedFinance': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'date_received_finance')),'receivedFinance': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'received_finance')),'needPayment': (getObjectProperty(selectedRecord, 'payment_amount')) > 0,'needDown': (getObjectProperty(selectedRecord, 'down_total')) > 0,'needFinance': (getObjectProperty(selectedRecord, 'finance_amount')) > 0,'custFname': (getObjectProperty(selectedRecord, 'cust_fname')),'custLname': (getObjectProperty(selectedRecord, 'cust_lname')),'rainbowPrice': (getObjectProperty(selectedRecord, 'rainbow_price')),'additionalProducts': (getObjectProperty(selectedRecord, 'add_products_total')),'addonPrice': (getObjectProperty(productAddonCosts, 'addonRev')),'total_wo_tax': (getObjectProperty(selectedRecord, 'sale_total_wo_tax')),'salesTax': (getObjectProperty(selectedRecord, 'sales_tax')),'total_w_tax': (getObjectProperty(selectedRecord, 'sale_total_with_tax')),'downTotal': (getObjectProperty(selectedRecord, 'down_total')),'financeAmount': (getObjectProperty(selectedRecord, 'finance_amount')),'payDate': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'payperiod')) != null ? (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'payperiod')))) : null,'ok2pay_original': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'ok2pay')),'ok2pay': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'ok2pay')),'productCost': (getObjectProperty(productAddonCosts, 'totalProductCost')),'numPayments': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'num_payments')),'firstPaymentDue': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'first_payment_due')),'monthlyPaymentAmount': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'monthly_payment_amount')),'APR': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'APR')),'deferredFee': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'deferred_fee')),'totalFinanceFee': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_fees_total')),'calcObjectId': (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'objectId')),'invoiceObjectId': (getObjectProperty(selectedRecord, 'objectId')),'link_to_dealer_payroll': link_to_D1_payroll,'link_to_manager_payroll': link_to_D2_payroll,'link_to_closed_payroll': link_to_D4_payroll,'link_to_setby_payroll': link_to_D3_payroll,'orderNumber': (getObjectProperty(selectedRecord, 'order_number')),'payment_method': (getObjectProperty(selectedRecord, 'payment_method')),'cancel_date': (getObjectProperty(selectedRecord, 'cancel_date')),'sale_cancelled': (getObjectProperty(selectedRecord, 'sale_cancelled')),'paymentReceived': (getObjectProperty(selectedRecord, 'payment_method')) == 'Check' || (getObjectProperty(selectedRecord, 'payment_method')) == 'Cash' || (getObjectProperty(selectedRecord, 'payment_method')) == 'Credit Card' });
  if ((getObjectProperty(returnObject, 'payDate')) != null) {
    returnObject['currentPaydateExists'] = true;
  } else {
    returnObject['currentPaydateExists'] = false;
  }
  if (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_fees_detail')) {
    returnObject['financeFees'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_fees_detail'));
    returnObject['netSaleTotal'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'netTotal'));
    returnObject['ok2pay'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'ok2pay'));
    returnObject['payDate'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'payperiod'));
    returnObject['financeCompany'] = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'finance_company'));
  } else {
    returnObject['financeFees'] = [];
    returnObject['netSaleTotal'] = (getObjectProperty(selectedRecord, 'finance_amount'));
  }
  returnObject['netSaleMinusTax'] = ((getObjectProperty(returnObject, 'netSaleTotal')) - (getObjectProperty(returnObject, 'salesTax')));
  payDates = [];
  var j_list = (await BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091']((['pay_date>\'',((new Date((new Date()).getTime() - ((1 * 86400) * 1000))).valueOf()),'\''].join(''))));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(payDates, ({ 'value': (Number((getObjectProperty(j, 'payDate')))),'label': (getObjectProperty(j, 'payDateDisplay')) }));
  }
  currentPayDate = (await asyncListFilter(payDates, async (item) => {


   return ((getObjectProperty(item, 'value')) == (getObjectProperty(returnObject, 'payDate')));
  }));
  if (currentPayDate.length == 0) {
    currentPayDate = (getObjectProperty((payDates[0]), 'value'));
  } else {
    currentPayDate = (getObjectProperty((currentPayDate[0]), 'value'));
  }
  returnObject['payDates'] = payDates;
  returnObject['currentPayDate'] = currentPayDate;
  returnObject['message'] = '';
  returnObject['financeCompanyOptions'] = (await Promise.all((await Backendless.Data.of('Finance_fees').find(Backendless.DataQueryBuilder.create().setWhereClause((String('Active = True'))).setGroupBy('Company').setPageSize(10))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Company')),'value': (getObjectProperty(item, 'Company')) });})));
  returnObject['financeTermsOptions'] = [];
  totalAfterCosts = (getObjectProperty((getObjectProperty(selectedRecord, 'link_to_calculations')), 'total_after_costs'));
  if (totalAfterCosts == 0) {
    allCosts = (await BackendlessUI.Functions.Custom['fn_884bd43441923ffdbc69ddfef4eb3f85'](returnObject));
    if ((getObjectProperty(selectedRecord, 'finance_amount')) != 0) {
      totalAfterCosts = ((getObjectProperty(selectedRecord, 'finance_amount')) + (Number((getObjectProperty(selectedRecord, 'down_total'))))) - allCosts;
    } else {
      totalAfterCosts = (getObjectProperty(selectedRecord, 'payment_amount')) - allCosts;
    }
  }
  returnObject['totalAfterCosts'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b'](totalAfterCosts));
  if ((getObjectProperty(selectedRecord, 'finance_amount')) == 0) {
    returnObject['saleType'] = 'A Sale';
    returnObject['displayFinance'] = false;
  } else {
    returnObject['displayFinance'] = true;
  }
  val = true;
  if ((getObjectProperty(returnObject, 'needFinance')) && !(getObjectProperty(returnObject, 'receivedFinance'))) {
    val = false;
  }
  if ((getObjectProperty(returnObject, 'needDown')) && !(getObjectProperty(returnObject, 'receivedDown'))) {
    val = false;
  }
  if ((getObjectProperty(returnObject, 'needPayment')) && !(getObjectProperty(returnObject, 'receivedPayment'))) {
    val = false;
  }
  returnObject['allowOk'] = (!val);
  if ((getObjectProperty(returnObject, 'sale_cancelled')) == true) {
    returnObject['displayCancelledSale'] = true;
  } else {
    returnObject['displayCancelledSale'] = false;
  }
  returnObject['lockSalesEdit'] = true;

return returnObject
}

})
define('./functions/c8584fefd6c6c4f49461f14bda9ff8f7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7'] = async function fn_c8584fefd6c6c4f49461f14bda9ff8f7(whereObject) {
var combinedWhere, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  combinedWhere = [];
  for (var j_index in whereObject) {
    j = whereObject[j_index];
    if (getObjectProperty(j, 'value')) {
      if ((getObjectProperty(j, 'comparison')).toLowerCase().trim() == 'like') {
        addItemToList(combinedWhere, ([(getObjectProperty(j, 'property')),' LIKE \'%',(getObjectProperty(j, 'value')),'%\''].join('')));
      } else {
        addItemToList(combinedWhere, ([(getObjectProperty(j, 'property')),' ',(getObjectProperty(j, 'comparison')),'\' ',(getObjectProperty(j, 'value')),'\''].join('')));
      }
    }
  }
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((combinedWhere.join(' AND ')));

return (combinedWhere.join(' AND '))
}

})
define('./functions/ce6a7744410fa122d5ca861572a6cbf6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6'] = async function fn_ce6a7744410fa122d5ca861572a6cbf6(tableName, dataModel, whereClause, propertiesToInclude, propertiesToExclude, propertiesToSortBy, relations) {
var loadedData, offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function init_offset_var() {
  offset = (getObjectProperty(dataModel, 'offset'));
  if (offset == null) {
    offset = 0;
  }
}

/**
 * Describe this function...
 */
async function load_data() {
  loadedData = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties(propertiesToInclude).excludeProperties(propertiesToExclude).setRelated(relations).setSortBy(propertiesToSortBy).setPageSize(100).setOffset(offset)));
}

/**
 * Describe this function...
 */
async function adjust_page_data_state() {
  if (loadedData.length < 100) {
    dataModel['loadingData'] = false;
  } else {
    dataModel['offset'] = (offset + loadedData.length);
  }
}


  await init_offset_var();
  await load_data();
  await adjust_page_data_state();

return loadedData
}

})
define('./functions/d12e99a80bd1fd1fbc2ced1a87712091/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091'] = async function fn_d12e99a80bd1fd1fbc2ced1a87712091(where) {
var returnVal, j, payDateDisplay, pay_date, endDateDisplay, end_date, startDateDisplay, start_date, pay_periods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  pay_periods = (await Backendless.Data.of('Pay_periods').find(Backendless.DataQueryBuilder.create().setWhereClause(where).setSortBy('pay_date').setPageSize(100)));
  returnVal = [];
  for (var j_index in pay_periods) {
    j = pay_periods[j_index];
    start_date = (getObjectProperty(j, 'start_date'));
    startDateDisplay = [(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd']((new Date(start_date).getMonth() + 1))),' ',(new Date(start_date).getDate())].join('');
    end_date = (getObjectProperty(j, 'end_date'));
    endDateDisplay = [(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd']((new Date(end_date).getMonth() + 1))),' ',(new Date(end_date).getDate())].join('');
    pay_date = (getObjectProperty(j, 'pay_date'));
    payDateDisplay = [(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd']((new Date(pay_date).getMonth() + 1))),' ',(new Date(pay_date).getDate())].join('');
    addItemToList(returnVal, ({ 'startDate': start_date,'startDateDisplay': startDateDisplay,'endDate': end_date,'endDateDisplay': endDateDisplay,'payDate': pay_date,'payDateDisplay': payDateDisplay,'objectId': (getObjectProperty(j, 'objectId')) }));
  }

return returnVal
}

})
define('./functions/d3828f6bb624eb8418cbf8fd6d9b5fd3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d3828f6bb624eb8418cbf8fd6d9b5fd3'] = async function fn_d3828f6bb624eb8418cbf8fd6d9b5fd3(selectedSale) {
var info, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  for (i = 1; i <= 6; i++) {
    info = ['D',i,'info'].join('');
    if ((getObjectProperty(selectedSale, (['D',i,'info.name'].join('')))).length > 2) {
      selectedSale[(['D',i,'info'].join(''))] = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((getObjectProperty(selectedSale, info)), (getObjectProperty(selectedSale, 'paidPercentage'))));
    }
  }

return selectedSale
}

})
define('./functions/d4a180ee751ffbb1c299dee78e24f237/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d4a180ee751ffbb1c299dee78e24f237'] = function fn_d4a180ee751ffbb1c299dee78e24f237(x) {
return ((typeof x === 'number' && !isNaN(x)) || (typeof x === 'string') ? x : 1)
}

})
define('./functions/d83e9234cec8c604b9329622d4ea1807/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d83e9234cec8c604b9329622d4ea1807'] = async function fn_d83e9234cec8c604b9329622d4ea1807(startDate, endDate, payDate, dealerName) {
var all_sales, allApprovedSales, approvedSales, asClosed, asManager, asSetby, i, item, itemPaydate, j, returnData, verdict, withDinfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](startDate);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](endDate);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](payDate);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](dealerName);
  returnData = [];
  all_sales = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['(sales_date >\'',startDate,'\' AND sales_date <\'',endDate,'\') OR link_to_calculations.payperiod = \'',payDate,'\''].join('')), null, null, null, 'link_to_calculations'));
  allApprovedSales = (await asyncListFilter(all_sales, async (item) => {
     if (!(getObjectProperty(item, 'link_to_calculations'))) {
      verdict = false;
    } else {
      verdict = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay'));
      itemPaydate = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'payperiod'));
      if ((getObjectProperty(item, 'cust_lname')) == 'Payne') {
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(item, 'cust_lname')));
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](itemPaydate);
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](verdict);
      }
      if ((itemPaydate === null) || (verdict === null)) {
        verdict = false;
      } else {
        if (itemPaydate != payDate) {
          verdict = false;
        }
      }
    }


   return verdict;
  }));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](allApprovedSales);
  approvedSales = [];
  for (i = 1; i <= 6; i++) {
    withDinfo = (await Promise.all((await asyncListFilter(allApprovedSales, async (item) => {


     return ((getObjectProperty(item, (['link_to_calculations.commissions_detail.D',i,'.name'].join('')))) == dealerName);
    })).map(async item => {  item['role'] = (getObjectProperty(item, (['link_to_calculations.commissions_detail.D',i,'.roleTitle'].join(''))));
      item['amount'] = (getObjectProperty(item, (['link_to_calculations.commissions_detail.D',i,'.amount'].join(''))));
      item['saleType'] = (getObjectProperty(item, (['link_to_calculations.commissions_detail.D',i,'.saleType'].join(''))));
    ; return item;})));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('With Dinfo : ');
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](withDinfo);
    for (var j_index in withDinfo) {
      j = withDinfo[j_index];
      addItemToList(approvedSales, ({ 'dateOfSale': (getObjectProperty(j, 'Sales_date_str')),'customer': (getObjectProperty(j, 'cust_name')),'orderNumber': (getObjectProperty(j, 'order_number')),'totalSale': (getObjectProperty(j, 'sale_total_with_tax')),'financedAmount': (getObjectProperty(j, 'finance_amount')),'financeFee': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'finance_fees_total')),'saleType': (getObjectProperty(j, 'saleType')),'amount': (getObjectProperty(j, 'amount')),'role': (getObjectProperty(j, 'role')),'invoiceObjectId': (getObjectProperty(j, 'objectId')) }));
    }
    returnData['unapprovedSales'] = (await asyncListFilter(all_sales, async (item) => {


     return ((getObjectProperty(item, 'dealer_name')) == dealerName && !(getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay')));
    }));
    returnData['approvedSales'] = (await asyncListSort(approvedSales, 1, async (item) => {


     return (getObjectProperty(item, 'dateOfSale'));
    }));
    await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  }

return returnData
}

})
define('./functions/dab32c1a59815cb1bb01bf3c96e663ee/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dab32c1a59815cb1bb01bf3c96e663ee'] = async function fn_dab32c1a59815cb1bb01bf3c96e663ee(startDate, officeObjId, locationId, productId, officeRecord, endDate) {
var count, itemsRemoved, itemsAdded, whereClauseRemoved, transactionTable, whereClauseAdded, officeRecord, whereClauseList, locationRecord, productRecord, startDate;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start get_inventory_locProd');
  if (!locationId && !productId) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('in function get_inventoryCount either the locationID or productID (or both) must be specified');
  }
  if (officeObjId) {
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  } else if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  }
  whereClauseList = [];
  addItemToList(whereClauseList, (String('num_items IS NOT NULL')));
  if (startDate) {
    addItemToList(whereClauseList, (String('transaction_date>') + String(startDate)));
  } else {
    startDate = 1679382000000;
    addItemToList(whereClauseList, (String('transaction_date>') + String(startDate)));
  }
  if (endDate) {
    addItemToList(whereClauseList, (String('transaction_date <= ') + String(endDate)));
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('Start date of count: ') + String(startDate)));
  if (productId) {
    productRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'product_table'))).findById(productId, ));
    if (getObjectProperty(productRecord, 'sn_required')) {
      return (await BackendlessUI.Functions.Custom['fn_14813796fd915e5c4afdbe592ddb3164'](locationId, officeObjId, productId));
    } else {
      addItemToList(whereClauseList, (['link_product = \'',productId,'\''].join('')));
    }
  }
  if (locationId) {
    locationRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'location_table'))).findById(locationId, ));
    if (!(getObjectProperty(locationRecord, 'isTracked'))) {
      return ;
    } else {
      whereClauseAdded = ['link_moved_to.objectId=\'',locationId,'\' AND ',whereClauseList.join(' AND ')].join('');
      whereClauseRemoved = ['link_moved_from.objectId=\'',locationId,'\' AND ',whereClauseList.join(' AND ')].join('');
    }
  } else {
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](whereClauseList);
  transactionTable = (getObjectProperty(officeRecord, 'productTransaction_table'));
  itemsAdded = (getObjectProperty(((await Backendless.Data.of(transactionTable).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClauseAdded).setProperties(['SUM(num_items)']).setPageSize(10)))[0]), 'sum'));
  itemsRemoved = (getObjectProperty(((await Backendless.Data.of(transactionTable).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClauseRemoved).setProperties(['SUM(num_items)']).setPageSize(10)))[0]), 'sum'));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('items added: ') + String(itemsAdded)));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](itemsAdded);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('items removed: ') + String(itemsRemoved)));
  count = itemsAdded - itemsRemoved;
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('count: ') + String(count)));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end getInventoryCount_locprod');

return count
}

})
define('./functions/dc9a708af549b58a4d75cae9feffd116/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dc9a708af549b58a4d75cae9feffd116'] = async function fn_dc9a708af549b58a4d75cae9feffd116(moduleList, shortcode, officeRecord) {
var tableNames, tables, tableObj, j, propertyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  tables = [];
  if (moduleList.includes('Inventory')) {
    if (!(tables.includes('dealer')) && !(getObjectProperty(officeRecord, 'dealer_table'))) {
      addItemToList(tables, 'dealer');
    }
    if (!(tables.includes('discrepancy')) && !(getObjectProperty(officeRecord, 'discrepancy_table'))) {
      addItemToList(tables, 'discrepancy');
    }
    if (!(tables.includes('location')) && !(getObjectProperty(officeRecord, 'location_table'))) {
      addItemToList(tables, 'location');
    }
    if (!(tables.includes('productTransaction')) && !(getObjectProperty(officeRecord, 'productTransaction_table'))) {
      addItemToList(tables, 'productTransaction');
    }
    if (!(tables.includes('product')) && !(getObjectProperty(officeRecord, 'product_table'))) {
      addItemToList(tables, 'product');
    }
    if (!(tables.includes('salesInvoice'))) {
      addItemToList(tables, 'salesInvoice');
    }
    if (!(tables.includes('salesCalculations'))) {
      addItemToList(tables, 'salesCalculations');
    }
    if (!(tables.includes('SN_tracking'))) {
      addItemToList(tables, 'SN_tracking');
    }
  }
  if (moduleList.includes('Payroll')) {
    if (!(tables.includes('product'))) {
      addItemToList(tables, 'product');
    }
    if (!(tables.includes('productTransaction'))) {
      addItemToList(tables, 'productTransaction');
    }
    if (!(tables.includes('dealer'))) {
      addItemToList(tables, 'dealer');
    }
    if (!(tables.includes('payrollTransaction'))) {
      addItemToList(tables, 'payrollTransaction');
    }
    if (!(tables.includes('salesInvoice'))) {
      addItemToList(tables, 'salesInvoice');
    }
    if (!(tables.includes('salesCalculations'))) {
      addItemToList(tables, 'salesCalculations');
    }
    if (!(tables.includes('financeCompanies'))) {
      addItemToList(tables, 'financeCompanies');
    }
  }
  if (moduleList.includes('Competitions')) {
    if (!(tables.includes('dealer')) && !(getObjectProperty(officeRecord, 'dealer_table'))) {
      addItemToList(tables, 'dealer');
    }
    if (!(tables.includes('divisions')) && !(getObjectProperty(officeRecord, 'dealer_table'))) {
      addItemToList(tables, 'divisions');
    }
    if (!(tables.includes('regions')) && !(getObjectProperty(officeRecord, 'dealer_table'))) {
      addItemToList(tables, 'regions');
    }
  }
  if (moduleList.includes('PCI')) {
    if (!(tables.includes('dealer'))) {
      addItemToList(tables, 'dealer');
    }
  }
  tableObj = [];
  tableNames = [];
  for (var j_index in tables) {
    j = tables[j_index];
    if (getObjectProperty(officeRecord, propertyName)) {
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('Using existing table') + String(getObjectProperty(officeRecord, propertyName))));
    } else if (j == 'dealer') {
      propertyName = 'dealer_table';
      if (!(getObjectProperty(officeRecord, propertyName))) {
        addItemToList(tableObj, ({ 'tableName': 'Dealers','tableType': propertyName,'currentTable': 'default' }));
        addItemToList(tableNames, propertyName);
      }
    } else if (j == 'product') {
      propertyName = 'product_table';
      if (!(getObjectProperty(officeRecord, propertyName))) {
        addItemToList(tableObj, ({ 'tableName': 'Products','tableType': propertyName,'currentTable': 'default' }));
        addItemToList(tableNames, propertyName);
      }
    } else if (j == 'location') {
      propertyName = 'location_table';
      if (!(getObjectProperty(officeRecord, propertyName))) {
        addItemToList(tableObj, ({ 'tableName': 'Locations','tableType': propertyName,'currentTable': 'default' }));
        addItemToList(tableNames, propertyName);
      }
    } else if ((typeof (getObjectProperty(officeRecord, (String(j) + String('_table')))) === 'string') && (getObjectProperty(officeRecord, (String(j) + String('_table')))).length > 0) {
    } else {
      propertyName = String(j) + String('_table');
      if (!(getObjectProperty(officeRecord, propertyName))) {
        addItemToList(tableObj, ({ 'tableName': [shortcode,'_',j].join(''),'tableType': propertyName,'currentTable': 'none' }));
        addItemToList(tableNames, ([shortcode,'_',j].join('')));
      }
    }
  }

return ({ 'tableObj': tableObj,'tables': tables,'tableNames': tableNames })
}

})
define('./functions/dd8a1dbc881553c7b0417d8fefd3c35d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d'] = async function fn_dd8a1dbc881553c7b0417d8fefd3c35d(commissionInfo, salePerc) {
var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start FMupdateCommission');
  var j_list = (getObjectProperty(commissionInfo, 'payMatrix'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((typeof (getObjectProperty(j, 'percentPaid')) === 'number' && !isNaN((getObjectProperty(j, 'percentPaid')))) && salePerc > (getObjectProperty(j, 'percentPaid'))) {
      commissionInfo['saleType'] = (getObjectProperty(j, 'type'));
      commissionInfo['amount'] = ((getObjectProperty(j, 'commission')) * (getObjectProperty(commissionInfo, 'numRainbows')));
      return commissionInfo;
    }
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end FMupdateCommission');

return commissionInfo
}

})
define('./functions/df46701cdb431c7eb27cb5c3b47677e9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'] = async function fn_df46701cdb431c7eb27cb5c3b47677e9(text) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('debug')) && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'sectionAccess.admin'))) {
    if (text !== null && !Array.isArray(text) && (typeof text === 'object')) {
      console.log(JSON.stringify(text));
    } else {
      console.log(text);
    }
  }

}

})
define('./functions/dfc86f0d2a6af0c4ad864a1bc8453cb1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'] = async function fn_dfc86f0d2a6af0c4ad864a1bc8453cb1(officeObjId, whereClause, sortby, relations, relationDepth, pageSize, pageOffset, getAll, groupBy, properties, officeRecord) {
var responseObject, transactions, pageSize, tableName, count;


  if (typeof pageSize === 'number' && !isNaN(pageSize)) {
    pageSize = pageSize;
  } else {
    pageSize = 100;
  }
  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', null, officeRecord));
  count = (await Backendless.Data.of(tableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(whereClause)));
  if (getAll == true) {
    transactions = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](tableName, whereClause, properties, null, sortby, relations));
  } else {
    transactions = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setRelated(relations).setRelationsDepth(relationDepth).setSortBy(sortby).setPageSize(pageSize).setOffset(pageOffset)));
  }
  responseObject = transactions;

return responseObject
}

})
define('./functions/dfde89045fdd53560e581c5cc2bd3889/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfde89045fdd53560e581c5cc2bd3889'] = async function fn_dfde89045fdd53560e581c5cc2bd3889(companyObjectId) {
var payroll_ID, companyRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (companyObjectId != null) {
    companyRecord = (await Backendless.Data.of('Offices').findById(companyObjectId, ));
  } else {
    // For now we default to Harrisonburg
    companyRecord = (await Backendless.Data.of('Offices').findById('DFFC7EA0-D6DF-4C8D-B7E1-02CA813B0582', ));
  }
  payroll_ID = (getObjectProperty(companyRecord, 'latest_payroll_id_num')) + 1;
  await Backendless.Data.of('Offices').save(({ 'objectId': companyObjectId,'latest_payroll_id_num': payroll_ID }), true);

return (String(getObjectProperty(companyRecord, 'company_short_identifier')) + String(payroll_ID))
}

})
define('./functions/e1eb11d474628804694665d6d2dbbd47/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'] = async function fn_e1eb11d474628804694665d6d2dbbd47(officeObjId, whereClause, sortby, debug, officeRecord) {
var responseObject, item, locations, tableName, officeRecord, officeObjId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start loadLocations');
  if (officeRecord) {
    officeObjId = (getObjectProperty(officeRecord, 'objectId'));
    officeRecord = officeRecord;
  } else if (officeObjId) {
    officeObjId = officeObjId;
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  } else {
    officeObjId = ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})());
    officeRecord = ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})());
  }
  tableName = (getObjectProperty(officeRecord, 'location_table'));
  locations = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](tableName, whereClause, null, null, sortby, 'associated_office'));
  responseObject = (await asyncListFilter(locations, async (item) => {


   return (officeObjId == (getObjectProperty(item, 'associated_office.objectId')));
  }));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end loadLocations');

return responseObject
}

})
define('./functions/e33ecc11abe7ceeb1cead543d30a2203/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e33ecc11abe7ceeb1cead543d30a2203'] = async function fn_e33ecc11abe7ceeb1cead543d30a2203(officeRecord, csvFile) {
var response, dealerRecord, uploadObj, spaceIndex, dealer_name, dealer_id, dealerMatch, item, existingDealers, j, csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('starting upload good barber dealers');
  response = '';
  existingDealers = (await Backendless.Data.of((getObjectProperty(officeRecord, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['office_link.objectId=\'',(getObjectProperty(officeRecord, 'objectId')),'\'','','','',''].join(''))).setPageSize(10)));
  for (var j_index in csvFile) {
    j = csvFile[j_index];
    dealer_name = j[0];
    dealer_id = j.slice(-1)[0];
    if (!(dealer_id.indexOf('@') !== -1)) {
      response = String(response) + String(['invalid value, skipping ',dealer_name,' ',dealer_id].join(''));
    } else {
      dealerMatch = (await asyncListFilter(existingDealers, async (item) => {


       return ((getObjectProperty(item, 'dealer_id')) == dealer_id || (getObjectProperty(item, 'dealer_email')) == dealer_id || (getObjectProperty(item, 'dealer_name')) == dealer_name);
      }));
      if (dealerMatch.length == 1) {
        dealerMatch = dealerMatch[0];
        dealerMatch['dealer_id'] = dealer_id;
        dealerRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'dealer_table'))).save(dealerMatch, true));
      } else if (dealerMatch.length > 1) {
        response = String(response) + String(['Duplicate records exist for ',dealer_name,' in table ',(getObjectProperty(officeRecord, 'dealer_table'))].join(''));
      } else {
        spaceIndex = dealer_name.indexOf(' ') + 1;
        uploadObj = ({ 'historic_comp_score': [({ 'date': '2022-01-01T02:00:00.000Z','demos': undefined,'sales': undefined,'recruits': undefined,'submissions': undefined,'appointments': undefined })],'dealer_id': dealer_id,'dealer_email': dealer_id,'dealer_nameFirst': dealer_name.slice(0, spaceIndex),'dealer_nameLast': dealer_name.slice((spaceIndex - 1), dealer_name.length) });
        dealerRecord = (await Backendless.Data.of((getObjectProperty(officeRecord, 'dealer_table'))).save(uploadObj, true));
        await Backendless.Data.of((getObjectProperty(officeRecord, 'dealer_table'))).setRelation((getObjectProperty(dealerRecord, 'objectId')), 'office_link', [(getObjectProperty(officeRecord, 'objectId'))]);
      }
    }
  }

return response
}

})
define('./functions/e5f530f101da378e128b7fe346268e6e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e5f530f101da378e128b7fe346268e6e'] = function fn_e5f530f101da378e128b7fe346268e6e() {
return true
}

})
define('./functions/e86ec673167f0faee157a449f9dd845b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b'] = function fn_e86ec673167f0faee157a449f9dd845b(x) {
return (String('$') + String((String(Math.round(x))).replace((new RegExp('(\\d)(?=(\\d{3})+(?!\\d))', 'g')), '$1,')))
}

})
define('./functions/eb42ea476121086caadc8b67091aea2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'] = async function fn_eb42ea476121086caadc8b67091aea2d(officeObjId, whereClause, sortby, relations, relationDepth, pageSize, pageOffset, getAll) {
var dealers, whereClause, tableName, pageSize;


  if ((function(){ try { return JSON.parse(localStorage.getItem('debug')) } catch(e){ return null }})()) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('start loadDealers');
  }
  if (typeof pageSize === 'number' && !isNaN(pageSize)) {
    pageSize = pageSize;
  } else {
    pageSize = 100;
  }
  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', officeObjId, null));
  if (typeof whereClause === 'string') {
    whereClause = ['office_link.objectId=\'',officeObjId,'\' AND ',whereClause].join('');
  } else {
    whereClause = ['office_link.objectId=\'',officeObjId,'\''].join('');
  }
  dealers = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](tableName, whereClause, null, null, sortby, relations));
  if ((function(){ try { return JSON.parse(localStorage.getItem('debug')) } catch(e){ return null }})()) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('end loadDealers');
  }

return dealers
}

})
define('./functions/f297f5de05e3421f5273f84e498e98c4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f297f5de05e3421f5273f84e498e98c4'] = async function fn_f297f5de05e3421f5273f84e498e98c4(locationId, productId, locationTableName) {
var numItems, inventoryRecord, item, inventory, locationTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start getTabulatedInventoryLocationProduct');
  numItems = 0;
  locationTable = (typeof locationTableName === 'string') ? locationTableName : 'demo_locations';
  inventory = (getObjectProperty((await Backendless.Data.of(locationTable).findById(locationId, )), 'inventory'));
  if (inventory != null) {
    inventoryRecord = (await asyncListFilter(inventory, async (item) => {


     return ((getObjectProperty(item, 'productObjId')) == productId);
    }));
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](inventoryRecord);
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((inventoryRecord.length));
    if (inventoryRecord != null && inventoryRecord.length == 1) {
      numItems = (getObjectProperty((inventoryRecord[0]), 'totalItems'));
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((getObjectProperty((inventoryRecord[0]), 'totalItems')));
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](numItems);
    }
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](numItems);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end getTabulatedInventoryLocationProduct');

return numItems
}

})
define('./functions/f3f49dcb24e9c0e61dbf2c232cce7c74/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f3f49dcb24e9c0e61dbf2c232cce7c74'] = async function fn_f3f49dcb24e9c0e61dbf2c232cce7c74(officeRecord, startDate) {
var locations, products, intervalLengthEpoch, i, officeRecord, startDate, j, locationTable, productTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting recalculate_histInventory');
  if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'));
  }
  if (startDate) {
    startDate = startDate;
  } else {
    startDate = (getObjectProperty(officeRecord, 'inventory_start_date'));
  }
  locationTable = (getObjectProperty(officeRecord, 'location_table'));
  productTable = (getObjectProperty(officeRecord, 'product_table'));
  locations = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](locationTable, (['active=TRUE and isTracked=TRUE AND associated_office = \'',(getObjectProperty(officeRecord, 'objectId')),'\''].join('')), null, null, null, null));
  products = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](productTable, (['active=TRUE AND associated_office = \'',(getObjectProperty(officeRecord, 'objectId')),'\''].join('')), null, null, null, null));
  for (var j_index in locations) {
    j = locations[j_index];
    j['inventory_historical'] = [];
    await Backendless.Data.of(locationTable).save(j, true);
  }
  intervalLengthEpoch = 604800000;
  var i_end = ((new Date((new Date()).getTime() + ((7 * 86400) * 1000))).valueOf());
  var i_inc = Math.abs(intervalLengthEpoch);
  if (startDate > i_end) {
    i_inc = -i_inc;
  }
  for (i = startDate; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('!!!!!!!!!!starting next timestep: ');
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((i + intervalLengthEpoch));
    await BackendlessUI.Functions.Custom['fn_507d7b8d0bd1aa8d56994bedecaf4986'](officeRecord, i, (i + intervalLengthEpoch), products, locations);
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end recalculate_histInventory');

return 
}

})
define('./functions/f403d444a75a2955804dd9adabbfe888/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f403d444a75a2955804dd9adabbfe888'] = async function fn_f403d444a75a2955804dd9adabbfe888(earliest_date, start_date, end_date, pay_date) {
var unapproved_sales, approved_sales, all_sales, item, no_calc_sales, verdict, itemPaydate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  all_sales = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date >\'',earliest_date,'\' AND sales_date <\'',end_date,'\''].join('')), null, null, 'sales_date DESC', 'link_to_calculations'));
  approved_sales = (await asyncListFilter(all_sales, async (item) => {
     console.log(item);
    console.log(getObjectProperty(item, 'link_to_calculations'));
    if ((typeof (getObjectProperty(item, 'link_to_calculations')) === 'undefined') || ((getObjectProperty(item, 'link_to_calculations')) === null)) {
      verdict = false;
    } else {
      console.log(getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay'));
      console.log(getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'payperiod'));
      verdict = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay'));
      itemPaydate = (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'payperiod'));
    }
    console.log(itemPaydate);
    console.log(verdict);
    if ((itemPaydate === null) || (verdict === null)) {
      verdict = false;
    } else {
      if (itemPaydate != pay_date) {
        verdict = false;
      }
    }
    console.log(verdict);


   return verdict;
  }));
  console.log(approved_sales);
  no_calc_sales = (await asyncListFilter(all_sales, async (item) => {


   return (!((typeof (getObjectProperty(item, 'link_to_calculations')) === 'undefined') || ((getObjectProperty(item, 'link_to_calculations')) === null)));
  }));
  unapproved_sales = (await asyncListFilter(no_calc_sales, async (item) => {


   return (!(getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'ok2pay')));
  }));

return ({ 'allSales': all_sales,'approvedSales': approved_sales,'unapprovedSales': unapproved_sales })
}

})
define('./functions/f9d2b58d28466fd672eaf755f913b7e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f9d2b58d28466fd672eaf755f913b7e6'] = async function fn_f9d2b58d28466fd672eaf755f913b7e6(movedToObjId, movedFromObjId, productObjId, numItems, serialNumber, officeObjId, transactionId, officeRecord) {
var summary, numItems, response, productRecord, movedToRecord, transactionDate, locationTable, movedFromRecord, officeRecord, inventoryMovedTo, inventoryMovedFrom, productTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start updateInventory');
  if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  }
  locationTable = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', null, officeRecord));
  productTable = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', null, officeRecord));
  numItems = numItems;
  Backendless.Logging.getLogger('Debugger').debug((['in update inventory',officeObjId,locationTable,productTable].join('')));
  if (typeof numItems === 'string') {
    numItems = (Number(numItems));
  }
  response = '';
  movedFromRecord = (await Backendless.Data.of(locationTable).findById(movedFromObjId, ));
  movedToRecord = (await Backendless.Data.of(locationTable).findById(movedToObjId, ));
  productRecord = (await Backendless.Data.of(productTable).findById(productObjId, ));
  if ((getObjectProperty(productRecord, 'sn_required')) && serialNumber == null) {
    response = 'Serial Number required for this item';
    return response;
  }
  if (getObjectProperty(productRecord, 'sn_required')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((['moving ',serialNumber,' to ',movedToObjId].join('')));
    await BackendlessUI.Functions.Custom['fn_163f6bc444576c5c6a86a4b3c4a746a2'](serialNumber, movedToObjId, productObjId, transactionId, officeRecord);
  }
  if (Array.isArray((getObjectProperty(movedFromRecord, 'inventory')))) {
    inventoryMovedFrom = (getObjectProperty(movedFromRecord, 'inventory'));
  } else {
    inventoryMovedFrom = [];
  }
  if (Array.isArray((getObjectProperty(movedToRecord, 'inventory')))) {
    inventoryMovedTo = (getObjectProperty(movedToRecord, 'inventory'));
  } else {
    inventoryMovedTo = [];
  }
  transactionDate = (getObjectProperty((await Backendless.Data.of((getObjectProperty(officeRecord, 'productTransaction_table'))).findById(transactionId, )), 'transaction_date'));
  if (getObjectProperty(movedFromRecord, 'isTracked')) {
    response = (await BackendlessUI.Functions.Custom['fn_53e5e80f02717a127926d3e322ca9229'](locationTable, movedFromObjId, productObjId, numItems, (getObjectProperty(productRecord, 'sn_required')), officeObjId, transactionDate));
    summary = [(getObjectProperty(movedFromRecord, 'name')),' now has ',(getObjectProperty(response, 'newTotal')),' ',(getObjectProperty(productRecord, 'product_name')),'<br/>'].join('');
  } else {
    summary = '';
  }
  if (getObjectProperty(movedToRecord, 'isTracked')) {
    response = (await BackendlessUI.Functions.Custom['fn_9e29f901341de3683ddee8d7cd24ae43'](locationTable, movedToObjId, productObjId, (getObjectProperty(productRecord, 'product_name')), numItems, serialNumber, (getObjectProperty(productRecord, 'sn_required')), officeObjId, transactionDate));
    summary = String(summary) + String([(getObjectProperty(movedToRecord, 'name')),' now has ',(getObjectProperty(response, 'newTotal')),' ',(getObjectProperty(productRecord, 'product_name')),'<br/>'].join(''));
  } else {
  }
  await BackendlessUI.Functions.Custom['fn_faed4cde7b0fc86b7964d807c2edf9d6'](null, officeRecord);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end updateInventory');

return summary
}

})
define('./functions/faed4cde7b0fc86b7964d807c2edf9d6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_faed4cde7b0fc86b7964d807c2edf9d6'] = async function fn_faed4cde7b0fc86b7964d807c2edf9d6(officeObjId, officeRecord) {
var totalInventory, officeRecord, serialNumbers, numItems, j, productTableName, k, filteredList, item, singleInventory, allProducts, allLocations, officeObjId, tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('start updateTotalInventory');
  if (officeRecord) {
    officeRecord = officeRecord;
  } else {
    officeRecord = (await Backendless.Data.of('Offices').findById(officeObjId, ));
  }
  tableName = (getObjectProperty(officeRecord, 'location_table'));
  productTableName = (getObjectProperty(officeRecord, 'product_table'));
  allProducts = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, null, null, officeRecord));
  allLocations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](officeObjId, (String('isTracked=TRUE')), null, null, null));
  totalInventory = [];
  singleInventory = [];
  for (var j_index in allLocations) {
    j = allLocations[j_index];
    if (Array.isArray((getObjectProperty(j, 'inventory')))) {
      addItemToList(singleInventory, (getObjectProperty(j, 'inventory')));
    }
  }
  for (var j_index2 in allProducts) {
    j = allProducts[j_index2];
    filteredList = (await asyncListFilter(singleInventory, async (item) => {


     return ((getObjectProperty(item, 'productObjId')) == (getObjectProperty(j, 'objectId')));
    }));
    numItems = (await Promise.all((filteredList.length > 0 ? filteredList : [({ 'totalItems': 0 })]).map(async item => {; return (getObjectProperty(item, 'totalItems'));}))).reduce(function(x, y) {return x + y;});
    addItemToList(totalInventory, ({ 'productObjId': (getObjectProperty(j, 'objectId')),'productName': (getObjectProperty((await Backendless.Data.of(productTableName).findById((getObjectProperty(j, 'objectId')), )), 'product_name')),'totalItems': numItems,'serialNumber': undefined }));
  }
  await Backendless.Data.of('Offices').save(({ 'objectId': (getObjectProperty(officeRecord, 'objectId')),'inventory': totalInventory }), true);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end updateTotalInventory');

return totalInventory
}

})
define('./functions/fb1a63e38aeda4981acc1ef67d28b238/code.js', () => { 

BackendlessUI.Functions.Custom['fn_fb1a63e38aeda4981acc1ef67d28b238'] = async function fn_fb1a63e38aeda4981acc1ef67d28b238() {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'sectionAccess.admin'))
}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var userLoggedIn;


  userLoggedIn = (await Backendless.UserService.getUserRoles());
  if (userLoggedIn == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/404/components/aafe3e91ff47675bb259bcdb1665381e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--addDealers/components/438e421c8dce68e7607b55eb10952ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showLoginAlert'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--addDealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var OfficeObj, j, Offices;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('admin', null, null);
  Offices = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setSortBy('office_name').setPageSize(100)));
  OfficeObj = [];
  for (var j_index in Offices) {
    j = Offices[j_index];
    addItemToList(OfficeObj, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'office_name')),'short_code': (getObjectProperty(j, 'company_short_identifier')) }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'officeList': OfficeObj,'modules': [] }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--addDealers/components/c21eab02fffb2705a0b9832db8d68fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var fields, fieldValsNice, fieldVals, k, csvParsed, fieldName, i, numFields, csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2list`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'csvURL': ___arguments.uploadedFiles }));
  csvParsed = [];
  numFields = csvFile[0].length;
  ___arguments.context.pageData['csvFile'] = csvFile;
  var i_inc = 1;
  if (1 > numFields) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= numFields : i >= numFields; i += i_inc) {
    fieldName = String('Field') + String(i);
    csvParsed[fieldName] = [];
  }
  for (var fields_index in csvFile) {
    fields = csvFile[fields_index];
    var i_inc2 = 1;
    if (1 > numFields) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= numFields : i >= numFields; i += i_inc2) {
      fieldName = String('Field') + String(i);
      addItemToList((getObjectProperty(csvParsed, fieldName)), (fields[(i - 1)]));
    }
  }
  fields = [];
  var i_inc3 = 1;
  if (1 > numFields) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= numFields : i >= numFields; i += i_inc3) {
    fieldName = String('Field') + String(i);
    fieldValsNice = '';
    fieldVals = (getObjectProperty(csvParsed, fieldName));
    for (k = 1; k <= 3; k++) {
      if (k == 1) {
        fieldValsNice = ['','',fieldVals[(k - 1)]].join('');
      } else {
        fieldValsNice = [fieldValsNice,',',fieldVals[(k - 1)]].join('');
      }
    }
    addItemToList(fields, ({ 'fieldValues': fieldVals,'fieldValuesNice': fieldValsNice,'fieldName': '','dealerFields': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'dealerFields')) }));
  }
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['fields'] = fields;

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['error'] = true;
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['error.message'] = ___arguments.error;

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/Admin--addDealers/components/0dc9a1e3f20ba12401f2e93ac31eebe2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, dealerFields, chosenOffice;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  chosenOffice = (await Backendless.Data.of('Offices').findById(___arguments.value, ));
  dealerFields = [];
  ___arguments.context.pageData['chosenOffice'] = chosenOffice;
  ___arguments.context.pageData['dealerTableName'] = (getObjectProperty(chosenOffice, 'dealer_table'));
  ___arguments.context.pageData['officeObjId'] = (getObjectProperty(chosenOffice, 'objectId'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['dealerFields'] = [({ 'value': 'dealer_name','label': 'Dealer name' }), ({ 'value': 'dealer_id','label': 'Dealer login' })];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--addDealers/components/6be6f982390b9cb8cc9e282ba0e4728c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.dataModel['fieldName'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--addDealers/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var dealerRecord, uploadObj, spaceIndex, existingDealer, i, j, fieldNames, csvFile, keepFields;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (getObjectProperty(___arguments.context.pageData, 'csvFile'));
  keepFields = ({ 'temp': undefined });
  fieldNames = [];
  await BackendlessUI.Functions.Custom['fn_e33ecc11abe7ceeb1cead543d30a2203']((getObjectProperty(___arguments.context.pageData, 'chosenOffice')), (getObjectProperty(___arguments.context.pageData, 'csvFile')));
  ___arguments.context.pageData['ok2test'] = true;

  },
  /* handler:onSubmit */
  /* content */
}));

define('./pages/Admin--addDealers/components/a069e35d8eae16bb183b00a6effa8d95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dealInformation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dealerTableName')) ? String('Dealer records will be saved in the table ') + String(getObjectProperty(___arguments.context.pageData, 'dealerTableName')) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('on login selected office is: ') + String(getObjectProperty(___arguments.context.dataModel, 'selectedOffice'))));
  if (getObjectProperty(___arguments.context.dataModel, 'selectedOffice')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('setting office ObjId');
    localStorage.setItem('officeObjId', JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'selectedOffice'))));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.dataModel, 'selectedOffice')));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/Admin--chooseOffice/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var OfficeObj, j, Offices;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Offices = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setSortBy('office_name').setPageSize(100)));
  OfficeObj = [];
  for (var j_index in Offices) {
    j = Offices[j_index];
    addItemToList(OfficeObj, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'office_name')) }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'officeList': OfficeObj }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/9a53aae15c278dc1925e45da34e98cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['selectedOffice'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/bc65133125e8614cbccd7ccf1256d4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--createOffice', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'selectedOffice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/849544f799c1cc2194a3050f6cdb0731/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--addDealers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'selectedOffice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/d2dfd5826bebf0e7258ba4b86f8ad272/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['userList'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Users', (['office_link.objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'selectedOffice')),'\''].join('')), null, null, null, null)), 'objectId', 'name'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['seeUserList'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/4b7ee33e83ca4d14764cea7d09238f8c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      localStorage.setItem('viewAs', JSON.stringify(true));
  localStorage.setItem('viewAsRecord', JSON.stringify((
      await Backendless.Data.of( Backendless.User ).findById(___arguments.value)
  )));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((String('viewing as: ') + String(
      await Backendless.Data.of( Backendless.User ).findById(___arguments.value)
  )));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--chooseOffice/components/c0a667cbbd4ac768683bba638c53693f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--testPCI', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'selectedOffice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--createOffice/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var nextSteps, officeObjLink, record, j, tableSetup, officeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  officeRecord = (getObjectProperty(___arguments.context.dataModel, 'office'));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](officeRecord);
  await Backendless.Data.of('Offices').save(officeRecord, true);
  ___arguments.context.pageData['showComplete'] = true;

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/Admin--createOffice/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var officeList, Offices;


  Offices = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, 'office_name', null));
  ___arguments.context.pageData['showComplete'] = false;
  officeList = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6'](Offices, 'objectId', 'office_name'));
  ___arguments.context.pageData['officeList'] = officeList;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'officeList': officeList,'modules': [] }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--createOffice/components/753530e9e7939e1f4edf2f76040cf796/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var neededTables;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Inventory');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Inventory', '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/ecdf4cdc5e8806199d07cef2b3c76823/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Payroll');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Payroll', '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/f92740e7439dfc4db859aab720161a98/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var newCode, rand, paddingVal, padding, existingCodes, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'PCI');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'modules')), 'PCI', '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/74dfd747ba51ab64b934ada8e2c649e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Competitions');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Competitions', '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/f69e0005c7f9a09e963b58bc4a1a42ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['office'] = (await Backendless.Data.of('Offices').findById(___arguments.value, ));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['Inventory'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')).includes('Inventory'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['Payroll'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')).includes('Payroll'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['Sales'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')).includes('Sales'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['Orders'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')).includes('Orders'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['Competitions'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')).includes('Competitions'));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['PCI'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')).includes('PCI'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/01c9b49878d1a8386d65baea8cbb4863/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Sales');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Sales', '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/abf84dea8fb6aff647728fcc1c26128b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.modules')), 'Orders');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'modules')), 'Orders', '');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--createOffice/components/e7828b5679ffdbd1e3d3381b25fed4d6/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--dashboard', undefined);

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
    var Offices;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('85dae34486144e2efa2d934bfdddb172');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'officeList': (getObjectProperty(___arguments.context.pageData, 'officeList')),'modules': [] }));
  ___arguments.context.pageData['showComplete'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Admin--createOffice/components/dd1d3852786e863a06f50dfc073790ef/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 0) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_inventory'] = 'Not using';
  } else if (___arguments.value == 50) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_inventory'] = 'Interested';
  } else if (___arguments.value == 100) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_inventory'] = 'Ready for Setup';
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Not using') {
    value = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Interested') {
    value = 50;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Ready for Setup') {
    value = 100;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) === 'string') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Not using' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Interested' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Ready for Setup')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--createOffice/components/be74fcb8e72a0351c97d665e71b4f048/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 0) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_payroll'] = 'Not using';
  } else if (___arguments.value == 50) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_payroll'] = 'Interested';
  } else if (___arguments.value == 100) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_payroll'] = 'Ready for Setup';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) === 'string') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) == 'Not using' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) == 'Interested' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) == 'Ready for Setup')

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) == 'Not using') {
    value = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) == 'Interested') {
    value = 50;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_payroll')) == 'Ready for Setup') {
    value = 100;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Admin--createOffice/components/a11e08d84488700fb9b733e78154600b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 0) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_PCI'] = 'Not using';
  } else if (___arguments.value == 50) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_PCI'] = 'Interested';
  } else if (___arguments.value == 100) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_PCI'] = 'Ready for Setup';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) === 'string') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) == 'Not using' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) == 'Interested' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) == 'Ready for Setup')

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) == 'Not using') {
    value = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) == 'Interested') {
    value = 50;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_PCI')) == 'Ready for Setup') {
    value = 100;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Admin--createOffice/components/f75df7bbaa0f3bfb601b559a5589ef91/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 0) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_sales'] = 'Not using';
  } else if (___arguments.value == 50) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_sales'] = 'Interested';
  } else if (___arguments.value == 100) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_sales'] = 'Ready for Setup';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) === 'string') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) == 'Not using' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) == 'Interested' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) == 'Ready for setup')

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) == 'Not using') {
    value = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) == 'Interested') {
    value = 50;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_sales')) == 'Ready for Setup') {
    value = 100;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Admin--createOffice/components/dc13825da081d08d6f7c0b3c6fdf716c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 0) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_orders'] = 'Not using';
  } else if (___arguments.value == 50) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_orders'] = 'Interested';
  } else if (___arguments.value == 100) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_orders'] = 'Ready for Setup';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_orders')) === 'string') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_orders')) == 'Not using' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_orders')) == 'Interested' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_inventory')) == 'Ready for Setup')

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_orders')) == 'Not using') {
    value = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_orders')) == 'Interested') {
    value = 50;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_orders')) == 'Ready for Setup') {
    value = 100;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Admin--createOffice/components/4ea984ce9548121203bda3071f54c80f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 0) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_competitions'] = 'Not using';
  } else if (___arguments.value == 50) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_competitions'] = 'Interested';
  } else if (___arguments.value == 100) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office'))['module_competitions'] = 'Ready for Setup';
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) === 'string') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) == 'Not using' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) == 'Interested' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) == 'Ready for Setup')

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) == 'Not using') {
    value = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) == 'Interested') {
    value = 50;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'office.module_competitions')) == 'Ready for Setup') {
    value = 100;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Admin--createOffice-nextSteps/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'nextSteps': (getObjectProperty(___arguments.context.pageData, 'nextSteps')) }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--createOffice-nextSteps/components/142d5cef6566ca681004a0e544d716b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'sixDigitCode')) ? ['PCI office code for ',(getObjectProperty(___arguments.context.pageData, 'officeName')),' is: ',(getObjectProperty(___arguments.context.pageData, 'sixDigitCode'))].join('') : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Admin--createOffice-nextSteps/components/d8fec0fd30fc1e1a1eaff485c5aa3727/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'showInstructions')) {
    ___arguments.context.dataModel['showInstructions'] = false;
  } else {
    ___arguments.context.dataModel['showInstructions'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--createOffice-nextSteps/components/7625ef9da1bb917fe2accf743a3e9a86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--addDealers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--createOffice-nextSteps/components/aea15dca4e2b438d9139c314eb552cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var tableObj;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--chooseOffice', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--createOffice-nextSteps/components/eb850c33c60674cb2063d535612499cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://coda.io/d/_d0VbYh4bEbv/Adding-new-PCI-office_su5lx', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, offices, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['addInventory'] = false;
  ___arguments.context.pageData['addPCI'] = false;
  ___arguments.context.pageData['pageTitle'] = 'Admin Dashboard';
  localStorage.setItem('viewAs', JSON.stringify(false));
  localStorage.setItem('viewAsRecord', JSON.stringify());
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  offices = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, 'office_name', null));
  ___arguments.context.pageData['offices'] = offices;
  ___arguments.context.pageData['usingInventory'] = ((await asyncListFilter(offices, async (item) => {


   return ((getObjectProperty(item, 'modules')) && ((getObjectProperty(item, 'modules')).includes('Inventory')));
  })).length);
  ___arguments.context.pageData['usingPayroll'] = ((await asyncListFilter(offices, async (item) => {


   return ((getObjectProperty(item, 'modules')) && ((getObjectProperty(item, 'modules')).includes('Payroll')));
  })).length);
  ___arguments.context.pageData['usingCompetitions'] = ((await asyncListFilter(offices, async (item) => {


   return ((getObjectProperty(item, 'modules')) && ((getObjectProperty(item, 'modules')).includes('Competitions')));
  })).length);
  ___arguments.context.pageData['usingPCI'] = ((await asyncListFilter(offices, async (item) => {


   return ((getObjectProperty(item, 'modules')) && ((getObjectProperty(item, 'modules')).includes('PCI')));
  })).length);
  ___arguments.context.pageData['showInventory'] = false;
  ___arguments.context.pageData['showPayroll'] = false;
  ___arguments.context.pageData['showPCI'] = false;
  ___arguments.context.pageData['showSales'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--dashboard/components/3168b80869756f881318e648ba787314/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'sidebarClosed')) {
    console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '0';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/9011679f98d63adb4182417b89ff8c74/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_inventory')) == 'Not using');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/1f799f31c9475d579534306fbae215e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_inventory')) == 'Interested');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/8c8a24899c73dfbda50be0c34b79854b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_inventory')) == 'Ready for Setup');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/700220386717b8d545d2f0d525755d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_inventory')) == 'Onboarding');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/1c8e857377a4ca7e853918d6f191e829/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_inventory')) == 'Using');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/0337d3d98916a37ba3c33c113d460295/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4712b11ab7237dfa2941d47ebce3c759')['module_inventory'] = 'Interested';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('4712b11ab7237dfa2941d47ebce3c759') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/50a192532ed19e52d39346414d6acb0d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f3dc67b9a8d159e8eb0a41e2ab4b0847')['module_inventory'] = 'Interested';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('f3dc67b9a8d159e8eb0a41e2ab4b0847') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/c62acc6194f19052ba0a559516ea15d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('74e601b910deaba7a24b2bd6a0f19a8d')['module_inventory'] = 'Not using';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('74e601b910deaba7a24b2bd6a0f19a8d') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/8f1e1452d53848e962e2923937096b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('74e601b910deaba7a24b2bd6a0f19a8d')['module_inventory'] = 'Ready for Setup';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('74e601b910deaba7a24b2bd6a0f19a8d') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/f9ae7706551eedb18abb2fbba1da3b92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7b86331399b30597e75392ee6e6b4406')['module_inventory'] = 'Using';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('7b86331399b30597e75392ee6e6b4406') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/4b656b2e900453325be6d87b56df12a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('078805a6aa8734e26d54d214a127c321')['module_inventory'] = 'Onboarding';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('078805a6aa8734e26d54d214a127c321') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/9dfb4df7287a85ceeaf35dbdf739fc23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInventory')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showInventory'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/8fed3669b5f412faec3580bb5e07c0a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showInventory'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/67cc58e32551f3c83eaaa01f20725e2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPayroll'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showPayroll')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/9bb32844119c17f4a9c7db71e4254adc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPayroll'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/26424619bf989596ea6b0dec7a3875a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_payroll')) == 'Not using');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/bc7335ccf41a50f143ef7589cd2e0f23/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_payroll')) == 'Interested');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/85bc16775dccf3a366687ae272251ddb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_payroll')) == 'Ready for Setup');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/0c2b84ffaf752a2fa4ec648b404f3228/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_payroll')) == 'Onboarding');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/4a8c05d2ac9694be9fecfc3b7db37fc6/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_payroll')) == 'Using');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/dbf7afe1548495ae750bb49753cd8e5e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_PCI')) == 'Not using');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/773f760dc2e18c9a26aea2ba9e41ded8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showPCI')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPCI'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/2f0d333eb189d0d957f13276c3afe464/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPCI'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/39d5af3290f30577c43ecab62e8c47c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_PCI')) == 'Interested');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/e328046d92089b48330646fbd76bb0fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_PCI')) == 'Ready for Setup');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/17147e41562eb1ac743b812984fce718/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_PCI')) == 'Onboarding');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/75063fef1462f6916ed48cd3dd3d0a54/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_PCI')) == 'Using');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/5d9138ac18f77d5f9f4df1d1b9a3e85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('169f39ed846a5be75293b97a992f05ed')['module_payroll'] = 'Interested';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('169f39ed846a5be75293b97a992f05ed') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/9ebed77ad40c2b7a670846da310e218b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('db15578d4b47116f5019ff9bd33eda48')['module_PCI'] = 'Interested';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('db15578d4b47116f5019ff9bd33eda48') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/b1f7826864684d5729d6cadb89ef7677/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('54beccb32809b5967d826b4c6e66c262')['module_payroll'] = 'Not using';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('54beccb32809b5967d826b4c6e66c262') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/8cc8a111bcb258b817c86df45a3a7c2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('87655ee8931af2aa681b4bb84fbe9fad')['module_PCI'] = 'Not using';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('87655ee8931af2aa681b4bb84fbe9fad') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/0795aa88dddd9d7947caf84777b8209c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('54beccb32809b5967d826b4c6e66c262')['module_payroll'] = 'Ready for Setup';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('54beccb32809b5967d826b4c6e66c262') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/62b7d1f5091496651cdff70530a6b3d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('87655ee8931af2aa681b4bb84fbe9fad')['module_PCI'] = 'Ready for Setup';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('87655ee8931af2aa681b4bb84fbe9fad') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/18f456692d4286338f9d9cdf00e9e481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('16955f13ae99e3badc637dbb474959f3')['module_payroll'] = 'Interested';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('16955f13ae99e3badc637dbb474959f3') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/cde709154245f55e1ce22ccca5eb35c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('5f7b4ad4752f6c1cc782fb01d908cd37')['module_PCI'] = 'Interested';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('5f7b4ad4752f6c1cc782fb01d908cd37') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/0d52125bcbdba86521389302e7bbf4d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8b7c9f8f20274e860791d30f06da1ea2')['module_payroll'] = 'Using';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('8b7c9f8f20274e860791d30f06da1ea2') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/6582701c3a9b5ae2fd7ead5b2cad417f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('941bca9b0d140ae4a9fab0e67aa128ed')['module_PCI'] = 'Using';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('941bca9b0d140ae4a9fab0e67aa128ed') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/4c0c427cfab5572b9269b8424d38dc5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1f2bc7f56214aacbf93df688fe5dfeb1')['module_payroll'] = 'Onboarding';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('1f2bc7f56214aacbf93df688fe5dfeb1') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/de93cdb3f11b98b9a14233544952a58d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a80e0be2a143c8d75e792375fe69760f')['module_PCI'] = 'Onboarding';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('a80e0be2a143c8d75e792375fe69760f') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/eb6c8a222ddb9d2f2e4fa8b584493ee7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedOffice'] = ___arguments.context.getComponentDataStoreByUid('4712b11ab7237dfa2941d47ebce3c759');
  ___arguments.context.pageData['addInventory'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/89e703a92294a0a5e47e83b8e956b32a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_inventory')) == 'Ready for Tech Team');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/fb2e47b9052ee9b6ab2f21e5bf151e67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a88feaf74da9f1cfadc1bf5ec6087489')['module_inventory'] = 'Ready for Setup';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('a88feaf74da9f1cfadc1bf5ec6087489') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/2d3be6edefc8e3fa465a3f334f3478dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedOffice'] = ___arguments.context.getComponentDataStoreByUid('5f7b4ad4752f6c1cc782fb01d908cd37');
  ___arguments.context.pageData['addPCI'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/827d6f575aebf2154dd5c13807a7fe9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedOffice'] = ___arguments.context.getComponentDataStoreByUid('6ae4fe2466cf3738d1c4568c1b7c88e5');
  ___arguments.context.pageData['addPCI'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/19e90a424fa15bf8251f481c3794b5a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'offices')), async (item) => {


 return ((getObjectProperty(item, 'module_PCI')) == 'Ready for Tech Team');
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--dashboard/components/7cdcfaaf90f718fa3d3693448c07e4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedOffice'] = ___arguments.context.getComponentDataStoreByUid('a88feaf74da9f1cfadc1bf5ec6087489');
  ___arguments.context.pageData['addInventory'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--dashboard/components/68e299bfd82b496ce89551db00ba9efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('6ae4fe2466cf3738d1c4568c1b7c88e5')['module_PCI'] = 'Ready for Setup';
  await Backendless.Data.of('Offices').save( ___arguments.context.getComponentDataStoreByUid('6ae4fe2466cf3738d1c4568c1b7c88e5') );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['selectedOffice'] = ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})());
  ___arguments.context.pageData['userList'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Users', (['office_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'selectedOffice.objectId')),'\''].join('')), null, null, null, null)), 'objectId', 'name'));
  ___arguments.context.pageData['addInventory'] = false;
  ___arguments.context.pageData['addPCI'] = false;
  ___arguments.context.pageData['pageTitle'] = 'Office Dashboard (Admin)';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['showInventory'] = false;
  ___arguments.context.pageData['showGeneralInfo'] = true;
  ___arguments.context.pageData['showAppInfo'] = false;
  ___arguments.context.pageData['showPayroll'] = false;
  ___arguments.context.pageData['showPCI'] = false;
  ___arguments.context.pageData['showSales'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/3168b80869756f881318e648ba787314/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'sidebarClosed')) {
    console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '0';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/9dfb4df7287a85ceeaf35dbdf739fc23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showInventory')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showInventory'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/8fed3669b5f412faec3580bb5e07c0a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showInventory'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/67cc58e32551f3c83eaaa01f20725e2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPayroll'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showPayroll')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/9bb32844119c17f4a9c7db71e4254adc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPayroll'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/773f760dc2e18c9a26aea2ba9e41ded8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showPCI')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPCI'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/2f0d333eb189d0d957f13276c3afe464/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showPCI'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/96e174ed9f42d4ccef3c4338f891321d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showGeneralInfo'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showGeneralInfo')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/697b6cce215b21fd23ae93b4cc7868fa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showGeneralInfo'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/c22a18740d26f48bf53cd717876f16d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showAppInfo'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showAppInfo')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/df228af9d173fe783a71a87ddb86bf5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showAppInfo'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/3ceb0b1bf7aa04e82446eed6fdb2c14c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  localStorage.setItem('officeObjId', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedOffice.objectId'))));
  localStorage.setItem('viewAs', JSON.stringify(true));
  localStorage.setItem('viewAsRecord', JSON.stringify((
      await Backendless.Data.of( Backendless.User ).findById(___arguments.value)
  )));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/e7a2d4c26a3fa7af1692ea040a01f901/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  localStorage.setItem('officeObjId', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedOffice.objectId'))));
  localStorage.setItem('officeRecord', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedOffice'))));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/27c464c73dbd452a950c0bc570e97358/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, oldLinks;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oldLinks = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((getObjectProperty(___arguments.context.pageData, 'selectedOffice.SN_tracking_table')), null, null, null, null, null));
  for (var j_index in oldLinks) {
    j = oldLinks[j_index];
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(j, 'serial_number')));
    if (getObjectProperty(j, 'cognito_id')) {
      j['cognito_id'] = '';
      await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'selectedOffice.SN_tracking_table'))).save(j, true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/298f7903029d1b59ed1c1e09b4abdfa7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['addInventory'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/ea5532e87cb722ee0a129eac7d0db06d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, cognitoRecords;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  cognitoRecords = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((getObjectProperty(___arguments.context.pageData, 'selectedOffice.SN_tracking_table')), 'location != \'Sold\'', null, null, null, null));
  for (var j_index in cognitoRecords) {
    j = cognitoRecords[j_index];
    console.log(getObjectProperty(j, 'serial_number'));
    if (!(getObjectProperty(j, 'cognito_id'))) {
      await Backendless.Request.post(`${Backendless.appPath}/services/webhookToCognito/sendWebhook`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'newLocation': (getObjectProperty(j, 'location')),'product': (getObjectProperty(j, 'product')),'office': (getObjectProperty(___arguments.context.pageData, 'selectedOffice.office_name')),'serialNumber': (getObjectProperty(j, 'serial_number')),'objectId': (getObjectProperty(j, 'objectId')),'tableName': (getObjectProperty(___arguments.context.pageData, 'selectedOffice.SN_tracking_table')) });
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--officeDashboard/components/d66b0b56d82e638f8b26c258c484705f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      localStorage.setItem('debug', JSON.stringify(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemSns/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var sn_table, item, newIssues, productSelector, k, locationSelector, j, error, offices, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['tableIssues'] = '';
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageTitle'] = 'Admin - Serial Number Issues';
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  offices = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', (String('SN_tracking_table is not null')), null, null, null, null));
  sn_table = [];
  for (var j_index in offices) {
    j = offices[j_index];
    ___arguments.context.pageData['checking'] = (String('Checking ') + String(getObjectProperty(j, 'office_name')));
    try {
      newIssues = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', (getObjectProperty(j, 'objectId')))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (['(link_location.name is null',' OR cognito_id is null ',' OR link_product.product_name is null)',' AND (last_moved > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),' OR created > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),') AND (link_location.name !=\'Sold\')'].join('')), null, null, 'last_moved desc', ['link_product', 'link_location']));

    } catch (error) {
      ___arguments.context.pageData['tableIssues'] = (String(getObjectProperty(___arguments.context.pageData, 'tableIssues')) + String(['<br/>',(getObjectProperty(j, 'office_name')),' is not set up properly.   '].join('')));
      ___arguments.context.pageData['tableIssues'] = ([(getObjectProperty(___arguments.context.pageData, 'tableIssues')),'  Look at: ',(await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', (getObjectProperty(j, 'objectId'))))].join(''));
      console.log(error);

    }
    if (newIssues.length > 0) {
      locationSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47']((getObjectProperty(j, 'objectId')), null, 'name')), 'objectId', 'name'));
      productSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e']((getObjectProperty(j, 'objectId')), null, 'product_name')), 'objectId', 'product_name'));
      for (var k_index in newIssues) {
        k = newIssues[k_index];
        k['office_name'] = (getObjectProperty(j, 'office_name'));
        k['officeObjId'] = (getObjectProperty(j, 'objectId'));
        k['setBackground'] = true;
        k['location_select'] = locationSelector;
        k['product_select'] = productSelector;
      }
      sn_table = (sn_table.concat(newIssues));
      ___arguments.context.pageData['filtered_table'] = sn_table;
    }
  }
  ___arguments.context.pageData['checking'] = undefined;
  sn_table = (await asyncListSort(sn_table, -1, async (item) => {


   return (getObjectProperty(item, 'last_moved'));
  }));
  ___arguments.context.pageData['datatable'] = sn_table;
  ___arguments.context.pageData['filtered_table'] = sn_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--problemSns/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' ',''].join(''));
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId'))));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('setting relations');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'newLocation')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_location', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_location.objectId'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'newProduct')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_product', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId'))]);
  }
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('saving');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemSns/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemSns/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Admin--problemSns/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemSns/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var transaction_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'whereClause')));
    transaction_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'created DESC', null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in transaction_table) {
      j = transaction_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['datatable'] = transaction_table;
    ___arguments.context.pageData['filtered_table'] = transaction_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--problemSns/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemSns/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemSns/components/d349ef026fff7f4760a82e823ab646f5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeRecords'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, null, null));
  ___arguments.context.pageData['officeSelector'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.pageData, 'officeRecords')), 'objectId', 'office_name'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/Admin--problemSns/components/e23b5e4167c7f645490d865b09a8f90f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'last_moved'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Admin--problemSns/components/f8f2735b46daa93ccd0c3aae3fed08f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['newLocation'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['location'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/6c27870a5354e714749ca60254959d23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['newProduct'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemSns/components/97b9a2f7da094f13594c2a39cf41c94b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId'))));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](tableName);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'));
  removeItemInList((getObjectProperty(___arguments.context.pageData, 'filtered_table')), ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), '');
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')));
  await Backendless.Data.of(tableName).remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var transaction_table, item, newIssues, productSelector, k, locationSelector, j, error, offices, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['tableIssues'] = '';
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageTitle'] = 'Admin - Transaction Issues';
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  offices = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', (String('productTransaction_table is not null')), null, null, null, null));
  transaction_table = [];
  for (var j_index in offices) {
    j = offices[j_index];
    ___arguments.context.pageData['checking'] = (String('Checking ') + String(getObjectProperty(j, 'office_name')));
    try {
      newIssues = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', (getObjectProperty(j, 'objectId')))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (['(link_moved_to.name is null',' OR link_moved_from.name is null',' OR link_product.product_name is null)',' AND (transaction_date > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),' OR created > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),')'].join('')), null, null, 'transaction_date desc', ['link_moved_to', 'link_moved_from', 'link_product']));

    } catch (error) {
      ___arguments.context.pageData['tableIssues'] = (String(getObjectProperty(___arguments.context.pageData, 'tableIssues')) + String(String(getObjectProperty(j, 'office_name')) + String(' is not set up properly.   ')));
      ___arguments.context.pageData['tableIssues'] = ([(getObjectProperty(___arguments.context.pageData, 'tableIssues')),'  Look at: ',(await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', (getObjectProperty(j, 'objectId'))))].join(''));
      console.log(error);

    }
    if (newIssues.length > 0) {
      locationSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47']((getObjectProperty(j, 'objectId')), null, 'name')), 'objectId', 'name'));
      productSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e']((getObjectProperty(j, 'objectId')), null, 'product_name')), 'objectId', 'product_name'));
      for (var k_index in newIssues) {
        k = newIssues[k_index];
        k['office_name'] = (getObjectProperty(j, 'office_name'));
        k['officeObjId'] = (getObjectProperty(j, 'objectId'));
        k['setBackground'] = true;
        k['moved_to_select'] = locationSelector;
        k['moved_from_select'] = locationSelector;
        k['product_select'] = productSelector;
      }
      transaction_table = (transaction_table.concat(newIssues));
      ___arguments.context.pageData['filtered_table'] = transaction_table;
    }
  }
  ___arguments.context.pageData['checking'] = undefined;
  transaction_table = (await asyncListSort(transaction_table, -1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
  ___arguments.context.pageData['datatable'] = transaction_table;
  ___arguments.context.pageData['filtered_table'] = transaction_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' ',''].join(''));
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId'))));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('setting relations');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_to', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_from', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_product', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'))]);
  }
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('saving');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'product_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product_old')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed'))) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var transaction_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'whereClause')));
    transaction_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'created DESC', null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in transaction_table) {
      j = transaction_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['datatable'] = transaction_table;
    ___arguments.context.pageData['filtered_table'] = transaction_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/d349ef026fff7f4760a82e823ab646f5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeRecords'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, null, null));
  ___arguments.context.pageData['officeSelector'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.pageData, 'officeRecords')), 'objectId', 'office_name'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/e23b5e4167c7f645490d865b09a8f90f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'transaction_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/f8f2735b46daa93ccd0c3aae3fed08f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['moved_from_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_moved_from'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_from'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_from.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/b87a43e9fa7d4f0fe5fe9684008a4805/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['moved_to_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_moved_to'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_to'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_to.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/6c27870a5354e714749ca60254959d23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['product_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_product'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--problemTransactions/components/97b9a2f7da094f13594c2a39cf41c94b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'officeObjId'))));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](tableName);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'));
  removeItemInList((getObjectProperty(___arguments.context.pageData, 'filtered_table')), ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), '');
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')));
  await Backendless.Data.of(tableName).remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')) );
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--testPCI/components/438e421c8dce68e7607b55eb10952ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showLoginAlert'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--testPCI/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var OfficeObj, j, Offices;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('admin', null, null);
  ___arguments.context.pageData['dealersByName'] = true;
  Offices = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((String('six_digit_office_code!=null') + String(''))).setSortBy('office_name').setPageSize(100)));
  OfficeObj = [];
  for (var j_index in Offices) {
    j = Offices[j_index];
    addItemToList(OfficeObj, ({ 'value': (getObjectProperty(j, 'objectId')),'label': [(getObjectProperty(j, 'office_name')),' - ',(getObjectProperty(j, 'six_digit_office_code'))].join(''),'short_code': (getObjectProperty(j, 'company_short_identifier')) }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'officeList': OfficeObj,'modules': [] }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--testPCI/components/0dc9a1e3f20ba12401f2e93ac31eebe2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var chosenOffice, dealerList, dealerSelector, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  chosenOffice = (await Backendless.Data.of('Offices').findById(___arguments.value, ));
  ___arguments.context.pageData['sixDigitCode'] = (getObjectProperty(chosenOffice, 'six_digit_office_code'));
  dealerList = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d']((getObjectProperty(chosenOffice, 'objectId')), null, 'dealer_name', null, null, null, null, null));
  dealerSelector = [];
  for (var j_index in dealerList) {
    j = dealerList[j_index];
    addItemToList(dealerSelector, ({ 'value': (getObjectProperty(j, 'dealer_id')),'label': [(getObjectProperty(j, 'dealer_name')),' - ',(getObjectProperty(j, 'dealer_id'))].join('') }));
  }
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['dealerSelector'] = dealerSelector;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--testPCI/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['response'] = undefined;
  try {
    response = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://demo.tellusapps.net/api/services/Tellus_finance_API/login')).setEncoding('utf8').send(({ 'login': 'tellus_prod@preferredcredit.com','password': 'MYQlmO2Z6f%^' })));
    response = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://demo.tellusapps.net/api/services/Tellus_finance_API/financeDeal')).set(({ 'user-token': (getObjectProperty(response, 'user-token')) })).setEncoding('utf8').send(({ 'approvalStatus': 'approved','contractA2LanguageCode': 'en','dealer': ({ 'login': (getObjectProperty(___arguments.context.pageData, 'dealerLogin')),'officeId': (getObjectProperty(___arguments.context.pageData, 'sixDigitCode')),'referenceOfficeId': '1111','firstName': 'Test','lastName': 'Test' }),'financeCompanyName': 'PCI','generatedDate': (new Date()),'primaryBuyer': ({ 'address': ({ 'city': 'Mountain View','stateOrProvince': 'CA','street': '1800 Amphibious Blvd.','zipOrPostalCode': '94045' }),'emailAddress': 'will.thebard@domain.com','firstName': 'William','lastName': 'Shakespeare','phoneNumber': '8005550100' }),'products': [({ 'amount': '1500','description': 'Rainbow','serialNumber': '22222222' }), ({ 'amount': '200','description': 'Power Nozzle','serialNumber': '44444444' })],'referenceId': '0323239875','requestId': 'd29021ee-6c54-4b01-80e6-d701748e0852','terms': ({ 'amountFinanced': '2688.5','dateOfSale': '2023-02-10','downPaymentAmount': '200','productsSubTotal': '2500','salesPrice': '2600','salesTaxAmount': '188.5','totalPurchasePrice': '2788.5','tradeInAllowance': '0','shippingAndHandlingAmount': '100','floridaDocStampTaxAmount': '0','downPaymentMethod': 'cash' }),'coBuyer': ({ 'address': ({ 'city': 'Mountain View','stateOrProvince': 'CA','street': '1800 Amphibious Blvd.','zipOrPostalCode': '94045' }),'emailAddress': 'will.thebard@domain.com','firstName': 'Lady','lastName': 'Shakespeare','phoneNumber': '8005550100' }) })));

  } catch (error) {
    response = (getObjectProperty(error, 'message'));

  }
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['response'] = response;
  console.log(response);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Admin--testPCI/components/2d2eebc776524fdcbc1b4d464f1b51b7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dealerLogin'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['dealerLogin'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--testPCI/components/2c678b412d083f9459a8fa3bbdc5e3e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('This dealer uses the login: ') + String(getObjectProperty(___arguments.context.pageData, 'dealerLogin')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Admin--testPCI/components/1db6409570334ef6c7a887889fa8ac7f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['dealerlist'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'fullDealerList')), 'dealer_id', 'dealer_id'));
  } else {
    ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['dealerlist'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'fullDealerList')), 'dealer_id', 'dealer_name'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--uploadSales/components/438e421c8dce68e7607b55eb10952ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showLoginAlert'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--uploadSales/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var OfficeObj, j, Offices;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Offices = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  OfficeObj = [];
  for (var j_index in Offices) {
    j = Offices[j_index];
    addItemToList(OfficeObj, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'office_name')),'short_code': (getObjectProperty(j, 'company_short_identifier')) }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85dae34486144e2efa2d934bfdddb172', ({ 'officeList': OfficeObj,'modules': [] }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Admin--uploadSales/components/0dc9a1e3f20ba12401f2e93ac31eebe2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var chosenOffice;


  chosenOffice = (await Backendless.Data.of('Offices').findById(___arguments.value, ));
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['chosenOffice'] = chosenOffice;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--uploadSales/components/6be6f982390b9cb8cc9e282ba0e4728c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ceec5e54bf791fdad6feb9fe4e52a979')['fieldName'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--uploadSales/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var uploadObj, record, recordExists, orderNumber, fieldValue, j, counter, keepFields, fieldNames, numItems, startLine, fieldMatchup, csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  csvFile = (getObjectProperty(___arguments.context.pageData, 'csvFile'));
  fieldMatchup = (getObjectProperty(___arguments.context.dataModel, 'fields'));
  keepFields = ({ 'temp': undefined });
  fieldNames = [];
  var j_list = (getObjectProperty(___arguments.context.dataModel, 'fields'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'fieldName')) {
      keepFields[(getObjectProperty(j, 'fieldName'))] = (getObjectProperty(j, 'fieldValues'));
      numItems = (getObjectProperty(j, 'fieldValues')).length;
      addItemToList(fieldNames, (getObjectProperty(j, 'fieldName')));
    }
  }
  startLine = (getObjectProperty(___arguments.context.dataModel, 'skipFirstLine')) ? 2 : 1;
  var counter_inc = 1;
  if (startLine > numItems) {
    counter_inc = -counter_inc;
  }
  for (counter = startLine; counter_inc >= 0 ? counter <= numItems : counter >= numItems; counter += counter_inc) {
    uploadObj = ({ 'temp': undefined });
    for (var j_index2 in fieldNames) {
      j = fieldNames[j_index2];
      fieldValue = (getObjectProperty(keepFields, j))[(counter - 1)];
      if (j == 'order_number') {
        fieldValue = [(getObjectProperty(___arguments.context.dataModel, 'formPrefix')),'-',fieldValue].join('');
        orderNumber = fieldValue;
      }
      if (j == 'payment_amount') {
        fieldValue = (fieldValue.match((new RegExp('([\\d,.]+)', 'g'))));
      }
      uploadObj[j] = fieldValue;
    }
    delete uploadObj['temp'];
    recordExists = (await Backendless.Data.of((getObjectProperty(___arguments.context.dataModel, 'tableName'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['order_number=\'',orderNumber,'\''].join(''))).setPageSize(10)));
    delete uploadObj['temp'];
    delete uploadObj[''];
    console.log('uploading');
    console.log(uploadObj);
    console.log(getObjectProperty(___arguments.context.dataModel, 'tableName'));
    record = (await Backendless.Data.of((getObjectProperty(___arguments.context.dataModel, 'tableName'))).save(uploadObj, true));
    console.log(record);
  }
  console.log('Done!');

  },
  /* handler:onSubmit */
  /* content */
}));

define('./pages/Admin--uploadSales/components/a069e35d8eae16bb183b00a6effa8d95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice')) ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'tableName')) ? String('Uploading to table ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'tableName')) : 'No table set up for this') : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Admin--uploadSales/components/6c6594947c8a44db44e28f041ac855ab/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var fields, tableFields, fieldValsNice, fieldVals, k, csvParsed, fieldName, goodFields, i, numFields, csvFile, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2list`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'csvURL': ___arguments.uploadedFiles }));
  tableFields = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'tableFields')), 1, async (item) => {


   return ((getObjectProperty(item, 'label')).toLowerCase());
  }));
  csvParsed = [];
  numFields = csvFile[0].length;
  var i_inc = 1;
  if (1 > numFields) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= numFields : i >= numFields; i += i_inc) {
    fieldName = String('Field') + String(i);
    csvParsed[fieldName] = [];
  }
  goodFields = [];
  for (var fields_index in csvFile) {
    fields = csvFile[fields_index];
    var i_inc2 = 1;
    if (1 > numFields) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= numFields : i >= numFields; i += i_inc2) {
      fieldName = String('Field') + String(i);
      addItemToList((getObjectProperty(csvParsed, fieldName)), (fields[(i - 1)]));
      if ((getObjectProperty(csvParsed, fieldName)).length > 1 && !(goodFields.includes(fieldName)) && !(fields[(i - 1)] == '')) {
        addItemToList(goodFields, fieldName);
      }
    }
  }
  ___arguments.context.pageData['csvFile'] = csvFile;
  fields = [];
  for (var fieldName_index in goodFields) {
    fieldName = goodFields[fieldName_index];
    fieldValsNice = '';
    fieldVals = (getObjectProperty(csvParsed, fieldName));
    for (k = 1; k <= 3; k++) {
      if (k == 1) {
        fieldValsNice = ['','',fieldVals[(k - 1)]].join('');
      } else {
        fieldValsNice = [fieldValsNice,', ',fieldVals[(k - 1)]].join('');
      }
    }
    addItemToList(fields, ({ 'fieldValues': fieldVals,'fieldValuesNice': fieldValsNice,'fieldName': '','possibleFields': tableFields,'skip': false }));
  }
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['fields'] = fields;

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/Admin--uploadSales/components/6c43df14f62e4d6d006419babb3b0047/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tableFields, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  tableFields = [];
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['isTransaction'] = false;
  if (___arguments.value == 'other') {
    ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['tableName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.salesOthers_table'));
    console.log(await Backendless.Data.describe( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.salesOthers_table')) ));
    var j_list = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.salesOthers_table')) ));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'type')) != 'STRING_ID' && !(getObjectProperty(j, 'relatedTable')) && !(getObjectProperty(j, 'expression'))) {
        addItemToList(tableFields, ({ 'value': (getObjectProperty(j, 'name')),'label': (getObjectProperty(j, 'name')) }));
      }
    }
  } else if (___arguments.value == 'invoice') {
    ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['tableName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.salesInvoice_table'));
    var j_list2 = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.salesInvoice_table')) ));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      if ((getObjectProperty(j, 'type')) != 'STRING_ID' && !(getObjectProperty(j, 'relatedTable')) && !(getObjectProperty(j, 'expression'))) {
        addItemToList(tableFields, ({ 'value': (getObjectProperty(j, 'name')),'label': (getObjectProperty(j, 'name')) }));
      }
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['tableName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.productTransaction_table'));
    ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['isTransaction'] = true;
    var j_list3 = (await Backendless.Data.describe( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice.productTransaction_table')) ));
    for (var j_index3 in j_list3) {
      j = j_list3[j_index3];
      if ((getObjectProperty(j, 'type')) != 'STRING_ID' && !(getObjectProperty(j, 'relatedTable')) && !(getObjectProperty(j, 'expression'))) {
        addItemToList(tableFields, ({ 'value': (getObjectProperty(j, 'name')),'label': (getObjectProperty(j, 'name')) }));
      }
    }
  }
  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['tableFields'] = tableFields;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Admin--uploadSales/components/3241dc4d8b6fbaf195c22644d80abd66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'chosenOffice')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'tableName')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--uploadSales/components/ceec5e54bf791fdad6feb9fe4e52a979/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.dataModel, 'skip')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Admin--uploadSales/components/6d5bad0fff8933de3dd9db08c21cf561/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j;


  ___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['regex'] = (___arguments.value.match((new RegExp('([\\d,.]+)', 'g'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var dealer_table, divisionTotalAppointments, divisionTotalDemos, divisionTotalRecruits, divisionTotalSales, divisionTotalSubmissions, item, j, k, l, loggedInUser, officeScoreList, temp, thisMonthsAppointmentsTotal, thisMonthsDemosTotal, thisMonthsRecruitsTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  console.log('entering page');
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Division Leaderboard';
  ___arguments.context.pageData['breadCrumb'] = 'Division Leaderboard';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  console.log(loggedInUser);
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['eagleDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((String('region_link = \'60D7A635-E285-41A1-86D6-094053A81D84\''))).setRelationsDepth(3).setPageSize(10)));
  console.log('checkpoint 1');
  var j_list = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_table', 'office_name', 'office_photo']).setRelationsDepth(2).setPageSize(10)));
    console.log((getObjectProperty(j, 'relatedOffices')).length);
    console.log(await Promise.all((getObjectProperty(j, 'relatedOffices')).map(async item => {; return ({ 'dealerTable': (getObjectProperty(item, 'dealer_table')),'officeId': (getObjectProperty(item, 'objectId')) });})));
    dealer_table = 0;
    var k_list = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      console.log(getObjectProperty(k, 'dealer_table'));
      k['officeDealers'] = (await Backendless.Data.of((getObjectProperty(k, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(k, 'objectId')),'\''].join(''))).setProperties(['historic_comp_scores']).setRelationsDepth(2).setPageSize(100)));
    }
  }
  console.log('checkpoint 2');
  console.log(getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      var l_list = (getObjectProperty(k, 'officeDealers'));
      for (var l_index in l_list) {
        l = l_list[l_index];
        if (getObjectProperty(l, 'historic_comp_scores')) {
          if (getObjectProperty(k, 'eventScores')) {
            addItemToList((getObjectProperty(k, 'eventScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
            })));
          } else {
            k['eventScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
            }));
          }
        }
      }
    }
  }
  console.log('checkpoint 3');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    var k_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index3 in k_list3) {
      k = k_list3[k_index3];
      if ((getObjectProperty(k, 'eventScores')).length > 0) {
        thisMonthsAppointmentsTotal = (await Promise.all((getObjectProperty(k, 'eventScores')).map(async item => {; return ((getObjectProperty(item, 'appointments')) ? (getObjectProperty(item, 'appointments')) : 0);}))).reduce(function(x, y) {return x + y;});
        thisMonthsDemosTotal = (await Promise.all((getObjectProperty(k, 'eventScores')).map(async item => {; return ((getObjectProperty(item, 'demos')) ? (getObjectProperty(item, 'demos')) : 0);}))).reduce(function(x, y) {return x + y;});
        thisMonthsRecruitsTotal = (await Promise.all((getObjectProperty(k, 'eventScores')).map(async item => {; return ((getObjectProperty(item, 'recruits')) ? (getObjectProperty(item, 'recruits')) : 0);}))).reduce(function(x, y) {return x + y;});
        thisMonthsSalesTotal = (await Promise.all((getObjectProperty(k, 'eventScores')).map(async item => {; return ((getObjectProperty(item, 'sales')) ? (getObjectProperty(item, 'sales')) : 0);}))).reduce(function(x, y) {return x + y;});
        thisMonthsSubmissionsTotal = (await Promise.all((getObjectProperty(k, 'eventScores')).map(async item => {; return ((getObjectProperty(item, 'submissions')) ? (getObjectProperty(item, 'submissions')) : 0);}))).reduce(function(x, y) {return x + y;});
      } else {
        thisMonthsAppointmentsTotal = 0;
        thisMonthsDemosTotal = 0;
        thisMonthsSalesTotal = 0;
        thisMonthsSubmissionsTotal = 0;
        thisMonthsRecruitsTotal = 0;
      }
      k['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
      k['dealerTotalDemos'] = thisMonthsDemosTotal;
      k['dealerTotalSales'] = thisMonthsSalesTotal;
      k['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
      k['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
    }
    divisionTotalAppointments = 0;
    divisionTotalDemos = 0;
    divisionTotalSales = 0;
    divisionTotalSubmissions = 0;
    divisionTotalRecruits = 0;
    var l_list2 = (getObjectProperty(j, 'relatedOffices'));
    for (var l_index2 in l_list2) {
      l = l_list2[l_index2];
      if (getObjectProperty(l, 'dealerTotalAppointments')) {
        divisionTotalAppointments = thisMonthsAppointmentsTotal + (getObjectProperty(l, 'dealerTotalAppointments'));
      }
      if (getObjectProperty(l, 'dealerTotalDemos')) {
        divisionTotalDemos = thisMonthsDemosTotal + (getObjectProperty(l, 'dealerTotalDemos'));
      }
      if (getObjectProperty(l, 'dealerTotalSales')) {
        divisionTotalSales = thisMonthsSalesTotal + (getObjectProperty(l, 'dealerTotalSales'));
      }
      if (getObjectProperty(l, 'dealerTotalSubmissions')) {
        divisionTotalSubmissions = thisMonthsSubmissionsTotal + (getObjectProperty(l, 'dealerTotalSubmissions'));
      }
      if (getObjectProperty(l, 'dealerTotalRecruits')) {
        divisionTotalRecruits = thisMonthsRecruitsTotal + (getObjectProperty(l, 'dealerTotalRecruits'));
      }
    }
    j['divisionTotalAppointments'] = divisionTotalAppointments;
    j['divisionTotalDemos'] = divisionTotalDemos;
    j['divisionTotalSales'] = divisionTotalSales;
    j['divisionTotalSubmissions'] = divisionTotalSubmissions;
    j['divisionTotalRecruits'] = divisionTotalRecruits;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalRecruits'));
  }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' - Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/c338909204e34dd5e87d22b258de45f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, officeScoreList, thisMonthsRecruitsTotal, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, l;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', true);
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['monthlyScores'] = null;
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/COPY--competitions--divisionLeaderboards/components/a297435dc8fff5617763b7a75e6c38e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', false);
  await BackendlessUI.Functions.Custom['fn_39c8388efde660a8fac97b5c2e8ea5a6'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/accessDenied/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var userLoggedIn;


  userLoggedIn = (await Backendless.UserService.getUserRoles());
  if (userLoggedIn == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/accessDenied/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/accessDenied/components/aafe3e91ff47675bb259bcdb1665381e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/accessDenied/components/7bbd13e8385be50c3ed35fd67469009d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['If you require access, ask your administrator to add ',(getObjectProperty(___arguments.context.pageData, 'requiredAccess')),' to your account access in settings'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin--bugReports/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--bugReports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Bug_reports, j, item, offices, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageTitle'] = 'Admin - Bug Reports';
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  offices = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, null, null));
  holdsData = [];
  Bug_reports = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']('Feedback', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), null, null, null, 'created desc', null));
  for (var j_index in Bug_reports) {
    j = Bug_reports[j_index];
    j['setBackground'] = true;
    j['officeName'] = (getObjectProperty(((await asyncListFilter(offices, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'office')));
    }))[0]), 'office_name'));
  }
  console.log(Bug_reports);
  ___arguments.context.pageData['datatable'] = Bug_reports;
  ___arguments.context.pageData['filtered_table'] = Bug_reports;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/admin--bugReports/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--bugReports/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--bugReports/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--bugReports/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--bugReports/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('on click');
  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('setting relations');
  await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_to', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'))]);
  await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_from', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'))]);
  await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_product', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'))]);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('saving');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'product_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product_old')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed'))) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--bugReports/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--bugReports/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/admin--bugReports/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--bugReports/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var transaction_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    transaction_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, null, null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in transaction_table) {
      j = transaction_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['datatable'] = transaction_table;
    ___arguments.context.pageData['filtered_table'] = transaction_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/admin--bugReports/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--bugReports/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--bugReports/components/d349ef026fff7f4760a82e823ab646f5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeRecords'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, null, null));
  ___arguments.context.pageData['officeSelector'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.pageData, 'officeRecords')), 'objectId', 'office_name'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/admin--bugReports/components/e23b5e4167c7f645490d865b09a8f90f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var transaction_table, productSelector, j, locationSelector, product_table, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageTitle'] = 'Admin - Transaction Records';
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  transaction_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', (getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'objectId')))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), null, null, null, 'transaction_date desc', ['link_moved_to', 'link_moved_from', 'link_product']));
  product_table = 0;
  locationSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, 'name')), 'objectId', 'name'));
  productSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, 'product_name')), 'objectId', 'product_name'));
  for (var j_index in transaction_table) {
    j = transaction_table[j_index];
    j['setBackground'] = true;
    j['moved_to_select'] = locationSelector;
    j['moved_from_select'] = locationSelector;
    j['product_select'] = productSelector;
  }
  ___arguments.context.pageData['datatable'] = transaction_table;
  ___arguments.context.pageData['filtered_table'] = transaction_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' ',''].join(''));
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('on click');
  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('setting relations');
  await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_to', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'))]);
  await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_from', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'))]);
  await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_product', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'))]);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('saving');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'product_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product_old')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed'))) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var transaction_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'whereClause')));
    transaction_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'created DESC', null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in transaction_table) {
      j = transaction_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['datatable'] = transaction_table;
    ___arguments.context.pageData['filtered_table'] = transaction_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/d349ef026fff7f4760a82e823ab646f5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeRecords'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, null, null));
  ___arguments.context.pageData['officeSelector'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.pageData, 'officeRecords')), 'objectId', 'office_name'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/e23b5e4167c7f645490d865b09a8f90f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'transaction_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/f8f2735b46daa93ccd0c3aae3fed08f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['moved_from_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_moved_from'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_from'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_from.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/b87a43e9fa7d4f0fe5fe9684008a4805/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['moved_to_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_moved_to'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_to'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_to.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--inventoryTransactions/components/6c27870a5354e714749ca60254959d23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['product_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_product'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--manageDealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var dealersTable, dealerObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Manage Dealers';
  ___arguments.context.pageData['dealersMenuOpen'] = true;
  console.log((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})());
  dealersTable = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = true', 'dealer_name ASC', true, 2, 50, 0, true));
  console.log(dealersTable);
  ___arguments.context.pageData['dealers_table'] = dealersTable;
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](dealersTable);
  if ((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollMatrix_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null))) {
    ___arguments.context.pageData['matrixOptions'] = (await Promise.all((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollMatrix_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=true') + String(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Title')),'value': (getObjectProperty(item, 'objectId')) });})));
  }
  dealerObj = (await Promise.all(dealersTable.map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['teamLeaderOptions'] = dealerObj;
  ___arguments.context.pageData['recruitedByOptions'] = dealerObj;
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3364a866c00e7577aa88f93f7b574728')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', dealersTable);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/admin--manageDealers/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--manageDealers/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/admin--manageDealers/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/admin--manageDealers/components/3655ebfada1566fab64959d87ad67273/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'matrixOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(___arguments.value);
  console.log(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--manageDealers/components/e5f4d34d6bc5025b11b5be8b75ed7f1c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'teamLeaderOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/admin--manageDealers/components/f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--manageDealers/components/184719acc309867f8cb2630b60a251fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['lockDealerEdit'] = true;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3655ebfada1566fab64959d87ad67273', (getObjectProperty(___arguments.context.dataModel, 'current_matrix_level.objectId')));

  },
  /* handler:onMounted */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.dataModel['lockDealerEdit'] = true;

  },
  /* handler:onVisibilityChange */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'viewInactiveDealers')) {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3655ebfada1566fab64959d87ad67273', (getObjectProperty(___arguments.context.dataModel, 'current_matrix_level.objectId')));
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/admin--manageDealers/components/48ddc72360253729a31c0648e94eaf4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--manageDealers/components/4e464907f60864c43d5bf9199443b6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = (getObjectProperty(___arguments.context.pageData, 'selectedDealer'));
  console.log(selectedDealer);
  await Backendless.Data.of('Dealers').remove( selectedDealer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('797d972e882aba5e545be8339eb928fa', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level').setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onSubmit */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerName = (getObjectProperty(___arguments.context.pageData, 'selectedDealerName'));

  return (['You are about to delete the dealer \'',dealerName,'\', are you sure?'].join(''))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/admin--manageDealers/components/0bc4f03e05fc6dc3c65b1c21e93fa126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'isTeamLeader')) {
    ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['teamLeaderObjId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId'));
  }
  await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save( ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') );
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'current_matrix_level')) {
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'current_matrix_level', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'current_matrix_level'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'teamLeaderObjId')) {
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'teamLeader', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'teamLeaderObjId'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruitedByObjId')) {
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'recruitedBy', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruitedByObjId'))]);
  }
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('a2ebd282f595125cbc38ebd3dec34d3d', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--manageDealers/components/7a8e273faf518dbf410be92822b58127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', true);
  ___arguments.context.pageData['dealers_table'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = FALSE ', 'dealer_name asc', 'current_matrix_level', 2, null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));
  ___arguments.context.pageData['viewInactiveDealers'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--manageDealers/components/187e1a17e595c884f153df83057d378a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', false);
  ___arguments.context.pageData['dealers_table'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = TRUE ', 'dealer_name asc', 'current_matrix_level', 2, null, null, true));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--manageDealers/components/1aeca0a1b76d64fb0bda359a2cd718be/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'recruitedByOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var sales_table, j, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageTitle'] = 'Admin - Sales Records';
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf4a68dbff19efd1724a5a13cadb5b7f')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/admin--salesRecords/components/8767c648fe39d38ee21ff4986c5ef18e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--individualRecord', ({ 'recordObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects, whereClause, j, whereList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereList = [];
  if (getObjectProperty(___arguments.context.pageData, 'flagged')) {
    addItemToList(whereList, ['link_to_calculations.red_flag = true']);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')) {
    addItemToList(whereList, [['order_num=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')) {
    addItemToList(whereList, [['sales_date>=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')) {
    addItemToList(whereList, [['sales_date<=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')) {
    addItemToList(whereList, [['dealer_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')) {
    addItemToList(whereList, [['cust_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.pageData, 'cancelled')) {
    addItemToList(whereList, [String('sale_cancelled=true')]);
  } else {
    addItemToList(whereList, [String('sale_cancelled=false')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')) {
    addItemToList(whereList, [['link_to_calculations.sale_type=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')),'\''].join('')]);
  }
  whereClause = whereList[0];
  if (whereList.length > 1) {
    var j_list = whereList.slice(1, whereList.length);
    for (var j_index in j_list) {
      j = j_list[j_index];
      whereClause = [whereClause,' AND ',j].join('');
    }
  }
  ___arguments.context.pageData['whereClause'] = whereClause;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/72ea530a22586916ed9544287529e324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['customer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  ___arguments.context.pageData['modalLoading'] = true;
  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;
  ___arguments.context.pageData['modalLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/d09d15686d444a14ca6864fb0dd2e9e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'ok2pay': ___arguments.value }), true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/e60d3ac83759bd74a71e5fd36734b2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['flagged'] = (!(getObjectProperty(___arguments.context.pageData, 'flagged')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'flagged')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#cccccc';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var sales_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, null, null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in sales_table) {
      j = sales_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['sales_table'] = sales_table;
    ___arguments.context.pageData['filtered_sales_table'] = sales_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/dfabf62d756fda2b26b81466095b2fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['saleType'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.sale_type=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.sale_type=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin--salesRecords/components/0c06a9be5a8254bf37074edc995f1535/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'sale_type')) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/85043e543db576c7e314c7a26ff89a2c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var saleType;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'setBackground')) && (getObjectProperty(___arguments.context.dataModel, 'link_to_calculations'))) {
    saleType = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'link_to_calculations')), 'sale_type'));
    ___arguments.context.dataModel['setBackground'] = false;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/a8c7e1c17aeb0504da1e9e1cce898fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['cancelled'] = (!(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled'))), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'cancelled')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#cccccc';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/admin--salesRecords/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin--salesRecords/components/d349ef026fff7f4760a82e823ab646f5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeRecords'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, null, null));
  ___arguments.context.pageData['officeSelector'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.pageData, 'officeRecords')), 'objectId', 'office_name'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['breadCrumb'] = 'Edit Dealer Scores';
  ___arguments.context.pageData['pageTitle'] = 'Update Scores';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/d20ed28973b4479984c81d86be4a681c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, allDatesExceptChosen, databaseScores, newScore, response, selectedDatePlus1, item, selectedDate, isObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['scoreSavingActive'] = true;
  selectedDate = (new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() - ((2 * 3600) * 1000)));
  selectedDatePlus1 = (new Date(selectedDate.getTime() + ((1 * 86400) * 1000)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealerRecord'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    newScore = (getObjectProperty(j, 'dealerScore'));
    if (newScore) {
      newScore['date'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() + ((12 * 3600) * 1000))).toISOString());
      databaseScores = (getObjectProperty(j, 'historic_comp_scores'));
      allDatesExceptChosen = (await asyncListFilter(databaseScores, async (item) => {
         isObject = (item !== null && !Array.isArray(item) && (typeof item === 'object'));
        if (isObject) {
          response = (new Date((getObjectProperty(item, 'date')))) < selectedDate || (new Date((getObjectProperty(item, 'date')))) >= selectedDatePlus1;
        } else {
          response = false;
        }


       return response;
      }));
      databaseScores = (addItemToList(allDatesExceptChosen, newScore));
      j['historic_comp_scores'] = databaseScores;
      console.log('new scores to be saved');
      console.log(allDatesExceptChosen);
      delete j['dealerScore'];
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(j, true);
    }
  }
  ___arguments.context.pageData['scoreSavingActive'] = false;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2396d5c8b0ecee5fc04e28398dac84ad', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealerRecord'] = undefined;
  ___arguments.context.pageData['selectedDate'] = undefined;
  ___arguments.context.pageData['submissionDailyTotal'] = undefined;
  ___arguments.context.pageData['saleDailyTotal'] = undefined;
  ___arguments.context.pageData['appointmentDailyTotal'] = undefined;
  ___arguments.context.pageData['demoDailyTotal'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/8c6d44e82e7b10b665ad3ea70643b22f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/bdf97d6fe8196affec1a20eb961e872a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var submissionTotal, saleTotal, demoTotal, appointmentTotal, j, dealerRecord, scores, selectedDate, item, historicScoreForDay, selectedDatePlus1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  selectedDate = (new Date(((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')))).toUTCString())));
  selectedDate.setHours(0);
  selectedDate.setMinutes(0);
  ___arguments.context.pageData['selectedDate'] = selectedDate;
  if (typeof ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) === 'undefined') {
    localStorage.setItem('officeObjId', JSON.stringify('C73B2210-82F4-4467-9AE1-4277517ADD54'));
  }
  selectedDatePlus1 = (new Date((new Date(selectedDate)).getTime() + ((1 * 86400) * 1000)));
  dealerRecord = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_active = TRUE and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\' ','',''].join('')), 'dealer_nameLast ASC', null, null, null, null, null));
  for (var j_index in dealerRecord) {
    j = dealerRecord[j_index];
    if (!((getObjectProperty(j, 'historic_comp_scores')) === null)) {
      historicScoreForDay = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((item !== null && !Array.isArray(item) && (typeof item === 'object')) && (new Date((getObjectProperty(item, 'date')))) >= selectedDate && (new Date((getObjectProperty(item, 'date')))) < selectedDatePlus1);
      }));
      if (historicScoreForDay.length > 1) {
        console.log('PROBLEM');
        console.log(j);
        console.log(getObjectProperty(j, 'historic_comp_scores'));
        console.log(selectedDate);
        console.log(selectedDatePlus1);
        console.log(historicScoreForDay);
      }
      console.log('on loading the historic comp scores are: ');
      console.log(getObjectProperty(j, 'historic_comp_scores'));
      j['dealerScore'] = (historicScoreForDay[0]);
    }
  }
  ___arguments.context.pageData['dealerRecord'] = dealerRecord;
  ___arguments.context.pageData['allScores'] = scores;
  for (var j_index2 in dealerRecord) {
    j = dealerRecord[j_index2];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/95939a88498a0c1fc19b0af541dff3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var dealerNames, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerNames = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealers_table'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }

  return dealerNames

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/c1c1148c616506ea59e4e065ab877d9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dateSelectedText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDate')) {
    dateSelectedText = ((getObjectProperty(___arguments.context.pageData, 'selectedDate')).toDateString());
  } else {
    dateSelectedText = '';
  }

  return dateSelectedText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/faafde8fa54a752379ec90565dabafa5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var appointmentTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/ee1abffadd2e834e466bcc8ffcdf4497/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var demoTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
  }
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/efc2ae5d82e13079ea0bbdba718b3208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var saleTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
  }
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bak--competitions--updateScores/components/865a0555425774de5b11e50514a9e687/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var submissionTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--addDealer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['pageTitle'] = 'Add Dealer';
  ___arguments.context.pageData['breadCrumb'] = 'Add Dealer';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['dealersData'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = TRUE AND office_link = \'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join(''))).setSortBy('dealer_name ASC').setPageSize(100)));
  ___arguments.context.pageData['managersData'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = TRUE AND is_team_leader = TRUE AND office_link = \'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\' and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\''].join(''))).setSortBy('dealer_name ASC').setPageSize(100)));
  ___arguments.context.pageData['showError'] = false;

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/competitions--addDealer/components/263fc32c058aceaba42d897232b950a5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var dealerObject;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/competitions--addDealer/components/0a42b893a12ba9febe2a02ce348240aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userRecord, dealerRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_email = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')),'\''].join(''))))) > 0 || (await Backendless.Data.of('Users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['errorMessage'] = 'A dealer account is already registered with this email address.';
    ___arguments.context.pageData['showError'] = true;
  } else {
    ___arguments.context.pageData['addDealerRunning'] = true;
    dealerRecord = ({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'objectId')),'dealer_nameFirst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerFirstName')),'dealer_nameLast': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerLastName')),'dealer_email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')),'dealer_phone': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerCell')),'is_team_leader': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'isTeamLeader')),'historic_comp_scores': [({ 'date': '2022-01-01T02:00:00.000Z','submissions': null,'appointments': null,'demos': null,'sales': null })] });
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(dealerRecord, true);
    userRecord = ({ 'name': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerFirstName')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerLastName'))].join(''),'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')),'password': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerPassword')),'userGroup': 'Dealer' });
    await Backendless.Data.of('Users').save(userRecord, true);
    ___arguments.context.pageData['userObjectID'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setSortBy('created DESC').setPageSize(1)));
    ___arguments.context.pageData['dealerObjectID'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setSortBy('created DESC').setPageSize(1)));
    await Backendless.Data.of('Users').setRelation((getObjectProperty(___arguments.context.pageData, 'userObjectID.0.objectId')), 'office_link', [(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId'))]);
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.pageData, 'dealerObjectID.0.objectId')), 'user_link', [(getObjectProperty(___arguments.context.pageData, 'userObjectID.0.objectId'))]);
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.pageData, 'dealerObjectID.0.objectId')), 'office_link', [(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId'))]);
    ___arguments.context.pageData['showError'] = false;
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'teamLeaderSelect')) == null)) {
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.pageData, 'dealerObjectID.0.objectId')), 'team_leader', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'teamLeaderSelect'))]);
    }
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'recruitedBy')) == null)) {
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.pageData, 'dealerObjectID.0.objectId')), 'recruited_by', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'recruitedBy'))]);
      ___arguments.context.pageData['showError'] = false;
    }
    ___arguments.context.pageData['addDealerRunning'] = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('b072a0d5d126d78a681d412717fa2173', undefined, undefined, undefined, undefined, undefined);
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerFirstName'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerLastName'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerEmail'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerCell'] = null;
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3a2dc6e58376c105965973ac21aebb8a', null);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('d4c611afd938927f3c0b54f6c68d79be', null);
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerPassword'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerConfirmPassword'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--addDealer/components/d4c611afd938927f3c0b54f6c68d79be/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var dealerNames, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerNames = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealersData'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }

  return dealerNames

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--addDealer/components/3c49f6040ffa369eaa5f772105d9939a/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerPassword')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerConfirmPassword'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32a9a9258d74b3fabd5fe4b2f51c17d4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32a9a9258d74b3fabd5fe4b2f51c17d4', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/competitions--addDealer/components/366e154af41b5702e5f729a6a358eefb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String('\'s Dealers'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--addDealer/components/3a2dc6e58376c105965973ac21aebb8a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var j, teamLeaderNames;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  teamLeaderNames = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'managersData'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(teamLeaderNames, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }

  return teamLeaderNames

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var dealerScoresList, dealersWithScores, dealerTableName, item, j, k, loggedInUser, thisMonthsAppointmentsTotal, thisMonthsDemosTotal, thisMonthsRecruitsTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsSurveysTotal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['pageTitle'] = 'Dealer Competitions Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Dealer Competitions Dashboard';
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')));
  ___arguments.context.pageData['currentUser'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  dealerTableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null));
  if (dealerTableName == 'Dealers_Dream_Team_Division') {
    ___arguments.context.pageData['dreamTeamOffice'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64cd979bbe2267aca25d301aa9242749'))['grid-template-columns'] = 'repeat(auto-fill, minmax(160px, 1fr))';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64cd979bbe2267aca25d301aa9242749'))['display'] = 'grid';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64cd979bbe2267aca25d301aa9242749'))['grid-gap'] = '15px';
  }
  ___arguments.context.pageData['relatedDealer'] = ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('related dealer');
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'relatedDealer')));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  if (getObjectProperty(___arguments.context.pageData, 'relatedDealer.historic_comp_scores')) {
    ___arguments.context.pageData['thisMonthsScores'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'relatedDealer.historic_comp_scores')), async (item) => {


     return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
    }));
  } else {
    ___arguments.context.pageData['thisMonthsScores'] = [];
  }
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  thisMonthsSurveysTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'thisMonthsScores'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
    if (getObjectProperty(j, 'surveys')) {
      thisMonthsSurveysTotal = thisMonthsSurveysTotal + (getObjectProperty(j, 'surveys'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100));
  ___arguments.context.pageData['dealerTotalSurveys'] = thisMonthsSurveysTotal;
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('before competitions call');
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.office_link.objectId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index5 in j_list3) {
    j = j_list3[j_index5];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index6 in j_list4) {
    j = j_list4[j_index6];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index7 in j_list5) {
    j = j_list5[j_index7];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/competitions--dashboard/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--dashboard/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--dashboard/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/fae67c2d442e9ff6a2838821f0d229a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showNumberOne;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showNumberOne = false;
  } else {
    showNumberOne = true;
  }

  return showNumberOne

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/afa92b8a9cd3e20259192d2285f1cdfc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8880bec0c184a379ca95852831a804'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/4ed14312995ef26da6954e01e1b1cc35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8880bec0c184a379ca95852831a804'), 'demosLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/a54de9a39eda3d997836ed0c940fbf25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/43de9671a1f5a4eb349c49fed61ac607/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('38e9607ca7cdceae501a0a6260689bd7'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/7b0b4e7db87968a19c5201acff6c0c96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661f81ae9db1385d7d168214a1037976'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/67bd7eead72929d7463203aacfa2c3cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('38e9607ca7cdceae501a0a6260689bd7'), 'appointmentsLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/7621a3cd7f7abd6fe534534a9136cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661f81ae9db1385d7d168214a1037976'), 'submissionsLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/e225e495e27754255e3f92e2afcf61ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/6046029c1113b6859964985f8d2fcd95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/7f787ea618077b870c083b85f1a5ae4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var closingAverageOutput;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')) {
    closingAverageOutput = (getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage'));
  } else {
    closingAverageOutput = 0;
  }

  return closingAverageOutput

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard/components/0ebcc1019d18a6e66a1a4dae1e135f76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dreamTeamOffice'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, item, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['pageTitle'] = 'Competition Dashboard';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['relatedDealer'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['thisMonthsScores'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'relatedDealer.dealerLink.historic_comp_scores')), async (item) => {


   return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'thisMonthsScores'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57f7a68285de6be42cfc28dc79b18f21', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d8e0e78b439b4b568aaaea6331f24da', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00540bff12b3d652dd4c49c603a84c54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d3c05e3617ff01a8604f0c6a9bd58c4', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8db890cd6e0486670ad49514b067c1e1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('739139e9d6046f8114fe9ad6ec4cd347', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4381bd5a81b67cde15ac900ba0ee5b94', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86f10b197935c30686a9b84d60c9c3eb', true);
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.dealerLink.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5be22fc5726c6d54c46b75ef506c1846', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', true);
  ___arguments.context.pageData['salesLeaderboard'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setSortBy('comp_sales DESC').setPageSize(5)));
  await Backendless.Counters.reset('salesPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b67e826efe3b63d4f0364576a117f348', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14eea1a13be69f63140c2b7eae37d2f8', true);
  }
  ___arguments.context.pageData['demosLeaderboard'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setSortBy('comp_demos DESC').setPageSize(5)));
  await Backendless.Counters.reset('demosPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b9e2b4dcc0be4da4fd4a735a0a7a4627', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac1f0e492772ada6cbbb29f584311905', true);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/14eea1a13be69f63140c2b7eae37d2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/fae67c2d442e9ff6a2838821f0d229a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showNumberOne;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showNumberOne = false;
  } else {
    showNumberOne = true;
  }

  return showNumberOne

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/ac1f0e492772ada6cbbb29f584311905/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/afa92b8a9cd3e20259192d2285f1cdfc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8880bec0c184a379ca95852831a804'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/4ed14312995ef26da6954e01e1b1cc35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8880bec0c184a379ca95852831a804'), 'demosLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/a54de9a39eda3d997836ed0c940fbf25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/7f787ea618077b870c083b85f1a5ae4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var closingAverage, thisMonthsDemosTotal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')) == null) {
    closingAverage = '0%';
  } else {
    closingAverage = String(getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')) + String('%');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c47666493604c53b01d1b7dabc116d64', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f787ea618077b870c083b85f1a5ae4b', true);

  return closingAverage

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--dashboard--test/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, dealerMonthlySubmissions, dealerMonthlySales, dealerMonthlyDemos, dealerMonthlyAppointments, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, loggedInUser, competitionRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (getObjectProperty(___arguments.context.pageData, 'competitionObjectId')) {
    competitionRecord = (await Backendless.Data.of('Competitions').findById((getObjectProperty(___arguments.context.pageData, 'competitionObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  } else {
    competitionRecord = (await Backendless.Data.of('Competitions').findById('B7698584-CAD8-41FD-8D0D-DBEC3FF9036D', Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    ___arguments.context.pageData['competitionObjectId'] = 'B7698584-CAD8-41FD-8D0D-DBEC3FF9036D';
  }
  ___arguments.context.pageData['selectedCompetition'] = competitionRecord;
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedCompetition'));
  ___arguments.context.pageData['competition_prizes'] = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_prizes'));
  ___arguments.context.pageData['pageTitle'] = 'Complete Competiton';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['targetAchieved'] = true;
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))].join(''));
  ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))).getTime() + (86400 * 1000)));
  ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'competition_start_date'));
  console.log(getObjectProperty(___arguments.context.pageData, 'competition_end_date'));
  console.log(getObjectProperty(___arguments.context.pageData, 'compEndDateModified'));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND objectId != \'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
        }));
      }
    }
  }
  dealersWithScores = dealerScoresList;
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Chase the Challenge') {
    ___arguments.context.pageData['firstPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 9);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'firstPrizeWinners')).length == 0) {
      ___arguments.context.pageData['firstPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['firstPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'firstPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['secondPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 7);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'secondPrizeWinners')).length == 0) {
      ___arguments.context.pageData['secondPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['secondPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'secondPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['thirdPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 5);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'thirdPrizeWinners')).length == 0) {
      ___arguments.context.pageData['thirdPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['thirdPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'thirdPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['fourthPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 3);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'fourthPrizeWinners')).length == 0) {
      ___arguments.context.pageData['fourthPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['fourthPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fourthPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['fifthPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 2);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'fifthPrizeWinners')).length == 0) {
      ___arguments.context.pageData['fifthPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['fifthPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fifthPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index5 in j_list3) {
    j = j_list3[j_index5];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index6 in j_list4) {
    j = j_list4[j_index6];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index7 in j_list5) {
    j = j_list5[j_index7];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/8173e99e3f82190d52af7e299f47f4ab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')),'\')'].join(''));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = 'url(\'https://demo.tellusapps.net/api/files/web/assets/images/Competition%20Featured%20Image%20Placeholder.jpg\')';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/4574c40309521b8ec1bc55af92ab200a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Ends on ') + String((await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/7e9513be7a57a93a0231da6fe7956842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2c7e26d6028958e1484f23667b1107a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/12ae497ee2054a6db6cba8f9d27451ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/35ae3cb6acb74385a158080fccd32102/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var salesOutput, salesProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  salesProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) * 100);
  if (salesProgress >= 100) {
    salesOutput = 100;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  } else {
    salesOutput = salesProgress;
  }

  return salesOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/eed8f156a86eabc8ded231dd40dee3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/417cc6e12279ac2aa60860cf8a1e72e2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var demoOutput, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  demoProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) * 100);
  if (demoProgress >= 100) {
    demoOutput = 100;
    ___arguments.context.pageData['demoTargetAchieved'] = true;
  } else {
    demoOutput = demoProgress;
  }

  return demoOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/07d570aa2c8a905a1f8aed8b1374c192/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/7daeb8424f3e32282e199b4640c12aca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')),' Appointments'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/6c639beee23abfba8e658214b684fa4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')),' Submissions'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/6b3c6606bc1e706150fc226db7a92f66/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var appointmentOutput, appointmentProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appointmentProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) * 100);
  if (appointmentProgress >= 100) {
    appointmentOutput = 100;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  } else {
    appointmentOutput = appointmentProgress;
  }

  return appointmentOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/24e6ea39eb650afbd7b75c75c6ab4bfc/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var submissionsOutput, submissionsProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  submissionsProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) * 100);
  if (submissionsProgress >= 100) {
    submissionsOutput = 100;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  } else {
    submissionsOutput = submissionsProgress;
  }

  return submissionsOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/e9e282eed90f1876650516c890bd41b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var demoWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) {
    demoWidgetVisible = true;
  } else {
    demoWidgetVisible = false;
  }

  return demoWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/b48579c6d305a5a511776ed41b51b83a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var submissionsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) {
    submissionsWidgetVisible = true;
    ___arguments.context.pageData['submissionTargetAchieved'] = null;
  } else {
    submissionsWidgetVisible = false;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  }

  return submissionsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/24a86bdd811b5bc177c56ad4f8c398ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) {
    salesWidgetVisible = true;
    ___arguments.context.pageData['saleTargetAchieved'] = null;
  } else {
    salesWidgetVisible = false;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  }

  return salesWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/1f683f038b46bc3e4392e8753797f9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var appointmentsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) {
    appointmentsWidgetVisible = true;
    ___arguments.context.pageData['appointmentTargetAchieved'] = null;
  } else {
    appointmentsWidgetVisible = false;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  }

  return appointmentsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2ff31c1ff518e445fa31a53c22de8aa1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/661b3534c607e78d89aeac7dd1bb8f43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/75bfceb38f05db6e438b9e433b997bda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2f3d48adfd2c7dce43c7bf16f92fc9f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/5be4e62fb8112c66d82cd6042ff3ea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')),' Demos.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/ef2ba114fd1fc83558fb24f665dd7d52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')),' Sales.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2a3d7ef495424e35bd5dd6b55db5b509/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')),' Appointments.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/07ee20f3cc1c049eec883a1dde7bbf51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')),' Submissions.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/e45e7119cb6512986bbbe9e796443a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/9c44eb6d5db53c0a47c7e308cdf5a9de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/b3fc7c19997fe2d2192682c7bd9f5757/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/ad54086dd504588b7a0493a91de28ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/7494a1974f1b357e020bb5433c64ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showCompleteBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'targetComplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'appointmentTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'demoTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'saleTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'submissionTargetAchieved'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/64ee7b41a369b9573784d0fa4c7f5039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'OR')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/e4346b278ccd8249ee16a1ed9e834156/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'AND')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/974ee2c6b54be9a43f2487b226cfb0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var closingAverageVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')) {
    closingAverageVisible = true;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = null;
  } else {
    closingAverageVisible = false;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
  }

  return closingAverageVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/7508ab5a8601bd7d420f17020e63d4d2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var closingAverageOutput, closingAverageAmount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  closingAverageAmount = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerClosingAverageValue')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))) * 100);
  if (closingAverageAmount >= 100) {
    closingAverageOutput = 100;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
  } else {
    closingAverageOutput = closingAverageAmount;
  }

  return closingAverageOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/78090408dc078006c2992244966cdb72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')),'% Closing Average'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2f7c04447635e3fa7183001df9a7d1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have a ',(getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')),' Closing Average.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/af13898b6c496042470e886520e713df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Closing Average'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/14b1e7ab4b28f2676e33fa0ed85a6011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/14cc8a38baa76093fa4fb5e94eb1363c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eca9f008baa152468b953f7bdc0f9c91'), 'dealerTotalSubmissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/a5f9258d93f9e6898cd2e7ab01425d59/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c5a5cb2d365b24c117ce89134e9f67a'), 'dealerTotalAppointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/f8c1bbd4dba4f60cf3a826bb383e2e66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cdd9ae65b9a1dc830decef692fab4766'), 'dealerTotalDemos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/7bb2ba7cb9821a0b67fc1eb1e86588f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('19b6d3eb71e9a395bef32158454ded9a'), 'dealerTotalSales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/dcdd48ac64a87e0304f6382ba65fdc7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/3ae45d640b175a9249a8e5489c5161f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/f1ffcb4600a6c0a183eea76679a7607e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/0bff8108d61e46bfcf2892f6f3b69f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/fcc4246e170e61e5457dba46599880ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/270daa742eaf1a45548e37dc69d4bd9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/0a99475152018365082d57872bd2c29c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/ffab9c17236ce5d91002794a6e8a3907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submission Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/61f7d2be3b98e94129437c2e2df92666/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Appointment Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/12c1aa753b82bac5cc58e6182b3cc6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Demo Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/2c6a45756e76a76d874559c14fdaf00b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Sale Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionCompetitionView/components/0037893ced6abb9e9dbd3125d425b9e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizesTTS;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Time to Shine' || (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Chase the Challenge') {
    showPrizesTTS = true;
  } else {
    showPrizesTTS = false;
  }

  return showPrizesTTS

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, thisMonthsRecruitsTotal, dealerRecords, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  console.log('entering division dashboard');
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competitions Division Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Division Dashboard';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  console.log((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['closingAverageMonthlyTotal'] = 0;
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  console.log('debugging division');
  console.log((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager IN (\'',(getObjectProperty(loggedInUser, 'objectId')),'\')'].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager IN (\'',(getObjectProperty(loggedInUser, 'objectId')),'\')'].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['relatedOfficesDealers'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  dealerRecords = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  ___arguments.context.pageData['monthlyScores'] = [];
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
        }));
      }
    }
  }
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list2) {
    j = j_list2[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  console.log('testing2');
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\'  AND related_office in (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['activeCompList'] = [];
  console.log(getObjectProperty(___arguments.context.pageData, 'activeCompList'));
  ___arguments.context.pageData['noActiveCompetitions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'noActiveCompetitions')) == 0) {
    ___arguments.context.pageData['showActiveCompAlert'] = true;
  }
  ___arguments.context.pageData['competitionsHistoricData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date <= \'',((new Date()).toISOString()),'\'  AND related_office in (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['noHistoricCompetitions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionsHistoricData')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'noHistoricCompetitions')) == 0) {
    ___arguments.context.pageData['showHistoricCompAlert'] = true;
  }
  ___arguments.context.pageData['competitionsUpcomingData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_start_date >= \'',((new Date()).toISOString()),'\'  AND related_office in (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['noUpcomingCompetitions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionsUpcomingData')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'noUpcomingCompetitions')) == 0) {
    ___arguments.context.pageData['showUpcomingCompAlert'] = true;
  }
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index4 in dealerScoresList) {
    j = dealerScoresList[j_index4];
    if (getObjectProperty(j, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  dealersWithScores = dealerScoresList;
  console.log(dealersWithScores);
  for (var j_index5 in dealersWithScores) {
    j = dealersWithScores[j_index5];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index6 in j_list3) {
    j = j_list3[j_index6];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index7 in j_list4) {
    j = j_list4[j_index7];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index8 in j_list5) {
    j = j_list5[j_index8];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list6 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index9 in j_list6) {
    j = j_list6[j_index9];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }
  console.log('end of page enter');

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newDivisionCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/ce418402b5d84aef8fc90fe429b79797/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
      return [({ 'name': 'John Doe','goal': 20,'progress': 16 }), ({ 'name': 'Amy Doe','goal': 20,'progress': 13 }), ({ 'name': 'Sam Doe','goal': 20,'progress': 8 })]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/5e5bcb9252b95c5db24a685d0e7ba96e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/eac39dcf5afdf452f68f28037dd8c028/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/4df27c387f5129a94243caa2526e938d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')),' - ',(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))),' Statistics'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/263f2c5f81ee1d7ef687ea32d19f532c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/18dd18c4d1daf94ea39fdc11887b0ca1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/dc33f128444db49aa11796e4d09678ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/ed21226de231a66b844cb4ed2975d2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/8ae68cdf9f527e7e184afeeca6739809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/27d26ad721a3d804d60338eb95c733ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c09b618edc3be09b16c11a7c21f6da35', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('303d7e288e476db668f61888c4c3b59c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/eb8ae826a47f2f1a6aba025e41c9f91b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c09b618edc3be09b16c11a7c21f6da35', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('303d7e288e476db668f61888c4c3b59c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/82c7648c014aad3b279bdf5927a7c4fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/e8dc37691ddf805f6e7b4511cde68743/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/18e85bd771f6b27406a67bb669950766/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/c00c83c5765ee55646c65a3de24c160f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/66246dbb368ed1e11b9c40282ea20051/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/9e640ff36b848145945c2bce9f86fd35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/377aaff792a566fcb12fbd89adb1c278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/66b118937503563f918c5c0598cf2c6f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDashboard/components/cebde4d44c3bfe2411f3135104b324da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c09b618edc3be09b16c11a7c21f6da35', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('303d7e288e476db668f61888c4c3b59c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, item, dealersWithScores, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Division Leaderboards';
  ___arguments.context.pageData['breadCrumb'] = 'Division Leaderboards';
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['relatedOfficesDealers'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  console.log('###debug###');
  console.log(getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  console.log('###debug###');
  dealersWithScores = dealerScoresList;
  console.log(dealersWithScores);
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/069b65b829b90db13668a75b3a3b26b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' - Overall Scores'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' - Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/c338909204e34dd5e87d22b258de45f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, item, dealersWithScores, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('67a93b5ded6c306343110de2d1acac66', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ff3714a7f5e245c72ad80f4e9a2412b', true);
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = [];
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    j['monthlyScores'] = null;
    if (getObjectProperty(j, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        }));
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return (getObjectProperty(item, 'monthlyScores'));
  }));
  console.log(dealersWithScores);
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  console.log(dealersWithScores);
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionDealerLeaderboards/components/67a93b5ded6c306343110de2d1acac66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var demoTotalStat, saleTotalStat, recruitTotalState, submissionTotalStat, appTotalStat, j, item, dealersWithScores, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('67a93b5ded6c306343110de2d1acac66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ff3714a7f5e245c72ad80f4e9a2412b', false);
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    j['dealerTotalAppointments'] = 0;
    j['dealerTotalDemos'] = 0;
    j['dealerTotalSales'] = 0;
    j['dealerTotalSubmissions'] = 0;
    j['dealerTotalRecruits'] = 0;
    if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
    if (getObjectProperty(j, 'monthlyScores')) {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      }
    } else {
      if (getObjectProperty(j, 'historic_comp_scores')) {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return (getObjectProperty(item, 'monthlyScores'));
  }));
  console.log(dealersWithScores);
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  appTotalStat = 0;
  demoTotalStat = 0;
  saleTotalStat = 0;
  submissionTotalStat = 0;
  recruitTotalState = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      appTotalStat = appTotalStat + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      demoTotalStat = demoTotalStat + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      saleTotalStat = saleTotalStat + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      submissionTotalStat = submissionTotalStat + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      recruitTotalState = recruitTotalState + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = appTotalStat;
  ___arguments.context.pageData['dealerTotalDemo'] = demoTotalStat;
  ___arguments.context.pageData['dealerTotalSale'] = saleTotalStat;
  ___arguments.context.pageData['dealerTotalSubmission'] = submissionTotalStat;
  ___arguments.context.pageData['dealerTotalRecruits'] = recruitTotalState;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((saleTotalStat / demoTotalStat) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, officeScoreList, thisMonthsRecruitsTotal, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, l, divisionTotalRecruits, divisionTotalSubmissions, divisionTotalSales, divisionTotalDemos, divisionTotalAppointments, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Division Leaderboard';
  ___arguments.context.pageData['breadCrumb'] = 'Division Leaderboard';
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['eagleDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((String('region_link = \'60D7A635-E285-41A1-86D6-094053A81D84\''))).setRelationsDepth(3).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_table', 'office_name', 'office_photo']).setRelationsDepth(2).setPageSize(10)));
    var k_list = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      k['officeDealers'] = (await Backendless.Data.of((getObjectProperty(k, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(k, 'objectId')),'\''].join(''))).setProperties(['historic_comp_scores']).setRelationsDepth(2).setPageSize(100)));
    }
  }
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      var l_list = (getObjectProperty(k, 'officeDealers'));
      for (var l_index in l_list) {
        l = l_list[l_index];
        if (getObjectProperty(l, 'historic_comp_scores')) {
          if (getObjectProperty(k, 'eventScores')) {
            addItemToList((getObjectProperty(k, 'eventScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
            })));
          } else {
            k['eventScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
            }));
          }
        }
      }
    }
  }
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    var k_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index3 in k_list3) {
      k = k_list3[k_index3];
      thisMonthsAppointmentsTotal = 0;
      thisMonthsDemosTotal = 0;
      thisMonthsSalesTotal = 0;
      thisMonthsSubmissionsTotal = 0;
      thisMonthsRecruitsTotal = 0;
      var l_list2 = (getObjectProperty(k, 'eventScores'));
      for (var l_index2 in l_list2) {
        l = l_list2[l_index2];
        if (getObjectProperty(l, 'appointments')) {
          thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(l, 'appointments'));
        }
        if (getObjectProperty(l, 'demos')) {
          thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(l, 'demos'));
        }
        if (getObjectProperty(l, 'sales')) {
          thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(l, 'sales'));
        }
        if (getObjectProperty(l, 'submissions')) {
          thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(l, 'submissions'));
        }
        if (getObjectProperty(l, 'recruits')) {
          thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(l, 'recruits'));
        }
      }
      k['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
      k['dealerTotalDemos'] = thisMonthsDemosTotal;
      k['dealerTotalSales'] = thisMonthsSalesTotal;
      k['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
      k['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
    }
    divisionTotalAppointments = 0;
    divisionTotalDemos = 0;
    divisionTotalSales = 0;
    divisionTotalSubmissions = 0;
    divisionTotalRecruits = 0;
    var l_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var l_index3 in l_list3) {
      l = l_list3[l_index3];
      if (getObjectProperty(l, 'dealerTotalAppointments')) {
        divisionTotalAppointments = divisionTotalAppointments + (getObjectProperty(l, 'dealerTotalAppointments'));
      }
      if (getObjectProperty(l, 'dealerTotalDemos')) {
        divisionTotalDemos = divisionTotalDemos + (getObjectProperty(l, 'dealerTotalDemos'));
      }
      if (getObjectProperty(l, 'dealerTotalSales')) {
        divisionTotalSales = divisionTotalSales + (getObjectProperty(l, 'dealerTotalSales'));
      }
      if (getObjectProperty(l, 'dealerTotalSubmissions')) {
        divisionTotalSubmissions = divisionTotalSubmissions + (getObjectProperty(l, 'dealerTotalSubmissions'));
      }
      if (getObjectProperty(l, 'dealerTotalRecruits')) {
        divisionTotalRecruits = divisionTotalRecruits + (getObjectProperty(l, 'dealerTotalRecruits'));
      }
    }
    j['divisionTotalAppointments'] = divisionTotalAppointments;
    j['divisionTotalDemos'] = divisionTotalDemos;
    j['divisionTotalSales'] = divisionTotalSales;
    j['divisionTotalSubmissions'] = divisionTotalSubmissions;
    j['divisionTotalRecruits'] = divisionTotalRecruits;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalRecruits'));
  }));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' - Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/c338909204e34dd5e87d22b258de45f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, officeScoreList, thisMonthsRecruitsTotal, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, l;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', true);
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['monthlyScores'] = null;
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-10-06T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-10-06T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionLeaderboards/components/a297435dc8fff5617763b7a75e6c38e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', false);
  await BackendlessUI.Functions.Custom['fn_39c8388efde660a8fac97b5c2e8ea5a6'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, dealerScoresList, item, officeScoreList, k, l, loggedInUser, dealersWithScores;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Office Leaderboards';
  ___arguments.context.pageData['breadCrumb'] = 'Office Leaderboards';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['relatedOfficesDealers'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    j['relatedDealers'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['monthlyScores'] = ___arguments.context.pageData;
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
          }));
        }
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
          }));
        }
      }
    }
  }
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index4 in j_list4) {
    j = j_list4[j_index4];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index5 in j_list5) {
    j = j_list5[j_index5];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/069b65b829b90db13668a75b3a3b26b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' - Overall Scores'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_name')) + String(' - Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/c338909204e34dd5e87d22b258de45f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, item, officeScoreList, k, l;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', true);
  ___arguments.context.pageData['monthlyScores'] = null;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['monthlyScores'] = null;
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          }));
        }
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          }));
        }
      }
    }
  }
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--divisionOfficeLeaderboards/components/a297435dc8fff5617763b7a75e6c38e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', false);
  await BackendlessUI.Functions.Custom['fn_39c8388efde660a8fac97b5c2e8ea5a6'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--editCompetition/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competitions Dashboard';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['editCompetition'] = true;
  ___arguments.context.pageData['targetAchieved'] = true;
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['competition_end_date'] = (new Date());
  ___arguments.context.pageData['andValue'] = 'AND';
  ___arguments.context.pageData['orValue'] = 'OR';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var competitionRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'competitionObjectId')) {
    competitionRecord = (await Backendless.Data.of('Competitions').findById((getObjectProperty(___arguments.context.pageData, 'competitionObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  } else {
    competitionRecord = (await Backendless.Data.of('Competitions').findById('59DC7C27-CB67-4A06-A978-D70B7A2B615C', Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    ___arguments.context.pageData['competitionObjectId'] = 'B7698584-CAD8-41FD-8D0D-DBEC3FF9036D';
  }
  ___arguments.context.pageData['selectedCompetition'] = competitionRecord;
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedCompetition'));
  ___arguments.context.pageData['competition_prizes'] = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_prizes'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/competitions--editCompetition/components/8173e99e3f82190d52af7e299f47f4ab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')),'\')'].join(''));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = 'url(\'https://demo.tellusapps.net/api/files/web/assets/images/Competition%20Featured%20Image%20Placeholder.jpg\')';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/4574c40309521b8ec1bc55af92ab200a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dateDifferenceDays, dateDifference, todaysDate, endDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endDate = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'));
  todaysDate = ((new Date()).valueOf());
  dateDifference = endDate - todaysDate;
  dateDifferenceDays = dateDifference / 86400000;

  return (['Ends in ',Math.ceil(dateDifferenceDays),' days'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/7e9513be7a57a93a0231da6fe7956842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--editCompetition/components/2c7e26d6028958e1484f23667b1107a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/12ae497ee2054a6db6cba8f9d27451ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/35ae3cb6acb74385a158080fccd32102/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var salesOutput, salesProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  salesProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_sales')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) * 100);
  if (salesProgress >= 100) {
    salesOutput = 100;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  } else {
    salesOutput = salesProgress;
  }

  return salesOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--editCompetition/components/eed8f156a86eabc8ded231dd40dee3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/417cc6e12279ac2aa60860cf8a1e72e2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var demoOutput, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  demoProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_demos')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) * 100);
  if (demoProgress >= 100) {
    demoOutput = 100;
    ___arguments.context.pageData['demoTargetAchieved'] = true;
  } else {
    demoOutput = demoProgress;
  }

  return demoOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--editCompetition/components/07d570aa2c8a905a1f8aed8b1374c192/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/7daeb8424f3e32282e199b4640c12aca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')),' Appointments'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/6c639beee23abfba8e658214b684fa4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')),' Submissions'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/6b3c6606bc1e706150fc226db7a92f66/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var appointmentOutput, appointmentProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appointmentProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_appointments')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) * 100);
  if (appointmentProgress >= 100) {
    appointmentOutput = 100;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  } else {
    appointmentOutput = appointmentProgress;
  }

  return appointmentOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--editCompetition/components/24e6ea39eb650afbd7b75c75c6ab4bfc/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var submissionsOutput, submissionsProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  submissionsProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_submissions')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) * 100);
  if (submissionsProgress >= 100) {
    submissionsOutput = 100;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  } else {
    submissionsOutput = submissionsProgress;
  }

  return submissionsOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--editCompetition/components/e9e282eed90f1876650516c890bd41b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var demoWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) {
    demoWidgetVisible = true;
  } else {
    demoWidgetVisible = false;
  }

  return demoWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/b48579c6d305a5a511776ed41b51b83a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var submissionsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) {
    submissionsWidgetVisible = true;
    ___arguments.context.pageData['submissionTargetAchieved'] = null;
  } else {
    submissionsWidgetVisible = false;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  }

  return submissionsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/24a86bdd811b5bc177c56ad4f8c398ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) {
    salesWidgetVisible = true;
    ___arguments.context.pageData['saleTargetAchieved'] = null;
  } else {
    salesWidgetVisible = false;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  }

  return salesWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/1f683f038b46bc3e4392e8753797f9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var appointmentsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) {
    appointmentsWidgetVisible = true;
    ___arguments.context.pageData['appointmentTargetAchieved'] = null;
  } else {
    appointmentsWidgetVisible = false;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  }

  return appointmentsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/5be4e62fb8112c66d82cd6042ff3ea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_demos')),' Demos.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/ef2ba114fd1fc83558fb24f665dd7d52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_sales')),' Sales.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/2a3d7ef495424e35bd5dd6b55db5b509/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_appointments')),' Appointments.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/07ee20f3cc1c049eec883a1dde7bbf51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'relatedDealer.0.dealerLink.comp_submissions')),' Submissions.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/e45e7119cb6512986bbbe9e796443a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/9c44eb6d5db53c0a47c7e308cdf5a9de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/b3fc7c19997fe2d2192682c7bd9f5757/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/ad54086dd504588b7a0493a91de28ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/7494a1974f1b357e020bb5433c64ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showCompleteBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'targetComplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'appointmentTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'demoTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'saleTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'submissionTargetAchieved'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/competitions--editCompetition/components/64ee7b41a369b9573784d0fa4c7f5039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'OR')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/e4346b278ccd8249ee16a1ed9e834156/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'AND')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/a9db400a6eb5655fe3b4c03d8fe54c85/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'editCompetition'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/9d0b452612a8d3b81da7a7a7722eebce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['editCompetition'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d0b452612a8d3b81da7a7a7722eebce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ae42faf497433dbbcdb9ddb1e78527d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('416bf51a5e0f451c9ee74353426558dd', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--editCompetition/components/9ae42faf497433dbbcdb9ddb1e78527d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['editCompetition'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d0b452612a8d3b81da7a7a7722eebce', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ae42faf497433dbbcdb9ddb1e78527d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('416bf51a5e0f451c9ee74353426558dd', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--editCompetition/components/416bf51a5e0f451c9ee74353426558dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Competitions').save((getObjectProperty(___arguments.context.pageData, 'selectedCompetition')), true);
  ___arguments.context.pageData['editCompetition'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('416bf51a5e0f451c9ee74353426558dd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ae42faf497433dbbcdb9ddb1e78527d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d0b452612a8d3b81da7a7a7722eebce', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--editCompetition/components/c2bd42126a3ec8d8d9efc3d9afaa2da8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['deleteEventModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--editCompetition/components/de635e2da6dd5ebf71cba0385cc211b8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Competitions').remove( (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.objectId')) );
  (function () { window.history.back(); })();

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/competitions--editCompetition/components/0b7c2d1aa736ad7df65172fd00dd400c/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([mathRandomInt(100, 100000),'-',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/competitions--editCompetition/components/cb08e104ac455e533ec9c9d793cb853c/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([mathRandomInt(100, 100000),'-',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, dealerMonthlySubmissions, dealerMonthlySales, dealerMonthlyDemos, dealerMonthlyAppointments, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, loggedInUser, competitionRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (getObjectProperty(___arguments.context.pageData, 'competitionObjectId')) {
    competitionRecord = (await Backendless.Data.of('Competitions').findById((getObjectProperty(___arguments.context.pageData, 'competitionObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  } else {
    competitionRecord = (await Backendless.Data.of('Competitions').findById('B7698584-CAD8-41FD-8D0D-DBEC3FF9036D', Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    ___arguments.context.pageData['competitionObjectId'] = 'B7698584-CAD8-41FD-8D0D-DBEC3FF9036D';
  }
  ___arguments.context.pageData['selectedCompetition'] = competitionRecord;
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedCompetition'));
  ___arguments.context.pageData['competition_prizes'] = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_prizes'));
  ___arguments.context.pageData['pageTitle'] = 'Complete Competiton';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['targetAchieved'] = true;
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))].join(''));
  ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))).getTime() + (86400 * 1000)));
  ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND objectId != \'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) {
      if ((getObjectProperty(j, 'dealerTotalAppointments')) >= (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) {
        j['appointmentTargetReached'] = true;
      } else {
        j['appointmentTargetReached'] = false;
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) {
      if ((getObjectProperty(j, 'dealerTotalDemos')) >= (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) {
        j['demoTargetReached'] = true;
      } else {
        j['demoTargetReached'] = false;
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) {
      if ((getObjectProperty(j, 'dealerTotalSales')) >= (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) {
        j['saleTargetReached'] = true;
      } else {
        j['saleTargetReached'] = false;
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) {
      if ((getObjectProperty(j, 'dealerTotalSubmissions')) >= (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) {
        j['submissionTargetReached'] = true;
      } else {
        j['submissionTargetReached'] = false;
      }
    }
    if ((getObjectProperty(j, 'appointmentTargetReached')) == false || (getObjectProperty(j, 'demoTargetReached')) == false || (getObjectProperty(j, 'saleTargetReached')) == false || (getObjectProperty(j, 'submissionTargetReached')) == false) {
      j['targetsAchieved'] = false;
    } else {
      j['targetsAchieved'] = true;
    }
  }
  console.log(dealersWithScores);
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Time to Shine') {
    ___arguments.context.pageData['firstPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 12);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'firstPrizeWinners')).length == 0) {
      ___arguments.context.pageData['firstPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['firstPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'firstPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['secondPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 9);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'secondPrizeWinners')).length == 0) {
      ___arguments.context.pageData['secondPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['secondPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'secondPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['thirdPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 7);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'thirdPrizeWinners')).length == 0) {
      ___arguments.context.pageData['thirdPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['thirdPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'thirdPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['fourthPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 5);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'fourthPrizeWinners')).length == 0) {
      ___arguments.context.pageData['fourthPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['fourthPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fourthPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['fifthPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 3);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'fifthPrizeWinners')).length == 0) {
      ___arguments.context.pageData['fifthPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['fifthPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fifthPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
  }
  ___arguments.context.pageData['compWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


   return ((getObjectProperty(item, 'targetsAchieved')) == true);
  }));
  console.log(getObjectProperty(___arguments.context.pageData, 'compWinners'));
  console.log((getObjectProperty(___arguments.context.pageData, 'compWinners')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'compWinners')).length == 0) {
    ___arguments.context.pageData['competitionWinners'] = null;
  } else {
    ___arguments.context.pageData['competitionWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'compWinners')), 1, async (item) => {


     return (getObjectProperty(item, 'dealer_nameLast'));
    }));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index4 in j_list) {
    j = j_list[j_index4];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index5 in j_list2) {
    j = j_list2[j_index5];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index6 in j_list3) {
    j = j_list3[j_index6];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index7 in j_list4) {
    j = j_list4[j_index7];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/8173e99e3f82190d52af7e299f47f4ab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')),'\')'].join(''));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = 'url(\'https://demo.tellusapps.net/api/files/web/assets/images/Competition%20Featured%20Image%20Placeholder.jpg\')';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/4574c40309521b8ec1bc55af92ab200a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var dateDifferenceDays, dateDifference, todaysDate, endDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Ended on ') + String((await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/7e9513be7a57a93a0231da6fe7956842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2c7e26d6028958e1484f23667b1107a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/12ae497ee2054a6db6cba8f9d27451ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/35ae3cb6acb74385a158080fccd32102/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var salesOutput, salesProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  salesProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) * 100);
  if (salesProgress >= 100) {
    salesOutput = 100;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  } else {
    salesOutput = salesProgress;
  }

  return salesOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/eed8f156a86eabc8ded231dd40dee3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/417cc6e12279ac2aa60860cf8a1e72e2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var demoOutput, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  demoProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) * 100);
  if (demoProgress >= 100) {
    demoOutput = 100;
    ___arguments.context.pageData['demoTargetAchieved'] = true;
  } else {
    demoOutput = demoProgress;
  }

  return demoOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/07d570aa2c8a905a1f8aed8b1374c192/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/7daeb8424f3e32282e199b4640c12aca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')),' Appointments'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/6c639beee23abfba8e658214b684fa4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')),' Submissions'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/6b3c6606bc1e706150fc226db7a92f66/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var appointmentOutput, appointmentProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appointmentProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) * 100);
  if (appointmentProgress >= 100) {
    appointmentOutput = 100;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  } else {
    appointmentOutput = appointmentProgress;
  }

  return appointmentOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/24e6ea39eb650afbd7b75c75c6ab4bfc/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var submissionsOutput, submissionsProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  submissionsProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) * 100);
  if (submissionsProgress >= 100) {
    submissionsOutput = 100;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  } else {
    submissionsOutput = submissionsProgress;
  }

  return submissionsOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/e9e282eed90f1876650516c890bd41b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var demoWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) {
    demoWidgetVisible = true;
  } else {
    demoWidgetVisible = false;
  }

  return demoWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/b48579c6d305a5a511776ed41b51b83a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var submissionsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) {
    submissionsWidgetVisible = true;
    ___arguments.context.pageData['submissionTargetAchieved'] = null;
  } else {
    submissionsWidgetVisible = false;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  }

  return submissionsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/24a86bdd811b5bc177c56ad4f8c398ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) {
    salesWidgetVisible = true;
    ___arguments.context.pageData['saleTargetAchieved'] = null;
  } else {
    salesWidgetVisible = false;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  }

  return salesWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/1f683f038b46bc3e4392e8753797f9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var appointmentsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) {
    appointmentsWidgetVisible = true;
    ___arguments.context.pageData['appointmentTargetAchieved'] = null;
  } else {
    appointmentsWidgetVisible = false;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  }

  return appointmentsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2ff31c1ff518e445fa31a53c22de8aa1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/661b3534c607e78d89aeac7dd1bb8f43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/75bfceb38f05db6e438b9e433b997bda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2f3d48adfd2c7dce43c7bf16f92fc9f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/5be4e62fb8112c66d82cd6042ff3ea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')),' Demos.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/ef2ba114fd1fc83558fb24f665dd7d52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')),' Sales.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2a3d7ef495424e35bd5dd6b55db5b509/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')),' Appointments.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/07ee20f3cc1c049eec883a1dde7bbf51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')),' Submissions.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/e45e7119cb6512986bbbe9e796443a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/9c44eb6d5db53c0a47c7e308cdf5a9de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/b3fc7c19997fe2d2192682c7bd9f5757/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/ad54086dd504588b7a0493a91de28ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/7494a1974f1b357e020bb5433c64ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showCompleteBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'targetComplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'appointmentTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'demoTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'saleTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'submissionTargetAchieved'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/64ee7b41a369b9573784d0fa4c7f5039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'OR')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/e4346b278ccd8249ee16a1ed9e834156/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'AND')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/974ee2c6b54be9a43f2487b226cfb0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var closingAverageVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')) {
    closingAverageVisible = true;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = null;
  } else {
    closingAverageVisible = false;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
  }

  return closingAverageVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/7508ab5a8601bd7d420f17020e63d4d2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var closingAverageOutput, closingAverageAmount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  closingAverageAmount = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerClosingAverageValue')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))) * 100);
  if (closingAverageAmount >= 100) {
    closingAverageOutput = 100;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
  } else {
    closingAverageOutput = closingAverageAmount;
  }

  return closingAverageOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/78090408dc078006c2992244966cdb72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')),'% Closing Average'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2f7c04447635e3fa7183001df9a7d1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have a ',(getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')),' Closing Average.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/af13898b6c496042470e886520e713df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Closing Average'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/14b1e7ab4b28f2676e33fa0ed85a6011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/14cc8a38baa76093fa4fb5e94eb1363c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eca9f008baa152468b953f7bdc0f9c91'), 'dealerTotalSubmissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/a5f9258d93f9e6898cd2e7ab01425d59/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c5a5cb2d365b24c117ce89134e9f67a'), 'dealerTotalAppointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/f8c1bbd4dba4f60cf3a826bb383e2e66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cdd9ae65b9a1dc830decef692fab4766'), 'dealerTotalDemos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/7bb2ba7cb9821a0b67fc1eb1e86588f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('19b6d3eb71e9a395bef32158454ded9a'), 'dealerTotalSales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/dcdd48ac64a87e0304f6382ba65fdc7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/3ae45d640b175a9249a8e5489c5161f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/f1ffcb4600a6c0a183eea76679a7607e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/0bff8108d61e46bfcf2892f6f3b69f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/fcc4246e170e61e5457dba46599880ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/270daa742eaf1a45548e37dc69d4bd9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/0a99475152018365082d57872bd2c29c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/ffab9c17236ce5d91002794a6e8a3907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submission Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/61f7d2be3b98e94129437c2e2df92666/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Appointment Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/12c1aa753b82bac5cc58e6182b3cc6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Demo Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/2c6a45756e76a76d874559c14fdaf00b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Sale Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/30bfd4beaa6b9882c5b22cc2ce64bce1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/10383a87efe6aa0a6bdac0451b4b5767/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/72387f3402fd5ed3332d8da65da5bc16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/a59b3448fab1b47421522f31ea67de77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--finishedCompetition/components/0037893ced6abb9e9dbd3125d425b9e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizesTTS;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Time to Shine') {
    showPrizesTTS = true;
  } else {
    showPrizesTTS = false;
  }

  return showPrizesTTS

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['pageTitle'] = 'Competitions History';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['relatedDealer'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  ___arguments.context.pageData['currentDealerRecord'] = ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedDealer'] = (getObjectProperty(___arguments.context.pageData, 'currentDealerRecord'));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date <= \'',((new Date()).toISOString()),'\' AND ','','related_office = \'',(getObjectProperty(___arguments.context.pageData, 'currentDealerRecord.office_link.objectId')),'\''].join(''))).setSortBy('competition_end_date DESC').setPageSize(100)));
  ___arguments.context.pageData['noHistoricComps'] = ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'noHistoricComps')) == 0) {
    ___arguments.context.pageData['showNoHistoricCompAlert'] = true;
  }
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',(getObjectProperty(___arguments.context.pageData, 'currentDealerRecord.office_link.objectId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric' })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  console.log(getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      }));
    }
  }
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  console.log(getObjectProperty(___arguments.context.pageData, 'currentDay'));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == 1) {
    dealersWithScores = dealerScoresList;
  } else {
    dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


     return ((getObjectProperty(item, 'monthlyScores')).length != 0);
    }));
  }
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index5 in j_list3) {
    j = j_list3[j_index5];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index6 in j_list4) {
    j = j_list4[j_index6];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--history/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--history/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--history/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--history/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/fae67c2d442e9ff6a2838821f0d229a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showNumberOne;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showNumberOne = false;
  } else {
    showNumberOne = true;
  }

  return showNumberOne

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/afa92b8a9cd3e20259192d2285f1cdfc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8880bec0c184a379ca95852831a804'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/4ed14312995ef26da6954e01e1b1cc35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8880bec0c184a379ca95852831a804'), 'demosLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/a54de9a39eda3d997836ed0c940fbf25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--history/components/7f787ea618077b870c083b85f1a5ae4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var closingAverage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'relatedDealer.comp_closing_average')) == null) {
    closingAverage = '0%';
  } else {
    closingAverage = String(getObjectProperty(___arguments.context.pageData, 'relatedDealer.comp_closing_average')) + String('%');
  }

  return closingAverage

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--history/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      if (___arguments.newValue) {
    console.log('Visibility Change Test');
  }
  console.log('Visibility Change Test');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/competitions--history/components/e0c62423a3edfa489df98b9f7167a54e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--history/components/ace11d870d27ff0f38b43d5de4c35299/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9f2c1f3d9879a8f303ea0a3c0d5cf9f7'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/b422c6aa61bdd2b930c8ff33141bed3d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9f2c1f3d9879a8f303ea0a3c0d5cf9f7'), 'appointmentsLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/33a2c944d0ebda19f40937218c9b4cc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f3cd41421fe1b2628ab273fabd23644e'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/d00dbdf8edc979b56d66c55b7f07f2c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showFirstNo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f3cd41421fe1b2628ab273fabd23644e'), 'submissionsLeaderboardPosition')) == 1) {
    showFirstNo = false;
  } else {
    showFirstNo = true;
  }

  return showFirstNo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--history/components/32b5199d86c334611bf92ea9aa3206cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--listings/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competitions Listings';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  console.log(getObjectProperty(___arguments.context.appData, 'currentUser'));
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['breadCrumb'] = 'Competition Listings';
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause('dealer_active = true').setPageSize(100)));
  ___arguments.context.pageData['activeDealerCounter'] = ((getObjectProperty(___arguments.context.pageData, 'activeDealers')).length);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--listings/components/6d044584ab52e4c9d8edbb01f2f37d74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e6343e1ed9b7d8aff99127914c1217de'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--listings/components/6e554c68b58ab90b8bf58ceaf4d71836/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e6343e1ed9b7d8aff99127914c1217de'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--listings/components/0c51a0f89e7187fbc3c871f837ba229d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e6343e1ed9b7d8aff99127914c1217de'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--listings/components/537f9ea3a036cb54f39803dcf02de7f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e6343e1ed9b7d8aff99127914c1217de'), 'competition_featured_image')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('537f9ea3a036cb54f39803dcf02de7f8'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e6343e1ed9b7d8aff99127914c1217de'), 'competition_featured_image')),'\')'].join(''));
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/competitions--listings/components/05ed797b71f520e71abb1b6884c7fdeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['competitionsData'] = (getObjectProperty(___arguments.context.pageData, 'upcomingCompetitions'));
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--listings/components/83344b9ada4c50ce7d1f1b83014f2541/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['competitionsData'] = (getObjectProperty(___arguments.context.pageData, 'historicCompetitions'));
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--listings/components/3c499b3f5c152b5f8ac93e95873f8c0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['competitionsData'] = (getObjectProperty(___arguments.context.pageData, 'activeCompetitions'));
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c499b3f5c152b5f8ac93e95873f8c0c')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05ed797b71f520e71abb1b6884c7fdeb')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83344b9ada4c50ce7d1f1b83014f2541')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--listings/components/b0128fe56bcb52f9df0d9a117f712ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var dealerList, item, shortList, sortedList;

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--listings/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--manageDealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['pageTitle'] = 'Manage Dealers';
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = TRUE AND office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\''].join(''))).setRelated(['team_leader', 'recruited_by', 'office_link']).setRelationsDepth(2).setSortBy('dealer_name asc').setPageSize(100)));
  ___arguments.context.pageData['teamLeaderOptions'] = (await Promise.all((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['is_team_leader = true and office_link =\'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join(''))).setSortBy('dealer_name asc').setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['recruitedByOptions'] = (await Promise.all((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true and office_link =\'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join(''))).setSortBy('dealer_name asc').setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3364a866c00e7577aa88f93f7b574728')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--manageDealers/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDealers/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--manageDealers/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--manageDealers/components/3655ebfada1566fab64959d87ad67273/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'recruitedByOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--manageDealers/components/e5f4d34d6bc5025b11b5be8b75ed7f1c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'teamLeaderOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--manageDealers/components/f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDealers/components/184719acc309867f8cb2630b60a251fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['lockDealerEdit'] = true;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e5f4d34d6bc5025b11b5be8b75ed7f1c', (getObjectProperty(___arguments.context.dataModel, 'team_leader.objectId')));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3655ebfada1566fab64959d87ad67273', (getObjectProperty(___arguments.context.dataModel, 'recruited_by.objectId')));

  },
  /* handler:onMounted */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.dataModel['lockDealerEdit'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/competitions--manageDealers/components/48ddc72360253729a31c0648e94eaf4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var dealerObjectID;


  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDealers/components/4e464907f60864c43d5bf9199443b6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = (getObjectProperty(___arguments.context.pageData, 'selectedDealer'));
  console.log(selectedDealer);
  await Backendless.Data.of('Dealers').remove( selectedDealer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('797d972e882aba5e545be8339eb928fa', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level').setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onSubmit */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerName = (getObjectProperty(___arguments.context.pageData, 'selectedDealerName'));

  return (['You are about to delete the dealer \'',dealerName,'\', are you sure?'].join(''))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/competitions--manageDealers/components/0bc4f03e05fc6dc3c65b1c21e93fa126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).save( ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') );
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruited_by')) {
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'recruited_by', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruited_by'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'team_leader')) {
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'team_leader', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'team_leader'))]);
  }
  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('a2ebd282f595125cbc38ebd3dec34d3d', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDealers/components/7a8e273faf518dbf410be92822b58127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', true);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = FALSE AND office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\''].join(''))).setRelated(['team_leader', 'recruited_by', 'office_link']).setRelationsDepth(2).setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDealers/components/187e1a17e595c884f153df83057d378a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', false);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = TRUE AND office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\''].join(''))).setRelated(['team_leader', 'recruited_by', 'office_link']).setRelationsDepth(2).setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDealers/components/bf154fe1b1919ed7a8775b3a57cf20e3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, j, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['pageTitle'] = 'Manage Dealers';
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelated(['team_leader', 'recruited_by', 'office_link']).setRelationsDepth(2).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'dealers_table'));
  ___arguments.context.pageData['teamLeaderOptions'] = (await Promise.all((await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause('is_team_leader = true').setSortBy('dealer_name asc').setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['recruitedByOptions'] = (await Promise.all((await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause('dealer_active = true').setSortBy('dealer_name asc').setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['officeOptions'] = (await Promise.all((await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'office_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3364a866c00e7577aa88f93f7b574728')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/3655ebfada1566fab64959d87ad67273/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'recruitedByOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/e5f4d34d6bc5025b11b5be8b75ed7f1c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'teamLeaderOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/184719acc309867f8cb2630b60a251fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['lockDealerEdit'] = true;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e5f4d34d6bc5025b11b5be8b75ed7f1c', (getObjectProperty(___arguments.context.dataModel, 'team_leader.objectId')));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3655ebfada1566fab64959d87ad67273', (getObjectProperty(___arguments.context.dataModel, 'recruited_by.objectId')));

  },
  /* handler:onMounted */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.dataModel['lockDealerEdit'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/48ddc72360253729a31c0648e94eaf4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var dealerObjectID;


  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/4e464907f60864c43d5bf9199443b6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = (getObjectProperty(___arguments.context.pageData, 'selectedDealer'));
  console.log(selectedDealer);
  await Backendless.Data.of('Dealers').remove( selectedDealer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('797d972e882aba5e545be8339eb928fa', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level').setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onSubmit */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerName = (getObjectProperty(___arguments.context.pageData, 'selectedDealerName'));

  return (['You are about to delete the dealer \'',dealerName,'\', are you sure?'].join(''))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/0bc4f03e05fc6dc3c65b1c21e93fa126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).save( ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') );
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruited_by')) {
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'recruited_by', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruited_by'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'team_leader')) {
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'team_leader', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'team_leader'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'office_link')) {
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.division_link.division_dealer_table'))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'office_link', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'office_link'))]);
  }
  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('a2ebd282f595125cbc38ebd3dec34d3d', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/7a8e273faf518dbf410be92822b58127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', true);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = FALSE AND office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\''].join(''))).setRelated(['team_leader', 'recruited_by', 'office_link']).setRelationsDepth(2).setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/187e1a17e595c884f153df83057d378a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', false);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = TRUE AND office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\''].join(''))).setRelated(['team_leader', 'recruited_by', 'office_link']).setRelationsDepth(2).setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/bf154fe1b1919ed7a8775b3a57cf20e3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/competitions--manageDivisionDealers/components/71cfb31857c56b23566e89ed885557ce/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'officeOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser, dealerTableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Add Competition';
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['relatedOffice'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(1)));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  dealerTableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null));
  if (dealerTableName == 'Dealers_Dream_Team_Division') {
    ___arguments.context.pageData['dreamTeamOffice'] = true;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--newCompetition/components/31dc077dd615a2d60c9f0b66fab30d42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'competitionName')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecdec82b681fcf532f154358b874fc6c', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('60f1bb768957b252983e404255adc3fa')), 'validation--error');
    ___arguments.context.pageData['compNameError'] = true;
  } else {
    ___arguments.context.pageData['compNameError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecdec82b681fcf532f154358b874fc6c', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionSlogan')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5f14f8391cfc2289639cfa999a3f97f', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('080b28b3e00fd5f2e0b9cb275c320b9a')), 'validation--error');
    ___arguments.context.pageData['compSloganError'] = true;
  } else {
    ___arguments.context.pageData['compSloganError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5f14f8391cfc2289639cfa999a3f97f', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionStartDate')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ddbb8a224c2827360c87ae1f66307cf')), 'validation--error');
    ___arguments.context.pageData['compStartDateError'] = true;
  } else {
    ___arguments.context.pageData['compStartDateError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionEndDate')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a268331bc1a1ed1cbd4b310e092a2a61')), 'validation--error');
    ___arguments.context.pageData['compEndDateError'] = true;
  } else {
    ___arguments.context.pageData['compEndDateError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionDescription')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58c25395daa2c16e31c120e549affa19', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('07539d223f3b99e5283fbaf15a4a4835')), 'validation--error');
    ___arguments.context.pageData['compDescError'] = true;
  } else {
    ___arguments.context.pageData['compDescError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58c25395daa2c16e31c120e549affa19', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'compNameError')) == false && (getObjectProperty(___arguments.context.pageData, 'compSloganError')) == false && (getObjectProperty(___arguments.context.pageData, 'compStartDateError')) == false && (getObjectProperty(___arguments.context.pageData, 'compEndDateError')) == false && (getObjectProperty(___arguments.context.pageData, 'compDescError')) == false) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fadffba41ec71246bc785cbd83fd1e8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/cc055ea9289b946f8f2edf4a9d964cf1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'firstPlacePrize')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2685415c242b7b2e8b4d248fb90cdca8', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c3a463ccead861cdb87b4eb9a8fac10a')), 'validation--error');
    ___arguments.context.pageData['formError'] = true;
  } else {
    ___arguments.context.pageData['formError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'formError')) == false) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/87596287aaf5568ec3a9e7278064b609/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a479d6dcd194e664313b1ebf12083a23', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/f1bec7b373d263c64b8633eb2ae4be53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/b07792d2d787281e9a3a01d7e82c6da7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).resetStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fadffba41ec71246bc785cbd83fd1e8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/312985417ef28fc7fef2ceffb1e29d36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/d0a834b1d6dde395df7ed96aadb10edf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/40f53921e3eb9fc55305d7eecff135e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/cb615f71d8e85c89b85840cf74eeee4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/5ccc5cbba30641c31ef19f0e1abbd715/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'competitionStartDate')) ? (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'competitionStartDate')))) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/5384ca3cd54af592d6d924650b6b7d4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'competitionEndDate')) ? (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'competitionEndDate')))) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/0b25e3b437bc48081f526f084f3c4039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionEndDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/f0396d4babd881addc1d9ed5077db4db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionStartDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/590da52de1bf10272b8a156c0f040152/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionName'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/d08943824b01ec5e4a866fa4dd1bf18b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).resetStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/32a7898e8ee67d0ee3a39c786e7ad17d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goPrevStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a479d6dcd194e664313b1ebf12083a23', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/179c844d09b1bc4ea2813fae8a8fc4d4/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([mathRandomInt(100, 100000),'-',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['competitionFeaturedImage'] = ___arguments.uploadedFiles;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('450f6b4608b78edbd356a35d120dd0d7', true);

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/competitions--newCompetition/components/450f6b4608b78edbd356a35d120dd0d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('179c844d09b1bc4ea2813fae8a8fc4d4');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/bf4497a4b219e0bbde1a55d59a262bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/e773b3393923114d05d953a645cbfd72/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/018bc6dcba6fca318b345f3c2468c345/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'appointmentsEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/b68ff74fe451cf57b663e7a6551c1c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submissionsEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/60f1bb768957b252983e404255adc3fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecdec82b681fcf532f154358b874fc6c', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('60f1bb768957b252983e404255adc3fa')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newCompetition/components/080b28b3e00fd5f2e0b9cb275c320b9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5f14f8391cfc2289639cfa999a3f97f', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('080b28b3e00fd5f2e0b9cb275c320b9a')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newCompetition/components/8ddbb8a224c2827360c87ae1f66307cf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ddbb8a224c2827360c87ae1f66307cf')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newCompetition/components/a268331bc1a1ed1cbd4b310e092a2a61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a268331bc1a1ed1cbd4b310e092a2a61')), 'validation--error', '');

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    var minDate;



  return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/07539d223f3b99e5283fbaf15a4a4835/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58c25395daa2c16e31c120e549affa19', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('07539d223f3b99e5283fbaf15a4a4835')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newCompetition/components/b5d3deeae22f394e5909c1edbce10b33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var competitionObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'surveysCheckbox')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c27926ff43f55d7991dff8734275f52b', true);
    ___arguments.context.pageData['measuringTargetError'] = true;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c27926ff43f55d7991dff8734275f52b', false);
    ___arguments.context.pageData['measuringTargetError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) == true && (getObjectProperty(___arguments.context.pageData, 'closingAverageAmount')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('467590e68f4470380d949c8f6cffbeff', true);
    ___arguments.context.pageData['closingAverageError'] = true;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('467590e68f4470380d949c8f6cffbeff', false);
    ___arguments.context.pageData['closingAverageError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'compLogicRequired')) == true) {
    if (getObjectProperty(___arguments.context.pageData, 'competitionLogic')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbe77afd8e43721854391ded270188ba', false);
      ___arguments.context.pageData['compLogicError'] = false;
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbe77afd8e43721854391ded270188ba', true);
      ___arguments.context.pageData['compLogicError'] = true;
    }
  } else {
    ___arguments.context.pageData['compLogicError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'measuringTargetError')) == false && (getObjectProperty(___arguments.context.pageData, 'closingAverageError')) == false && (getObjectProperty(___arguments.context.pageData, 'compLogicError')) == false) {
    ___arguments.context.pageData['addCompRunning'] = true;
    competitionObject = ({ 'competition_name': (getObjectProperty(___arguments.context.pageData, 'competitionName')),'competition_slogan': (getObjectProperty(___arguments.context.pageData, 'competitionSlogan')),'competition_start_date': (getObjectProperty(___arguments.context.pageData, 'competitionStartDate')),'competition_end_date': (getObjectProperty(___arguments.context.pageData, 'competitionEndDate')),'competition_description': (getObjectProperty(___arguments.context.pageData, 'competitionDescription')),'competition_featured_image': (getObjectProperty(___arguments.context.pageData, 'competitionFeaturedImage')),'competition_poster_image': (getObjectProperty(___arguments.context.pageData, 'competitionPosterImage')),'competition_prizes': ({ 'prize1': (getObjectProperty(___arguments.context.pageData, 'firstPlacePrize')),'prize1image': (getObjectProperty(___arguments.context.pageData, 'firstPlacePrizeImage')),'prize2': (getObjectProperty(___arguments.context.pageData, 'secondPlacePrize')),'prize2image': (getObjectProperty(___arguments.context.pageData, 'secondPlacePrizeImage')),'prize3': (getObjectProperty(___arguments.context.pageData, 'thirdPlacePrize')),'prize3image': (getObjectProperty(___arguments.context.pageData, 'thirdPlacePrizeImage')),'prize4': (getObjectProperty(___arguments.context.pageData, 'fourthPlacePrize')),'prize4image': (getObjectProperty(___arguments.context.pageData, 'fourthPlacePrizeImage')),'prize5': (getObjectProperty(___arguments.context.pageData, 'fifthPlacePrize')),'prize5image': (getObjectProperty(___arguments.context.pageData, 'fifthPlacePrizeImage')) }),'competition_entry_requirements': ({ 'entry_sales': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--sales')),'entry_demos': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--demos')),'entry_appointments': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--appointments')),'entry_submissions': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--submissions')) }),'competition_targets': ({ 'target_sales': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--sales')),'target_demos': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--demos')),'target_appointments': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--appointments')),'target_submissions': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--submissions')),'target_closingAverage': (getObjectProperty(___arguments.context.pageData, 'closingAverageAmount')),'target_surveys': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--surveys')) }),'competition_target_operator': (getObjectProperty(___arguments.context.pageData, 'competitionLogic')),'competition_closing_average_required': (getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) });
    ___arguments.context.pageData['createdCompetition'] = (await Backendless.Data.of('Competitions').save(competitionObject, true));
    await Backendless.Data.of('Competitions').addRelation((getObjectProperty(___arguments.context.pageData, 'createdCompetition.objectId')), 'related_office', [(getObjectProperty(___arguments.context.pageData, 'relatedOffice.office_link.objectId'))]);
    ___arguments.context.pageData['addCompRunning'] = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('3c61a3ea334276847d1336bc8ae44c45', undefined, undefined, undefined, undefined, undefined);
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/eafb1f311da4e7f1c7ece39ead16ee2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('493e2215906b2b7f3539e147236c3743');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/493e2215906b2b7f3539e147236c3743/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([mathRandomInt(100, 100000),'-',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/c3a463ccead861cdb87b4eb9a8fac10a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2685415c242b7b2e8b4d248fb90cdca8', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c3a463ccead861cdb87b4eb9a8fac10a')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newCompetition/components/e06c1e16c6c4274d1ecd8a749c6d7802/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var displayAndOrBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  displayAndOrBlock = false;
  if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) == true) {
    displayAndOrBlock = true;
  }

  return displayAndOrBlock

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/1cb44fc316d7e4eed137c0c664149c23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79956c153a2ff772bf35e3343e2e4673', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65aad0a2e25d4409b747b4b4d0cf6a92', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1cb44fc316d7e4eed137c0c664149c23', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/bdbc28f288ed9204aa6e94a9bfde40d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).pop();
  }
  ___arguments.context.pageData['competitionLogic'] = 'AND';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/3fceeeef7ca1207c2f76e8c611659681/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).pop();
  }
  ___arguments.context.pageData['competitionLogic'] = 'OR';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newCompetition/components/f82c626c31c1fe2102ff88735754d17c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'closingAverageRequired'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/25ca429c4754c81ea9819972cb0b0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var displayAndOrBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  displayAndOrBlock = false;
  if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  }

  return displayAndOrBlock

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newCompetition/components/2433a3214feb25c58369b69f7f8161ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'surveysCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'dreamTeamOffice')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Add Competition';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['relatedOffice'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(1)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDivision.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/31dc077dd615a2d60c9f0b66fab30d42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'competitionName')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecdec82b681fcf532f154358b874fc6c', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('60f1bb768957b252983e404255adc3fa')), 'validation--error');
    ___arguments.context.pageData['compNameError'] = true;
  } else {
    ___arguments.context.pageData['compNameError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecdec82b681fcf532f154358b874fc6c', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionSlogan')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5f14f8391cfc2289639cfa999a3f97f', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('080b28b3e00fd5f2e0b9cb275c320b9a')), 'validation--error');
    ___arguments.context.pageData['compSloganError'] = true;
  } else {
    ___arguments.context.pageData['compSloganError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5f14f8391cfc2289639cfa999a3f97f', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionStartDate')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ddbb8a224c2827360c87ae1f66307cf')), 'validation--error');
    ___arguments.context.pageData['compStartDateError'] = true;
  } else {
    ___arguments.context.pageData['compStartDateError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionEndDate')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a268331bc1a1ed1cbd4b310e092a2a61')), 'validation--error');
    ___arguments.context.pageData['compEndDateError'] = true;
  } else {
    ___arguments.context.pageData['compEndDateError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'competitionDescription')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58c25395daa2c16e31c120e549affa19', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('07539d223f3b99e5283fbaf15a4a4835')), 'validation--error');
    ___arguments.context.pageData['compDescError'] = true;
  } else {
    ___arguments.context.pageData['compDescError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58c25395daa2c16e31c120e549affa19', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'compNameError')) == false && (getObjectProperty(___arguments.context.pageData, 'compSloganError')) == false && (getObjectProperty(___arguments.context.pageData, 'compStartDateError')) == false && (getObjectProperty(___arguments.context.pageData, 'compEndDateError')) == false && (getObjectProperty(___arguments.context.pageData, 'compDescError')) == false) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fadffba41ec71246bc785cbd83fd1e8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/cc055ea9289b946f8f2edf4a9d964cf1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'firstPlacePrize')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2685415c242b7b2e8b4d248fb90cdca8', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c3a463ccead861cdb87b4eb9a8fac10a')), 'validation--error');
    ___arguments.context.pageData['formError'] = true;
  } else {
    ___arguments.context.pageData['formError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'formError')) == false) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/87596287aaf5568ec3a9e7278064b609/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a479d6dcd194e664313b1ebf12083a23', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/f1bec7b373d263c64b8633eb2ae4be53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/b07792d2d787281e9a3a01d7e82c6da7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).resetStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fadffba41ec71246bc785cbd83fd1e8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/312985417ef28fc7fef2ceffb1e29d36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/d0a834b1d6dde395df7ed96aadb10edf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/40f53921e3eb9fc55305d7eecff135e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/cb615f71d8e85c89b85840cf74eeee4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/5ccc5cbba30641c31ef19f0e1abbd715/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'competitionStartDate')) ? (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'competitionStartDate')))) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/5384ca3cd54af592d6d924650b6b7d4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'competitionEndDate')) ? (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'competitionEndDate')))) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/0b25e3b437bc48081f526f084f3c4039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionEndDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/f0396d4babd881addc1d9ed5077db4db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionStartDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/590da52de1bf10272b8a156c0f040152/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionName'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/d08943824b01ec5e4a866fa4dd1bf18b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).resetStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02da2c5873bafdbf4236fb0912fd9f9f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/32a7898e8ee67d0ee3a39c786e7ad17d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goPrevStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a479d6dcd194e664313b1ebf12083a23', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cb97b2f5b7485e2bc36f2c4f833f911', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/179c844d09b1bc4ea2813fae8a8fc4d4/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([mathRandomInt(100, 100000),'-',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['competitionFeaturedImage'] = ___arguments.uploadedFiles;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('450f6b4608b78edbd356a35d120dd0d7', true);

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/450f6b4608b78edbd356a35d120dd0d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('179c844d09b1bc4ea2813fae8a8fc4d4');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/bf4497a4b219e0bbde1a55d59a262bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/e773b3393923114d05d953a645cbfd72/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/018bc6dcba6fca318b345f3c2468c345/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'appointmentsEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/b68ff74fe451cf57b663e7a6551c1c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submissionsEntryCheckbox'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/60f1bb768957b252983e404255adc3fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecdec82b681fcf532f154358b874fc6c', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('60f1bb768957b252983e404255adc3fa')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/080b28b3e00fd5f2e0b9cb275c320b9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5f14f8391cfc2289639cfa999a3f97f', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('080b28b3e00fd5f2e0b9cb275c320b9a')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/8ddbb8a224c2827360c87ae1f66307cf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ddbb8a224c2827360c87ae1f66307cf')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/a268331bc1a1ed1cbd4b310e092a2a61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d47c424c49091359c8140c21cd4ee28a', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a268331bc1a1ed1cbd4b310e092a2a61')), 'validation--error', '');

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    var minDate;



  return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/07539d223f3b99e5283fbaf15a4a4835/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58c25395daa2c16e31c120e549affa19', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('07539d223f3b99e5283fbaf15a4a4835')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/b5d3deeae22f394e5909c1edbce10b33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, competitionObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['addCompRunning'] = true;
  competitionObject = ({ 'competition_name': (getObjectProperty(___arguments.context.pageData, 'competitionName')),'competition_slogan': (getObjectProperty(___arguments.context.pageData, 'competitionSlogan')),'competition_start_date': (getObjectProperty(___arguments.context.pageData, 'competitionStartDate')),'competition_end_date': (getObjectProperty(___arguments.context.pageData, 'competitionEndDate')),'competition_description': (getObjectProperty(___arguments.context.pageData, 'competitionDescription')),'competition_featured_image': (getObjectProperty(___arguments.context.pageData, 'competitionFeaturedImage')),'competition_poster_image': (getObjectProperty(___arguments.context.pageData, 'competitionPosterImage')),'competition_prizes': ({ 'prize1': (getObjectProperty(___arguments.context.pageData, 'firstPlacePrize')),'prize1image': (getObjectProperty(___arguments.context.pageData, 'firstPlacePrizeImage')),'prize2': (getObjectProperty(___arguments.context.pageData, 'secondPlacePrize')),'prize2image': (getObjectProperty(___arguments.context.pageData, 'secondPlacePrizeImage')),'prize3': (getObjectProperty(___arguments.context.pageData, 'thirdPlacePrize')),'prize3image': (getObjectProperty(___arguments.context.pageData, 'thirdPlacePrizeImage')),'prize4': (getObjectProperty(___arguments.context.pageData, 'fourthPlacePrize')),'prize4image': (getObjectProperty(___arguments.context.pageData, 'fourthPlacePrizeImage')),'prize5': (getObjectProperty(___arguments.context.pageData, 'fifthPlacePrize')),'prize5image': (getObjectProperty(___arguments.context.pageData, 'fifthPlacePrizeImage')) }),'competition_entry_requirements': ({ 'entry_sales': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--sales')),'entry_demos': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--demos')),'entry_appointments': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--appointments')),'entry_submissions': (getObjectProperty(___arguments.context.pageData, 'entryRequirementSlider--submissions')) }),'competition_targets': ({ 'target_sales': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--sales')),'target_demos': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--demos')),'target_appointments': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--appointments')),'target_submissions': (getObjectProperty(___arguments.context.pageData, 'competitionTargets--submissions')),'target_closingAverage': (getObjectProperty(___arguments.context.pageData, 'closingAverageAmount')) }),'competition_target_operator': (getObjectProperty(___arguments.context.pageData, 'competitionLogic')),'competition_closing_average_required': (getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) });
  ___arguments.context.pageData['createdCompetition'] = (await Backendless.Data.of('Competitions').save(competitionObject, true));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'selectedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Backendless.Data.of('Competitions').addRelation((getObjectProperty(___arguments.context.pageData, 'createdCompetition.objectId')), 'related_office', [j]);
  }
  ___arguments.context.pageData['addCompRunning'] = false;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('3c61a3ea334276847d1336bc8ae44c45', undefined, undefined, undefined, undefined, undefined);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/eafb1f311da4e7f1c7ece39ead16ee2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('493e2215906b2b7f3539e147236c3743');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/493e2215906b2b7f3539e147236c3743/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([mathRandomInt(100, 100000),'-',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/c3a463ccead861cdb87b4eb9a8fac10a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2685415c242b7b2e8b4d248fb90cdca8', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c3a463ccead861cdb87b4eb9a8fac10a')), 'validation--error', '');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/e06c1e16c6c4274d1ecd8a749c6d7802/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var displayAndOrBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  displayAndOrBlock = false;
  if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) == true) {
    displayAndOrBlock = true;
  }

  return displayAndOrBlock

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/1cb44fc316d7e4eed137c0c664149c23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79956c153a2ff772bf35e3343e2e4673', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65aad0a2e25d4409b747b4b4d0cf6a92', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1cb44fc316d7e4eed137c0c664149c23', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/bdbc28f288ed9204aa6e94a9bfde40d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).pop();
  }
  ___arguments.context.pageData['competitionLogic'] = 'AND';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/3fceeeef7ca1207c2f76e8c611659681/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3fceeeef7ca1207c2f76e8c611659681')), 'active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).includes('active')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bdbc28f288ed9204aa6e94a9bfde40d2')).pop();
  }
  ___arguments.context.pageData['competitionLogic'] = 'OR';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/f82c626c31c1fe2102ff88735754d17c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'closingAverageRequired'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/25ca429c4754c81ea9819972cb0b0e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var displayAndOrBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  displayAndOrBlock = false;
  if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) == true) {
    displayAndOrBlock = true;
    ___arguments.context.pageData['compLogicRequired'] = true;
  }

  return displayAndOrBlock

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/b566528ec25f827d84beabc60ad5d069/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'salesCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'demosCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'appointmentsCheckbox')) == null && (getObjectProperty(___arguments.context.pageData, 'submissionsCheckbox')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c27926ff43f55d7991dff8734275f52b', true);
    ___arguments.context.pageData['measuringTargetError'] = true;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c27926ff43f55d7991dff8734275f52b', false);
    ___arguments.context.pageData['measuringTargetError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'closingAverageRequired')) == true && (getObjectProperty(___arguments.context.pageData, 'closingAverageAmount')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('467590e68f4470380d949c8f6cffbeff', true);
    ___arguments.context.pageData['closingAverageError'] = true;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('467590e68f4470380d949c8f6cffbeff', false);
    ___arguments.context.pageData['closingAverageError'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'compLogicRequired')) == true) {
    if (getObjectProperty(___arguments.context.pageData, 'competitionLogic')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbe77afd8e43721854391ded270188ba', false);
      ___arguments.context.pageData['compLogicError'] = false;
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbe77afd8e43721854391ded270188ba', true);
      ___arguments.context.pageData['compLogicError'] = true;
    }
  } else {
    ___arguments.context.pageData['compLogicError'] = false;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'measuringTargetError'));
  console.log(getObjectProperty(___arguments.context.pageData, 'closingAverageError'));
  console.log(getObjectProperty(___arguments.context.pageData, 'compLogicError'));
  if ((getObjectProperty(___arguments.context.pageData, 'measuringTargetError')) == false && (getObjectProperty(___arguments.context.pageData, 'closingAverageError')) == false && (getObjectProperty(___arguments.context.pageData, 'compLogicError')) == false) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a479d6dcd194e664313b1ebf12083a23', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9497e58b7e2e0117514838421ab86f19', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/f33ab96f13251da5e9311caf6d75fb79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    if (getObjectProperty(___arguments.context.pageData, 'selectedOffices')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'selectedOffices')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    } else {
      ___arguments.context.pageData['selectedOffices'] = [(getObjectProperty(___arguments.context.dataModel, 'objectId'))];
    }
  }
  if (___arguments.value == false) {
    if (getObjectProperty(___arguments.context.pageData, 'selectedOffices')) {
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'selectedOffices')), (getObjectProperty(___arguments.context.dataModel, 'objectId')), '');
    } else {
      removeItemInList((getObjectProperty(___arguments.context.pageData, 'selectedOffices')), (getObjectProperty(___arguments.context.dataModel, 'objectId')), '');
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--newDivisionCompetition/components/f55c125fcf2a5a18e3fb41dd099d89b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goPrevStep() })('7db4bb2f79fa1ba6d2daa3ee739dbe8b');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a479d6dcd194e664313b1ebf12083a23', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9497e58b7e2e0117514838421ab86f19', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsSurveysTotals, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, loggedInUser, competitionRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (getObjectProperty(___arguments.context.pageData, 'competitionObjectId')) {
    competitionRecord = (await Backendless.Data.of('Competitions').findById((getObjectProperty(___arguments.context.pageData, 'competitionObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  } else {
    competitionRecord = (await Backendless.Data.of('Competitions').findById('B7698584-CAD8-41FD-8D0D-DBEC3FF9036D', Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    ___arguments.context.pageData['competitionObjectId'] = 'B7698584-CAD8-41FD-8D0D-DBEC3FF9036D';
  }
  ___arguments.context.pageData['selectedCompetition'] = competitionRecord;
  ___arguments.context.pageData['competition_prizes'] = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_prizes'));
  ___arguments.context.pageData['pageTitle'] = 'Complete Competiton';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['targetAchieved'] = true;
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))].join(''));
  ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))).getTime() + (86400 * 1000)));
  ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND objectId != \'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsSurveysTotals = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'surveys')) {
        thisMonthsSurveysTotals = thisMonthsSurveysTotals + (getObjectProperty(k, 'surveys'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalSurveys'] = thisMonthsSurveysTotals;
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['dealerTotalSurveys'] = thisMonthsSurveysTotals;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Time to Shine' || (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Chase the Challenge') {
    ___arguments.context.pageData['firstPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 9);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'firstPrizeWinners')).length == 0) {
      ___arguments.context.pageData['firstPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['firstPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'firstPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['secondPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 7);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'secondPrizeWinners')).length == 0) {
      ___arguments.context.pageData['secondPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['secondPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'secondPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['thirdPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 5);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'thirdPrizeWinners')).length == 0) {
      ___arguments.context.pageData['thirdPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['thirdPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'thirdPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['fourthPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 3);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'fourthPrizeWinners')).length == 0) {
      ___arguments.context.pageData['fourthPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['fourthPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fourthPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
    ___arguments.context.pageData['fifthPrizeWinners'] = (await asyncListFilter(dealersWithScores, async (item) => {


     return ((getObjectProperty(item, 'dealerTotalDemos')) >= 2);
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'fifthPrizeWinners')).length == 0) {
      ___arguments.context.pageData['fifthPrizeWinners'] = null;
    } else {
      ___arguments.context.pageData['fifthPrizeWinners'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fifthPrizeWinners')), -1, async (item) => {


       return (getObjectProperty(item, 'dealerTotalDemos'));
      }));
    }
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index5 in j_list3) {
    j = j_list3[j_index5];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index6 in j_list4) {
    j = j_list4[j_index6];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }
  ___arguments.context.pageData['competitionSurveysTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSurveys'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSurveys'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSurveysTotals')).slice(0, 3));
  await Backendless.Counters.reset('surveysPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSurveys'));
  for (var j_index7 in j_list5) {
    j = j_list5[j_index7];
    await Backendless.Counters.addAndGet('surveysPosition', 1);
    j['surveysLeaderboardPosition'] = (await Backendless.Counters.get('surveysPosition'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/8173e99e3f82190d52af7e299f47f4ab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')),'\')'].join(''));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = 'url(\'https://demo.tellusapps.net/api/files/web/assets/images/Competition%20Featured%20Image%20Placeholder.jpg\')';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/4574c40309521b8ec1bc55af92ab200a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Ends on ') + String((await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/7e9513be7a57a93a0231da6fe7956842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2c7e26d6028958e1484f23667b1107a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/12ae497ee2054a6db6cba8f9d27451ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/35ae3cb6acb74385a158080fccd32102/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var salesOutput, salesProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  salesProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) * 100);
  if (salesProgress >= 100) {
    salesOutput = 100;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  } else {
    salesOutput = salesProgress;
  }

  return salesOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/eed8f156a86eabc8ded231dd40dee3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/417cc6e12279ac2aa60860cf8a1e72e2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var demoOutput, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  demoProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) * 100);
  if (demoProgress >= 100) {
    demoOutput = 100;
    ___arguments.context.pageData['demoTargetAchieved'] = true;
  } else {
    demoOutput = demoProgress;
  }

  return demoOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/07d570aa2c8a905a1f8aed8b1374c192/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/7daeb8424f3e32282e199b4640c12aca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')),' Appointments'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/6c639beee23abfba8e658214b684fa4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')),' Submissions'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/6b3c6606bc1e706150fc226db7a92f66/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var appointmentOutput, appointmentProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appointmentProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) * 100);
  if (appointmentProgress >= 100) {
    appointmentOutput = 100;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  } else {
    appointmentOutput = appointmentProgress;
  }

  return appointmentOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/24e6ea39eb650afbd7b75c75c6ab4bfc/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var submissionsOutput, submissionsProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  submissionsProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) * 100);
  if (submissionsProgress >= 100) {
    submissionsOutput = 100;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  } else {
    submissionsOutput = submissionsProgress;
  }

  return submissionsOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/e9e282eed90f1876650516c890bd41b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var demoWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) {
    demoWidgetVisible = true;
  } else {
    demoWidgetVisible = false;
  }

  return demoWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/b48579c6d305a5a511776ed41b51b83a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var submissionsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) {
    submissionsWidgetVisible = true;
    ___arguments.context.pageData['submissionTargetAchieved'] = null;
  } else {
    submissionsWidgetVisible = false;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  }

  return submissionsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/24a86bdd811b5bc177c56ad4f8c398ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) {
    salesWidgetVisible = true;
    ___arguments.context.pageData['saleTargetAchieved'] = null;
  } else {
    salesWidgetVisible = false;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  }

  return salesWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/1f683f038b46bc3e4392e8753797f9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var appointmentsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) {
    appointmentsWidgetVisible = true;
    ___arguments.context.pageData['appointmentTargetAchieved'] = null;
  } else {
    appointmentsWidgetVisible = false;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  }

  return appointmentsWidgetVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2ff31c1ff518e445fa31a53c22de8aa1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/661b3534c607e78d89aeac7dd1bb8f43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/75bfceb38f05db6e438b9e433b997bda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2f3d48adfd2c7dce43c7bf16f92fc9f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/5be4e62fb8112c66d82cd6042ff3ea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')),' Demos.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/ef2ba114fd1fc83558fb24f665dd7d52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')),' Sales.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2a3d7ef495424e35bd5dd6b55db5b509/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')),' Appointments.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/07ee20f3cc1c049eec883a1dde7bbf51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')),' Submissions.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/e45e7119cb6512986bbbe9e796443a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/9c44eb6d5db53c0a47c7e308cdf5a9de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/b3fc7c19997fe2d2192682c7bd9f5757/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/ad54086dd504588b7a0493a91de28ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/7494a1974f1b357e020bb5433c64ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showCompleteBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'targetComplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'appointmentTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'demoTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'saleTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'submissionTargetAchieved'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/64ee7b41a369b9573784d0fa4c7f5039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'OR')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/e4346b278ccd8249ee16a1ed9e834156/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'AND')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/974ee2c6b54be9a43f2487b226cfb0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var closingAverageVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')) {
    closingAverageVisible = true;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = null;
  } else {
    closingAverageVisible = false;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
  }

  return closingAverageVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/7508ab5a8601bd7d420f17020e63d4d2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var closingAverageOutput, closingAverageAmount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  closingAverageAmount = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerClosingAverageValue')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))) * 100);
  if (closingAverageAmount >= 100) {
    closingAverageOutput = 100;
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
  } else {
    closingAverageOutput = closingAverageAmount;
  }

  return closingAverageOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/78090408dc078006c2992244966cdb72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')),'% Closing Average'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2f7c04447635e3fa7183001df9a7d1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have a ',(getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')),' Closing Average.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/af13898b6c496042470e886520e713df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Closing Average'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/14b1e7ab4b28f2676e33fa0ed85a6011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/14cc8a38baa76093fa4fb5e94eb1363c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eca9f008baa152468b953f7bdc0f9c91'), 'dealerTotalSubmissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/a5f9258d93f9e6898cd2e7ab01425d59/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c5a5cb2d365b24c117ce89134e9f67a'), 'dealerTotalAppointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/f8c1bbd4dba4f60cf3a826bb383e2e66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cdd9ae65b9a1dc830decef692fab4766'), 'dealerTotalDemos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/7bb2ba7cb9821a0b67fc1eb1e86588f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('19b6d3eb71e9a395bef32158454ded9a'), 'dealerTotalSales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/dcdd48ac64a87e0304f6382ba65fdc7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/3ae45d640b175a9249a8e5489c5161f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/f1ffcb4600a6c0a183eea76679a7607e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/0bff8108d61e46bfcf2892f6f3b69f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/fcc4246e170e61e5457dba46599880ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/270daa742eaf1a45548e37dc69d4bd9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/0a99475152018365082d57872bd2c29c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/ffab9c17236ce5d91002794a6e8a3907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Submission Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/61f7d2be3b98e94129437c2e2df92666/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Appointment Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/12c1aa753b82bac5cc58e6182b3cc6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Demo Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/2c6a45756e76a76d874559c14fdaf00b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Sale Scores (',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),' - ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/0037893ced6abb9e9dbd3125d425b9e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizesTTS;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Time to Shine' || (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Chase the Challenge') {
    showPrizesTTS = true;
  } else {
    showPrizesTTS = false;
  }

  return showPrizesTTS

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/6b8498d6e551e7ea2888eeebf38ce7e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_surveys')) + String(' Surveys'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/f5b5b40457dc2d0746dcdd0941c8f68f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_surveys'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/faa2f3e7fdb35dcd6b47eda1bff7350e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_surveys'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/b65b0fc93e3c4deb733730cace933a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('36427f27c231f0af68e50d43b1ef9d9c'), 'surveysLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeCompetitionView/components/f143cc62dc6c14fe7f1d2103ca85776f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('36427f27c231f0af68e50d43b1ef9d9c'), 'surveysLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, thisMonthsSurveysTotal, thisMonthsRecruitsTotal, loggedInUser, dealerTableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competitions Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['closingAverageMonthlyTotal'] = 0;
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  dealerTableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null));
  if (dealerTableName == 'Dealers_Dream_Team_Division') {
    ___arguments.context.pageData['dreamTeamOffice'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('64cd979bbe2267aca25d301aa9242749'))['grid-template-columns'] = 'repeat(auto-fill, minmax(300px, 1fr))';
  }
  ___arguments.context.pageData['relatedDealer'] = ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
      })));
    } else {
      ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
      }));
    }
  }
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  thisMonthsSurveysTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index2 in j_list) {
    j = j_list[j_index2];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
    if (getObjectProperty(j, 'surveys')) {
      thisMonthsSurveysTotal = thisMonthsSurveysTotal + (getObjectProperty(j, 'surveys'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerTotalSurveys'] = thisMonthsSurveysTotal;
  if (thisMonthsSalesTotal != 0) {
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  } else {
    ___arguments.context.pageData['dealerClosingAverage'] = 0;
  }
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruits')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySurveysAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSurveys')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySurveysScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySurveysAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  }
  ___arguments.context.pageData['competitionsHistoricData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsHistoricData')).length == 0) {
    ___arguments.context.pageData['noHistoricComps'] = true;
  }
  ___arguments.context.pageData['competitionsUpcomingData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_start_date >= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsUpcomingData')).length == 0) {
    ___arguments.context.pageData['noUpcomingComps'] = true;
  }
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index3 in dealerScoresList) {
    j = dealerScoresList[j_index3];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index4 in dealersWithScores) {
    j = dealersWithScores[j_index4];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index5 in j_list2) {
    j = j_list2[j_index5];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index6 in j_list3) {
    j = j_list3[j_index6];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index7 in j_list4) {
    j = j_list4[j_index7];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index8 in j_list5) {
    j = j_list5[j_index8];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }

  },
  /* handler:onResize */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = 0;
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = 0;
  ___arguments.context.pageData['monthlySalesScaleTarget'] = 0;
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = 0;
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = 0;
  ___arguments.context.pageData['dealerClosingAverage'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'dreamTeamOffice')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/ce418402b5d84aef8fc90fe429b79797/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
      return [({ 'name': 'John Doe','goal': 20,'progress': 16 }), ({ 'name': 'Amy Doe','goal': 20,'progress': 13 }), ({ 'name': 'Sam Doe','goal': 20,'progress': 8 })]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/5e5bcb9252b95c5db24a685d0e7ba96e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/eac39dcf5afdf452f68f28037dd8c028/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/4df27c387f5129a94243caa2526e938d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var monthlyText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('1aa2ef8d31a361d2fd483fc947c566c3')) == '2023-01-') {
    monthlyText = String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' - January 2023 Statistics');
  } else {
    monthlyText = [(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')),' - ',(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))),' Statistics'].join('');
  }

  return monthlyText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/263f2c5f81ee1d7ef687ea32d19f532c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/18dd18c4d1daf94ea39fdc11887b0ca1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/dc33f128444db49aa11796e4d09678ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/ed21226de231a66b844cb4ed2975d2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/8ae68cdf9f527e7e184afeeca6739809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/27d26ad721a3d804d60338eb95c733ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63316f31920f88796ff7b528c1b35afa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4fa9bd7a3486624008deaeba3f1df99', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/eb8ae826a47f2f1a6aba025e41c9f91b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63316f31920f88796ff7b528c1b35afa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4fa9bd7a3486624008deaeba3f1df99', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/82c7648c014aad3b279bdf5927a7c4fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/e8dc37691ddf805f6e7b4511cde68743/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/18e85bd771f6b27406a67bb669950766/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/c00c83c5765ee55646c65a3de24c160f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/66246dbb368ed1e11b9c40282ea20051/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/9e640ff36b848145945c2bce9f86fd35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/377aaff792a566fcb12fbd89adb1c278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/66b118937503563f918c5c0598cf2c6f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/e4f726724fb4770e144af283b5933c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63316f31920f88796ff7b528c1b35afa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4fa9bd7a3486624008deaeba3f1df99', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/1aa2ef8d31a361d2fd483fc947c566c3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, item, dealersWithScores, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == 'this-month') {
    ___arguments.context.pageData['dateRangeLoading'] = true;
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
    dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
    ___arguments.context.pageData['monthlyScores'] = null;
    for (var j_index in dealerScoresList) {
      j = dealerScoresList[j_index];
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
        }));
      }
    }
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
    for (var j_index2 in j_list) {
      j = j_list[j_index2];
      if (getObjectProperty(j, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
      }
      if (getObjectProperty(j, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
      }
      if (getObjectProperty(j, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
      }
      if (getObjectProperty(j, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
      }
    }
    ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
    ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
    ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
    ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
    ___arguments.context.pageData['dateRangeLoading'] = false;
  }
  if (___arguments.value == '2023-01-') {
    ___arguments.context.pageData['dateRangeLoading'] = true;
    dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
    ___arguments.context.pageData['monthlyScores'] = null;
    for (var j_index3 in dealerScoresList) {
      j = dealerScoresList[j_index3];
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf('2023-01-') !== -1);
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf('2023-01-') !== -1);
        }));
      }
    }
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var j_list2 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
    for (var j_index4 in j_list2) {
      j = j_list2[j_index4];
      if (getObjectProperty(j, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
      }
      if (getObjectProperty(j, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
      }
      if (getObjectProperty(j, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
      }
      if (getObjectProperty(j, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
      }
    }
    ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
    ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
    ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
    ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
    ___arguments.context.pageData['dateRangeLoading'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/d4deff8c292b4981e238d82f3a7ea20d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var noActiveCompAlert;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'noActiveComps'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/45230712d90bb68529ba033b2a4b7677/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/c25bd4ffbf52423be3690b577edd0731/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/92937cc746917acadbca77cd7e5b8a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/ca97292784b452e1fccca321169b7916/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/8679623268f648635d44d3235089e48d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/7d7467059b0665cb136a05c12448a927/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScoresDT', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dreamTeamOffice'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/929ee76f9d952e1d5eb6eed8a663f302/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dreamTeamOffice'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard/components/795dfcdac2681e0a8395f02ee42993ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySurveysScaleTarget')) + String(' Surveys'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, thisMonthsRecruitsTotal, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competitions Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['closingAverageMonthlyTotal'] = 0;
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDealer'] = ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedDealer'));
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
      })));
    } else {
      ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
      }));
    }
  }
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index2 in j_list) {
    j = j_list[j_index2];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthDaysRemaining'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return daysLeftInMonth
  })());
  ___arguments.context.pageData['currentDayOfMonth'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['dailySalesAverage'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth'))));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = ((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthDaysRemaining')));
  console.log('#####');
  console.log(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget'));
  console.log('#####');
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  }
  ___arguments.context.pageData['competitionsHistoricData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsHistoricData')).length == 0) {
    ___arguments.context.pageData['noHistoricComps'] = true;
  }
  ___arguments.context.pageData['competitionsUpcomingData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_start_date >= \'',((new Date()).toISOString()),'\' AND related_office = \'',(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.objectId')),'\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsUpcomingData')).length == 0) {
    ___arguments.context.pageData['noUpcomingComps'] = true;
  }
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index3 in dealerScoresList) {
    j = dealerScoresList[j_index3];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  console.log(dealersWithScores);
  for (var j_index4 in dealersWithScores) {
    j = dealersWithScores[j_index4];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index5 in j_list2) {
    j = j_list2[j_index5];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index6 in j_list3) {
    j = j_list3[j_index6];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index7 in j_list4) {
    j = j_list4[j_index7];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index8 in j_list5) {
    j = j_list5[j_index8];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/ce418402b5d84aef8fc90fe429b79797/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
      return [({ 'name': 'John Doe','goal': 20,'progress': 16 }), ({ 'name': 'Amy Doe','goal': 20,'progress': 13 }), ({ 'name': 'Sam Doe','goal': 20,'progress': 8 })]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/5e5bcb9252b95c5db24a685d0e7ba96e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/eac39dcf5afdf452f68f28037dd8c028/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/4df27c387f5129a94243caa2526e938d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var monthlyText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('1aa2ef8d31a361d2fd483fc947c566c3')) == '2023-01-') {
    monthlyText = String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' - January 2023 Statistics');
  } else {
    monthlyText = [(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')),' - ',(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))),' Statistics'].join('');
  }

  return monthlyText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/263f2c5f81ee1d7ef687ea32d19f532c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/18dd18c4d1daf94ea39fdc11887b0ca1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/dc33f128444db49aa11796e4d09678ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/ed21226de231a66b844cb4ed2975d2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/8ae68cdf9f527e7e184afeeca6739809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/27d26ad721a3d804d60338eb95c733ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63316f31920f88796ff7b528c1b35afa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4fa9bd7a3486624008deaeba3f1df99', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/eb8ae826a47f2f1a6aba025e41c9f91b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63316f31920f88796ff7b528c1b35afa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4fa9bd7a3486624008deaeba3f1df99', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/82c7648c014aad3b279bdf5927a7c4fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/e8dc37691ddf805f6e7b4511cde68743/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/18e85bd771f6b27406a67bb669950766/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/c00c83c5765ee55646c65a3de24c160f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/66246dbb368ed1e11b9c40282ea20051/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/9e640ff36b848145945c2bce9f86fd35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/377aaff792a566fcb12fbd89adb1c278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/66b118937503563f918c5c0598cf2c6f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/e4f726724fb4770e144af283b5933c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63316f31920f88796ff7b528c1b35afa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4fa9bd7a3486624008deaeba3f1df99', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/1aa2ef8d31a361d2fd483fc947c566c3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, item, dealersWithScores, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == 'this-month') {
    ___arguments.context.pageData['dateRangeLoading'] = true;
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
    dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
    ___arguments.context.pageData['monthlyScores'] = null;
    for (var j_index in dealerScoresList) {
      j = dealerScoresList[j_index];
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))) !== -1);
        }));
      }
    }
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
    for (var j_index2 in j_list) {
      j = j_list[j_index2];
      if (getObjectProperty(j, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
      }
      if (getObjectProperty(j, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
      }
      if (getObjectProperty(j, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
      }
      if (getObjectProperty(j, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
      }
    }
    ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
    ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
    ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
    ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
    ___arguments.context.pageData['dateRangeLoading'] = false;
  }
  if (___arguments.value == '2023-01-') {
    ___arguments.context.pageData['dateRangeLoading'] = true;
    dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
    ___arguments.context.pageData['monthlyScores'] = null;
    for (var j_index3 in dealerScoresList) {
      j = dealerScoresList[j_index3];
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf('2023-01-') !== -1);
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).indexOf('2023-01-') !== -1);
        }));
      }
    }
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var j_list2 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
    for (var j_index4 in j_list2) {
      j = j_list2[j_index4];
      if (getObjectProperty(j, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
      }
      if (getObjectProperty(j, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
      }
      if (getObjectProperty(j, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
      }
      if (getObjectProperty(j, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
      }
    }
    ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
    ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
    ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
    ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
    ___arguments.context.pageData['dateRangeLoading'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--officeDashboard--old/components/d4deff8c292b4981e238d82f3a7ea20d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var noActiveCompAlert;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'noActiveComps'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, item, dealersWithScores, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Dealer Leaderboards';
  ___arguments.context.pageData['breadCrumb'] = 'Dealer Leaderboards';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  console.log(getObjectProperty(___arguments.context.pageData, 'userProfile'));
  ___arguments.context.pageData['relatedOfficesDealers'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = true', null, null, 2, null, null, null));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerFinalScores'] = dealersWithScores;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  if (thisMonthsSalesTotal != 0) {
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  } else {
    ___arguments.context.pageData['dealerClosingAverage'] = 0;
  }
  ___arguments.context.pageData['compSubmissionData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compDemoData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compSaleData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/069b65b829b90db13668a75b3a3b26b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' - Overall Scores'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.office_link.office_name')) + String(' - Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/7fe7b1e676e848359fc6a66ebbcf352d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/352679fd2984834ea8bbdb5d37233322/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, ttsTotalRecruits, ttsTotalSubs, ttsTotalSales, ttsTotalDemos, ttsTotalApps, j, item, dealersWithScores, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, thisMonthsRecruitsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('352679fd2984834ea8bbdb5d37233322', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d8ec7d6457e55ecce3f565652b57565', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4616ea74865c080a3eb81de19c0f02a3', true);
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    j['monthlyScores'] = null;
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    j['dealerTotalAppointments'] = 0;
    j['dealerTotalDemos'] = 0;
    j['dealerTotalSales'] = 0;
    j['dealerTotalSubmissions'] = 0;
    j['dealerTotalRecruits'] = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerFinalScores'] = dealersWithScores;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  if (thisMonthsSalesTotal != 0) {
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  } else {
    ___arguments.context.pageData['dealerClosingAverage'] = 0;
  }
  ___arguments.context.pageData['compSubmissionData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compDemoData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compSaleData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ttsTotalApps = 0;
  ttsTotalDemos = 0;
  ttsTotalSales = 0;
  ttsTotalSubs = 0;
  ttsTotalRecruits = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      ttsTotalApps = ttsTotalApps + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      ttsTotalDemos = ttsTotalDemos + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      ttsTotalSales = ttsTotalSales + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      ttsTotalSubs = ttsTotalSubs + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      ttsTotalRecruits = ttsTotalRecruits + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = ttsTotalApps;
  ___arguments.context.pageData['dealerTotalDemo'] = ttsTotalDemos;
  ___arguments.context.pageData['dealerTotalSale'] = ttsTotalSales;
  ___arguments.context.pageData['dealerTotalSubmission'] = ttsTotalSubs;
  ___arguments.context.pageData['dealerTotalRecruits'] = ttsTotalRecruits;
  if (thisMonthsSalesTotal != 0) {
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  } else {
    ___arguments.context.pageData['dealerClosingAverage'] = 0;
  }
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--officeLeaderboards/components/2d8ec7d6457e55ecce3f565652b57565/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ttsTotalDemos, ttsTotalSales, ttsTotalRecruits, ttsTotalSubs, ttsTotalApps, j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, thisMonthsRecruitsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('352679fd2984834ea8bbdb5d37233322', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d8ec7d6457e55ecce3f565652b57565', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4616ea74865c080a3eb81de19c0f02a3', false);
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    j['monthlyScores'] = null;
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    j['dealerTotalAppointments'] = 0;
    j['dealerTotalDemos'] = 0;
    j['dealerTotalSales'] = 0;
    j['dealerTotalSubmissions'] = 0;
    j['dealerTotalRecruits'] = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerFinalScores'] = dealersWithScores;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['compSubmissionData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compDemoData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compSaleData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ttsTotalApps = 0;
  ttsTotalDemos = 0;
  ttsTotalSales = 0;
  ttsTotalSubs = 0;
  ttsTotalRecruits = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      ttsTotalApps = ttsTotalApps + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      ttsTotalDemos = ttsTotalDemos + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      ttsTotalSales = ttsTotalSales + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      ttsTotalSubs = ttsTotalSubs + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      ttsTotalRecruits = ttsTotalRecruits + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = ttsTotalApps;
  ___arguments.context.pageData['dealerTotalDemo'] = ttsTotalDemos;
  ___arguments.context.pageData['dealerTotalSale'] = ttsTotalSales;
  ___arguments.context.pageData['dealerTotalSubmission'] = ttsTotalSubs;
  ___arguments.context.pageData['dealerTotalRecruits'] = ttsTotalRecruits;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((ttsTotalSales / ttsTotalDemos) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, dealerRecords, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Region Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Region Dashboard';
  ___arguments.context.pageData['pageEnterRunning'] = true;
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['closingAverageMonthlyTotal'] = 0;
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  ___arguments.context.pageData['relatedRegion'] = ((await Backendless.Data.of('Regions').find(Backendless.DataQueryBuilder.create().setWhereClause((['region_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedRegion'));
  ___arguments.context.pageData['regionsRelatedDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['region_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedRegion.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(50)));
  console.log(getObjectProperty(___arguments.context.pageData, 'regionsRelatedDivisions'));
  ___arguments.context.pageData['linkedDivisionsIds'] = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'regionsRelatedDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds')), (getObjectProperty(j, 'objectId')));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds'));
  ___arguments.context.pageData['relatedDivisionList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedDivisionListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedDivisionList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedDivisionListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['linkedOfficeIds'] = [];
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds')), (getObjectProperty(j, 'objectId')));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds'));
  ___arguments.context.pageData['linkedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['linkedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['linkedDealers'] = [];
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    ___arguments.context.pageData['linkedDealers'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedDealers')), (await Backendless.Data.of((getObjectProperty(j, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link =\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_active', 'dealer_name', 'historic_comp_scores']).setRelated(['office_link', null, null]).setRelationsDepth(2).setPageSize(100)))));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  dealerRecords = (getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index4 in dealerScoresList) {
    j = dealerScoresList[j_index4];
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
        }));
      }
    }
  }
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index5 in j_list4) {
    j = j_list4[j_index5];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  console.log('###DEBUG###');
  console.log('###DEBUG###');
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index6 in dealerScoresList) {
    j = dealerScoresList[j_index6];
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
        }));
      }
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  console.log(dealersWithScores);
  for (var j_index7 in dealersWithScores) {
    j = dealersWithScores[j_index7];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index8 in j_list5) {
    j = j_list5[j_index8];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list6 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index9 in j_list6) {
    j = j_list6[j_index9];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list7 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index10 in j_list7) {
    j = j_list7[j_index10];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list8 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index11 in j_list8) {
    j = j_list8[j_index11];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }
  ___arguments.context.pageData['pageEnterRunning'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/338d29d4372b51bb44bfe37cae21a238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/12751a2165a2738b59dd933f1a26d8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/ce418402b5d84aef8fc90fe429b79797/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
      return [({ 'name': 'John Doe','goal': 20,'progress': 16 }), ({ 'name': 'Amy Doe','goal': 20,'progress': 13 }), ({ 'name': 'Sam Doe','goal': 20,'progress': 8 })]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/5e5bcb9252b95c5db24a685d0e7ba96e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/eac39dcf5afdf452f68f28037dd8c028/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/263f2c5f81ee1d7ef687ea32d19f532c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedRegion.region_name')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/18dd18c4d1daf94ea39fdc11887b0ca1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedRegion.region_name')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/dc33f128444db49aa11796e4d09678ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/ed21226de231a66b844cb4ed2975d2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/8ae68cdf9f527e7e184afeeca6739809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd27de9627cacad1183b7197c22c5c89'), 'demosLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/27d26ad721a3d804d60338eb95c733ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c09b618edc3be09b16c11a7c21f6da35', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('303d7e288e476db668f61888c4c3b59c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/eb8ae826a47f2f1a6aba025e41c9f91b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c09b618edc3be09b16c11a7c21f6da35', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('303d7e288e476db668f61888c4c3b59c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/82c7648c014aad3b279bdf5927a7c4fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/e8dc37691ddf805f6e7b4511cde68743/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/18e85bd771f6b27406a67bb669950766/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2e4825b27397c74559a7655f69eab69'), 'appointmentsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/c00c83c5765ee55646c65a3de24c160f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showRank;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2c99169b5d11bf35d0e72987fbc66ea'), 'submissionsLeaderboardPosition')) == 1) {
    showRank = false;
  } else {
    showRank = true;
  }

  return showRank

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/66246dbb368ed1e11b9c40282ea20051/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedRegion.region_name')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/9e640ff36b848145945c2bce9f86fd35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedRegion.region_name')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/377aaff792a566fcb12fbd89adb1c278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/66b118937503563f918c5c0598cf2c6f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionDashboard/components/cebde4d44c3bfe2411f3135104b324da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('299e2307cf9a4c25154bb0be6202fe45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd9404960a4333f94cef3579b4d1a5e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c09b618edc3be09b16c11a7c21f6da35', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dba260bcdf4fc5b178be5f8bbe586f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ddab3853b89ddf86c4738422e5d0bd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('303d7e288e476db668f61888c4c3b59c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var compRecruitsTotals, item, dealersWithScores, compSalesTotals, compDemosTotals, compAppointmentsTotals, compSubmissionTotals, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, thisMonthsRecruitsTotal, j, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Region Leaderboards';
  ___arguments.context.pageData['breadCrumb'] = 'Division Leaderboards';
  ___arguments.context.pageData['leaderboardsLoading'] = true;
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedRegion'] = ((await Backendless.Data.of('Regions').find(Backendless.DataQueryBuilder.create().setWhereClause((['region_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(5)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedRegion'));
  ___arguments.context.pageData['regionsRelatedDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['region_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedRegion.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(50)));
  console.log(getObjectProperty(___arguments.context.pageData, 'regionsRelatedDivisions'));
  ___arguments.context.pageData['linkedDivisionsIds'] = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'regionsRelatedDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds')), (getObjectProperty(j, 'objectId')));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds'));
  ___arguments.context.pageData['relatedDivisionList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedDivisionListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedDivisionList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  console.log('###debug###');
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedDivisionListEdited'));
  console.log('###debug###');
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedDivisionListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['linkedOfficeIds'] = [];
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds')), (getObjectProperty(j, 'objectId')));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds'));
  ___arguments.context.pageData['linkedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['linkedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['linkedDealers'] = [];
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    ___arguments.context.pageData['linkedDealers'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedDealers')), (await Backendless.Data.of((getObjectProperty(j, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link =\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_active', 'dealer_name', 'historic_comp_scores', 'dealer_photo']).setRelated(['office_link', null, null]).setRelationsDepth(2).setPageSize(100)))));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index4 in dealerScoresList) {
    j = dealerScoresList[j_index4];
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  console.log(dealersWithScores);
  for (var j_index5 in dealersWithScores) {
    j = dealersWithScores[j_index5];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  compSubmissionTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = compSubmissionTotals;
  ___arguments.context.pageData['compSubmissionData'] = compSubmissionTotals;
  compAppointmentsTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = compAppointmentsTotals;
  ___arguments.context.pageData['compAppointmentData'] = compAppointmentsTotals;
  compDemosTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = compDemosTotals;
  ___arguments.context.pageData['compDemoData'] = compDemosTotals;
  compSalesTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = compSalesTotals;
  ___arguments.context.pageData['compSaleData'] = compSalesTotals;
  compRecruitsTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = compRecruitsTotals;
  ___arguments.context.pageData['compRecruitData'] = compRecruitsTotals;
  ___arguments.context.pageData['leaderboardsLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedRegion.region_name')) + String(' - Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/17e3b9bdad6e5145bfc130783f55d319/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--regionLeaderboards/components/11b6fcc51e9ab3026a9c225df903d5b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, compRecruitsTotals, item, dealersWithScores, compSalesTotals, compDemosTotals, compAppointmentsTotals, compSubmissionTotals, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Time to Shine Dealers Leaderboard';
  ___arguments.context.pageData['breadCrumb'] = 'Time to Shine Dealers Leaderboard';
  ___arguments.context.pageData['leaderboardsLoading'] = true;
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedRegion'] = ((await Backendless.Data.of('Regions').find(Backendless.DataQueryBuilder.create().setWhereClause((String('objectId = \'60D7A635-E285-41A1-86D6-094053A81D84\''))).setRelationsDepth(2).setPageSize(5)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedRegion'));
  ___arguments.context.pageData['regionsRelatedDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['region_link = \'',(getObjectProperty(___arguments.context.pageData, 'relatedRegion.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(50)));
  console.log(getObjectProperty(___arguments.context.pageData, 'regionsRelatedDivisions'));
  ___arguments.context.pageData['linkedDivisionsIds'] = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'regionsRelatedDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds')), (getObjectProperty(j, 'objectId')));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds'));
  ___arguments.context.pageData['relatedDivisionList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'linkedDivisionsIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedDivisionListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedDivisionList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  console.log('###debug###');
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedDivisionListEdited'));
  console.log('###debug###');
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedDivisionListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['linkedOfficeIds'] = [];
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds')), (getObjectProperty(j, 'objectId')));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds'));
  ___arguments.context.pageData['linkedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['linkedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'linkedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['linkedDealers'] = [];
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    ___arguments.context.pageData['linkedDealers'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'linkedDealers')), (await Backendless.Data.of((getObjectProperty(j, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link =\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_active', 'dealer_name', 'historic_comp_scores', 'dealer_photo']).setRelated(['office_link', null, null]).setRelationsDepth(2).setPageSize(100)))));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'linkedDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index4 in dealerScoresList) {
    j = dealerScoresList[j_index4];
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  console.log(dealersWithScores);
  for (var j_index5 in dealersWithScores) {
    j = dealersWithScores[j_index5];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  compSubmissionTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = compSubmissionTotals;
  ___arguments.context.pageData['compSubmissionData'] = compSubmissionTotals;
  compAppointmentsTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = compAppointmentsTotals;
  ___arguments.context.pageData['compAppointmentData'] = compAppointmentsTotals;
  compDemosTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = compDemosTotals;
  ___arguments.context.pageData['compDemoData'] = compDemosTotals;
  compSalesTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = compSalesTotals;
  ___arguments.context.pageData['compSaleData'] = compSalesTotals;
  compRecruitsTotals = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = compRecruitsTotals;
  ___arguments.context.pageData['compRecruitData'] = compRecruitsTotals;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index6 in j_list4) {
    j = j_list4[j_index6];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  if (thisMonthsSalesTotal != 0) {
    ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  } else {
    ___arguments.context.pageData['dealerClosingAverage'] = 0;
  }
  ___arguments.context.pageData['leaderboardsLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'relatedRegion.region_name')) + String(' - Dealer Leaderboards'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/17e3b9bdad6e5145bfc130783f55d319/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--regionLeaderboards--ld/components/11b6fcc51e9ab3026a9c225df903d5b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'office_link.office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, dealerScoresList, item, officeScoreList, k, l, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Time to Shine Office Leaderboard';
  ___arguments.context.pageData['breadCrumb'] = 'Time to Shine Office Leaderboard';
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link IS NOT NULL','',''].join(''))).setRelationsDepth(2).setPageSize(50)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')), (getObjectProperty(j, 'objectId')));
    } else {
      ___arguments.context.pageData['relatedOfficesIds'] = [(getObjectProperty(j, 'objectId'))];
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['relatedOfficeIdList'] = (((JSON.stringify((getObjectProperty(___arguments.context.pageData, 'relatedOfficesIds')))).replace('[', '')).replace(']', ''));
  ___arguments.context.pageData['relatedOfficeIdListEdited'] = (String((getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdList')).replace((new RegExp('"', 'g')), '\'')) + String(''));
  ___arguments.context.pageData['relatedOfficesDealers'] = (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'relatedDivision.division_dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link IN (',(getObjectProperty(___arguments.context.pageData, 'relatedOfficeIdListEdited')),')'].join(''))).setRelationsDepth(2).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    j['relatedDealers'] = (await Backendless.Data.of((getObjectProperty(j, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['monthlyScores'] = ___arguments.context.pageData;
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          }));
        }
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          })));
        }
      } else {
        if (getObjectProperty(l, 'historic_comp_scores')) {
          ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


           return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
          }));
        }
      }
    }
  }
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index4 in j_list4) {
    j = j_list4[j_index4];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compSubmissionData'] = (getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals'));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals'));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compDemoData'] = (getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals'));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compSaleData'] = (getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals'));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (getObjectProperty(___arguments.context.pageData, 'competitionRecruitsTotals'));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index5 in j_list5) {
    j = j_list5[j_index5];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/069b65b829b90db13668a75b3a3b26b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' - Overall Scores'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionOfficeLeaderboards--ld/components/14eeabf8171619a659a115fbf9253782/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'office_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, officeScoreList, thisMonthsRecruitsTotal, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, l, divisionTotalRecruits, divisionTotalSubmissions, divisionTotalSales, divisionTotalDemos, divisionTotalAppointments, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Division Leaderboard';
  ___arguments.context.pageData['breadCrumb'] = 'Division Leaderboard';
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDivision'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  ___arguments.context.pageData['eagleDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((String('region_link = \'60D7A635-E285-41A1-86D6-094053A81D84\''))).setRelationsDepth(3).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_table', 'office_name', 'office_photo']).setRelationsDepth(2).setPageSize(10)));
    var k_list = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      k['officeDealers'] = (await Backendless.Data.of((getObjectProperty(k, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(k, 'objectId')),'\''].join(''))).setProperties(['historic_comp_scores']).setRelationsDepth(2).setPageSize(100)));
    }
  }
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      var l_list = (getObjectProperty(k, 'officeDealers'));
      for (var l_index in l_list) {
        l = l_list[l_index];
        if (getObjectProperty(l, 'historic_comp_scores')) {
          if (getObjectProperty(k, 'eventScores')) {
            addItemToList((getObjectProperty(k, 'eventScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
            })));
          } else {
            k['eventScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
            }));
          }
        }
      }
    }
  }
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    var k_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index3 in k_list3) {
      k = k_list3[k_index3];
      thisMonthsAppointmentsTotal = 0;
      thisMonthsDemosTotal = 0;
      thisMonthsSalesTotal = 0;
      thisMonthsSubmissionsTotal = 0;
      thisMonthsRecruitsTotal = 0;
      var l_list2 = (getObjectProperty(k, 'eventScores'));
      for (var l_index2 in l_list2) {
        l = l_list2[l_index2];
        if (getObjectProperty(l, 'appointments')) {
          thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(l, 'appointments'));
        }
        if (getObjectProperty(l, 'demos')) {
          thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(l, 'demos'));
        }
        if (getObjectProperty(l, 'sales')) {
          thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(l, 'sales'));
        }
        if (getObjectProperty(l, 'submissions')) {
          thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(l, 'submissions'));
        }
        if (getObjectProperty(l, 'recruits')) {
          thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(l, 'recruits'));
        }
      }
      k['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
      k['dealerTotalDemos'] = thisMonthsDemosTotal;
      k['dealerTotalSales'] = thisMonthsSalesTotal;
      k['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
      k['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
    }
    divisionTotalAppointments = 0;
    divisionTotalDemos = 0;
    divisionTotalSales = 0;
    divisionTotalSubmissions = 0;
    divisionTotalRecruits = 0;
    var l_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var l_index3 in l_list3) {
      l = l_list3[l_index3];
      if (getObjectProperty(l, 'dealerTotalAppointments')) {
        divisionTotalAppointments = divisionTotalAppointments + (getObjectProperty(l, 'dealerTotalAppointments'));
      }
      if (getObjectProperty(l, 'dealerTotalDemos')) {
        divisionTotalDemos = divisionTotalDemos + (getObjectProperty(l, 'dealerTotalDemos'));
      }
      if (getObjectProperty(l, 'dealerTotalSales')) {
        divisionTotalSales = divisionTotalSales + (getObjectProperty(l, 'dealerTotalSales'));
      }
      if (getObjectProperty(l, 'dealerTotalSubmissions')) {
        divisionTotalSubmissions = divisionTotalSubmissions + (getObjectProperty(l, 'dealerTotalSubmissions'));
      }
      if (getObjectProperty(l, 'dealerTotalRecruits')) {
        divisionTotalRecruits = divisionTotalRecruits + (getObjectProperty(l, 'dealerTotalRecruits'));
      }
    }
    j['divisionTotalAppointments'] = divisionTotalAppointments;
    j['divisionTotalDemos'] = divisionTotalDemos;
    j['divisionTotalSales'] = divisionTotalSales;
    j['divisionTotalSubmissions'] = divisionTotalSubmissions;
    j['divisionTotalRecruits'] = divisionTotalRecruits;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalRecruits'));
  }));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/c338909204e34dd5e87d22b258de45f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, officeScoreList, thisMonthsRecruitsTotal, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, l;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', true);
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['monthlyScores'] = null;
    var l_list = (getObjectProperty(j, 'relatedDealers'));
    for (var l_index in l_list) {
      l = l_list[l_index];
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2024-01-26T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2024-01-28T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'relatedOffices'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--regionalDivisionLeaderboard/components/a297435dc8fff5617763b7a75e6c38e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338909204e34dd5e87d22b258de45f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a297435dc8fff5617763b7a75e6c38e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12026e7c6f8fc60332ad9da7941d9e86', false);
  await BackendlessUI.Functions.Custom['fn_39c8388efde660a8fac97b5c2e8ea5a6'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsRecruitsTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, j, item, dealersWithScores, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  ___arguments.context.pageData['hideSidebarIcon'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Team Leader Stats';
  ___arguments.context.pageData['breadCrumb'] = 'Team Leader Stats';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['userProfile'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link').setRelationsDepth(2)));
  ___arguments.context.pageData['relatedDealerRecord'] = ((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join('')), null, null, 2, null, null, null))[0]);
  ___arguments.context.pageData['relatedOfficesDealers'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['team_leader = \'',(getObjectProperty(___arguments.context.pageData, 'relatedDealerRecord.objectId')),'\''].join('')), null, 'team_leader', 2, null, null, true));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'is_team_leader')) == true) {
      console.log(String(getObjectProperty(j, 'dealer_name')) + String(' is a team leader.'));
      console.log((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['team_leader = \'',(getObjectProperty(j, 'objectId')),'\''].join('')), null, 'team_leader', 2, null, null, true)));
      if ((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['team_leader = \'',(getObjectProperty(j, 'objectId')),'\''].join('')), null, 'team_leader', 2, null, null, true))) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers')), (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['team_leader = \'',(getObjectProperty(j, 'objectId')),'\''].join('')), null, 'team_leader', 2, null, null, true)));
      }
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerFinalScores'] = dealersWithScores;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['compSubmissionData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compDemoData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compSaleData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  thisMonthsRecruitsTotal = 0;
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/069b65b829b90db13668a75b3a3b26b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' - Overall Scores'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/b6854fd4917b50b49c5b0a5579060f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'userProfile.name')) + String('\'s Team Leaderboard'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/7fe7b1e676e848359fc6a66ebbcf352d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/352679fd2984834ea8bbdb5d37233322/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ttsTotalDemos, ttsTotalSales, ttsTotalRecruits, ttsTotalSubs, ttsTotalApps, j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, thisMonthsRecruitsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('352679fd2984834ea8bbdb5d37233322', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d8ec7d6457e55ecce3f565652b57565', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4616ea74865c080a3eb81de19c0f02a3', true);
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    j['monthlyScores'] = null;
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-10-06T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-10-06T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-10-06T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')) >= '2023-10-06T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-10-08T23:59:00.000Z');
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    j['dealerTotalAppointments'] = 0;
    j['dealerTotalDemos'] = 0;
    j['dealerTotalSales'] = 0;
    j['dealerTotalSubmissions'] = 0;
    j['dealerTotalRecruits'] = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerFinalScores'] = dealersWithScores;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['compSubmissionData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compDemoData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compSaleData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ttsTotalApps = 0;
  ttsTotalDemos = 0;
  ttsTotalSales = 0;
  ttsTotalSubs = 0;
  ttsTotalRecruits = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      ttsTotalApps = ttsTotalApps + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      ttsTotalDemos = ttsTotalDemos + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      ttsTotalSales = ttsTotalSales + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      ttsTotalSubs = ttsTotalSubs + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      ttsTotalRecruits = ttsTotalRecruits + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = ttsTotalApps;
  ___arguments.context.pageData['dealerTotalDemo'] = ttsTotalDemos;
  ___arguments.context.pageData['dealerTotalSale'] = ttsTotalSales;
  ___arguments.context.pageData['dealerTotalSubmission'] = ttsTotalSubs;
  ___arguments.context.pageData['dealerTotalRecruits'] = ttsTotalRecruits;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((ttsTotalSales / ttsTotalDemos) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/2d8ec7d6457e55ecce3f565652b57565/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ttsTotalDemos, ttsTotalSales, ttsTotalRecruits, ttsTotalSubs, ttsTotalApps, j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, thisMonthsRecruitsTotal, k, dealerScoresList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('352679fd2984834ea8bbdb5d37233322', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d8ec7d6457e55ecce3f565652b57565', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('069b65b829b90db13668a75b3a3b26b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4616ea74865c080a3eb81de19c0f02a3', false);
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'relatedOfficesDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index in dealerScoresList) {
    j = dealerScoresList[j_index];
    j['monthlyScores'] = null;
    if (getObjectProperty(j, 'historic_comp_scores')) {
      if (getObjectProperty(j, 'monthlyScores')) {
        addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
      if (getObjectProperty(___arguments.context.pageData, 'monthlyScores')) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        })));
      } else {
        ___arguments.context.pageData['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


         return ((getObjectProperty(item, 'date')).startsWith((getObjectProperty(___arguments.context.pageData, 'currentMonthYear'))));
        }));
      }
    }
  }
  console.log(dealerScoresList);
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')) ? (getObjectProperty(item, 'monthlyScores')).length != 0 : null);
  }));
  for (var j_index2 in dealersWithScores) {
    j = dealersWithScores[j_index2];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    thisMonthsRecruitsTotal = 0;
    j['dealerTotalAppointments'] = 0;
    j['dealerTotalDemos'] = 0;
    j['dealerTotalSales'] = 0;
    j['dealerTotalSubmissions'] = 0;
    j['dealerTotalRecruits'] = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
      if (getObjectProperty(k, 'recruits')) {
        thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(k, 'recruits'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
    j['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
  }
  ___arguments.context.pageData['dealerFinalScores'] = dealersWithScores;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['compSubmissionData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['compAppointmentData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['compDemoData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['compSaleData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['compRecruitData'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalRecruits'));
  }));
  ttsTotalApps = 0;
  ttsTotalDemos = 0;
  ttsTotalSales = 0;
  ttsTotalSubs = 0;
  ttsTotalRecruits = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'monthlyScores'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    if (getObjectProperty(j, 'appointments')) {
      ttsTotalApps = ttsTotalApps + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      ttsTotalDemos = ttsTotalDemos + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      ttsTotalSales = ttsTotalSales + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      ttsTotalSubs = ttsTotalSubs + (getObjectProperty(j, 'submissions'));
    }
    if (getObjectProperty(j, 'recruits')) {
      ttsTotalRecruits = ttsTotalRecruits + (getObjectProperty(j, 'recruits'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = ttsTotalApps;
  ___arguments.context.pageData['dealerTotalDemo'] = ttsTotalDemos;
  ___arguments.context.pageData['dealerTotalSale'] = ttsTotalSales;
  ___arguments.context.pageData['dealerTotalSubmission'] = ttsTotalSubs;
  ___arguments.context.pageData['dealerTotalRecruits'] = ttsTotalRecruits;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((ttsTotalSales / ttsTotalDemos) * 100)) + String('%'));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--teamLeaderboard/components/80311049283db1b5b9466849b9f3fe35/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSubmissionData')), async (item) => {


   return (((getObjectProperty(item, 'team_leader.dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compAppointmentData')), async (item) => {


   return (((getObjectProperty(item, 'team_leader.dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compDemoData')), async (item) => {


   return (((getObjectProperty(item, 'team_leader.dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compSaleData')), async (item) => {


   return (((getObjectProperty(item, 'team_leader.dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'compRecruitData')), async (item) => {


   return (((getObjectProperty(item, 'team_leader.dealer_name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['breadCrumb'] = 'Edit Dealer Scores';
  ___arguments.context.pageData['pageTitle'] = 'Update Scores';
  if (typeof ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) === 'undefined') {
    localStorage.setItem('officeObjId', JSON.stringify('C73B2210-82F4-4467-9AE1-4277517ADD54'));
  }
  ___arguments.context.pageData['dealers_table'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_active = TRUE and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\' ','',''].join('')), 'dealer_nameLast ASC', null, null, null, null, null));
  console.log(getObjectProperty(___arguments.context.pageData, 'dealers_table'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/d20ed28973b4479984c81d86be4a681c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, allDatesExceptChosen, databaseScores, newScore, response, selectedDatePlus1, item, selectedDate, isObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['scoreSavingActive'] = true;
  selectedDate = (new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() - ((2 * 3600) * 1000)));
  selectedDatePlus1 = (new Date(selectedDate.getTime() + ((1 * 86400) * 1000)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealerRecord'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    newScore = (getObjectProperty(j, 'dealerScore'));
    if (newScore) {
      newScore['date'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() + ((12 * 3600) * 1000))).toISOString());
      databaseScores = (getObjectProperty(j, 'historic_comp_scores'));
      allDatesExceptChosen = (await asyncListFilter(databaseScores, async (item) => {
         isObject = (item !== null && !Array.isArray(item) && (typeof item === 'object'));
        if (isObject) {
          response = (new Date((getObjectProperty(item, 'date')))) < selectedDate || (new Date((getObjectProperty(item, 'date')))) >= selectedDatePlus1;
        } else {
          response = false;
        }


       return response;
      }));
      databaseScores = (addItemToList(allDatesExceptChosen, newScore));
      j['historic_comp_scores'] = databaseScores;
      console.log('new scores to be saved');
      console.log(allDatesExceptChosen);
      delete j['dealerScore'];
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(j, true);
    }
  }
  ___arguments.context.pageData['scoreSavingActive'] = false;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2396d5c8b0ecee5fc04e28398dac84ad', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealerRecord'] = undefined;
  ___arguments.context.pageData['selectedDate'] = undefined;
  ___arguments.context.pageData['submissionDailyTotal'] = undefined;
  ___arguments.context.pageData['saleDailyTotal'] = undefined;
  ___arguments.context.pageData['appointmentDailyTotal'] = undefined;
  ___arguments.context.pageData['demoDailyTotal'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/8c6d44e82e7b10b665ad3ea70643b22f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/bdf97d6fe8196affec1a20eb961e872a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var submissionTotal, saleTotal, demoTotal, appointmentTotal, j, dealerRecord, scores, selectedDate, item, historicScoreForDay, selectedDatePlus1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  selectedDate = (new Date(((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')))).toUTCString())));
  selectedDate.setHours(0);
  selectedDate.setMinutes(0);
  ___arguments.context.pageData['selectedDate'] = selectedDate;
  if (typeof ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) === 'undefined') {
    localStorage.setItem('officeObjId', JSON.stringify('C73B2210-82F4-4467-9AE1-4277517ADD54'));
  }
  selectedDatePlus1 = (new Date((new Date(selectedDate)).getTime() + ((1 * 86400) * 1000)));
  dealerRecord = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_active = TRUE and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\' ','',''].join('')), 'dealer_nameLast ASC', null, null, null, null, null));
  for (var j_index in dealerRecord) {
    j = dealerRecord[j_index];
    if (!((getObjectProperty(j, 'historic_comp_scores')) === null)) {
      historicScoreForDay = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((item !== null && !Array.isArray(item) && (typeof item === 'object')) && (new Date((getObjectProperty(item, 'date')))) >= selectedDate && (new Date((getObjectProperty(item, 'date')))) < selectedDatePlus1);
      }));
      if (historicScoreForDay.length > 1) {
        console.log('PROBLEM');
        console.log(j);
        console.log(getObjectProperty(j, 'historic_comp_scores'));
        console.log(selectedDate);
        console.log(selectedDatePlus1);
        console.log(historicScoreForDay);
      }
      console.log('on loading the historic comp scores are: ');
      console.log(getObjectProperty(j, 'historic_comp_scores'));
      j['dealerScore'] = (historicScoreForDay[0]);
    }
  }
  ___arguments.context.pageData['dealerRecord'] = dealerRecord;
  ___arguments.context.pageData['allScores'] = scores;
  for (var j_index2 in dealerRecord) {
    j = dealerRecord[j_index2];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/95939a88498a0c1fc19b0af541dff3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var dealerNames, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerNames = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealers_table'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }

  return dealerNames

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var submissionTotal, saleTotal, demoTotal, appointmentTotal, j, dealerRecord, scores, selectedDate, item, historicScoreForDay, selectedDatePlus1, selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = ___arguments.value;
  console.log(selectedDealer);
  if (typeof ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) === 'undefined') {
    ___arguments.context.appData['officeObjId'] = 'C73B2210-82F4-4467-9AE1-4277517ADD54';
  }
  dealerRecord = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_active = TRUE and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\' ','and dealer_name = \'',selectedDealer,'\''].join('')), 'dealer_nameLast ASC', null, null, null, null, null));
  console.log(dealerRecord);
  console.log(dealerRecord[0]);
  ___arguments.context.pageData['dealerRecord'] = (getObjectProperty((dealerRecord[0]), 'historic_comp_scores'));
  ___arguments.context.pageData['allScores'] = scores;
  for (var j_index in dealerRecord) {
    j = dealerRecord[j_index];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/faafde8fa54a752379ec90565dabafa5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var appointmentTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/ee1abffadd2e834e466bcc8ffcdf4497/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var demoTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
  }
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/efc2ae5d82e13079ea0bbdba718b3208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var saleTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
  }
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/865a0555425774de5b11e50514a9e687/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var submissionTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateDealerScores/components/8476aefb7b86a94fbad3b0118e22f95c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--updateScores/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['breadCrumb'] = 'Edit Dealer Scores';
  ___arguments.context.pageData['pageTitle'] = 'Update Scores';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--updateScores/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateScores/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--updateScores/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--updateScores/components/d20ed28973b4479984c81d86be4a681c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, allDatesExceptChosen, databaseScores, newScore, response, selectedDatePlus1, item, selectedDate, isObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['scoreSavingActive'] = true;
  selectedDate = (new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() - ((2 * 3600) * 1000)));
  selectedDatePlus1 = (new Date(selectedDate.getTime() + ((1 * 86400) * 1000)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealerRecord'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    newScore = (getObjectProperty(j, 'dealerScore'));
    if (newScore) {
      newScore['date'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() + ((12 * 3600) * 1000))).toISOString());
      if (getObjectProperty(j, 'historic_comp_scores')) {
        databaseScores = (getObjectProperty(j, 'historic_comp_scores'));
      }
      allDatesExceptChosen = (await asyncListFilter(databaseScores, async (item) => {
         isObject = (item !== null && !Array.isArray(item) && (typeof item === 'object'));
        if (isObject) {
          response = (new Date((getObjectProperty(item, 'date')))) < selectedDate || (new Date((getObjectProperty(item, 'date')))) >= selectedDatePlus1;
        } else {
          response = false;
        }


       return response;
      }));
      databaseScores = (addItemToList(allDatesExceptChosen, newScore));
      j['historic_comp_scores'] = databaseScores;
      console.log('new scores to be saved');
      console.log(allDatesExceptChosen);
      delete j['dealerScore'];
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).save(j, true);
    }
  }
  ___arguments.context.pageData['scoreSavingActive'] = false;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2396d5c8b0ecee5fc04e28398dac84ad', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealerRecord'] = undefined;
  ___arguments.context.pageData['selectedDate'] = undefined;
  ___arguments.context.pageData['submissionDailyTotal'] = undefined;
  ___arguments.context.pageData['saleDailyTotal'] = undefined;
  ___arguments.context.pageData['appointmentDailyTotal'] = undefined;
  ___arguments.context.pageData['demoDailyTotal'] = undefined;
  ___arguments.context.pageData['recruitsDailyTotal'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateScores/components/8c6d44e82e7b10b665ad3ea70643b22f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateScores/components/bdf97d6fe8196affec1a20eb961e872a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var recruitsTotal, submissionTotal, saleTotal, demoTotal, appointmentTotal, j, dealerRecord, scores, selectedDate, item, historicScoreForDay, selectedDatePlus1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  selectedDate = (new Date(((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')))).toUTCString())));
  selectedDate.setHours(0);
  selectedDate.setMinutes(0);
  ___arguments.context.pageData['selectedDate'] = selectedDate;
  if (typeof ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) === 'undefined') {
    localStorage.setItem('officeObjId', JSON.stringify('C73B2210-82F4-4467-9AE1-4277517ADD54'));
  }
  selectedDatePlus1 = (new Date((new Date(selectedDate)).getTime() + ((1 * 86400) * 1000)));
  dealerRecord = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_active = TRUE and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\' ','',''].join('')), 'dealer_nameLast ASC', null, null, null, null, null));
  for (var j_index in dealerRecord) {
    j = dealerRecord[j_index];
    if (!((getObjectProperty(j, 'historic_comp_scores')) === null)) {
      historicScoreForDay = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((item !== null && !Array.isArray(item) && (typeof item === 'object')) && (new Date((getObjectProperty(item, 'date')))) >= selectedDate && (new Date((getObjectProperty(item, 'date')))) < selectedDatePlus1);
      }));
      if (historicScoreForDay.length > 1) {
        console.log('PROBLEM');
        console.log(j);
        console.log(getObjectProperty(j, 'historic_comp_scores'));
        console.log(selectedDate);
        console.log(selectedDatePlus1);
        console.log(historicScoreForDay);
      }
      console.log('on loading the historic comp scores are: ');
      console.log(getObjectProperty(j, 'historic_comp_scores'));
      j['dealerScore'] = (historicScoreForDay[0]);
    }
  }
  ___arguments.context.pageData['dealerRecord'] = dealerRecord;
  ___arguments.context.pageData['allScores'] = scores;
  for (var j_index2 in dealerRecord) {
    j = dealerRecord[j_index2];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
    if (getObjectProperty(j, 'dealerScore.recruits')) {
      recruitsTotal = (typeof recruitsTotal == 'number' ? recruitsTotal : 0) + (getObjectProperty(j, 'dealerScore.recruits'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;
  ___arguments.context.pageData['recruitsDailyTotal'] = recruitsTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScores/components/95939a88498a0c1fc19b0af541dff3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var dealerNames, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerNames = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealers_table'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }

  return dealerNames

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--updateScores/components/c1c1148c616506ea59e4e065ab877d9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dateSelectedText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDate')) {
    dateSelectedText = ((getObjectProperty(___arguments.context.pageData, 'selectedDate')).toDateString());
  } else {
    dateSelectedText = '';
  }

  return dateSelectedText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--updateScores/components/faafde8fa54a752379ec90565dabafa5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var appointmentTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScores/components/ee1abffadd2e834e466bcc8ffcdf4497/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var demoTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
  }
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScores/components/efc2ae5d82e13079ea0bbdba718b3208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var saleTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
  }
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScores/components/865a0555425774de5b11e50514a9e687/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var submissionTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScores/components/6e14df3922d8575eec9201bb7552d8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var recruitsTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.recruits')) {
      recruitsTotal = (typeof recruitsTotal == 'number' ? recruitsTotal : 0) + (getObjectProperty(j, 'dealerScore.recruits'));
    }
  }
  ___arguments.context.pageData['recruitsDailyTotal'] = recruitsTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScores/components/61abb2082995e18394ae7bc3bd493ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showDateAlert;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showDateAlert = true;
  if (getObjectProperty(___arguments.context.pageData, 'selectedDate')) {
    showDateAlert = false;
  } else {
    showDateAlert = true;
  }

  return showDateAlert

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['breadCrumb'] = 'Edit Dealer Scores';
  ___arguments.context.pageData['pageTitle'] = 'Update Scores';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/d20ed28973b4479984c81d86be4a681c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, allDatesExceptChosen, databaseScores, newScore, response, selectedDatePlus1, item, selectedDate, isObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['scoreSavingActive'] = true;
  selectedDate = (new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() - ((2 * 3600) * 1000)));
  selectedDatePlus1 = (new Date(selectedDate.getTime() + ((1 * 86400) * 1000)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealerRecord'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    newScore = (getObjectProperty(j, 'dealerScore'));
    if (newScore) {
      newScore['date'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')).getTime() + ((12 * 3600) * 1000))).toISOString());
      if (getObjectProperty(j, 'historic_comp_scores')) {
        databaseScores = (getObjectProperty(j, 'historic_comp_scores'));
      }
      allDatesExceptChosen = (await asyncListFilter(databaseScores, async (item) => {
         isObject = (item !== null && !Array.isArray(item) && (typeof item === 'object'));
        if (isObject) {
          response = (new Date((getObjectProperty(item, 'date')))) < selectedDate || (new Date((getObjectProperty(item, 'date')))) >= selectedDatePlus1;
        } else {
          response = false;
        }


       return response;
      }));
      databaseScores = (addItemToList(allDatesExceptChosen, newScore));
      j['historic_comp_scores'] = databaseScores;
      delete j['dealerScore'];
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).save(j, true);
    }
  }
  ___arguments.context.pageData['scoreSavingActive'] = false;
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2396d5c8b0ecee5fc04e28398dac84ad', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealerRecord'] = undefined;
  ___arguments.context.pageData['selectedDate'] = undefined;
  ___arguments.context.pageData['submissionDailyTotal'] = undefined;
  ___arguments.context.pageData['saleDailyTotal'] = undefined;
  ___arguments.context.pageData['appointmentDailyTotal'] = undefined;
  ___arguments.context.pageData['demoDailyTotal'] = undefined;
  ___arguments.context.pageData['recruitsDailyTotal'] = undefined;
  ___arguments.context.pageData['surveysDailyTotal'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/8c6d44e82e7b10b665ad3ea70643b22f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/bdf97d6fe8196affec1a20eb961e872a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var appointmentTotal, dealerRecord, demoTotal, historicScoreForDay, item, j, recruitsTotal, saleTotal, scores, selectedDate, selectedDatePlus1, submissionTotal, surveysTotal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  selectedDate = (new Date(((new Date((getObjectProperty(___arguments.context.pageData, 'selectedDate')))).toUTCString())));
  selectedDate.setHours(0);
  selectedDate.setMinutes(0);
  ___arguments.context.pageData['selectedDate'] = selectedDate;
  if (typeof ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')) === 'undefined') {
    localStorage.setItem('officeObjId', JSON.stringify('C73B2210-82F4-4467-9AE1-4277517ADD54'));
  }
  selectedDatePlus1 = (new Date((new Date(selectedDate)).getTime() + ((1 * 86400) * 1000)));
  dealerRecord = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), (['dealer_active = TRUE and objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\' ','',''].join('')), 'dealer_nameLast ASC', null, null, null, null, null));
  for (var j_index in dealerRecord) {
    j = dealerRecord[j_index];
    if (!((getObjectProperty(j, 'historic_comp_scores')) === null)) {
      historicScoreForDay = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((item !== null && !Array.isArray(item) && (typeof item === 'object')) && (new Date((getObjectProperty(item, 'date')))) >= selectedDate && (new Date((getObjectProperty(item, 'date')))) < selectedDatePlus1);
      }));
      if (historicScoreForDay.length > 1) {
      }
      j['dealerScore'] = (historicScoreForDay[0]);
    }
  }
  ___arguments.context.pageData['dealerRecord'] = dealerRecord;
  ___arguments.context.pageData['allScores'] = scores;
  for (var j_index2 in dealerRecord) {
    j = dealerRecord[j_index2];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
    if (getObjectProperty(j, 'dealerScore.recruits')) {
      recruitsTotal = (typeof recruitsTotal == 'number' ? recruitsTotal : 0) + (getObjectProperty(j, 'dealerScore.recruits'));
    }
    if (getObjectProperty(j, 'dealerScore.surveys')) {
      surveysTotal = (typeof surveysTotal == 'number' ? surveysTotal : 0) + (getObjectProperty(j, 'dealerScore.surveys'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;
  ___arguments.context.pageData['recruitsDailyTotal'] = recruitsTotal;
  ___arguments.context.pageData['surveysDailyTotal'] = surveysTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/95939a88498a0c1fc19b0af541dff3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var dealerNames, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerNames = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'dealers_table'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }

  return dealerNames

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/c1c1148c616506ea59e4e065ab877d9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dateSelectedText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDate')) {
    dateSelectedText = ((getObjectProperty(___arguments.context.pageData, 'selectedDate')).toDateString());
  } else {
    dateSelectedText = '';
  }

  return dateSelectedText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/faafde8fa54a752379ec90565dabafa5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var appointmentTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.appointments')) {
      appointmentTotal = (typeof appointmentTotal == 'number' ? appointmentTotal : 0) + (getObjectProperty(j, 'dealerScore.appointments'));
    }
  }
  ___arguments.context.pageData['appointmentDailyTotal'] = appointmentTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/ee1abffadd2e834e466bcc8ffcdf4497/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var demoTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.demos')) {
      demoTotal = (typeof demoTotal == 'number' ? demoTotal : 0) + (getObjectProperty(j, 'dealerScore.demos'));
    }
  }
  ___arguments.context.pageData['demoDailyTotal'] = demoTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/efc2ae5d82e13079ea0bbdba718b3208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var saleTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.sales')) {
      saleTotal = (typeof saleTotal == 'number' ? saleTotal : 0) + (getObjectProperty(j, 'dealerScore.sales'));
    }
  }
  ___arguments.context.pageData['saleDailyTotal'] = saleTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/865a0555425774de5b11e50514a9e687/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var submissionTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.submissions')) {
      submissionTotal = (typeof submissionTotal == 'number' ? submissionTotal : 0) + (getObjectProperty(j, 'dealerScore.submissions'));
    }
  }
  ___arguments.context.pageData['submissionDailyTotal'] = submissionTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/6e14df3922d8575eec9201bb7552d8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var recruitsTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.recruits')) {
      recruitsTotal = (typeof recruitsTotal == 'number' ? recruitsTotal : 0) + (getObjectProperty(j, 'dealerScore.recruits'));
    }
  }
  ___arguments.context.pageData['recruitsDailyTotal'] = recruitsTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/61abb2082995e18394ae7bc3bd493ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showDateAlert;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showDateAlert = true;
  if (getObjectProperty(___arguments.context.pageData, 'selectedDate')) {
    showDateAlert = false;
  } else {
    showDateAlert = true;
  }

  return showDateAlert

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--updateScoresDT/components/d636735412f6c52cd9c9d34e00c6e8bc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var surveysTotal, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('1a2dcb0f02e91722930c546e39387377'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'dealerScore.surveys')) {
      surveysTotal = (typeof surveysTotal == 'number' ? surveysTotal : 0) + (getObjectProperty(j, 'dealerScore.surveys'));
    }
  }
  ___arguments.context.pageData['surveysDailyTotal'] = surveysTotal;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, item, dealersWithScores, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competitions Dashboard';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }
  ___arguments.context.pageData['targetAchieved'] = true;
  loggedInUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['competition_end_date'] = (new Date());
  ___arguments.context.pageData['currentUser'] = (await Backendless.Data.of('Users').findById((getObjectProperty(loggedInUser, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  ___arguments.context.pageData['currentDealerRecord'] = ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0]);
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND objectId != \'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.objectId')),'\' and related_office = \'',(getObjectProperty(___arguments.context.pageData, 'currentDealerRecord.office_link.objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['thisMonthsScores'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'currentDealerRecord.historic_comp_scores')), async (item) => {


   return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
  }));
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  thisMonthsSubmissionsTotal = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'thisMonthsScores'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'appointments')) {
      thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(j, 'submissions'));
    }
  }
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['dealerClosingAverageValue'] = (Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100));
  ___arguments.context.pageData['appointmentProgress'] = (Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) * 100));
  ___arguments.context.pageData['demoProgress'] = (Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) * 100));
  ___arguments.context.pageData['saleProgress'] = (Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) * 100));
  ___arguments.context.pageData['submissionProgress'] = (Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) * 100));
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) == null) {
    ___arguments.context.pageData['appointmentTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'appointmentProgress')) >= 100) {
    ___arguments.context.pageData['appointmentTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) == null) {
    ___arguments.context.pageData['demoTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'demoProgress')) >= 100) {
    ___arguments.context.pageData['demoTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) == null) {
    ___arguments.context.pageData['saleTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'saleProgress')) >= 100) {
    ___arguments.context.pageData['saleTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) == null) {
    ___arguments.context.pageData['submissionTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'submissionProgress')) >= 100) {
    ___arguments.context.pageData['submissionTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'OR') {
    if ((getObjectProperty(___arguments.context.pageData, 'appointmentProgress')) >= 100 || (getObjectProperty(___arguments.context.pageData, 'demoProgress')) >= 100 || (getObjectProperty(___arguments.context.pageData, 'saleProgress')) >= 100 || (getObjectProperty(___arguments.context.pageData, 'submissionProgress')) >= 100) {
      ___arguments.context.pageData['targetComplete'] = true;
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'AND') {
    if ((getObjectProperty(___arguments.context.pageData, 'appointmentTargetComplete')) == true && (getObjectProperty(___arguments.context.pageData, 'demoTargetComplete')) == true && (getObjectProperty(___arguments.context.pageData, 'saleTargetComplete')) == true && (getObjectProperty(___arguments.context.pageData, 'submissionTargetComplete')) == true) {
      ___arguments.context.pageData['targetComplete'] = true;
    }
  }
  ___arguments.context.pageData['activeDealers'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'',(getObjectProperty(___arguments.context.pageData, 'currentDealerRecord.office_link.objectId')),'\' and ','historic_comp_scores != null'].join(''))).setRelationsDepth(2).setPageSize(100)));
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  dealerScoresList = (getObjectProperty(___arguments.context.pageData, 'activeDealers'));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 3));
  await Backendless.Counters.reset('submissionsPosition');
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSubmissions'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    await Backendless.Counters.addAndGet('submissionsPosition', 1);
    j['submissionsLeaderboardPosition'] = (await Backendless.Counters.get('submissionsPosition'));
  }
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 3));
  await Backendless.Counters.reset('appointmentsPosition');
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardAppointments'));
  for (var j_index5 in j_list3) {
    j = j_list3[j_index5];
    await Backendless.Counters.addAndGet('appointmentsPosition', 1);
    j['appointmentsLeaderboardPosition'] = (await Backendless.Counters.get('appointmentsPosition'));
  }
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 3));
  await Backendless.Counters.reset('demosPosition');
  var j_list4 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardDemos'));
  for (var j_index6 in j_list4) {
    j = j_list4[j_index6];
    await Backendless.Counters.addAndGet('demosPosition', 1);
    j['demosLeaderboardPosition'] = (await Backendless.Counters.get('demosPosition'));
  }
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 3));
  await Backendless.Counters.reset('salesPosition');
  var j_list5 = (getObjectProperty(___arguments.context.pageData, 'competitionLeaderboardSales'));
  for (var j_index7 in j_list5) {
    j = j_list5[j_index7];
    await Backendless.Counters.addAndGet('salesPosition', 1);
    j['salesLeaderboardPosition'] = (await Backendless.Counters.get('salesPosition'));
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var salesWidgetVisible, demoWidgetVisible, appointmentsWidgetVisible, competitionRecord, submissionsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'competitionObjectId')) {
    competitionRecord = (await Backendless.Data.of('Competitions').findById((getObjectProperty(___arguments.context.pageData, 'competitionObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  } else {
    competitionRecord = (await Backendless.Data.of('Competitions').findById('B7698584-CAD8-41FD-8D0D-DBEC3FF9036D', Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    ___arguments.context.pageData['competitionObjectId'] = 'B7698584-CAD8-41FD-8D0D-DBEC3FF9036D';
  }
  ___arguments.context.pageData['selectedCompetition'] = competitionRecord;
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedCompetition'));
  ___arguments.context.pageData['competition_prizes'] = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_prizes'));
  ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))].join(''));
  ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date')))).getTime() + (86400 * 1000)));
  ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')) {
    ___arguments.context.pageData['closingAverageTargetAchieved'] = null;
    ___arguments.context.pageData['closingAverageVisible'] = true;
  } else {
    ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
    ___arguments.context.pageData['closingAverageVisible'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')) {
    appointmentsWidgetVisible = true;
    ___arguments.context.pageData['appointmentTargetAchieved'] = null;
    ___arguments.context.pageData['appointmentWidgetVisible'] = true;
  } else {
    appointmentsWidgetVisible = false;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
    ___arguments.context.pageData['appointmentWidgetVisible'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')) {
    demoWidgetVisible = true;
    ___arguments.context.pageData['demosWidgetVisible'] = true;
  } else {
    demoWidgetVisible = false;
    ___arguments.context.pageData['demosWidgetVisible'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')) {
    salesWidgetVisible = true;
    ___arguments.context.pageData['saleTargetAchieved'] = null;
    ___arguments.context.pageData['salesWidgetVisible'] = true;
  } else {
    salesWidgetVisible = false;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
    ___arguments.context.pageData['salesWidgetVisible'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')) {
    submissionsWidgetVisible = true;
    ___arguments.context.pageData['submissionTargetAchieved'] = null;
    ___arguments.context.pageData['submissionsWidgetVisible'] = true;
  } else {
    submissionsWidgetVisible = false;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
    ___arguments.context.pageData['submissionsWidgetVisible'] = false;
  }

  },
  /* handler:onBeforeEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1366) {
    ___arguments.context.pageData['showSidebar'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1366) {
    ___arguments.context.pageData['showSidebar'] = true;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/8173e99e3f82190d52af7e299f47f4ab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_featured_image')),'\')'].join(''));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8173e99e3f82190d52af7e299f47f4ab'))['backgroundImage'] = 'url(\'https://demo.tellusapps.net/api/files/web/assets/images/Competition%20Featured%20Image%20Placeholder.jpg\')';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/4574c40309521b8ec1bc55af92ab200a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dateDifferenceDays, dateDifference, todaysDate, endDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  endDate = (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'));
  todaysDate = ((new Date()).valueOf());
  dateDifference = endDate - todaysDate;
  dateDifferenceDays = dateDifference / 86400000;

  return (['Ends in ',Math.ceil(dateDifferenceDays),' days'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/7e9513be7a57a93a0231da6fe7956842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/2c7e26d6028958e1484f23667b1107a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/12ae497ee2054a6db6cba8f9d27451ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/35ae3cb6acb74385a158080fccd32102/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var salesOutput, salesProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  salesProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))) * 100);
  if (salesProgress >= 100) {
    salesOutput = 100;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  } else {
    salesOutput = salesProgress;
  }

  return salesOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/eed8f156a86eabc8ded231dd40dee3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/417cc6e12279ac2aa60860cf8a1e72e2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var demoOutput, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  demoProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))) * 100);
  if (demoProgress >= 100) {
    demoOutput = 100;
    ___arguments.context.pageData['demoTargetAchieved'] = true;
  } else {
    demoOutput = demoProgress;
  }

  return demoOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/07d570aa2c8a905a1f8aed8b1374c192/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos')),' Demos'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/7daeb8424f3e32282e199b4640c12aca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments')),' Appointments'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/6c639beee23abfba8e658214b684fa4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions')),' Submissions'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/6b3c6606bc1e706150fc226db7a92f66/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var appointmentOutput, appointmentProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appointmentProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))) * 100);
  if (appointmentProgress >= 100) {
    appointmentOutput = 100;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  } else {
    appointmentOutput = appointmentProgress;
  }

  return appointmentOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/24e6ea39eb650afbd7b75c75c6ab4bfc/bundle.js', [], () => ({
  /* content */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:maxProgressLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var submissionsOutput, submissionsProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  submissionsProgress = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))) * 100);
  if (submissionsProgress >= 100) {
    submissionsOutput = 100;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  } else {
    submissionsOutput = submissionsProgress;
  }

  return submissionsOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/e9e282eed90f1876650516c890bd41b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var demoWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosWidgetVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/b48579c6d305a5a511776ed41b51b83a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var submissionsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'submissionsWidgetVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/24a86bdd811b5bc177c56ad4f8c398ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesWidgetVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/1f683f038b46bc3e4392e8753797f9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var appointmentsWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'appointmentWidgetVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/2ff31c1ff518e445fa31a53c22de8aa1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var salesWidgetVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/661b3534c607e78d89aeac7dd1bb8f43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/75bfceb38f05db6e438b9e433b997bda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/2f3d48adfd2c7dce43c7bf16f92fc9f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_entry_requirements.entry_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/5be4e62fb8112c66d82cd6042ff3ea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')),' Demos.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/ef2ba114fd1fc83558fb24f665dd7d52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')),' Sales.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/2a3d7ef495424e35bd5dd6b55db5b509/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')),' Appointments.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/07ee20f3cc1c049eec883a1dde7bbf51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have ',(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')),' Submissions.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/e45e7119cb6512986bbbe9e796443a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/9c44eb6d5db53c0a47c7e308cdf5a9de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/b3fc7c19997fe2d2192682c7bd9f5757/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/ad54086dd504588b7a0493a91de28ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/7494a1974f1b357e020bb5433c64ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showCompleteBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'targetComplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'appointmentTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'demoTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'saleTargetAchieved'));
  console.log(getObjectProperty(___arguments.context.pageData, 'submissionTargetAchieved'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/64ee7b41a369b9573784d0fa4c7f5039/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'OR')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/e4346b278ccd8249ee16a1ed9e834156/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_target_operator')) == 'AND')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/974ee2c6b54be9a43f2487b226cfb0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var closingAverageVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'closingAverageVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/7508ab5a8601bd7d420f17020e63d4d2/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var closingAverageOutput, closingAverageAmount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'dealerClosingAverageValue')) {
    closingAverageAmount = Math.round(((getObjectProperty(___arguments.context.pageData, 'dealerClosingAverageValue')) / (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))) * 100);
    if (closingAverageAmount >= 100) {
      closingAverageOutput = 100;
      ___arguments.context.pageData['closingAverageTargetAchieved'] = true;
    } else {
      closingAverageOutput = closingAverageAmount;
    }
  } else {
    closingAverageOutput = 0;
  }

  return closingAverageOutput

  },
  /* handler:progressLogic */
  /* handler:maxProgressLogic */
  ['maxProgressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage'))

  },
  /* handler:maxProgressLogic */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/78090408dc078006c2992244966cdb72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Target: ',(getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_closingAverage')),'% Closing Average'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/2f7c04447635e3fa7183001df9a7d1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var closingAverageAmount, closingAverageOutput, outputtedClosingAverage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'dealerClosingAverageValue')) {
    closingAverageOutput = ['You have a ',(getObjectProperty(___arguments.context.pageData, 'dealerClosingAverage')),' Closing Average.'].join('');
  } else {
    closingAverageOutput = 'You have a 0% Closing Average.';
  }

  return closingAverageOutput

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/af13898b6c496042470e886520e713df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))) + String(' Closing Average'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/12cf0a0bedb6913b8477a6189cc99586/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizeBox;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Time to Shine' || (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_name')) == 'Chase the Challenge') && (getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) >= 3) {
    showPrizeBox = true;
  } else {
    showPrizeBox = false;
  }

  return showPrizeBox

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/30eff8ec5fbe87c8d5cef63d08571df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizeImage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) >= 2) {
    showPrizeImage = true;
  } else {
    showPrizeImage = false;
  }

  return showPrizeImage

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/d4a5252b329727f7caec3d7d49a437f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizeImage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) >= 3) {
    showPrizeImage = true;
  } else {
    showPrizeImage = false;
  }

  return showPrizeImage

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/efc6b4f1e28ef41b8d44a64868e1d1a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizeImage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) >= 7) {
    showPrizeImage = true;
  } else {
    showPrizeImage = false;
  }

  return showPrizeImage

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/b0e662c11bbab2921b9e135d0c3e97cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizeImage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) >= 9) {
    showPrizeImage = true;
  } else {
    showPrizeImage = false;
  }

  return showPrizeImage

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/dac1f05a9c0b37494957c48314f14f72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_poster_image')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/competitions--viewCompetition/components/530c6ace74352b963a6a6fa10b465a97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showPrizeImage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) >= 9) {
    showPrizeImage = true;
  } else {
    showPrizeImage = false;
  }

  return showPrizeImage

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var temp, monthlyTotal, j, thisMonthsSales;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  thisMonthsSales = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (String('sales_date>') + String((new Date(([(new Date((new Date())).getMonth() + 1),'\'/01/\'',(new Date((new Date())).getFullYear())].join('')))).valueOf())), null, null, null, null));
  monthlyTotal = 0;
  for (var j_index in thisMonthsSales) {
    j = thisMonthsSales[j_index];
    monthlyTotal = monthlyTotal + (getObjectProperty(j, 'sale_total_wo_tax'));
  }
  ___arguments.context.pageData['currentMonthSales'] = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b'](monthlyTotal));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Dashboard';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUserGroup')) == 'Demo') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2b7c0429ed1585dfcc7eafe4c90ab3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27d552ed3f8b7b2d652d4851f32cb648', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e05f572905ea86cf2633316b33695b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a7cf38464fbd7dab3eb7229a488c3fc', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard/components/3168b80869756f881318e648ba787314/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'sidebarClosed')) {
    console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '0';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/dealers--addDealer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Add Dealer';
  ___arguments.context.pageData['dealersMenuOpen'] = true;
  ___arguments.context.pageData['dealerData'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, null, null, null, null, null, null));
  if (getObjectProperty((await Backendless.Data.of('Offices').findById(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), )), 'payrollMatrix_table')) {
    ___arguments.context.pageData['matrixOptions'] = (await Promise.all((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollMatrix_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Title')),'value': (getObjectProperty(item, 'objectId')) });})));
  }
  ___arguments.context.pageData['teamLeaderOptions'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'is_team_leader = true and dealer_active = true', null, null, null, null, null, null)).map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['recruitedByOptions'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'is_team_leader = true and dealer_active = true', null, null, null, null, null, null)).map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['showError'] = false;

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('dealers', null, null);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/dealers--addDealer/components/263fc32c058aceaba42d897232b950a5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var dealerObject;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/dealers--addDealer/components/14e1efbc29bd44fa0663fe3a79823791/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'matrixOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['matrixChoice'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--addDealer/components/0a42b893a12ba9febe2a02ce348240aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dealerRecord, locationRecord, locationTable, dealerTable, dealerEmail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerTable = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())));
  if ((await Backendless.Data.of(dealerTable).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')),'\''].join(''))))) > 0 || (await Backendless.Data.of(dealerTable).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_nameFirst=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerFirstName')),'\' AND dealer_nameLast = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerLastName')),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['errorMessage'] = 'Dealer with this name already exists';
    ___arguments.context.pageData['showError'] = true;
  } else {
    ___arguments.context.pageData['addDealerActive'] = true;
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')) {
      dealerEmail = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerEmail')).toLowerCase();
    } else {
      dealerEmail = 0;
    }
    dealerRecord = ({ 'dealer_name': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerFirstName')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerLastName'))].join(''),'dealer_active': true,'dealer_nameFirst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerFirstName')),'dealer_nameLast': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerLastName')),'dealer_address_line1': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerAddressLine1')),'dealer_address_line2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerAddressLine2')),'dealer_city': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerCity')),'dealer_state': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerState')),'dealer_zip': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerZIP')),'dealer_email': dealerEmail,'dealer_phone': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerCell')),'social_security': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'socialSecurityNo')),'is_team_leader': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'is_team_leader')),'recruitedByObjId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'recruitedByChoice')),'teamLeaderObjId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'teamLeaderChoice')) });
    dealerRecord = (await Backendless.Data.of(dealerTable).save(dealerRecord, true));
    await Backendless.Data.of(dealerTable).addRelation((getObjectProperty(dealerRecord, 'objectId')), 'office_link', [((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]);
    ___arguments.context.pageData['showError'] = false;
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'teamLeaderChoice')) == null)) {
      await Backendless.Data.of(dealerTable).setRelation((getObjectProperty(dealerRecord, 'objectId')), 'team_leader', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'teamLeaderChoice'))]);
      ___arguments.context.pageData['showError'] = false;
    }
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'recruitedByChoice')) == null)) {
      await Backendless.Data.of(dealerTable).setRelation((getObjectProperty(dealerRecord, 'objectId')), 'recruited_by', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'recruitedByChoice'))]);
      ___arguments.context.pageData['showError'] = false;
    }
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'matrixChoice')) == null)) {
      await Backendless.Data.of(dealerTable).setRelation((getObjectProperty(dealerRecord, 'objectId')), 'current_matrix_level', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'matrixChoice'))]);
      await Backendless.Data.of(dealerTable).setRelation((getObjectProperty(dealerRecord, 'objectId')), 'office_link', [((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]);
      ___arguments.context.pageData['showError'] = false;
    }
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'addLocation')) {
      locationTable = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())));
      locationRecord = (await Backendless.Data.of(locationTable).save(({ 'name': [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerFirstName')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerLastName'))].join(''),'type': 'Dealer','active': true,'isTracked': true,'inventory': [] }), true));
      await Backendless.Data.of(locationTable).setRelation((getObjectProperty(locationRecord, 'objectId')), 'associated_office', [((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]);
      await Backendless.Data.of(locationTable).setRelation((getObjectProperty(locationRecord, 'objectId')), 'link_to_dealer', [(getObjectProperty(dealerRecord, 'objectId'))]);
    }
    ___arguments.context.pageData['addDealerActive'] = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('b072a0d5d126d78a681d412717fa2173', undefined, undefined, undefined, undefined, undefined);
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerFirstName'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerLastName'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerAddressLine1'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerAddressLine2'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerCity'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerState'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerZIP'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerEmail'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerCell'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['socialSecurityNo'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['addLocation'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['recruitedByChoice'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['teamLeaderChoice'] = null;
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['matrixChoice'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--addDealer/components/f684a6b63f6e679aae5c5d1f3197cdbd/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'teamLeaderOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dealers--addDealer/components/af23ee9effb2d1f30aeca728f25b845e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'recruitedByOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dealers--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Dealers Dashboard';
  ___arguments.context.pageData['dealersMenuOpen'] = true;
  ___arguments.context.pageData['dealerRecordsLoading'] = true;
  console.log((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})());
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('27eb6c228ae3bd65f6b35e886514203b', (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = true', 'dealer_nameLast ASC', null, 2, null, null, true)));
  ___arguments.context.pageData['dealerRecordsLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dealers--dashboard/components/d37e57f2dd6bbcc33c142397ce3ec3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cce2781fe1f78fa834fc680eef18213a'), 'phone_link')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dashboard/components/2369b4bbc154d872efc7e831fe8617af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dashboard/components/cd4d5d634e94b56f74669b5a0224bb7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cce2781fe1f78fa834fc680eef18213a'), 'message_link')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dashboard/components/66a2476261eedb63b091226a2d4df1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['selectedDealer'] = ___arguments.context.getComponentDataStoreByUid('cce2781fe1f78fa834fc680eef18213a');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dealerProfile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dashboard/components/304c1a3f0bde8aab2856b834db59cdaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['dealerRecordsLoading'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('27eb6c228ae3bd65f6b35e886514203b', (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = false', 'dealer_nameLast ASC', null, 2, null, null, null)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abb6155e71763baf2f2a80c98a52d4d6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('304c1a3f0bde8aab2856b834db59cdaf', false);
  ___arguments.context.pageData['dealerRecordsLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dashboard/components/abb6155e71763baf2f2a80c98a52d4d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['dealerRecordsLoading'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('27eb6c228ae3bd65f6b35e886514203b', (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = true', 'dealer_nameLast ASC', null, 2, null, null, null)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abb6155e71763baf2f2a80c98a52d4d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('304c1a3f0bde8aab2856b834db59cdaf', true);
  ___arguments.context.pageData['dealerRecordsLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var payrollTransactionNotes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'selectedDealer')) {
    ___arguments.context.pageData['selectedDealerRecord'] = (getObjectProperty(___arguments.context.appData, 'selectedDealer'));
    ___arguments.context.pageData['selectedDealerPayrollTransactions'] = (await Backendless.Data.of('Payroll_transactions').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name = \'',(getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord.dealer_name')),'\''].join(''))).setPageSize(10)));
    console.log(getObjectProperty(___arguments.context.pageData, 'selectedDealerPayrollTransactions'));
    payrollTransactionNotes = (getObjectProperty(___arguments.context.pageData, 'selectedDealerPayrollTransactions.payroll_notes'));
    console.log(payrollTransactionNotes);
  } else {
    ___arguments.context.pageData['selectedDealerRecord'] = (await Backendless.Data.of('Dealers').findFirst());
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord'));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Dealer Profile';
  ___arguments.context.pageData['dealersMenuOpen'] = true;
  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    ___arguments.context.pageData['socialSecurityNo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'social_security'));
    ___arguments.context.pageData['hiddenSocialSecurityNo'] = (String('####-##-') + String(subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'socialSecurityNo')), 7)));
  } else {
    ___arguments.context.pageData['hiddenSocialSecurityNo'] = 0;
  }

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_name'));
  } else {
    value = '';
  }

  return (String(value) + String('\'s Profile - TellUS App'))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/d89e357948d61153638c2a1232970649/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_name'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/3f951d5da8ccb9090ce2f3361c7f95ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_name'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/90f809f728454d853add3b7464a8711c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_email'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/7b5f1f03b74848623fc961631adb2cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'current_matrix_level.Title'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/398266716cd23d135becdfaa626234d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'manager_name'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/e59a1f0b1df8bf3f5606a34eb708d182/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'phone_link')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/ab2e8d61652bee5513b85eb19a2c8144/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'message_link')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/8b1d3738e563382382ae7e5ae454c7c6/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty(((await Backendless.Data.of('Dealers').loadRelations((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('current_matrix_level').setPageSize(1).setOffset(0)))[0]), 'weekly_salary'));
  } else {
    value = '0';
  }
  if (value > 0) {
    ___arguments.context.pageData['receivesSalary'] = true;
  } else {
    ___arguments.context.pageData['receivesSalary'] = false;
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/80aace7964052f2f8dd910595c929d71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_phone'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--editDealer', ({ 'dealerRecord': (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/527ba624e46232897fd87b3dfcf9a981/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_zip'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/e351d5ac0ff839917c7db9ab4b62dcd3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_state'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/0dc1739f83798874d7d3ae31f1554afc/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_city'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/98696594ac8e0aaee8fcaf2861a82dea/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_address_line2'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/e6e31d580e25f45c3646e4ca4491274d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_address_line1'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/ab8bef15c72dbd658d578404ebcf8a4a/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    dealerName = ['dealer_name = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_name')),'\''].join('');
  } else {
    dealerName = null;
  }

  return dealerName

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/5abe4a289955e3f2645f22167babb1a9/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    dealerName = ['dealer_name = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_name')),'\''].join('');
  } else {
    dealerName = null;
  }

  return dealerName

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/8dac7ebb4c863042da7d860ea8f39014/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'dealer_name'));
  } else {
    value = '';
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--dealerProfile/components/f8c597d298a8b7aa65faf81a1d625e21/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['hiddenSocialSecurityNo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord')), 'social_security'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/dealers--editDealer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Edit Dealer';
  ___arguments.context.pageData['dealersMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'dealerRecord')) {
    value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerRecord')), 'dealer_name'));
  } else {
    value = '';
  }

  return (['Edit ',value,' - TellUS App'].join(''))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/dealers--editDealer/components/92b73803cfbb6d9877bad0d76da41d8c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dealerManagerOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'manager_name'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dealers--editDealer/components/6a01a388fd7a7dd43827d36e74f7cb5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--editDealer/components/82e48a473dc1dd39dcf965f4e63a3389/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var currentLevel, dealerRecord, item, list, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecord')) == null) {
    dealerRecord = (await Backendless.Data.of('Dealers').findFirst(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level')));
  } else {
    dealerRecord = (getObjectProperty(___arguments.context.pageData, 'dealerRecord'));
  }
  console.log(dealerRecord);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('82e48a473dc1dd39dcf965f4e63a3389', dealerRecord);
  options = (await Promise.all((await Backendless.Data.of('Payroll_matrix').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Title')),'value': (getObjectProperty(item, 'objectId')) });})));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('e1aef268d5ffceade8afd8429eff666f', options);
  currentLevel = (await asyncListFilter(options, async (item) => {


   return ((getObjectProperty(item, 'label')) == (getObjectProperty((getObjectProperty(dealerRecord, 'current_matrix_level')), 'Title')));
  }))[0];
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e1aef268d5ffceade8afd8429eff666f', (getObjectProperty(currentLevel, 'value')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dealers--editDealer/components/d17b949c7f314e7d1b01622f71e7fc05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dealerRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerRecord = ({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'objectId')),'dealer_nameFirst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_nameFirst')),'dealer_nameLast': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_nameLast')),'dealer_address_line1': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_address_line1')),'dealer_address_line2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_address_line2')),'dealer_city': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_city')),'dealer_state': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_state')),'dealer_zip': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_zip')),'dealer_email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_email')),'dealer_phone': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'dealer_phone')) });
  await Backendless.Data.of('Dealers').save(dealerRecord, true);
  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'matrixChoice')) == null)) {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'matrixChoice'));
    await Backendless.Data.of('Dealers').setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'objectId')), 'current_matrix_level', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389'), 'matrixChoice'))]);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--editDealer/components/e1aef268d5ffceade8afd8429eff666f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['matrixChoice'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/6288aa7e27cb190af6c9e2b57b4ed0f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_nameFirst'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/4f87968b536390f476553a312cbd5841/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_nameLast'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/9533e50972814c72df11572bf67bc742/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/6a02d4632da8c907875863c194f84145/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_phone'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/85bb83c8cce7800b919fcaef12ec4c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_address_line1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/5414253f7f05173910730b3717689da6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_address_line2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/143ca5797513f646f18d0651d9d8e7cc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/2343ec598a385a665ca4f4117d583e0e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_state'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/103696767351d09ab7697b038ffce684/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('82e48a473dc1dd39dcf965f4e63a3389')['dealer_zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--editDealer/components/337af90bfab5c986f3666a2fb7a41f56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerRecord')), 'dealer_name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--editDealer/components/25aed63e80695d2b23f4caab2f4c376b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerRecord')), 'dealer_phone'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--editDealer/components/90f809f728454d853add3b7464a8711c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerRecord')), 'dealer_email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dealers--editDealer/components/e59a1f0b1df8bf3f5606a34eb708d182/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerRecord')), 'phone_link')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--editDealer/components/ab2e8d61652bee5513b85eb19a2c8144/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerRecord')), 'message_link')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var dealersTable, dealerObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Manage Dealers';
  ___arguments.context.pageData['dealersMenuOpen'] = true;
  dealersTable = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = true', 'dealer_name ASC', null, 2, null, null, true));
  ___arguments.context.pageData['dealers_table'] = dealersTable;
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](dealersTable);
  if ((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollMatrix_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))) {
    ___arguments.context.pageData['matrixOptions'] = (await Promise.all((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollMatrix_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=true') + String(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Title')),'value': (getObjectProperty(item, 'objectId')) });})));
  }
  dealerObj = (await Promise.all(dealersTable.map(async item => {; return ({ 'label': (getObjectProperty(item, 'dealer_name')),'value': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['teamLeaderOptions'] = dealerObj;
  ___arguments.context.pageData['recruitedByOptions'] = dealerObj;
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3364a866c00e7577aa88f93f7b574728')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', dealersTable);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dealers--manageDealers/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--addDealer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/dealers--manageDealers/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/dealers--manageDealers/components/3655ebfada1566fab64959d87ad67273/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'matrixOptions'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(___arguments.value);
  console.log(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dealers--manageDealers/components/e5f4d34d6bc5025b11b5be8b75ed7f1c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'teamLeaderOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dealers--manageDealers/components/f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/184719acc309867f8cb2630b60a251fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['lockDealerEdit'] = true;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3655ebfada1566fab64959d87ad67273', (getObjectProperty(___arguments.context.dataModel, 'current_matrix_level.objectId')));

  },
  /* handler:onMounted */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.dataModel['lockDealerEdit'] = true;

  },
  /* handler:onVisibilityChange */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'viewInactiveDealers')) {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3655ebfada1566fab64959d87ad67273', (getObjectProperty(___arguments.context.dataModel, 'current_matrix_level.objectId')));
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/dealers--manageDealers/components/48ddc72360253729a31c0648e94eaf4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/4e464907f60864c43d5bf9199443b6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = (getObjectProperty(___arguments.context.pageData, 'selectedDealer'));
  console.log(selectedDealer);
  await Backendless.Data.of('Dealers').remove( selectedDealer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('797d972e882aba5e545be8339eb928fa', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level').setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onSubmit */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerName = (getObjectProperty(___arguments.context.pageData, 'selectedDealerName'));

  return (['You are about to delete the dealer \'',dealerName,'\', are you sure?'].join(''))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/dealers--manageDealers/components/0bc4f03e05fc6dc3c65b1c21e93fa126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockDealerEdit'] = true;
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'isTeamLeader')) {
    ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['teamLeaderObjId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId'));
  }
  await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save( ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') );
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'current_matrix_level')) {
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'current_matrix_level', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'current_matrix_level'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'teamLeaderObjId')) {
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'teamLeader', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'teamLeaderObjId'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruitedByObjId')) {
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'objectId')), 'recruitedBy', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd'), 'recruitedByObjId'))]);
  }
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('a2ebd282f595125cbc38ebd3dec34d3d', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/7a8e273faf518dbf410be92822b58127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', true);
  ___arguments.context.pageData['dealers_table'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = FALSE ', 'dealer_name asc', 'current_matrix_level', 2, null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));
  ___arguments.context.pageData['viewInactiveDealers'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/187e1a17e595c884f153df83057d378a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', false);
  ___arguments.context.pageData['dealers_table'] = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = TRUE ', 'dealer_name asc', 'current_matrix_level', 2, null, null, true));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dealers--manageDealers/components/1aeca0a1b76d64fb0bda359a2cd718be/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'recruitedByOptions'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, officeScoreList, thisMonthsRecruitsTotal, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, l, divisionTotalRecruits, divisionTotalSubmissions, divisionTotalSales, divisionTotalDemos, divisionTotalAppointments, loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['monthlyScoresLoading'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Division Leaderboard';
  ___arguments.context.pageData['breadCrumb'] = 'Division Leaderboard';
  ___arguments.context.pageData['eagleDivisions'] = (await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((String('region_link = \'60D7A635-E285-41A1-86D6-094053A81D84\''))).setRelationsDepth(3).setPageSize(10)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['relatedOffices'] = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_link = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['dealer_table', 'office_name', 'office_photo']).setRelationsDepth(2).setPageSize(10)));
    var k_list = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      k['officeDealers'] = (await Backendless.Data.of((getObjectProperty(k, 'dealer_table'))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','office_link = \'',(getObjectProperty(k, 'objectId')),'\''].join(''))).setProperties(['historic_comp_scores']).setRelationsDepth(2).setPageSize(100)));
    }
  }
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      var l_list = (getObjectProperty(k, 'officeDealers'));
      for (var l_index in l_list) {
        l = l_list[l_index];
        if (getObjectProperty(l, 'historic_comp_scores')) {
          if (getObjectProperty(k, 'eventScores')) {
            addItemToList((getObjectProperty(k, 'eventScores')), (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
            })));
          } else {
            k['eventScores'] = (await asyncListFilter((getObjectProperty(l, 'historic_comp_scores')), async (item) => {


             return ((getObjectProperty(item, 'date')) >= '2023-03-03T00:00:00.000Z' && (getObjectProperty(item, 'date')) <= '2023-03-05T23:59:00.000Z');
            }));
          }
        }
      }
    }
  }
  var j_list3 = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    var k_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var k_index3 in k_list3) {
      k = k_list3[k_index3];
      thisMonthsAppointmentsTotal = 0;
      thisMonthsDemosTotal = 0;
      thisMonthsSalesTotal = 0;
      thisMonthsSubmissionsTotal = 0;
      thisMonthsRecruitsTotal = 0;
      var l_list2 = (getObjectProperty(k, 'eventScores'));
      for (var l_index2 in l_list2) {
        l = l_list2[l_index2];
        if (getObjectProperty(l, 'appointments')) {
          thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(l, 'appointments'));
        }
        if (getObjectProperty(l, 'demos')) {
          thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(l, 'demos'));
        }
        if (getObjectProperty(l, 'sales')) {
          thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(l, 'sales'));
        }
        if (getObjectProperty(l, 'submissions')) {
          thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(l, 'submissions'));
        }
        if (getObjectProperty(l, 'recruits')) {
          thisMonthsRecruitsTotal = thisMonthsRecruitsTotal + (getObjectProperty(l, 'recruits'));
        }
      }
      k['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
      k['dealerTotalDemos'] = thisMonthsDemosTotal;
      k['dealerTotalSales'] = thisMonthsSalesTotal;
      k['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
      k['dealerTotalRecruits'] = thisMonthsRecruitsTotal;
    }
    divisionTotalAppointments = 0;
    divisionTotalDemos = 0;
    divisionTotalSales = 0;
    divisionTotalSubmissions = 0;
    divisionTotalRecruits = 0;
    var l_list3 = (getObjectProperty(j, 'relatedOffices'));
    for (var l_index3 in l_list3) {
      l = l_list3[l_index3];
      if (getObjectProperty(l, 'dealerTotalAppointments')) {
        divisionTotalAppointments = divisionTotalAppointments + (getObjectProperty(l, 'dealerTotalAppointments'));
      }
      if (getObjectProperty(l, 'dealerTotalDemos')) {
        divisionTotalDemos = divisionTotalDemos + (getObjectProperty(l, 'dealerTotalDemos'));
      }
      if (getObjectProperty(l, 'dealerTotalSales')) {
        divisionTotalSales = divisionTotalSales + (getObjectProperty(l, 'dealerTotalSales'));
      }
      if (getObjectProperty(l, 'dealerTotalSubmissions')) {
        divisionTotalSubmissions = divisionTotalSubmissions + (getObjectProperty(l, 'dealerTotalSubmissions'));
      }
      if (getObjectProperty(l, 'dealerTotalRecruits')) {
        divisionTotalRecruits = divisionTotalRecruits + (getObjectProperty(l, 'dealerTotalRecruits'));
      }
    }
    j['divisionTotalAppointments'] = divisionTotalAppointments;
    j['divisionTotalDemos'] = divisionTotalDemos;
    j['divisionTotalSales'] = divisionTotalSales;
    j['divisionTotalSubmissions'] = divisionTotalSubmissions;
    j['divisionTotalRecruits'] = divisionTotalRecruits;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  officeScoreList = (getObjectProperty(___arguments.context.pageData, 'eagleDivisions'));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalSales'));
  }));
  ___arguments.context.pageData['competitionRecruitsTotals'] = (await asyncListSort(officeScoreList, -1, async (item) => {


   return (getObjectProperty(item, 'divisionTotalRecruits'));
  }));
  ___arguments.context.pageData['monthlyScoresLoading'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/ed8da141c4f18c1aa0712c9dc11c6505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/a7a49dfb1b698d9c6f67f6c99ffdf7f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/4f2d82c4d93f1bbc2e52ef3578b955cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize5'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/632d88a92b9b0a04bda59b9f7b362176/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/10c6263eb51331d7b1ae308dd4ef9a08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize3'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/7ad53c0dda29add318bd311ff6edecf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competition_prizes.prize2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/adf9aa469da375e1b5b3e341cdae930d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSidebar'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/3984fa42d4c454a88cff63e1b87920a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_demos'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/916fa213d9c5722ce231980bcdd5b571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/2b85f459cda5a7d83e63214b0e79d1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2a58bc24e68ebc98d9a241b155c39beb'), 'salesLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/af7d99ead5a432f590ac54e966425c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/8db70cf76fe733eef33a50bee3721681/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35d20d1292c4d691d0bfc06bc80c2218'), 'demosLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/3fb1208a1e3a15294ce689e5e5ee1229/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_appointments'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/d7a2acd3b6917b54cca481e6d164b442/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/742f31fa3989a8b708da2432153705a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8119ec11f391041a78d290c8141f24cf'), 'appointmentsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/dcee16662932cdf3eaca7b0511cde947/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_submissions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/b3b912eafe388e622b7103dd3b9630ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = true;
  } else {
    showTrophy = false;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/a9396ed7e0828018f5d15e3b65acd1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showTrophy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed9c71536a4ed606464bbf6340d30244'), 'submissionsLeaderboardPosition')) == 1) {
    showTrophy = false;
  } else {
    showTrophy = true;
  }

  return showTrophy

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/cf5c6aa33c411737736e5dc3784ec5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedCompetition.competition_targets.target_sales'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/eagleRegion--scoreboard/components/dfb9f42291ca2f4ca9c4270f663ce2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Counters.get('dealerCount'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/faq/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var temp, monthlyTotal, j, thisMonthsSales;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  thisMonthsSales = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (String('sales_date>') + String((new Date(([(new Date((new Date())).getMonth() + 1),'\'/01/\'',(new Date((new Date())).getFullYear())].join('')))).valueOf())), null, null, null, null));
  monthlyTotal = 0;
  for (var j_index in thisMonthsSales) {
    j = thisMonthsSales[j_index];
    monthlyTotal = monthlyTotal + (getObjectProperty(j, 'sale_total_wo_tax'));
  }
  ___arguments.context.pageData['currentMonthSales'] = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b'](monthlyTotal));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Dashboard';
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUserGroup')) == 'Demo') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2b7c0429ed1585dfcc7eafe4c90ab3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27d552ed3f8b7b2d652d4851f32cb648', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e05f572905ea86cf2633316b33695b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a7cf38464fbd7dab3eb7229a488c3fc', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/faq/components/3168b80869756f881318e648ba787314/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'sidebarClosed')) {
    console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '0';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))['marginLeft'] = '300px';
  }

  return ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3168b80869756f881318e648ba787314'))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/feedback--submitFeedback/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/feedback--submitFeedback/components/8c1732febe1f51a7a8c1db234feb9e59/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Feedback').save( ({ 'issue_area': (getObjectProperty(___arguments.context.dataModel, 'issueArea')),'issue_title': (getObjectProperty(___arguments.context.dataModel, 'issueTitle')),'issue_description': (getObjectProperty(___arguments.context.dataModel, 'issueDesc')),'issue_url': (getObjectProperty(___arguments.context.dataModel, 'issueURL')),'issue_priority': (getObjectProperty(___arguments.context.dataModel, 'issuePriority')),'issue_reported_time': (new Date()),'issue_screenshot': (getObjectProperty(___arguments.context.dataModel, 'fileUploadURL')),'issue_reported_by': (getObjectProperty(___arguments.context.dataModel, 'reportedBy')),'issue_status': 'New','office': ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) }) );
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('8c1732febe1f51a7a8c1db234feb9e59', ({ 'issue_area': '','issue_title': '','issue_description': '','issue_url': '','issue_priority': '','issue_reported_time': '','issue_screenshot': '','issue_reported_by': '','issue_status': '' }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89a77f19ef3fd8b507a2599558dfb73b', true);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/feedback--submitFeedback/components/48b90dea530e2e632581c6dad95d5577/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8c1732febe1f51a7a8c1db234feb9e59')['fileUploadURL'] = ___arguments.uploadedFiles;

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/inventory--addLocation/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  ___arguments.context.pageData['pageTitle'] = 'Add Location';
  ___arguments.context.pageData['locationMenuOpen'] = true;
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['needScan'] = false;
  ___arguments.context.pageData['showError'] = false;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('263fc32c058aceaba42d897232b950a5', ({ 'isTracked': false }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--addLocation/components/0a42b893a12ba9febe2a02ce348240aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var locationRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'name')),'\' AND associated_office =\'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['errorMessage'] = 'Location with this name already exists';
    ___arguments.context.pageData['showError'] = true;
  } else {
    locationRecord = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(({ 'name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'name')),'type': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'type')),'isTracked': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'isTracked')),'active': true }), true));
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).addRelation((getObjectProperty(locationRecord, 'objectId')), 'associated_office', [String((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]);
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('b072a0d5d126d78a681d412717fa2173', undefined, undefined, undefined, undefined, undefined);
    ___arguments.context.pageData['showError'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('263fc32c058aceaba42d897232b950a5');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--addLocation/components/ca9a748518016145a401f7bc650b89d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'type')) == 'Dealer')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRequiredStateAssignment */
  ['onRequiredStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'type')) == 'Dealer')

  },
  /* handler:onRequiredStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var name2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dealerObjList'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'value')) == ___arguments.value) {
      name2 = (getObjectProperty(j, 'label'));
    }
  }
  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['name'] = name2;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--addLocation/components/9a6b61c931c84c7bbb7c6f06da2f25c3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == 'Dealer') {
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['dealerObjList'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, 'dealer_name', null, null, null, null, null)), 'objectId', 'dealer_name'));
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['isTracked'] = true;
  } else if (___arguments.value == 'Office') {
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['isTracked'] = true;
  } else if (false) {
  } else {
    ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['isTracked'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--addLocation/components/0442c25911e17d0971ea3ee115f7d4a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'type')) == 'Dealer')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--addLocation/components/d91d8558c5ab55d65f6e72e80f858a1a/bundle.js', [], () => ({
  /* content */
  /* handler:onRequiredStateAssignment */
  ['onRequiredStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'type')) != 'Dealer')

  },
  /* handler:onRequiredStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'type')) != 'Dealer')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--addProduct/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var productList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  ___arguments.context.pageData['pageTitle'] = 'Add Product';
  ___arguments.context.pageData['productMenuOpen'] = true;
  productList = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, null));
  ___arguments.context.pageData['productData'] = productList;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('263fc32c058aceaba42d897232b950a5', ({ 'productDropdown': (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6'](productList, 'objectId', 'product_name')),'product': (getObjectProperty(___arguments.context.pageData, 'selectedProduct')) ? (getObjectProperty(___arguments.context.pageData, 'selectedProduct')) : null,'existingProduct': false }));
  ___arguments.context.pageData['needScan'] = false;
  ___arguments.context.pageData['showError'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--addProduct/components/263fc32c058aceaba42d897232b950a5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['needScan'] = false;

  },
  /* handler:onBeforeMount */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var productRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToCamelCase(str) {
 const words = str.split(/[-_\s]+/g).filter(item => item)

 const toTitle = words.map((item, index) => {
   if (index !== 0) {
     return item.substr(0, 1).toUpperCase() + item.substr(1).toLowerCase()
   }

   return item.toLowerCase()
 })

 return toTitle.join('')
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if (getObjectProperty(___arguments.context.dataModel, 'existingProduct')) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.dataModel, 'product')));
    await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save((getObjectProperty(___arguments.context.dataModel, 'product')), true);
  } else {
    if ((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['product_name=\'',(getObjectProperty(___arguments.context.dataModel, 'productName')),'\''].join(''))))) > 0) {
      ___arguments.context.pageData['errorMessage'] = 'Product with this name already exists';
      ___arguments.context.pageData['showError'] = true;
    } else {
      productRecord = (getObjectProperty(___arguments.context.dataModel, 'product'));
      productRecord['active'] = true;
      if (getObjectProperty(___arguments.context.dataModel, 'imageUploaded')) {
        productRecord['product_image'] = (await Backendless.Files.renameFile( encodePath('/web/assets/images/product_images/temp'), encodePath((String('') + String(textToCamelCase(getObjectProperty(___arguments.context.dataModel, 'productName'))))) ));
      }
      await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).addRelation((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(productRecord, true)), 'associated_office', [((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]);
      await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('b072a0d5d126d78a681d412717fa2173', undefined, undefined, undefined, undefined, undefined);
      ___arguments.context.pageData['showError'] = false;
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('263fc32c058aceaba42d897232b950a5');
    }
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory--addProduct/components/00dc6da499ebc8a6a07e112946d49e6f/bundle.js', [], () => ({
  /* content */
  /* handler:onGetBarcode */
  ['onGetBarcode'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['productBarcodeValue'] = (___arguments['barcode'].trim());
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'product'))['product_barcode'] = (___arguments['barcode'].trim());

  },
  /* handler:onGetBarcode */
  /* content */
}))

define('./pages/inventory--addProduct/components/7ca894219bd80aa855af0e2537e211f9/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
      return 'temp'

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['imageUploaded'] = true;
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'imageUploaded'));
  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['productImage'] = ___arguments.uploadedFiles;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d343221e977769f7904acadd5c150ce4', true);

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/inventory--addProduct/components/f891522a7e0a5849ce773fef9fd4f02b/bundle.js', [], () => ({
  /* content */
  /* handler:onGetBarcode */
  ['onGetBarcode'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['cartonBarcodeValue'] = (___arguments['barcode'].trim());
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'product'))['carton_barcode'] = (___arguments['barcode'].trim());

  },
  /* handler:onGetBarcode */
  /* content */
}))

define('./pages/inventory--addProduct/components/d343221e977769f7904acadd5c150ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('7ca894219bd80aa855af0e2537e211f9');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d343221e977769f7904acadd5c150ce4', false);
  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['productImage'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--addProduct/components/53e782a1cf18de0794b9221a1b1566b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['product'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).findById(___arguments.value, ));
  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['existingProduct'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--addProduct/components/cfdd520185e5ae616b55616f746c4249/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'product'))['product_barcode'] = ___arguments.value;
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'product')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--currentInventory/components/d04e158d896517fc21f67ab92e690923/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var inventorySummary, j, locationId, productId, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedLocationId'] = ___arguments.value;
  ___arguments.context.pageData['selectedLocation'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'label'));
  if ((await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('admin', null, true))) {
    localStorage.setItem('debug', JSON.stringify(true));
    if (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) {
      inventorySummary = [({ 'location': (getObjectProperty(___arguments.context.pageData, 'selectedLocation')),'productName': (getObjectProperty(___arguments.context.pageData, 'selectedProduct')),'locationId': (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')),'productId': (getObjectProperty(___arguments.context.pageData, 'selectedProductId')),'totalItems': (await BackendlessUI.Functions.Custom['fn_dab32c1a59815cb1bb01bf3c96e663ee'](null, null, ___arguments.value, (getObjectProperty(___arguments.context.pageData, 'selectedProductId')), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), null)) })];
      ___arguments.context.pageData['inventorySummary'] = inventorySummary;
    } else {
      ___arguments.context.pageData['inventorySummary'] = [];
      var j_list = (getObjectProperty(___arguments.context.pageData, 'productList'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'inventorySummary')), ({ 'location': (getObjectProperty(___arguments.context.pageData, 'selectedLocation')),'productName': (getObjectProperty(j, 'label')),'locationId': locationId,'productId': (getObjectProperty(j, 'value')),'totalItems': (await BackendlessUI.Functions.Custom['fn_dab32c1a59815cb1bb01bf3c96e663ee'](null, null, ___arguments.value, (getObjectProperty(j, 'value')), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), null)) }));
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](j);
        await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'inventorySummary')));
      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--currentInventory/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var totalInventory, inventorySummary, numItems, j, locationName, productInv, item, locationInventory, locationRecord, locationList, productId, productName, theMatch, productList, locations, products;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting On Before Page Enter  - Current Inventory');
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('about to check permissions');
  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'inventoryTotals', null);
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('permissions checked');
  ___arguments.context.pageData['pageTitle'] = 'Current Inventory';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['includeZeros'] = true;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, (String('active = ') + String(true)), 'name', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))));
  locationList = [];
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, (String('active = ') + String(true)), 'product_name', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))));
  productList = [];
  for (var j_index in products) {
    j = products[j_index];
    addItemToList(productList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')) }));
  }
  for (var j_index2 in locations) {
    j = locations[j_index2];
    if ((getObjectProperty(j, 'isTracked')) && (getObjectProperty(j, 'active'))) {
      addItemToList(locationList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')) }));
    }
  }
  totalInventory = (await BackendlessUI.Functions.Custom['fn_21bc4232922e725addab6b1fcbae1aa7']((await Promise.all(productList.map(async item => {; return (getObjectProperty(item, 'value'));}))), (await Promise.all(locationList.map(async item => {; return (getObjectProperty(item, 'value'));}))), null, false, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))));
  ___arguments.context.pageData['totalInventory'] = totalInventory;
  ___arguments.context.pageData['locationList'] = locationList;
  ___arguments.context.pageData['productList'] = productList;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedProductId')) && (getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))) {
    productName = (getObjectProperty(((await asyncListFilter(productList, async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'selectedProductId')));
    }))[0]), 'label'));
    locationName = (getObjectProperty(((await asyncListFilter(locationList, async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')));
    }))[0]), 'label'));
    inventorySummary = [({ 'location': locationName,'productName': productName,'locationId': (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')),'productId': (getObjectProperty(___arguments.context.pageData, 'selectedProductId')),'totalItems': (await BackendlessUI.Functions.Custom['fn_f297f5de05e3421f5273f84e498e98c4']((getObjectProperty(___arguments.context.pageData, 'selectedLocationId')), (getObjectProperty(___arguments.context.pageData, 'selectedProductId')), (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')))))) })];
    ___arguments.context.pageData['inventorySummary'] = inventorySummary;
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string') {
    productName = (getObjectProperty(((await asyncListFilter(productList, async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'selectedProductId')));
    }))[0]), 'label'));
    productId = (getObjectProperty(___arguments.context.pageData, 'selectedProductId'));
    inventorySummary = [];
    var j_list = (getObjectProperty(___arguments.context.pageData, 'locationList'));
    for (var j_index3 in j_list) {
      j = j_list[j_index3];
      locationInventory = (getObjectProperty(j, 'inventory'));
      if (Array.isArray(locationInventory)) {
        theMatch = (await asyncListFilter(locationInventory, async (item) => {


         return ((getObjectProperty(item, 'productObjId')) == productId);
        }))[0];
        if (theMatch !== null && !Array.isArray(theMatch) && (typeof theMatch === 'object')) {
          numItems = (getObjectProperty(theMatch, 'totalItems'));
          addItemToList(inventorySummary, ({ 'location': (getObjectProperty(j, 'label')),'productName': productName,'locationId': (getObjectProperty(j, 'value')),'productId': productId,'totalItems': numItems }));
        } else {
          addItemToList(inventorySummary, ({ 'location': (getObjectProperty(j, 'label')),'productName': productName,'locationId': (getObjectProperty(j, 'value')),'productId': productId,'totalItems': 0 }));
        }
      } else {
        addItemToList(inventorySummary, ({ 'location': (getObjectProperty(j, 'label')),'productName': productName,'locationId': (getObjectProperty(j, 'value')),'productId': productId,'totalItems': 0 }));
      }
    }
    ___arguments.context.pageData['inventorySummary'] = inventorySummary;
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string') {
    inventorySummary = [];
    locationRecord = (await asyncListFilter(locationList, async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')));
    }))[0];
    locationName = (getObjectProperty(locationRecord, 'label'));
    locationInventory = (getObjectProperty(locationRecord, 'inventory'));
    var j_list2 = (getObjectProperty(___arguments.context.pageData, 'productList'));
    for (var j_index4 in j_list2) {
      j = j_list2[j_index4];
      productInv = (await asyncListFilter(locationInventory, async (item) => {


       return ((getObjectProperty(item, 'productObjId')) == (getObjectProperty(j, 'value')));
      }));
      numItems = (Array.isArray(productInv)) && productInv.length > 0 ? (getObjectProperty((productInv[0]), 'totalItems')) : 0;
      addItemToList(inventorySummary, ({ 'location': locationName,'productName': (getObjectProperty(j, 'label')),'locationId': (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')),'productId': (getObjectProperty(j, 'value')),'totalItems': numItems }));
    }
    ___arguments.context.pageData['inventorySummary'] = inventorySummary;
  } else {
    ___arguments.context.pageData['inventorySummary'] = totalInventory;
  }
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting On Before Page Enter  - Current Inventory');

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--currentInventory/components/337a9325e2d4f1871d16690db4af396c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inventorySummary, productId, j, numItems, theMatch, item, locationInventory, locationId, productInv, locations, products;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  locationId = (getObjectProperty(___arguments.context.pageData, 'selectedLocationId'));
  productId = (getObjectProperty(___arguments.context.pageData, 'selectedProductId'));
  if (productId == 'All' || (locationId === null) || (typeof locationId === 'undefined')) {
    products = (getObjectProperty(___arguments.context.pageData, 'productList'));
  } else {
    products = (getObjectProperty(___arguments.context.pageData, 'selectedProduct'));
  }
  if (locationId == 'Total' || (locationId === null) || (typeof locationId === 'undefined')) {
  } else if (locationId == 'All') {
    locations = (getObjectProperty(___arguments.context.pageData, 'locationList'));
  } else {
    locations = (getObjectProperty(___arguments.context.pageData, 'selectedLocation'));
  }
  if ((typeof locationId === 'string') && (typeof productId === 'string')) {
    inventorySummary = [({ 'location': (getObjectProperty(___arguments.context.pageData, 'selectedLocation')),'productName': (getObjectProperty(___arguments.context.pageData, 'selectedProduct')),'locationId': (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')),'productId': (getObjectProperty(___arguments.context.pageData, 'selectedProductId')),'totalItems': (await BackendlessUI.Functions.Custom['fn_f297f5de05e3421f5273f84e498e98c4'](locationId, productId, (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')))))) })];
  } else if (typeof locationId === 'string') {
    inventorySummary = [];
    locationInventory = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == locationId);
    }))[0]), 'inventory'));
    var j_list = (getObjectProperty(___arguments.context.pageData, 'productList'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      productInv = (await asyncListFilter(locationInventory, async (item) => {


       return ((getObjectProperty(item, 'productObjId')) == (getObjectProperty(j, 'value')));
      }));
      numItems = (Array.isArray(productInv)) && productInv.length > 0 ? (getObjectProperty((productInv[0]), 'totalItems')) : 0;
      addItemToList(inventorySummary, ({ 'location': (getObjectProperty(___arguments.context.pageData, 'selectedLocation')),'productName': (getObjectProperty(j, 'label')),'locationId': locationId,'productId': (getObjectProperty(j, 'value')),'totalItems': numItems }));
    }
  } else if (typeof productId === 'string') {
    inventorySummary = [];
    var j_list2 = (getObjectProperty(___arguments.context.pageData, 'locationList'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      locationInventory = (getObjectProperty(j, 'inventory'));
      if (Array.isArray(locationInventory)) {
        theMatch = (await asyncListFilter(locationInventory, async (item) => {


         return ((getObjectProperty(item, 'productObjId')) == productId);
        }))[0];
        if (theMatch !== null && !Array.isArray(theMatch) && (typeof theMatch === 'object')) {
          numItems = (getObjectProperty(theMatch, 'totalItems'));
          addItemToList(inventorySummary, ({ 'location': (getObjectProperty(j, 'label')),'productName': (getObjectProperty(___arguments.context.pageData, 'selectedProduct')),'locationId': (getObjectProperty(j, 'value')),'productId': productId,'totalItems': numItems }));
        } else {
          addItemToList(inventorySummary, ({ 'location': (getObjectProperty(j, 'label')),'productName': (getObjectProperty(___arguments.context.pageData, 'selectedProduct')),'locationId': (getObjectProperty(j, 'value')),'productId': productId,'totalItems': 0 }));
        }
      } else {
        addItemToList(inventorySummary, ({ 'location': (getObjectProperty(j, 'label')),'productName': (getObjectProperty(___arguments.context.pageData, 'selectedProduct')),'locationId': (getObjectProperty(j, 'value')),'productId': productId,'totalItems': 0 }));
      }
    }
  } else if (false) {
  } else {
  }
  ___arguments.context.pageData['inventorySummary'] = inventorySummary;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'productName')) && !(getObjectProperty(___arguments.context.pageData, 'movedTo')) && !(getObjectProperty(___arguments.context.pageData, 'movedFrom')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--currentInventory/components/37d3f0d7e9b5b55f521bffea0a91973b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedProductId'] = ___arguments.value;
  ___arguments.context.pageData['selectedProduct'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'label'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--currentInventory/components/95d7dd4fdc6207486a19abeec9239d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', ({ 'selectedProductId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'productId')),'selectedLocationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'locationId')),'selectedProduct': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'productName')),'selectedLocation': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'location')),'runningTotal': true }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--currentInventory/components/5db4f72472f696825393b781bb4a1d33/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['includeZeros'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--currentInventory/components/1ab720633bd35a8504d517cb4407b59e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var response, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'inventorySummary')) {
    if (getObjectProperty(___arguments.context.pageData, 'includeZeros')) {
      response = (getObjectProperty(___arguments.context.pageData, 'inventorySummary'));
    } else {
      response = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'inventorySummary')), async (item) => {


       return ((getObjectProperty(item, 'totalItems')) != 0);
      }));
    }
  }

  return response

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory--currentInventory/components/50f6ae8875de8ebe31c73156cf0a6665/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedProductId'] = undefined;
  ___arguments.context.pageData['selectedProduct'] = undefined;
  ___arguments.context.pageData['selectedLocationId'] = undefined;
  ___arguments.context.pageData['selectedLocation'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--currentInventory/components/5b14ad5f1c02c148eecf70c68ccc0ed4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, transactions, productRecord, sns;


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('staring recalc');
  await BackendlessUI.Functions.Custom['fn_63bfc57b5762d36e79456fc928d87efe']('1679382000000', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()));
  console.log('done with recalc');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'sectionAccess.admin'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--currentInventory/components/dafd56cda75cc002a8f4b892e8c20424/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var itemInventory, numberRemoved, numberAdded, k, j, locationTable, item, recordsRemoved, recordsAdded, transactions, products, locations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('checking for errors');
  localStorage.setItem('debug', JSON.stringify(true));
  locationTable = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')), null));
  locations = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'](locationTable, (['active=TRUE AND isTracked=TRUE AND associated_office = \'',(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'objectId')),'\''].join('')), null, null, null, null));
  products = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')))), (['active=TRUE AND associated_office = \'',((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')),'\''].join('')), null, null, null, null));
  for (var j_index in locations) {
    j = locations[j_index];
    console.log(getObjectProperty(j, 'name'));
    for (var k_index in products) {
      k = products[k_index];
      console.log(getObjectProperty(k, 'product_name'));
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('locProdResult');
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((await BackendlessUI.Functions.Custom['fn_dab32c1a59815cb1bb01bf3c96e663ee'](null, null, (getObjectProperty(j, 'objectId')), (getObjectProperty(k, 'objectId')), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), null)));
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('locationProductResult');
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((await BackendlessUI.Functions.Custom['fn_8a860b7f0f29d23441012eeacee82a9f'](null, null, (getObjectProperty(j, 'objectId')), (getObjectProperty(k, 'objectId')), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), null)));
      if (transactions) {
        recordsAdded = (await asyncListFilter(transactions, async (item) => {


         return ((getObjectProperty(item, 'link_product.objectId')) == (getObjectProperty(k, 'objectId')) && (getObjectProperty(item, 'link_moved_to.objectId')) == (getObjectProperty(j, 'objectId')));
        }));
        recordsRemoved = (await asyncListFilter(transactions, async (item) => {


         return ((getObjectProperty(item, 'link_product.objectId')) == (getObjectProperty(k, 'objectId')) && (getObjectProperty(item, 'link_moved_from.objectId')) == (getObjectProperty(j, 'objectId')));
        }));
        if (recordsAdded.length >= 1) {
          numberAdded = (await Promise.all(recordsAdded.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
        } else {
          numberAdded = 0;
        }
        if (recordsRemoved.length >= 1) {
          numberRemoved = (await Promise.all(recordsRemoved.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
        } else {
          numberRemoved = 0;
        }
        itemInventory = (await BackendlessUI.Functions.Custom['fn_f297f5de05e3421f5273f84e498e98c4']((getObjectProperty(j, 'objectId')), (getObjectProperty(k, 'objectId')), locationTable));
        if (numberAdded - numberRemoved != itemInventory) {
          if (!((getObjectProperty(k, 'product_name')) == 'RB SRX')) {
            console.log(['Inventory mismatch for ',(getObjectProperty(j, 'name')),'  ',(getObjectProperty(k, 'product_name'))].join(''));
            console.log(['Transactions: ',numberAdded - numberRemoved,'  Inventory: ',itemInventory,'  Difference: ',(numberAdded - numberRemoved) - itemInventory].join(''));
          }
        }
      }
    }
  }
  console.log('done with check');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_fb1a63e38aeda4981acc1ef67d28b238']())

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--currentInventory/components/e6160c0c9065ad0be5c719ad78cf5e07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_f3f49dcb24e9c0e61dbf2c232cce7c74'](((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 1679356800000);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_fb1a63e38aeda4981acc1ef67d28b238']())

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting on page enter -- Dashboard');
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Inventory Dashboard';
  ___arguments.context.pageData['user'] = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['activeDiscrepancies'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('discrepancy_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('resolved != true')));
  ___arguments.context.pageData['missingLinks'] = (await Backendless.Data.of((getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'productTransaction_table'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(link_moved_to.name is null',' OR link_moved_from.name is null',' OR link_product.product_name is null)',' AND (transaction_date > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),' OR created > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),')'].join('')))));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end on page enter -- Dashboard');

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item, currentInventory, salesOther, sales, fromDate, topSold, j, count, productsSold, products, transactions;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting on before page enter -- Dashboard');
  fromDate = (new Date());
  fromDate.setDate(1);
  fromDate.setMinutes(0);
  fromDate.setHours(0);
  transactions = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (['transaction_date>',(fromDate.valueOf()),'AND (moved_to=\'Sold\' OR moved_to = \'Sold_other\')'].join('')), null, null, null, 'link_product'));
  productsSold = (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'link_product.product_name'));})));
  topSold = [];
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, 'active=True', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  for (var j_index in products) {
    j = products[j_index];
    count = (await asyncListFilter(productsSold, async (item) => {


     return (item == (getObjectProperty(j, 'product_name')));
    })).length;
    addItemToList(topSold, ({ 'product_name': (getObjectProperty(j, 'product_name')),'product_id': (getObjectProperty(j, 'objectId')),'count': count,'cost': (getObjectProperty(j, 'RDG_cost')),'soldValue': count * (getObjectProperty(j, 'RDG_cost')) }));
  }
  ___arguments.context.pageData['best_selling'] = ((await asyncListSort(topSold, -1, async (item) => {


   return (getObjectProperty(item, 'count'));
  })).slice(0, 5));
  ___arguments.context.pageData['soldStockValue'] = (Math.round((await Promise.all(topSold.map(async item => {; return (getObjectProperty(item, 'soldValue'));}))).reduce(function(x, y) {return x + y;})));
  sales = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (String('sales_date>') + String(fromDate.valueOf())), null, null, null, null));
  salesOther = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (String('sales_date>') + String(fromDate.valueOf())), null, null, null, null));
  ___arguments.context.pageData['totalSales'] = (Math.round((await Promise.all(sales.map(async item => {; return (Number((getObjectProperty(item, 'sale_total_wo_tax'))));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(salesOther.map(async item => {; return (Number((getObjectProperty(item, 'total_amount'))));}))).reduce(function(x, y) {return x + y;})));
  currentInventory = (getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'inventory'));
  ___arguments.context.pageData['lowInventory'] = (await asyncListSort((await asyncListFilter(currentInventory, async (item) => {


   return ((getObjectProperty(item, 'totalItems')) < 10);
  })), -1, async (item) => {


   return (getObjectProperty(item, 'totalItems'));
  }));
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end on before page enter -- Dashboard');

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--dashboard/components/30aa1691b821dfd2ee0719724b9d7287/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--initialInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/72a1df672b89de98462ed52abb06e0db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--bookItems', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/f15ebef41c23f006b1656bdcd46150c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dealerInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/77fd7d4beeea685ed62c6ac1552c5117/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--officeInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/045623f9d62ccab4c57bb0087304fac1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locationSRX', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/a529bae355edfd2cc41110df92b1a59d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/e5b58992f6cec6c9a7d76e4152d2d759/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--reconcileDiscrepancy', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/06bfcaf1831d59115b7334ae75ddd0c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--reconcileSRXDiscrepancy', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/33f183cff98c1b41bfaa6008c6140a65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--currentInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/33165738baea2eb2e4cf1a4ca56b2c23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.limitedPricing')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--dashboard/components/52eb343fa8cd4d7b6ecb75959d52880a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--problemTransactions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--dashboard/components/9768a2a759d97088475364db5aab7ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--discrepancies', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--discrepancies/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var discrepancies, system_SN, manual_SN, system_count, manual_count, product_name, location_name, date, unresolvedDescr, productList, locationList, j, products, locations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  ___arguments.context.pageData['discrepancyDir'] = (['/officeSpecificSaveFiles/',(getObjectProperty((await Backendless.Data.of('Offices').findById(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), )), 'company_short_identifier')),'/discrepancies/'].join(''));
  ___arguments.context.pageData['pageTitle'] = 'Discrepancies';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, (String('active=') + String(true)), 'name', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  locationList = [];
  for (var j_index in locations) {
    j = locations[j_index];
    addItemToList(locationList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')) }));
  }
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, (String('active=') + String(true)), 'product_name', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  productList = [];
  for (var j_index2 in products) {
    j = products[j_index2];
    addItemToList(productList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')),'serialNumberRequired': (getObjectProperty(j, 'sn_required')) }));
  }
  ___arguments.context.pageData['locationList'] = locationList;
  ___arguments.context.pageData['productList'] = productList;
  unresolvedDescr = (await BackendlessUI.Functions.Custom['fn_63982c1ae3dbd4d57b645661584b971d'](null, 'resolved != true', 'date_of_count desc', null, 1, null, null, true, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  ___arguments.context.pageData['openDiscrepancies'] = unresolvedDescr;
  discrepancies = (await BackendlessUI.Functions.Custom['fn_63982c1ae3dbd4d57b645661584b971d'](null, null, 'date_of_count desc', null, 1, null, null, null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  ___arguments.context.pageData['tableColumns'] = ['{"field": "date_of_count", "flex": 1}', '{"field": "Dealer", "sortable": true, "flex": 1}', '{"field": "Product", "flex": 1}', '{"field": "manual_count", "sortable": true, "flex": 1}', '{"field": "System Count", "sortable": true, "flex": 1}', '{"field": "Reported SN", "sortable": true, "flex": 1}', '{"field": "System SN", "sortable": true, "flex": 1}'];
  date = [];
  location_name = [];
  product_name = [];
  manual_count = [];
  system_count = [];
  manual_SN = [];
  system_SN = [];
  ___arguments.context.pageData['newDiscrepancies'] = ({ 'Date': date,'Dealer': location_name,'Product': product_name,'Reported Count': manual_count,'System Count': system_count,'Reported SN': manual_SN,'System SN': system_SN });
  ___arguments.context.pageData['newDiscrepancies'] = discrepancies;
  ___arguments.context.pageData['allDiscrepancies'] = discrepancies;
  ___arguments.context.pageData['showAll'] = false;

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'discrepancies', null);
  ___arguments.context.pageData['serialNumber'] = '';
  ___arguments.context.pageData['results'] = 'Enter serial number to see summary';
  ___arguments.context.pageData['tableVisibility'] = false;
  ___arguments.context.pageData['openDiscrepancyModal'] = false;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--discrepancies/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--discrepancies/components/92d4c61df5ba5f6dd98d508792c5472d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var movements, serialNumbers, j, item, selectedProduct;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedProductId'] = ___arguments.value;
  selectedProduct = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['selectedProduct'] = (getObjectProperty(selectedProduct, 'label'));
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string') && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string')) {
    movements = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allInventoryTransactions')), async (item) => {


     return (((getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) == (getObjectProperty(item, 'link_moved_from.objectId')) || (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) == (getObjectProperty(item, 'link_moved_to.objectId'))) && (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) == (getObjectProperty(item, 'link_product.objectId')));
    }));
    if (getObjectProperty(selectedProduct, 'serialNumberRequired')) {
      ___arguments.context.pageData['showSN'] = true;
    } else {
      ___arguments.context.pageData['showSN'] = false;
    }
  } else {
    movements = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allInventoryTransactions')), async (item) => {


     return ((getObjectProperty(___arguments.context.pageData, 'selectedProductId')) == (getObjectProperty(item, 'link_product.objectId')));
    }));
    if (getObjectProperty(selectedProduct, 'serialNumberRequired')) {
      ___arguments.context.pageData['showSN'] = true;
    } else {
      ___arguments.context.pageData['showSN'] = false;
    }
  }
  ___arguments.context.pageData['selectedInventoryTransactions'] = movements;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--discrepancies/components/452b61a1ffddd7e3276a10abc09f2092/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var movements, item, j, serialNumbers, selectedRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedLocationId'] = ___arguments.value;
  selectedRecord = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['selectedLocation'] = (getObjectProperty(selectedRecord, 'label'));
  ___arguments.context.pageData['locationInventory'] = (getObjectProperty(selectedRecord, 'inventory'));
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string') && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string')) {
    movements = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allInventoryTransactions')), async (item) => {


     return (((getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) == (getObjectProperty(item, 'link_moved_from.objectId')) || (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) == (getObjectProperty(item, 'link_moved_to.objectId'))) && (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) == (getObjectProperty(item, 'link_product.objectId')));
    }));
    if (getObjectProperty(___arguments.context.pageData, 'showSN')) {
      serialNumbers = [];
      var j_list = (getObjectProperty(((await asyncListFilter((getObjectProperty(selectedRecord, 'inventory')), async (item) => {


       return ((getObjectProperty(item, 'productObjId')) == (getObjectProperty(___arguments.context.pageData, 'selectedProductId')));
      }))[0]), 'serialNumber'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        addItemToList(serialNumbers, ({ 'label': j,'value': j }));
      }
      ___arguments.context.pageData['serialNumbers'] = serialNumbers;
    }
  } else {
    movements = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allInventoryTransactions')), async (item) => {


     return ((getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) == (getObjectProperty(item, 'link_moved_from.objectId')) || (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) == (getObjectProperty(item, 'link_moved_to.objectId')));
    }));
  }
  ___arguments.context.pageData['selectedInventoryTransactions'] = movements;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--discrepancies/components/a5ef4ea1dedabb8cfff6e182e435a59c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var response;



  return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'showAll')) ? (getObjectProperty(___arguments.context.pageData, 'allDiscrepancies')) : (getObjectProperty(___arguments.context.pageData, 'openDiscrepancies')))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory--discrepancies/components/1666868ee0326486db02f43a3372418f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'date_of_count'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory--discrepancies/components/78c532124d3219a83e5d76072fdb0045/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, serialNumbers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  serialNumbers = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allSNs')), async (item) => {


   return ((String(getObjectProperty(item, 'label'))).indexOf(___arguments['inputValue']) !== -1);
  })).slice(0, 10);
  ___arguments.context.pageData['serialNumbers'] = serialNumbers;
  ___arguments.context.pageData['selectedInventoryTransactions'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'selectedInventoryTransactions')), async (item) => {


   return ((String(getObjectProperty(item, 'serial_number'))).indexOf(___arguments['inputValue']) !== -1);
  }));

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  async ['onButtonClearClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedInventoryTransactions'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'selectedInventoryTransactions')), async (item) => {


   return ((String(getObjectProperty(item, 'serial_number'))).indexOf('2060') !== -1);
  }));

  },
  /* handler:onButtonClearClick */
  /* content */
}))

define('./pages/inventory--discrepancies/components/a1c95d95f6b24dc240cc670ea0a524b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var isSN, selectedDiscrepancy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDiscrepancy = ___arguments.context.dataModel;
  selectedDiscrepancy['isSN'] = ((getObjectProperty(___arguments.context.dataModel, 'link_product.sn_required')) && (getObjectProperty(___arguments.context.dataModel, 'link_location.type')) == 'Dealer');
  isSN = (getObjectProperty(___arguments.context.dataModel, 'link_product.sn_required')) && (getObjectProperty(___arguments.context.dataModel, 'link_location.type')) == 'Dealer';
  if (isSN) {
    selectedDiscrepancy['firstTitle'] = 'SN in system';
    selectedDiscrepancy['firstValue'] = ((getObjectProperty(___arguments.context.dataModel, 'system_SN')) ? (getObjectProperty(___arguments.context.dataModel, 'system_SN')) : ' - ');
    selectedDiscrepancy['secondTitle'] = 'SN in Dealer count';
    selectedDiscrepancy['secondValue'] = ((getObjectProperty(___arguments.context.dataModel, 'manual_SN')) ? (getObjectProperty(___arguments.context.dataModel, 'manual_SN')) : ' - ');
    selectedDiscrepancy['totalCost'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((getObjectProperty(___arguments.context.dataModel, 'link_product.dealer_cost'))));
    selectedDiscrepancy['showDiff'] = false;
  } else {
    selectedDiscrepancy['firstTitle'] = 'System Count';
    selectedDiscrepancy['firstValue'] = (getObjectProperty(___arguments.context.dataModel, 'system_count'));
    selectedDiscrepancy['secondTitle'] = 'Manual Count';
    selectedDiscrepancy['secondValue'] = (getObjectProperty(___arguments.context.dataModel, 'manual_count'));
    selectedDiscrepancy['showDiff'] = true;
    selectedDiscrepancy['diff'] = ((getObjectProperty(___arguments.context.dataModel, 'system_count')) - (getObjectProperty(___arguments.context.dataModel, 'manual_count')));
    selectedDiscrepancy['cost'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((getObjectProperty(___arguments.context.dataModel, 'link_product.dealer_cost'))));
    selectedDiscrepancy['totalCost'] = (await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](((getObjectProperty(___arguments.context.dataModel, 'diff')) * (getObjectProperty(___arguments.context.dataModel, 'cost')))));
  }
  ___arguments.context.pageData['selectedDiscrepancy'] = selectedDiscrepancy;
  ___arguments.context.pageData['openDiscrepancyModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--discrepancies/components/1e543556904b9878cde724642eb58c06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showAll'] = (!(getObjectProperty(___arguments.context.pageData, 'showAll')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--discrepancies/components/73894213c6146367cdb5442a60f8af48/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'manual_SN'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory--forms/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Inventory Forms';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--forms/components/ac8142cd15d5e305fb7aed21312a5d5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--bookItems', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/82fd00f4ca5ddcdd69efde7b7787ab8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dealerInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/faf987cf037a6ce19277e9d76c689534/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dealerLocationUpdate', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/bae3ec44e44a4275ec639aa24aaf2498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--initialInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/126d612429fe7a6875bf056d618f2dec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--itemReturns', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/0ff89db280463887b467ecdd8cc20e97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--officeInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/3767a03ed4a14c71cb746f39e3a4f982/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dealerCheckout', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/910544e16a7126febf52844d8b7d82eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dealerPurchaseRequest', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/0c6b511be3dc0dd2848f7d19c4fdf91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--reconcileDiscrepancy', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/e0d120f6c9846b92d8c99247641cd991/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--reconcileSRXDiscrepancy', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/eea5090df907f90ea0b8ff51efc20ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--shipmentRexair', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/4b44c0abc914eff44a3a65d2e0d80bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--lookupSRX', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/3452844e0c7ab3290acdd85c1ecff901/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--stockAdjustmentSRX', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/897aaa07938bc48863b4189f42cd998d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dealerTransfer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--forms/components/8f654a5e43f3605445320cfd9e3cdecc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--officeTransfer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var serialNums, productList, locationList, j, products, locations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting on page enter');
  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewTransactions', null);
  ___arguments.context.pageData['showDeleteConfirmation'] = false;
  ___arguments.context.pageData['pageTitle'] = 'Inventory Historical Transactions';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, (String('active=') + String(true)), 'name', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  locationList = [];
  for (var j_index in locations) {
    j = locations[j_index];
    addItemToList(locationList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory_historical': (getObjectProperty(j, 'inventory_historical')) }));
  }
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, (String('active=') + String(true)), 'product_name', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  productList = [];
  for (var j_index2 in products) {
    j = products[j_index2];
    addItemToList(productList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')),'serialNumberRequired': (getObjectProperty(j, 'sn_required')) }));
  }
  ___arguments.context.pageData['locationList'] = locationList;
  ___arguments.context.pageData['productList'] = productList;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageSize'] = 20;
  serialNums = [];
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end on page enter');

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['serialNumber'] = '';
  ___arguments.context.pageData['results'] = 'Enter serial number to see summary';
  ___arguments.context.pageData['tableVisibility'] = false;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/92d4c61df5ba5f6dd98d508792c5472d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var transactions, record, item, item2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedProductId'] = ___arguments.value;
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'locationInventory')));
  transactions = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'locationInventory')).map(async item => {  record = (await asyncListFilter((getObjectProperty(item, 'inventory')), async (item2) => {


     return ((getObjectProperty(item2, 'productId')) == ___arguments.value);
    }))[0];
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](record);
  ; return ({ 'date': (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(item, 'asOfDate')))),'product_name': (getObjectProperty(((await asyncListFilter((getObjectProperty(item, 'inventory')), async (item2) => {


   return ((getObjectProperty(item2, 'productId')) == ___arguments.value);
  }))[0]), 'productName')),'num_items': (getObjectProperty(((await asyncListFilter((getObjectProperty(item, 'inventory')), async (item2) => {


   return ((getObjectProperty(item2, 'productId')) == ___arguments.value);
  }))[0]), 'count')) });})));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](transactions);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5ef4ea1dedabb8cfff6e182e435a59c', transactions);
  ___arguments.context.pageData['selectedProduct'] = (getObjectProperty(transactions, 'label'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/452b61a1ffddd7e3276a10abc09f2092/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedRecord, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedLocationId'] = ___arguments.value;
  selectedRecord = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['locationInventory'] = (getObjectProperty(selectedRecord, 'inventory_historical'));
  ___arguments.context.pageData['selectedLocation'] = (getObjectProperty(selectedRecord, 'label'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/a5ef4ea1dedabb8cfff6e182e435a59c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var response;



  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/6f0fcf49914c3fc4dd1981a405025b0e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var startDate;


  startDate = (new Date(___arguments.value));
  startDate.setHours(0);
  startDate.setMinutes(0);
  ___arguments.context.pageData['startDate'] = startDate;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/fc9e6aa8bf4ff79af751787c3b7e2959/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endDate;


  endDate = (new Date(___arguments.value));
  endDate.setHours(24);
  ___arguments.context.pageData['endDate'] = endDate;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/cd819b2dbbcfe98472f3071c98098504/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedLocationId'] = undefined;
  ___arguments.context.pageData['selectedProductId'] = undefined;
  ___arguments.context.pageData['startDate'] = undefined;
  ___arguments.context.pageData['startDateVal'] = undefined;
  ___arguments.context.pageData['endDate'] = undefined;
  ___arguments.context.pageData['endDateVal'] = undefined;
  ___arguments.context.pageData['endDateVal'] = undefined;
  ___arguments.context.pageData['selectedInventoryTransactions'] = (getObjectProperty(___arguments.context.pageData, 'allInventoryTransactions'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/8fc4c3242aa292dc17436c8ff82736fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var snObject, j, serialNumbers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  serialNumbers = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'serialNumbers')), async (item) => {


   return ((String(getObjectProperty(item, 'label'))).indexOf((String(___arguments.value))) !== -1);
  })).slice(0, 5);
  snObject = [];
  for (var j_index in serialNumbers) {
    j = serialNumbers[j_index];
    addItemToList(snObject, ({ 'serialNumber': (getObjectProperty(j, 'label')),'transObjId': (getObjectProperty(j, 'value')) }));
  }
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['filteredSerialNumbers'] = snObject;
  ___arguments.context.pageData['autoCompleteMenu'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/3b945e121711fdca065d257d27bbc184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedSerialNumber'] = (String(getObjectProperty(___arguments.context.dataModel, 'serialNumber')));
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['autoCompleteMenu'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/8d01c277f8f51ecb08abf60a7de8cec6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/ff64ce3e81d76ad291920ac92f4c0abc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedLocation')) && (getObjectProperty(___arguments.context.pageData, 'selectedProduct')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['startDate'] = (new Date(1679382000000));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/97abb2a15a26c3bfdf5820573225f9e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) ? String('Total in inventory count: ') + String(getObjectProperty(___arguments.context.pageData, 'inventoryCount')) : null)

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) && (typeof (getObjectProperty(___arguments.context.pageData, 'inventoryCount')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'inventoryCount')))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/59a67b1b36084846c3eb11af053b9af9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) ? String('Number in stock: ') + String(getObjectProperty(___arguments.context.pageData, 'transactionCount')) : null)

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) && (typeof (getObjectProperty(___arguments.context.pageData, 'transactionCount')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'transactionCount')))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/c29671cafacfe1722291c92f0576875c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['recalcRunning'] = true;
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')), (getObjectProperty(___arguments.context.pageData, 'selectedProductId')), ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), null);
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['recalcRunning'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/8741cd4d6c2b9de4a2c9a6395b95f61c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'calcFinished')) && (getObjectProperty(___arguments.context.pageData, 'inventoryCount')) != (getObjectProperty(___arguments.context.pageData, 'transactionCount')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/a1c95d95f6b24dc240cc670ea0a524b8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1c95d95f6b24dc240cc670ea0a524b8'))['background'] = (getObjectProperty(___arguments.context.dataModel, 'background'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/33929a683aafb6fcc781a7e75825d4c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['offset'] = (Math.min(Math.max((getObjectProperty(___arguments.context.pageData, 'offset')) + (getObjectProperty(___arguments.context.pageData, 'pageSize')), 0), (getObjectProperty(___arguments.context.pageData, 'recordCount'))));
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/27a63db69701403b3b428fe5cd5265d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'offset')) > 0) {
    ___arguments.context.pageData['offset'] = (Math.min(Math.max((getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'pageSize')), 0), (getObjectProperty(___arguments.context.pageData, 'recordCount'))));
    ___arguments.context.pageData['recalcFilter'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/47d46cdeb0e669ed907fb35bff85336a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'created')) > (new Date((new Date()).getTime() - ((30 * 86400) * 1000))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedTransaction'] = ___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8');
  ___arguments.context.pageData['showDeleteConfirmation'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/f5792afcef268aac736461490a9e8d28/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var objId, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['recalcRunning'] = true;
  ___arguments.context.pageData['showDeleteConfirmation'] = false;
  transaction = (getObjectProperty(___arguments.context.pageData, 'selectedTransaction'));
  objId = (getObjectProperty(transaction, 'objectId'));
  transaction['office'] = (getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'office_name'));
  delete transaction['__class'];
  await Backendless.Data.of('deleted_transactions').save(transaction, true);
  await Backendless.Data.of((getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'productTransaction_table'))).remove( objId );
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(transaction, 'link_moved_from.objectId')), (getObjectProperty(transaction, 'link_product.objectId')), null);
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(transaction, 'link_moved_to.objectId')), (getObjectProperty(transaction, 'link_product.objectId')), null);
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['recalcRunning'] = false;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['selectedTransaction'] = undefined;
  ___arguments.context.pageData['showDeleteConfirmation'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/f6a4165a1ed1ddc45b26270a0e421341/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--problemTransactions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--historicalInventory/components/610747849816d017b29713041d8d7753/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--locations/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--locations/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Inventory Locations';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['refresh'] = false;

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var locationRecords, j, stockValue, itemsInStock, discrepanciesObj, sortedInventory, k, locDisc, item, discrepanciesTable, productCost, temp, prodObjId, filterItem, productsTable, singleItem, RDG_cost, locationTable, totalStock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  productsTable = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, (String('active=') + String(true)), 'product_name ASC', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  ___arguments.context.pageData['productRecords'] = productsTable;
  locationTable = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, (['active=',true,' and isTracked=',true].join('')), null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  discrepanciesTable = (await BackendlessUI.Functions.Custom['fn_63982c1ae3dbd4d57b645661584b971d'](null, (String('resolved=') + String(false)), null, null, 1, null, null, null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  totalStock = 0;
  locationRecords = [];
  for (var j_index in locationTable) {
    j = locationTable[j_index];
    ___arguments.context.pageData['locationsLoading'] = true;
    itemsInStock = 0;
    stockValue = 0;
    if (!(Array.isArray((getObjectProperty(j, 'inventory'))))) {
      j['inventory'] = [];
      stockValue = 0;
      sortedInventory = [];
      itemsInStock = 0;
    } else if ((getObjectProperty(j, 'inventory')).length == 0) {
      stockValue = 0;
      sortedInventory = [];
      itemsInStock = 0;
    } else if ((getObjectProperty(j, 'inventory')).length == 1) {
      singleItem = (getObjectProperty(j, 'inventory'))[0];
      RDG_cost = (getObjectProperty((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())))).findById((getObjectProperty(singleItem, 'productObjId')), )), 'RDG_cost'));
      if (RDG_cost) {
        stockValue = String('$') + String((await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](((getObjectProperty(singleItem, 'totalItems')) * RDG_cost))));
      }
      sortedInventory = [singleItem];
      itemsInStock = (getObjectProperty(singleItem, 'totalItems'));
    } else {
      sortedInventory = (await asyncListSort((getObjectProperty(j, 'inventory')), -1, async (item) => {


       return (getObjectProperty(item, 'totalItems'));
      }));
      itemsInStock = (await Promise.all((getObjectProperty(j, 'inventory')).map(async item => {; return (getObjectProperty(item, 'totalItems'));}))).reduce(function(x, y) {return x + y;});
      stockValue = String('$') + String((await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a'](((await Promise.all((getObjectProperty(j, 'inventory')).map(async item => {  prodObjId = (getObjectProperty(item, 'productObjId'));
        temp = (await asyncListFilter(productsTable, async (filterItem) => {


         return ((getObjectProperty(filterItem, 'objectId')) == prodObjId);
        }));
        if (temp.length > 0) {
          productCost = (getObjectProperty((temp[0]), 'RDG_cost'));
        } else {
          productCost = 0;
        }
      ; return ((getObjectProperty(item, 'totalItems')) * productCost);}))).reduce(function(x, y) {return x + y;})))));
    }
    discrepanciesObj = [];
    locDisc = (await asyncListFilter(discrepanciesTable, async (item) => {


     return ((getObjectProperty(item, 'link_location.objectId')) == (getObjectProperty(j, 'objectId')));
    }));
    if (locDisc.length > 0) {
      for (var k_index in locDisc) {
        k = locDisc[k_index];
        addItemToList(discrepanciesObj, ({ 'product': (getObjectProperty(k, 'link_product.product_name')),'objectId': (getObjectProperty(k, 'objectId')),'value': (getObjectProperty(k, 'system_count')) - (getObjectProperty(k, 'manual_count')) }));
      }
    }
    addItemToList(locationRecords, ({ 'name': (getObjectProperty(j, 'name')),'location_icon': (getObjectProperty(j, 'location_icon')),'sortedInventory': sortedInventory,'discrepancies': discrepanciesObj,'objectId': (getObjectProperty(j, 'objectId')),'itemsInStock': itemsInStock,'stockValue': stockValue,'inventory': (getObjectProperty(j, 'inventory')) }));
  }
  ___arguments.context.pageData['locationsLoading'] = false;
  ___arguments.context.pageData['locationData'] = locationRecords;
  ___arguments.context.pageData['filteredLocationData'] = locationRecords;
  ___arguments.context.pageData['refresh'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--locations/components/c44a09a18bc4b726c78a59f32a979be1/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'sortedInventory')).length >= 1 ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'sortedInventory'))[0]), 'productName')) : null)

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--locations/components/41ceb876c134ba9ef21384175988e738/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'sortedInventory')).length >= 2 ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'sortedInventory'))[1]), 'productName')) : null)

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--locations/components/25895a5a368fe804e4a97f9224aa5731/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'sortedInventory')).length >= 3 ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'sortedInventory'))[2]), 'productName')) : null)

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--locations/components/f3e41467b546a301659760acdd01bb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'product')),' - ',(getObjectProperty(___arguments.context.dataModel, 'value'))].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--discrepancies', ({ 'discrepancyObjId': (getObjectProperty(___arguments.context.dataModel, 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--locations/components/586f5e6a1e4a43f9575f0265ff9cb1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['filteredLocationData'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationData')), async (item) => {


   return (((getObjectProperty(item, 'name')).toLowerCase()).indexOf((___arguments['inputValue'].toLowerCase())) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--locations/components/642a6684f5a8c0b86b77b3bb4cf81832/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--manageLocations', undefined);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
      return (!(await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'addLocations', true)))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory--locations/components/b8e7ba724077c379254a06b37c884e7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--discrepancies', ({ 'selectedLocationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--locations/components/ec2664fc6197be8c93b32a2185e45145/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--moveProduct', ({ 'movedFromId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--locations/components/50f17c6687c3ade1a7341509c63833e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--currentInventory', ({ 'selectedLocationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--locations/components/23e4f668b7535b249fcf65d771739ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', ({ 'selectedLocationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--locations/components/8ba983dd5e66cb379ceaf277e026bb1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var locationRecords, productCost, item, prodObjId, filterItem, productRecords, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'filteredLocationData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory--manageLocations/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, locationRecords, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', ({ 'redirect': 'inventory--manageLocations' }));
  }
  ___arguments.context.pageData['pageTitle'] = 'Manage Locations';
  ___arguments.context.pageData['showModal'] = false;
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  locationRecords = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, 'name asc', null, null));
  for (var j_index in locationRecords) {
    j = locationRecords[j_index];
    j['lockProductEdit'] = true;
    j['typeOptions'] = [({ 'value': 'Dealer','label': 'Dealer' }), ({ 'value': 'Office','label': 'Office' }), ({ 'value': 'Supplier','label': 'Supplier' }), ({ 'value': 'Other','label': 'Other' })];
  }
  ___arguments.context.pageData['location_table_all'] = locationRecords;
  ___arguments.context.pageData['location_table_active'] = (await asyncListFilter(locationRecords, async (item) => {


   return (getObjectProperty(item, 'active'));
  }));
  ___arguments.context.pageData['location_table_inactive'] = (await asyncListFilter(locationRecords, async (item) => {


   return (!(getObjectProperty(item, 'active')));
  }));
  ___arguments.context.pageData['location_table_current'] = (getObjectProperty(___arguments.context.pageData, 'location_table_active'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--manageLocations/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--addLocation', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageLocations/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/inventory--manageLocations/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/inventory--manageLocations/components/f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockProductEdit'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageLocations/components/184719acc309867f8cb2630b60a251fd/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.dataModel['lockDealerEdit'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory--manageLocations/components/48ddc72360253729a31c0648e94eaf4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockProductEdit'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageLocations/components/4e464907f60864c43d5bf9199443b6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = (getObjectProperty(___arguments.context.pageData, 'selectedLocation'));
  await Backendless.Data.of('Dealers').remove( selectedDealer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('797d972e882aba5e545be8339eb928fa', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level').setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onSubmit */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerName = (getObjectProperty(___arguments.context.pageData, 'selectedDealerName'));

  return (['You are about to delete the dealer \'',dealerName,'\', are you sure?'].join(''))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/inventory--manageLocations/components/0bc4f03e05fc6dc3c65b1c21e93fa126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockLocationEdit'] = true;
  await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save( ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') );
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('a2ebd282f595125cbc38ebd3dec34d3d', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageLocations/components/7a8e273faf518dbf410be92822b58127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', true);
  ___arguments.context.pageData['location_table_current'] = (getObjectProperty(___arguments.context.pageData, 'location_table_inactive'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageLocations/components/187e1a17e595c884f153df83057d378a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', false);
  ___arguments.context.pageData['location_table_current'] = (getObjectProperty(___arguments.context.pageData, 'location_table_active'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, productRecords, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Manage Products';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['showModal'] = false;
  productRecords = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, null, 'product_name desc', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  for (var j_index in productRecords) {
    j = productRecords[j_index];
    j['lockProductEdit'] = true;
  }
  ___arguments.context.pageData['product_table_all'] = productRecords;
  ___arguments.context.pageData['product_table_active'] = (await asyncListFilter(productRecords, async (item) => {


   return (getObjectProperty(item, 'active'));
  }));
  ___arguments.context.pageData['product_table_inactive'] = (await asyncListFilter(productRecords, async (item) => {


   return (!(getObjectProperty(item, 'active')));
  }));
  ___arguments.context.pageData['product_table_current'] = (getObjectProperty(___arguments.context.pageData, 'product_table_active'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--manageProducts/components/66936abc53c135d2ae6daabd8ab9447f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--addProduct', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/339485ddec228b37aa7b32bf84abb308/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/inventory--manageProducts/components/2dc9b2724d372ba6921d5f5cbcb17bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('339485ddec228b37aa7b32bf84abb308');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2dc9b2724d372ba6921d5f5cbcb17bf8');

  },
  /* handler:onObjectDelete */
  /* content */
}))

define('./pages/inventory--manageProducts/components/f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockProductEdit'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/184719acc309867f8cb2630b60a251fd/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.dataModel['lockDealerEdit'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory--manageProducts/components/48ddc72360253729a31c0648e94eaf4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockProductEdit'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/4e464907f60864c43d5bf9199443b6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedDealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedDealer = (getObjectProperty(___arguments.context.pageData, 'selectedDealer'));
  console.log(selectedDealer);
  await Backendless.Data.of('Dealers').remove( selectedDealer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e464907f60864c43d5bf9199443b6f8');
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('797d972e882aba5e545be8339eb928fa', undefined, undefined, undefined, undefined, undefined);
  ___arguments.context.pageData['dealers_table'] = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setRelated('current_matrix_level').setSortBy('dealer_name asc').setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a2dcb0f02e91722930c546e39387377', (getObjectProperty(___arguments.context.pageData, 'dealers_table')));

  },
  /* handler:onSubmit */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var dealerName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dealerName = (getObjectProperty(___arguments.context.pageData, 'selectedDealerName'));

  return (['You are about to delete the dealer \'',dealerName,'\', are you sure?'].join(''))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/inventory--manageProducts/components/0bc4f03e05fc6dc3c65b1c21e93fa126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d9b1ad24a3ddc5c6ce5b3fd6fa30fb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bc4f03e05fc6dc3c65b1c21e93fa126', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ddc72360253729a31c0648e94eaf4b', false);
  ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd')['lockProductEdit'] = true;
  await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('product_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())))).save( ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') );
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('a2ebd282f595125cbc38ebd3dec34d3d', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/7a8e273faf518dbf410be92822b58127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', true);
  ___arguments.context.pageData['product_table_current'] = (getObjectProperty(___arguments.context.pageData, 'product_table_inactive'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/187e1a17e595c884f153df83057d378a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a8e273faf518dbf410be92822b58127', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('187e1a17e595c884f153df83057d378a', false);
  ___arguments.context.pageData['product_table_current'] = (getObjectProperty(___arguments.context.pageData, 'product_table_active'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/761a9f5f4c080d389e2aef0d88fbcd24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--addProduct', ({ 'selectedProduct': ___arguments.context.getComponentDataStoreByUid('184719acc309867f8cb2630b60a251fd') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--manageProducts/components/36785c039fabda5e33b3819cc6794f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/47fe9f7f583acead8e7b3296ccc80fcb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/05f4a71387c8240fd8736369b07ae41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/23d488a11557bbba263312bd78375714/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/2f97d0ee313e07235a5a7b012d46431c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/876494029fa7fd8e0847f3e8776b9782/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.limitedPricing')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/7b7bbe7d52459df6b3df51c887e1624b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.limitedPricing')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/01c4fe4d1846e9ec4344d2728c6fecdd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.limitedPricing')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--manageProducts/components/e64799c136e7baa1d06b297b4fe5c555/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.allPricing')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'sectionAccessInventory.limitedPricing')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--moveProduct/components/10848287681fba6da495f7669a192d4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toRecord, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['movedToId'] = ___arguments.value;
  toRecord = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'secondLocationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['movementList'] = [];
  ___arguments.context.pageData['toRecord'] = toRecord;
  ___arguments.context.pageData['toInventory'] = (getObjectProperty(toRecord, 'inventory'));
  ___arguments.context.pageData['toTrack'] = (getObjectProperty(toRecord, 'track'));
  ___arguments.context.pageData['movedTo'] = (getObjectProperty(toRecord, 'label'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--moveProduct/components/d04e158d896517fc21f67ab92e690923/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var chosenProduct, item, fromRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['movedFromId'] = ___arguments.value;
  fromRecord = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'firstLocationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  if (!(await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'moveTOonlyULAI', true))) {
    ___arguments.context.pageData['secondLocationList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'firstLocationList')), async (item) => {


     return ((getObjectProperty(item, 'value')) != ___arguments.value);
    }));
  }
  if ((getObjectProperty(fromRecord, 'type')) == 'Supplier') {
    ___arguments.context.pageData['showItems'] = false;
    ___arguments.context.pageData['showCartons'] = true;
    ___arguments.context.pageData['numItems'] = 0;
  } else {
    ___arguments.context.pageData['showItems'] = true;
    ___arguments.context.pageData['showCartons'] = false;
  }
  ___arguments.context.pageData['fromRecord'] = fromRecord;
  ___arguments.context.pageData['fromInventory'] = (getObjectProperty(fromRecord, 'inventory'));
  ___arguments.context.pageData['movementList'] = [];
  ___arguments.context.pageData['fromTrack'] = (getObjectProperty(fromRecord, 'track'));
  ___arguments.context.pageData['movedFrom'] = (getObjectProperty(fromRecord, 'label'));
  if (getObjectProperty(___arguments.context.pageData, 'productId')) {
    chosenProduct = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'productId')));
    }))[0];
    if (getObjectProperty(chosenProduct, 'serialNumRequired')) {
      ___arguments.context.pageData['potentialSNs'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allSNs')), async (item) => {


       return ((getObjectProperty(item, 'location.objectId')) == ___arguments.value);
      }));
    } else {
      ___arguments.context.pageData['itemsPerCarton'] = (getObjectProperty(chosenProduct, 'itemsPerCarton'));
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--moveProduct/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var fromRecord, item, locationList, chosenProduct, productsList, groupedLocations, otherMin, dealersMin, officesMin, suppliersMin, other, dealers, offices, suppliers, j, locations, dealerRecord, mainOffice, products, officeObjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  localStorage.setItem('debug', JSON.stringify(true));
  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', null, null);
  ___arguments.context.pageData['mobileQuickAction'] = true;
  ___arguments.context.pageData['inventoryDir'] = (['/officeSpecificSaveFiles/',(getObjectProperty((await Backendless.Data.of('Offices').findById(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), )), 'company_short_identifier')),'/inventory/'].join(''));
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, (String('active = ') + String(true)), 'name', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, (String('active = ') + String(true)), 'product_name', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  locationList = [];
  productsList = [];
  dealers = [];
  dealersMin = [];
  suppliers = [];
  suppliersMin = [];
  offices = [];
  officesMin = [];
  other = [];
  otherMin = [];
  ___arguments.context.pageData['numCartons'] = undefined;
  ___arguments.context.pageData['numItems'] = 1;
  ___arguments.context.pageData['transferDate'] = (new Date());
  for (var j_index in products) {
    j = products[j_index];
    addItemToList(productsList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')),'serialNumRequired': (getObjectProperty(j, 'sn_required')),'product_barcode': (getObjectProperty(j, 'product_barcode')),'carton_barcode': (getObjectProperty(j, 'carton_barcode')),'itemsPerCarton': (getObjectProperty(j, 'items_per_carton')) }));
  }
  ___arguments.context.pageData['productList'] = productsList;
  if ((await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'moveTOonlyULAI', true))) {
    mainOffice = (await Backendless.Data.of('ULAI_locations').findById('8AC6CF25-58F1-4530-A313-49361EE044DE', ));
    mainOffice['value'] = (getObjectProperty(mainOffice, 'objectId'));
    ___arguments.context.pageData['fromRecord'] = mainOffice;
    ___arguments.context.pageData['fromInventory'] = (getObjectProperty(mainOffice, 'inventory'));
    ___arguments.context.pageData['fromTrack'] = (getObjectProperty(mainOffice, 'track'));
    ___arguments.context.pageData['movedFrom'] = (getObjectProperty(mainOffice, 'name'));
    dealerRecord = (await asyncListFilter(locations, async (item) => {


     return ((getObjectProperty(item, 'name')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')));
    }));
    if (dealerRecord.length == 0) {
      dealerRecord = (await Backendless.Data.of('ULAI_locations').findById('D9EDE19F-F2D7-4D77-B21D-23A5F5D297A4', ));
    } else {
      dealerRecord = dealerRecord[0];
    }
    dealerRecord['value'] = (getObjectProperty(dealerRecord, 'objectId'));
    ___arguments.context.pageData['toRecord'] = dealerRecord;
    ___arguments.context.pageData['toTrack'] = (getObjectProperty(dealerRecord, 'track'));
    ___arguments.context.pageData['movedTo'] = (getObjectProperty(dealerRecord, 'name'));
    ___arguments.context.pageData['firstLocationList'] = [({ 'value': (getObjectProperty(mainOffice, 'objectId')),'label': (getObjectProperty(mainOffice, 'name')),'inventory': (getObjectProperty(mainOffice, 'inventory')),'track': (getObjectProperty(mainOffice, 'isTracked')),'type': 'Office' })];
    ___arguments.context.pageData['secondLocationList'] = [({ 'value': (getObjectProperty(dealerRecord, 'objectId')),'label': (getObjectProperty(dealerRecord, 'name')),'inventory': (getObjectProperty(dealerRecord, 'inventory')),'track': (getObjectProperty(dealerRecord, 'isTracked')),'type': 'Dealer' })];
    ___arguments.context.pageData['allSNs'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (['location=\'',(getObjectProperty(mainOffice, 'name')),'\''].join('')), null, null, null, 'link_location'));
    ___arguments.context.pageData['movedFromId'] = (getObjectProperty(mainOffice, 'objectId'));
    ___arguments.context.pageData['movedToId'] = (getObjectProperty(dealerRecord, 'objectId'));
  } else {
    for (var j_index2 in locations) {
      j = locations[j_index2];
      if ((getObjectProperty(j, 'type')) == 'Dealer') {
        addItemToList(dealers, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Dealer' }));
        addItemToList(dealersMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      } else if ((getObjectProperty(j, 'type')) == 'Office') {
        addItemToList(offices, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Office' }));
        addItemToList(officesMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      } else if ((getObjectProperty(j, 'type')) == 'Supplier') {
        addItemToList(suppliers, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Supplier' }));
        addItemToList(suppliersMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      } else {
        addItemToList(other, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Other' }));
        addItemToList(otherMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      }
    }
    locationList = (suppliers.concat((offices.concat((dealers.concat(other))))));
    ___arguments.context.pageData['firstLocationList'] = locationList;
    ___arguments.context.pageData['firstLocationListGrouped'] = groupedLocations;
    ___arguments.context.pageData['secondLocationList'] = locationList;
    if (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) {
      ___arguments.context.pageData['productId'] = (getObjectProperty(___arguments.context.pageData, 'selectedProductId'));
      chosenProduct = (await asyncListFilter(productsList, async (item) => {


       return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'selectedProductId')));
      }))[0];
      ___arguments.context.pageData['productName'] = (getObjectProperty(chosenProduct, 'label'));
      ___arguments.context.pageData['serialNumRequired'] = (getObjectProperty(chosenProduct, 'serialNumRequired'));
      ___arguments.context.pageData['itemsPerCarton'] = (getObjectProperty(chosenProduct, 'itemsPerCarton'));
    } else {
      ___arguments.context.pageData['productId'] = undefined;
    }
    if (getObjectProperty(___arguments.context.pageData, 'movedFromId')) {
      fromRecord = (await asyncListFilter(locationList, async (item) => {


       return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'movedFromId')));
      }))[0];
      ___arguments.context.pageData['secondLocationList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'firstLocationList')), async (item) => {


       return ((getObjectProperty(item, 'value')) != (getObjectProperty(___arguments.context.pageData, 'movedFromId')));
      }));
      ___arguments.context.pageData['fromRecord'] = fromRecord;
      ___arguments.context.pageData['fromInventory'] = (getObjectProperty(fromRecord, 'inventory'));
      ___arguments.context.pageData['fromTrack'] = (getObjectProperty(fromRecord, 'track'));
      ___arguments.context.pageData['movedFrom'] = (getObjectProperty(fromRecord, 'label'));
    } else {
      ___arguments.context.pageData['movedFromId'] = undefined;
    }
    ___arguments.context.pageData['allSNs'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (String('location!=\'Sold\'')), null, null, null, 'link_location'));
  }
  ___arguments.context.pageData['signatureConfirmed'] = false;
  ___arguments.context.pageData['serialNumRequired'] = false;
  ___arguments.context.pageData['movementList'] = [];
  ___arguments.context.pageData['barcodeValue'] = '';
  ___arguments.context.pageData['openScanner'] = false;

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Move Products';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['showItems'] = true;
  ___arguments.context.pageData['showItemCartonChecks'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
    ___arguments.context.pageData['showSideMenu'] = false;
    ___arguments.context.pageData['inventoryFormVisible'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    ___arguments.context.pageData['showSideMenu'] = true;
    ___arguments.context.pageData['inventoryFormVisible'] = true;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--moveProduct/components/337a9325e2d4f1871d16690db4af396c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fromRecord, item, j, locationList, myTransaction, response, toRecord, transactionRecord, transactionRef, transOperation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  response = '';
  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeObjId')) === null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  ___arguments.context.pageData['inventoryMoveRunning'] = true;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'movementList'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    myTransaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTransaction;

      transactionRef = (_uow.create((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'productTransaction_table')), ({ 'serial_number_display': (getObjectProperty(j, 'serialNumberDisplay')),'serial_numbers': (getObjectProperty(j, 'serialNumber')),'product_name': (getObjectProperty(j, 'product_name')),'transaction_date': (getObjectProperty(___arguments.context.pageData, 'transferDate')),'num_items': (Number((getObjectProperty(j, 'num_items')))),'moved_to': (getObjectProperty(___arguments.context.pageData, 'movedTo')),'moved_from': (getObjectProperty(___arguments.context.pageData, 'movedFrom')),'responsible_person': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')),'notes': (getObjectProperty(j, 'notes')),'product_photo': (getObjectProperty(___arguments.context.pageData, 'productPhoto')),'signature_file': (getObjectProperty(___arguments.context.pageData, 'signatureFile')) })).setOpResultId('createTransaction'));
      _uow.setRelation((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'productTransaction_table')), transactionRef, 'link_moved_from', [(getObjectProperty(___arguments.context.pageData, 'movedFromId'))]);
      _uow.setRelation((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'productTransaction_table')), transactionRef, 'link_moved_to', [(getObjectProperty(___arguments.context.pageData, 'movedToId'))]);
      _uow.setRelation((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord')), 'productTransaction_table')), transactionRef, 'link_product', [(getObjectProperty(j, 'product_id'))]);
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](((await myTransaction.execute()).getResults()));
      transactionRecord = (getObjectProperty(((await myTransaction.execute()).getResults()), 'createTransaction.result'));
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9'](transactionRecord);

    })();

    response = [response,'\n',(await BackendlessUI.Functions.Custom['fn_f9d2b58d28466fd672eaf755f913b7e6']((getObjectProperty(___arguments.context.pageData, 'movedToId')), (getObjectProperty(___arguments.context.pageData, 'movedFromId')), (getObjectProperty(j, 'product_id')), (Number((getObjectProperty(j, 'num_items')))), (getObjectProperty(j, 'serialNumber')), null, (getObjectProperty(transactionRecord, 'objectId')), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))].join('');
  }
  fromRecord = (getObjectProperty(___arguments.context.pageData, 'fromRecord'));
  toRecord = (getObjectProperty(___arguments.context.pageData, 'toRecord'));
  locationList = (getObjectProperty(___arguments.context.pageData, 'firstLocationList'));
  locationList = (await asyncListFilter(locationList, async (item) => {


   return ((getObjectProperty(item, 'value')) != (getObjectProperty(fromRecord, 'value')));
  }));
  locationList = (await asyncListFilter(locationList, async (item) => {


   return ((getObjectProperty(item, 'value')) != (getObjectProperty(toRecord, 'value')));
  }));
  fromRecord['inventory'] = (getObjectProperty((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).findById((getObjectProperty(fromRecord, 'value')), )), 'inventory'));
  toRecord['inventory'] = (getObjectProperty((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', null, ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('officeRecord'))))).findById((getObjectProperty(toRecord, 'value')), )), 'inventory'));
  addItemToList(locationList, fromRecord);
  addItemToList(locationList, toRecord);
  ___arguments.context.pageData['firstLocationList'] = locationList;
  ___arguments.context.pageData['secondLocationList'] = locationList;
  ___arguments.context.pageData['inventoryMoveRunning'] = false;
  ___arguments.context.pageData['confirmation'] = response;
  ___arguments.context.pageData['movementList'] = [];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/996ecb3745de8e16602c3efa1965f6a5/bundle.js', [], () => ({
  /* content */
  /* handler:onGetBarcode */
  async ['onGetBarcode'](___arguments) {
    var byCarton, byProduct, barcode, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  barcode = (Number(___arguments['barcode']));
  ___arguments.context.pageData['barcodeValue'] = barcode;
  byProduct = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


   return ((Number((getObjectProperty(item, 'product_barcode')))) == barcode);
  }));
  byCarton = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


   return ((Number((getObjectProperty(item, 'carton_barcode')))) == barcode);
  }));
  if (byProduct.length == 1) {
    ___arguments.context.pageData['productId'] = (getObjectProperty((byProduct[0]), 'value'));
    ___arguments.context.pageData['numItems'] = 1;
  } else if (byCarton.length == 1) {
    ___arguments.context.pageData['showCartons'] = true;
    ___arguments.context.pageData['numCartons'] = 1;
  } else {
    ___arguments.context.pageData['response'] = 'Product not found';
  }

  },
  /* handler:onGetBarcode */
  /* content */
}))

define('./pages/inventory--moveProduct/components/44b77315831e289870511939f029ccf6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var chosenProduct, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['productId'] = ___arguments.value;
  chosenProduct = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['productName'] = (getObjectProperty(chosenProduct, 'label'));
  ___arguments.context.pageData['serialNumRequired'] = (getObjectProperty(chosenProduct, 'serialNumRequired'));
  if (getObjectProperty(chosenProduct, 'serialNumRequired')) {
    ___arguments.context.pageData['showItemCartonChecks'] = false;
    ___arguments.context.pageData['showItems'] = false;
    ___arguments.context.pageData['showCartons'] = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'fromRecord.type')) == 'Supplier') {
    ___arguments.context.pageData['showItemCartonChecks'] = true;
    ___arguments.context.pageData['showItems'] = false;
    ___arguments.context.pageData['showCartons'] = true;
  } else {
    ___arguments.context.pageData['showItemCartonChecks'] = true;
    ___arguments.context.pageData['showItems'] = true;
    ___arguments.context.pageData['showCartons'] = false;
  }
  if (getObjectProperty(chosenProduct, 'serialNumRequired')) {
    if (getObjectProperty(___arguments.context.pageData, 'fromTrack')) {
      ___arguments.context.pageData['potentialSNs'] = (await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allSNs')), async (item) => {


       return ((getObjectProperty(item, 'link_location.objectId')) == (getObjectProperty(___arguments.context.pageData, 'movedFromId')));
      })).map(async item => {; return (getObjectProperty(item, 'serial_number'));})));
    } else {
      ___arguments.context.pageData['potentialSNs'] = [];
    }
  } else {
  }
  ___arguments.context.pageData['itemsPerCarton'] = (getObjectProperty(chosenProduct, 'itemsPerCarton'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--moveProduct/components/66ff0d1e94aa9874de6447bd89e990f1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var snObject, j, serialNumbers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'fromType')) != 'Supplier') {
    serialNumbers = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'potentialSNs')), async (item) => {


     return ((String(item)).indexOf(___arguments.value) !== -1);
    })).slice(0, 5);
    snObject = [];
    for (var j_index in serialNumbers) {
      j = serialNumbers[j_index];
      addItemToList(snObject, ({ 'serialNumber': j }));
    }
    ___arguments.context.pageData['serialNumbers'] = snObject;
    ___arguments.context.pageData['autoCompleteMenu'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--moveProduct/components/c8018da13918b8baeaafa9ed4195b7cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var totalItems, item, parsedSerialNumbers, productName, productRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function subsequenceFromStartFromEnd(sequence, at1, at2) {
  var start = at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'serialNumRequired')) {
    if ((getObjectProperty(___arguments.context.pageData, 'rawSerialNumber')).length > 0) {
      parsedSerialNumbers = (await BackendlessUI.Functions.Custom['fn_642965abd54d833d81bfa3f755fac658']((getObjectProperty(___arguments.context.pageData, 'rawSerialNumber'))));
    } else {
      ___arguments.context.pageData['response'] = 'A serial number is required';
      return 'A serial number is required';
    }
    productName = (getObjectProperty(___arguments.context.pageData, 'productName'));
    ___arguments.context.pageData['response'] = (await BackendlessUI.Functions.Custom['fn_b40438df16512717d48fd803581b8e33']((getObjectProperty(___arguments.context.pageData, 'fromInventory')), (getObjectProperty(___arguments.context.pageData, 'toInventory')), true, parsedSerialNumbers, 1, (getObjectProperty(___arguments.context.pageData, 'fromTrack')), (getObjectProperty(___arguments.context.pageData, 'toTrack')), productName, (getObjectProperty(___arguments.context.pageData, 'productId')), (getObjectProperty(___arguments.context.pageData, 'movedFrom')), (getObjectProperty(___arguments.context.pageData, 'movedTo')), null));
    if (parsedSerialNumbers.length <= 1) {
      ___arguments.context.pageData['movementList'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'movementList')), ({ 'product_name': productName,'product_id': (getObjectProperty(___arguments.context.pageData, 'productId')),'num_items': parsedSerialNumbers.length,'serialNumberDisplay': parsedSerialNumbers[0],'serialNumber': parsedSerialNumbers,'notes': (getObjectProperty(___arguments.context.pageData, 'notes')) })));
    } else if (parsedSerialNumbers.length <= 5) {
      ___arguments.context.pageData['movementList'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'movementList')), ({ 'product_name': productName,'product_id': (getObjectProperty(___arguments.context.pageData, 'productId')),'num_items': parsedSerialNumbers.length,'serialNumberDisplay': subsequenceFromStartFromEnd((JSON.stringify(parsedSerialNumbers)), 1, 1),'serialNumber': parsedSerialNumbers,'notes': (getObjectProperty(___arguments.context.pageData, 'notes')) })));
    } else {
      ___arguments.context.pageData['movementList'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'movementList')), ({ 'product_name': productName,'product_id': (getObjectProperty(___arguments.context.pageData, 'productId')),'num_items': parsedSerialNumbers.length,'serialNumberDisplay': [parsedSerialNumbers[0],', ',parsedSerialNumbers[1],', ...',parsedSerialNumbers.slice(-1)[0]].join(''),'serialNumber': parsedSerialNumbers,'notes': (getObjectProperty(___arguments.context.pageData, 'notes')) })));
    }
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
      ___arguments.context.pageData['inventoryFormVisible'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('832646f4e53b180ca50ce9870c5b6a57', false);
    }
  } else {
    totalItems = (await BackendlessUI.Functions.Custom['fn_755cdc7d96ebc637b633759559383b95']((getObjectProperty(___arguments.context.pageData, 'numItems')))) + (await BackendlessUI.Functions.Custom['fn_d4a180ee751ffbb1c299dee78e24f237']((getObjectProperty(___arguments.context.pageData, 'itemsPerCarton')))) * (await BackendlessUI.Functions.Custom['fn_755cdc7d96ebc637b633759559383b95']((getObjectProperty(___arguments.context.pageData, 'numCartons'))));
    ___arguments.context.pageData['response'] = (await BackendlessUI.Functions.Custom['fn_b40438df16512717d48fd803581b8e33']((getObjectProperty(___arguments.context.pageData, 'fromInventory')), (getObjectProperty(___arguments.context.pageData, 'toInventory')), false, null, totalItems, (getObjectProperty(___arguments.context.pageData, 'fromTrack')), (getObjectProperty(___arguments.context.pageData, 'toTrack')), (getObjectProperty(___arguments.context.pageData, 'productName')), (getObjectProperty(___arguments.context.pageData, 'productId')), (getObjectProperty(___arguments.context.pageData, 'movedFrom')), (getObjectProperty(___arguments.context.pageData, 'movedTo')), null));
    ___arguments.context.pageData['movementList'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'movementList')), ({ 'product_name': (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'productId')));
    }))[0]), 'label')),'product_id': (getObjectProperty(___arguments.context.pageData, 'productId')),'num_items': totalItems,'serial_number': undefined,'notes': (getObjectProperty(___arguments.context.pageData, 'notes')) })));
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
      ___arguments.context.pageData['inventoryFormVisible'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('832646f4e53b180ca50ce9870c5b6a57', false);
    }
  }
  ___arguments.context.pageData['productId'] = undefined;
  ___arguments.context.pageData['numItems'] = undefined;
  ___arguments.context.pageData['numCartons'] = undefined;
  ___arguments.context.pageData['parsedSerialNumbers'] = undefined;
  ___arguments.context.pageData['serialNumRequired'] = false;
  ___arguments.context.pageData['rawSerialNumber'] = undefined;
  ___arguments.context.pageData['notes'] = undefined;
  ___arguments.context.pageData['mobileQuickAction'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/3d7e8a855ad2bf5d542a2b697de16b9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['movementList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'movementList')), async (item) => {


   return (item != ___arguments.context.getComponentDataStoreByUid('2f417cae303e5bcf28f427718a4b3795'));
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/11898f04a522107f609fb01ba276bc02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['rawSerialNumber'] = (String(getObjectProperty(___arguments.context.dataModel, 'serialNumber')));
  ___arguments.context.pageData['autoCompleteMenu'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/e993aa0b800df4ccc3f850aba7577d28/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    
  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory--moveProduct/components/873364cb3397e3be952b5f4d147efb76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryFormVisible'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/5a72ba32a2818e628aa43b13b01acff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryFormVisible'] = true;
  ___arguments.context.pageData['mobileQuickAction'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/96620f2c3b515afd05327628a012f509/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--moveProduct/components/d79c69ae6fe1baec99a347ceb48a2bed/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['signatureFile'] = (await Backendless.Files.saveFile(encodePath((getObjectProperty(___arguments.context.pageData, 'inventoryDir'))), (String((new Date()).toISOString()) + String('_signature.png')), ___arguments['signature'], true));
  ___arguments.context.pageData['signatureConfirmed'] = true;

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/28d33eea524f209fa81b27386564fa14/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
      return (String((new Date()).toISOString()) + String('_productPhoto'))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/inventory--moveProduct/components/cb9a945376257c7fcc5961110bba1f19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['mobileQuickAction'] = true;
  ___arguments.context.pageData['inventoryFormVisible'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/9b46a5b8c7a597ccc32d655585f53a3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['movementList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'movementList')), async (item) => {


   return (item != ___arguments.context.getComponentDataStoreByUid('2f417cae303e5bcf28f427718a4b3795'));
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--moveProduct/components/f8ce745a3cfd1af1245e9ddde31113a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryFormVisible'] = true;
  ___arguments.context.pageData['mobileQuickAction'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var transaction_table, item, newIssues, productSelector, k, locationSelector, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['tableIssues'] = '';
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['showSpinner'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Transaction Issues';
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  transaction_table = [];
  newIssues = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (['(link_moved_to.name is null',' OR link_moved_from.name is null',' OR link_product.product_name is null)',' AND (transaction_date > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),' OR created > ',((new Date((new Date()).getTime() - ((7 * 86400) * 1000))).valueOf()),')'].join('')), null, null, 'transaction_date desc', ['link_moved_to', 'link_moved_from', 'link_product']));
  if (newIssues.length > 0) {
    locationSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, null, 'name', null)), 'objectId', 'name'));
    productSelector = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, null, 'product_name', null)), 'objectId', 'product_name'));
    for (var k_index in newIssues) {
      k = newIssues[k_index];
      k['setBackground'] = true;
      k['moved_to_select'] = locationSelector;
      k['moved_from_select'] = locationSelector;
      k['product_select'] = productSelector;
    }
    transaction_table = (transaction_table.concat(newIssues));
    ___arguments.context.pageData['filtered_table'] = transaction_table;
    ___arguments.context.pageData['message'] = undefined;
  } else {
    ___arguments.context.pageData['message'] = 'No missing links';
  }
  transaction_table = (await asyncListSort(transaction_table, -1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
  ___arguments.context.pageData['datatable'] = transaction_table;
  ___arguments.context.pageData['filtered_table'] = transaction_table;
  ___arguments.context.pageData['flagged'] = false;
  ___arguments.context.pageData['showSpinner'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' ',''].join(''));
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, officeRecord, tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['showSpinner'] = true;
  officeRecord = ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})());
  tableName = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', null, officeRecord));
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_to', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_moved_from', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product')) {
    await Backendless.Data.of(tableName).setRelation((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')), 'link_product', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'))]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'product_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product_old')), officeRecord);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed'))) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_to_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_to')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'moved_from_changed')) {
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'old_link_moved_from')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
    await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')), officeRecord);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product.objectId')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from.objectId')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to.objectId'))) {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'filtered_table')), ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), '');
  }
  ___arguments.context.pageData['showSpinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var transaction_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    transaction_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null)), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'created DESC', null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in transaction_table) {
      j = transaction_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['datatable'] = transaction_table;
    ___arguments.context.pageData['filtered_table'] = transaction_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/e23b5e4167c7f645490d865b09a8f90f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'transaction_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/f8f2735b46daa93ccd0c3aae3fed08f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['moved_from_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_moved_from'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_from'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_from'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_from.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/b87a43e9fa7d4f0fe5fe9684008a4805/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['moved_to_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_moved_to'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_moved_to'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_to'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_moved_to.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--problemTransactions/components/6c27870a5354e714749ca60254959d23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['product_changed'] = true;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['old_link_product'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_product'));
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')['link_product.objectId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--products/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--products/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var productsTable, k, item, recentProdSales, recentSales, totalStock, inventory, discrepanciesObj, discreps, prodDisc, discrepanciesTable, itemNumber, j, theMatch, locationInventory, locationTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewProducts', null);
  ___arguments.context.pageData['productsLoadingSpinner'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Inventory Products';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  productsTable = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, 'active = true', 'product_name ASC', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  locationTable = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, 'active = true and isTracked=True', null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  discrepanciesTable = (await BackendlessUI.Functions.Custom['fn_63982c1ae3dbd4d57b645661584b971d'](null, (String('resolved=') + String(false)), null, null, 1, null, null, null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  recentSales = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('productTransaction_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()))), (['transaction_date > \'',((new Date((new Date()).getTime() - ((28 * 86400) * 1000))).valueOf()),'\' AND moved_to = \'Sold\'','','',''].join('')), null, null, null, ['link_location', 'link_product']));
  for (var k_index in productsTable) {
    k = productsTable[k_index];
    inventory = [];
    totalStock = 0;
    for (var j_index in locationTable) {
      j = locationTable[j_index];
      locationInventory = (getObjectProperty(j, 'inventory'));
      if (!(Array.isArray(locationInventory))) {
        locationInventory = [];
      }
      theMatch = (await asyncListFilter(locationInventory, async (item) => {


       return ((getObjectProperty(item, 'productObjId')) == (getObjectProperty(k, 'objectId')));
      }))[0];
      if (theMatch !== null && !Array.isArray(theMatch) && (typeof theMatch === 'object')) {
        itemNumber = (getObjectProperty(theMatch, 'totalItems'));
      } else {
        itemNumber = 0;
      }
      addItemToList(inventory, ({ 'location': (getObjectProperty(j, 'name')),'supply': itemNumber,'display': [(getObjectProperty(j, 'name')),' - ',itemNumber].join('') }));
      totalStock = (typeof totalStock == 'number' ? totalStock : 0) + itemNumber;
    }
    prodDisc = (await asyncListFilter(discrepanciesTable, async (item) => {


     return ((getObjectProperty(item, 'link_product.objectId')) == (getObjectProperty(k, 'objectId')));
    }));
    discrepanciesObj = [];
    if (prodDisc.length > 0) {
      for (var discreps_index in prodDisc) {
        discreps = prodDisc[discreps_index];
        addItemToList(discrepanciesObj, ({ 'product': (getObjectProperty(discreps, 'link_product.product_name')),'objectId': (getObjectProperty(discreps, 'objectId')),'location': (getObjectProperty(discreps, 'link_location.name')),'value': (getObjectProperty(discreps, 'system_count')) - (getObjectProperty(discreps, 'manual_count')) }));
      }
    }
    k['discrepancies'] = discrepanciesObj;
    k['inventory'] = (await asyncListSort(inventory, -1, async (item) => {


     return (getObjectProperty(item, 'supply'));
    }));
    k['totalStock'] = totalStock;
    recentProdSales = (await asyncListFilter(recentSales, async (item) => {


     return ((getObjectProperty(item, 'link_product.objectId')) == (getObjectProperty(k, 'objectId')));
    }));
    if (recentProdSales.length > 0) {
      k['recentSales'] = ((await Promise.all(recentProdSales.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;}));
    } else {
      k['recentSales'] = 0;
    }
  }
  ___arguments.context.pageData['productsData'] = productsTable;
  ___arguments.context.pageData['filteredProductsData'] = productsTable;
  ___arguments.context.pageData['productNames'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6'](productsTable, 'objectId', 'product_name'));
  ___arguments.context.pageData['productsLoadingSpinner'] = false;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--products/components/c44a09a18bc4b726c78a59f32a979be1/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'inventory')).length > 0 ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'inventory'))[0]), 'display')) : null)

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--products/components/41ceb876c134ba9ef21384175988e738/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'inventory')).length > 1 ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'inventory'))[1]), 'display')) : null)

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--products/components/25895a5a368fe804e4a97f9224aa5731/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'inventory')).length > 2 ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'inventory'))[2]), 'display')) : null)

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--products/components/5c4492bead17aa1ae73cf123f953cfcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--manageProducts', undefined);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
      return (!(await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'addProducts', true)))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory--products/components/f3e41467b546a301659760acdd01bb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'location')),' - ',(getObjectProperty(___arguments.context.dataModel, 'value'))].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inventory--products/components/b8e7ba724077c379254a06b37c884e7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--discrepancies', ({ 'selectedProductId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--products/components/ec2664fc6197be8c93b32a2185e45145/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--moveProduct', ({ 'selectedProductId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--products/components/50f17c6687c3ade1a7341509c63833e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--currentInventory', ({ 'selectedProductId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--products/components/23e4f668b7535b249fcf65d771739ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', ({ 'selectedProductId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2437102061748bf22cee3d4b26dd639'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--products/components/d63c7c5fc7e1652499acdfe8c2b50e48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, locationDropdown, locations, loggedInUser, productDropdown, products;


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Add Product';
  ___arguments.context.pageData['productMenuOpen'] = true;
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (String('active = ') + String(true)), 'product_name'));
  ___arguments.context.pageData['productData'] = products;
  productDropdown = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6'](products, 'objectId', 'product_name'));
  ___arguments.context.pageData['productDropdown'] = productDropdown;
  ___arguments.context.pageData['showError'] = false;
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUser'] = loggedInUser;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (String('active = ') + String(true)), 'name'));
  locationDropdown = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6'](locations, 'objectId', 'name'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef7d49e4a59152fe3236ec19b56c284e', [({ 'productName': null,'productDropdown': productDropdown,'numItems': null,'numCartons': null,'costPerItem': null,'totalItems': null,'totalPrice': null })]);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/0a42b893a12ba9febe2a02ce348240aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var productRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToCamelCase(str) {
 const words = str.split(/[-_\s]+/g).filter(item => item)

 const toTitle = words.map((item, index) => {
   if (index !== 0) {
     return item.substr(0, 1).toUpperCase() + item.substr(1).toLowerCase()
   }

   return item.toLowerCase()
 })

 return toTitle.join('')
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((await Backendless.Data.of('Products').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['product_name=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productName')),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['errorMessage'] = 'Product with this name already exists';
    ___arguments.context.pageData['showError'] = true;
  } else {
    productRecord = ({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'objectId')),'product_name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productName')),'RDG_cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'rdgCost')),'active': true,'productBarcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productBarcodeValue')),'cartonBarcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'cartonBarcodeValue')),'dealer_cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'costToDealer')),'DT_cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dtCost')),'items_per_carton': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'itemsPerCarton')),'price_to_customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'priceToCustomer')),'product_image': (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'imageUploaded')) === 'boolean') ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'imageUploaded')) ? (await Backendless.Files.renameFile( encodePath('/web/assets/images/product_images/temp'), encodePath((String('') + String(textToCamelCase(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productName'))))) )) : null) : null,'serialNumberRequired': (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'serialNumRequired')) === 'boolean') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'serialNumRequired')) : false });
    console.log(productRecord);
    await Backendless.Data.of('Products').save(productRecord, true);
    ___arguments.context.pageData['showError'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/a8bcd52fbfb26d0386d13718ccb655b3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/d91d8558c5ab55d65f6e72e80f858a1a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loggedInUser.fName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/31b917d9093146ccce26502279247e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loggedInUser.lName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/021a5f788f85db5d6ffd2f56b39944b9/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/4fb333db70cb07658e78b3e9745dd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var productDropdown;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ef7d49e4a59152fe3236ec19b56c284e')), ({ 'productName': null,'productDropdown': (getObjectProperty(___arguments.context.pageData, 'productDropdown')),'numItems': null,'numCartons': null,'costPerItem': null,'totalItems': null,'totalPrice': null }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/3a56da8e93eda2aaf14ccff1a24ceab5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ef7d49e4a59152fe3236ec19b56c284e')), ___arguments.context.getComponentDataStoreByUid('cf2f366c20aeabadadf965ed6a18bb7d'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/509bf5f8fe617cf1818913e3240af7cc/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['signatureFile'] = (await Backendless.Files.saveFile(encodePath('/'), 'signature.png', ___arguments['signature'], true));

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/inventory--purchaseRequest--dealer/components/a9cfc7b3b966fe3d27cf97ebe6dc4abb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Add Product';
  ___arguments.context.pageData['productMenuOpen'] = true;
  ___arguments.context.pageData['productData'] = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e']((getObjectProperty(___arguments.context.appData, 'officeObjId')), null, null));
  console.log(___arguments.context.appData);
  console.log(getObjectProperty(___arguments.context.appData, 'officeObjId'));
  ___arguments.context.pageData['needScan'] = false;
  ___arguments.context.pageData['showError'] = false;
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  console.log(loggedInUser);
  ___arguments.context.pageData['loggedInUser'] = loggedInUser;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef7d49e4a59152fe3236ec19b56c284e', [({ 'productName': null,'numItems': null,'numCartons': null,'costPerItem': null,'totalItems': null,'totalPrice': null })]);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/0a42b893a12ba9febe2a02ce348240aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var productRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToCamelCase(str) {
 const words = str.split(/[-_\s]+/g).filter(item => item)

 const toTitle = words.map((item, index) => {
   if (index !== 0) {
     return item.substr(0, 1).toUpperCase() + item.substr(1).toLowerCase()
   }

   return item.toLowerCase()
 })

 return toTitle.join('')
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((await Backendless.Data.of('Products').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['product_name=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productName')),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['errorMessage'] = 'Product with this name already exists';
    ___arguments.context.pageData['showError'] = true;
  } else {
    productRecord = ({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'objectId')),'product_name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productName')),'RDG_cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'rdgCost')),'active': true,'productBarcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productBarcodeValue')),'cartonBarcode': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'cartonBarcodeValue')),'dealer_cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'costToDealer')),'DT_cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'dtCost')),'items_per_carton': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'itemsPerCarton')),'price_to_customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'priceToCustomer')),'product_image': (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'imageUploaded')) === 'boolean') ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'imageUploaded')) ? (await Backendless.Files.renameFile( encodePath('/web/assets/images/product_images/temp'), encodePath((String('') + String(textToCamelCase(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'productName'))))) )) : null) : null,'serialNumberRequired': (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'serialNumRequired')) === 'boolean') ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'serialNumRequired')) : false });
    console.log(productRecord);
    await Backendless.Data.of('Products').save(productRecord, true);
    ___arguments.context.pageData['showError'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/a8bcd52fbfb26d0386d13718ccb655b3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/d91d8558c5ab55d65f6e72e80f858a1a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loggedInUser.fName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/31b917d9093146ccce26502279247e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loggedInUser.lName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/021a5f788f85db5d6ffd2f56b39944b9/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/4fb333db70cb07658e78b3e9745dd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ef7d49e4a59152fe3236ec19b56c284e')), ({ 'productName': null,'numItems': null,'numCartons': null,'costPerItem': null,'totalItems': null,'totalPrice': null }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--purchaseRequest--subOffice/components/3a56da8e93eda2aaf14ccff1a24ceab5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ef7d49e4a59152fe3236ec19b56c284e')), ___arguments.context.getComponentDataStoreByUid('cf2f366c20aeabadadf965ed6a18bb7d'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--snTracking/components/d04e158d896517fc21f67ab92e690923/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedLocationId'] = ___arguments.value;
  ___arguments.context.pageData['filteredSnTracking'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'filteredSnTracking')), async (item) => {


   return ((getObjectProperty(item, 'link_location.objectId')) == ___arguments.value);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--snTracking/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item, snTracking, locationList, j, locations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'snTracking', null);
  ___arguments.context.pageData['pageTitle'] = 'Serial Number Locations';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (String('isTracked=TRUE AND active = TRUE') + String('')), 'name'));
  locationList = [];
  snTracking = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), null, null, null, 'serial_number', ['link_location', 'link_transactions']));
  for (var j_index in locations) {
    j = locations[j_index];
    addItemToList(locationList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'type': (getObjectProperty(j, 'type')) }));
  }
  for (var j_index2 in snTracking) {
    j = snTracking[j_index2];
    if ((getObjectProperty(j, 'location')) != (getObjectProperty(j, 'link_location.name'))) {
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('sn inconsistent location in tracking table');
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(j, 'serial_number')));
    }
  }
  ___arguments.context.pageData['locationList'] = locationList;
  ___arguments.context.pageData['snTracking'] = snTracking;
  ___arguments.context.pageData['filteredSnTracking'] = snTracking;
  ___arguments.context.pageData['filteredSnTracking'] = snTracking;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--snTracking/components/819a0a05c22aed85446250cbe332b417/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteredSnTracking'] = (getObjectProperty(___arguments.context.pageData, 'snTracking'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--snTracking/components/77086c9344cf543793c8421394ae5455/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/inventory--snTracking/components/a527cfdfa762f311253392b3ad588f66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'last_moved')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory--snTracking/components/a1b84636b555aa0e94e4306e7a1d5869/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['serialNumber'] = ___arguments.value;
  ___arguments.context.pageData['filteredSnTracking'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'filteredSnTracking')), async (item) => {


   return ((getObjectProperty(item, 'serial_number')).indexOf(___arguments.value) !== -1);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--snTracking/components/4336f0744a52218fa1934d6833859d74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', ({ 'transactions': (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'link_transactions')), -1, async (item) => {


   return (getObjectProperty(item, 'transaction_date'));
  })) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--stockCount/components/d04e158d896517fc21f67ab92e690923/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedLocationId'] = ___arguments.value;
  ___arguments.context.pageData['productRepeaterOpen'] = true;
  ___arguments.context.pageData['locationType'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'type'));
  ___arguments.context.pageData['selectedLocation'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'label'));
  ___arguments.context.pageData['currentInventory'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'inventory'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--stockCount/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var productList, locationList, j, locations, products;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['pageTitle'] = 'Manual Inventory';
  ___arguments.context.pageData['productRepeaterOpen'] = false;
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (String('(type=\'Office\' OR type=\'Dealer\' OR type=\'Warehouse\') AND active = ') + String(true)), 'name'));
  locationList = [];
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (String('active = ') + String(true)), 'product_name'));
  productList = [];
  for (var j_index in products) {
    j = products[j_index];
    addItemToList(productList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')),'snRequired': (getObjectProperty(j, 'sn_required')),'count': undefined }));
  }
  for (var j_index2 in locations) {
    j = locations[j_index2];
    addItemToList(locationList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'type': (getObjectProperty(j, 'type')) }));
  }
  ___arguments.context.pageData['locationList'] = locationList;
  ___arguments.context.pageData['productCount'] = productList;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--stockCount/components/a5930e2cf12c4d467ec63c6e6de29813/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reportedCount, discrepancyRecord, discrepancyTable, j, systemCount, mismatchedSNs, snDiscrepancyExists, discrepancyExists, discrepancyCount, reportedSNs, systemSNs, SN, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  discrepancyTable = (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('discrepancy_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())));
  discrepancyCount = 0;
  var reportedCount_list = (getObjectProperty(___arguments.context.pageData, 'productCount'));
  for (var reportedCount_index in reportedCount_list) {
    reportedCount = reportedCount_list[reportedCount_index];
    discrepancyExists = false;
    snDiscrepancyExists = false;
    systemCount = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'currentInventory')), async (item) => {


     return ((getObjectProperty(item, 'productObjId')) == (getObjectProperty(reportedCount, 'value')));
    }));
    if (systemCount.length == 0) {
      if (!((getObjectProperty(reportedCount, 'count')) == 0)) {
        discrepancyExists = true;
      }
    } else {
      systemCount = systemCount[0];
      if ((getObjectProperty(reportedCount, 'count')) != (getObjectProperty(systemCount, 'totalItems'))) {
        discrepancyExists = true;
      }
      if ((getObjectProperty(reportedCount, 'snRequired')) && (getObjectProperty(___arguments.context.pageData, 'locationType')) == 'Dealer') {
        mismatchedSNs = [];
        systemSNs = (getObjectProperty(systemCount, 'serialNumber'));
        reportedSNs = [];
        var j_list = (getObjectProperty(reportedCount, 'serialNumbers'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          SN = String(getObjectProperty(j, 'serialNum'));
          addItemToList(reportedSNs, SN);
          if (!(systemSNs.includes(SN))) {
            snDiscrepancyExists = true;
            addItemToList(mismatchedSNs, ({ 'systemSN': undefined,'manualSN': SN }));
          }
        }
        for (var j_index2 in systemSNs) {
          j = systemSNs[j_index2];
          if (!(reportedSNs.includes(j))) {
            snDiscrepancyExists = true;
            addItemToList(mismatchedSNs, ({ 'systemSN': j,'manualSN': undefined }));
          }
        }
      }
    }
    if (discrepancyExists) {
      discrepancyCount = (typeof discrepancyCount == 'number' ? discrepancyCount : 0) + 1;
    }
    if (discrepancyExists && !snDiscrepancyExists) {
      discrepancyRecord = (await Backendless.Data.of(discrepancyTable).save(({ 'date_of_count': (new Date()),'manual_count': (Number((getObjectProperty(reportedCount, 'count')))),'system_count': (Number((getObjectProperty(systemCount, 'totalItems')))) }), true));
      await Backendless.Data.of(discrepancyTable).addRelation(discrepancyRecord, 'link_location', [(getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))]);
      await Backendless.Data.of(discrepancyTable).addRelation(discrepancyRecord, 'link_product', [(getObjectProperty(reportedCount, 'value'))]);
    } else if (snDiscrepancyExists) {
      for (var j_index3 in mismatchedSNs) {
        j = mismatchedSNs[j_index3];
        discrepancyRecord = (await Backendless.Data.of(discrepancyTable).save(({ 'date_of_count': (new Date()),'manual_count': (Number((getObjectProperty(reportedCount, 'count')))),'system_count': (Number((getObjectProperty(systemCount, 'totalItems')))),'manual_SN': (getObjectProperty(j, 'manualSN')),'system_SN': (getObjectProperty(j, 'systemSN')) }), true));
        await Backendless.Data.of(discrepancyTable).addRelation(discrepancyRecord, 'link_location', [(getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))]);
        await Backendless.Data.of(discrepancyTable).addRelation(discrepancyRecord, 'link_product', [(getObjectProperty(reportedCount, 'value'))]);
      }
    } else {
    }
  }
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('620a72532e747b5bb0323966b63cf7f6', undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--stockCount/components/fdec9c3438fc81675203e75148484f1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var serialNums, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413'), 'snRequired')) && (getObjectProperty(___arguments.context.pageData, 'locationType')) == 'Dealer') {
    serialNums = [];
    if (___arguments.value > 0) {
      var i_end = ___arguments.value;
      var i_inc = 1;
      if (1 > i_end) {
        i_inc = -i_inc;
      }
      for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
        addItemToList(serialNums, ({ 'serialNum': '' }));
      }
    }
    ___arguments.context.getComponentDataStoreByUid('d4991e2b5dca0dcd740bc9a86e188413')['serialNumbers'] = serialNums;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var movements, serialNums, k, j, snfromRecord, productList, locationList, products, locations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting on page enter');
  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewTransactions', null);
  ___arguments.context.pageData['showDeleteConfirmation'] = false;
  ___arguments.context.pageData['recalcRunning'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Inventory Transactions';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](null, (String('active=') + String(true)), 'name', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  locationList = [];
  for (var j_index in locations) {
    j = locations[j_index];
    addItemToList(locationList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')) }));
  }
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, (String('active=') + String(true)), 'product_name', ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  productList = [];
  for (var j_index2 in products) {
    j = products[j_index2];
    addItemToList(productList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')),'serialNumberRequired': (getObjectProperty(j, 'sn_required')) }));
  }
  ___arguments.context.pageData['locationList'] = locationList;
  ___arguments.context.pageData['productList'] = productList;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageSize'] = 20;
  ___arguments.context.pageData['recordCount'] = (await Backendless.Data.of((getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'productTransaction_table'))).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(link_moved_to.name is not null',' AND link_moved_from.name is not null',' AND link_product.product_name is not null)',''].join('')))));
  movements = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (['(link_moved_to.name is not null',' AND link_moved_from.name is not null',' AND link_product.product_name is not null)',''].join('')), 'transaction_date desc', ['link_moved_to', 'link_moved_from', 'link_product'], 1, (getObjectProperty(___arguments.context.pageData, 'pageSize')), (getObjectProperty(___arguments.context.pageData, 'offset')), false, null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
  ___arguments.context.pageData['allInventoryTransactions'] = movements;
  serialNums = [];
  for (var j_index3 in movements) {
    j = movements[j_index3];
    snfromRecord = (getObjectProperty(j, 'serial_numbers'));
    if (Array.isArray(snfromRecord)) {
      for (var k_index in snfromRecord) {
        k = snfromRecord[k_index];
        addItemToList(serialNums, ({ 'value': (getObjectProperty(j, 'objectId')),'label': String(k) }));
      }
    }
  }
  ___arguments.context.pageData['serialNumbers'] = serialNums;
  ___arguments.context.pageData['allSNs'] = serialNums;
  if (getObjectProperty(___arguments.context.pageData, 'transactions')) {
    ___arguments.context.pageData['selectedInventoryTransactions'] = (getObjectProperty(___arguments.context.pageData, 'transactions'));
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string') && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string')) {
    ___arguments.context.pageData['recalcFilter'] = true;
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string') {
    ___arguments.context.pageData['recalcFilter'] = true;
    ___arguments.context.pageData['runningTotal'] = false;
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string') {
    ___arguments.context.pageData['recalcFilter'] = true;
    ___arguments.context.pageData['runningTotal'] = false;
  } else {
    ___arguments.context.pageData['selectedInventoryTransactions'] = movements;
    ___arguments.context.pageData['runningTotal'] = false;
  }
  ___arguments.context.pageData['recalcRunning'] = false;
  await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end on page enter');

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['serialNumber'] = '';
  ___arguments.context.pageData['results'] = 'Enter serial number to see summary';
  ___arguments.context.pageData['tableVisibility'] = false;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory--transactions/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/92d4c61df5ba5f6dd98d508792c5472d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedProduct, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedProductId'] = ___arguments.value;
  selectedProduct = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'productList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['selectedProduct'] = (getObjectProperty(selectedProduct, 'label'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/452b61a1ffddd7e3276a10abc09f2092/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedRecord, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['selectedLocationId'] = ___arguments.value;
  selectedRecord = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'locationList')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['selectedLocation'] = (getObjectProperty(selectedRecord, 'label'));
  ___arguments.context.pageData['locationInventory'] = (getObjectProperty(selectedRecord, 'inventory'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/a5ef4ea1dedabb8cfff6e182e435a59c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string') && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string');

  return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var j, whereClause, transactions, total, item, movements, matchingObjIds, serialNumbers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'recalcFilter')) {
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('starting recalc in repeater logic');
    ___arguments.context.pageData['recalcFilter'] = false;
    ___arguments.context.pageData['recalcRunning'] = true;
    whereClause = [['(link_moved_to.name is not null',' AND link_moved_from.name is not null',' AND link_product.product_name is not null)',''].join('')];
    if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) === 'string') {
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((getObjectProperty(___arguments.context.pageData, 'selectedProductId')));
      addItemToList(whereClause, (['link_product.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'selectedProductId')),'\''].join('')));
    }
    if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) === 'string') {
      addItemToList(whereClause, (['(link_moved_from.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'selectedLocationId')),'\' OR link_moved_to.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'selectedLocationId')),'\')'].join('')));
    }
    if ((typeof (getObjectProperty(___arguments.context.pageData, 'selectedSerialNumber')) === 'string') && (getObjectProperty(___arguments.context.pageData, 'selectedSerialNumber')).length == 8) {
      serialNumbers = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allSNs')), async (item) => {


       return ((getObjectProperty(item, 'label')).indexOf((getObjectProperty(___arguments.context.pageData, 'selectedSerialNumber'))) !== -1);
      }));
      matchingObjIds = (await Promise.all(serialNumbers.map(async item => {; return (getObjectProperty(item, 'value'));})));
      addItemToList(whereClause, (['objectId in (\'',matchingObjIds.join('\', \''),'\')'].join('')));
    }
    if (getObjectProperty(___arguments.context.pageData, 'startDate')) {
      addItemToList(whereClause, (String('transaction_date>=') + String((getObjectProperty(___arguments.context.pageData, 'startDate')).valueOf())));
    }
    if (getObjectProperty(___arguments.context.pageData, 'endDate')) {
      addItemToList(whereClause, (String('transaction_date<=') + String((getObjectProperty(___arguments.context.pageData, 'endDate')).valueOf())));
    }
    if (getObjectProperty(___arguments.context.pageData, 'runningTotal')) {
      ___arguments.context.pageData['calcFinished'] = false;
      transactions = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (whereClause.join(' AND ')), 'transaction_date', ['link_moved_to', 'link_moved_from', 'link_product'], 1, null, (getObjectProperty(___arguments.context.pageData, 'offset')), true, null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
      total = 0;
      for (var j_index in transactions) {
        j = transactions[j_index];
        if ((getObjectProperty(j, 'link_moved_to.objectId')) == (getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))) {
          total = (typeof total == 'number' ? total : 0) + (getObjectProperty(j, 'num_items'));
          j['runningTotal'] = total;
        } else if ((getObjectProperty(j, 'link_moved_from.objectId')) == (getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))) {
          total = (typeof total == 'number' ? total : 0) + -(getObjectProperty(j, 'num_items'));
          j['runningTotal'] = total;
        }
      }
      ___arguments.context.pageData['transactionCount'] = total;
      ___arguments.context.pageData['inventoryCount'] = (await BackendlessUI.Functions.Custom['fn_f297f5de05e3421f5273f84e498e98c4']((getObjectProperty(___arguments.context.pageData, 'selectedLocationId')), (getObjectProperty(___arguments.context.pageData, 'selectedProductId')), (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('location_table', null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())))));
      await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']((String('inventory count is now: ') + String(getObjectProperty(___arguments.context.pageData, 'inventoryCount'))));
      ___arguments.context.pageData['calcFinished'] = true;
      ___arguments.context.pageData['selectedInventoryTransactions'] = transactions;
    } else {
      ___arguments.context.pageData['selectedInventoryTransactions'] = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (whereClause.join(' AND ')), 'transaction_date desc', ['link_moved_to', 'link_moved_from', 'link_product'], 1, (getObjectProperty(___arguments.context.pageData, 'pageSize')), (getObjectProperty(___arguments.context.pageData, 'offset')), null, null, null, ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})())));
    }
    if (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')) {
      var j_list = (getObjectProperty(___arguments.context.pageData, 'selectedInventoryTransactions'));
      for (var j_index2 in j_list) {
        j = j_list[j_index2];
        if ((getObjectProperty(j, 'link_moved_to.objectId')) == (getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))) {
          j['background'] = '#d9ffcb';
        } else if ((getObjectProperty(j, 'link_moved_from.objectId')) == (getObjectProperty(___arguments.context.pageData, 'selectedLocationId'))) {
          j['background'] = '#f5ced2';
        } else {
          j['background'] = '#888888';
        }
      }
    } else {
    }
    ___arguments.context.pageData['recalcRunning'] = false;
    await BackendlessUI.Functions.Custom['fn_df46701cdb431c7eb27cb5c3b47677e9']('end recalc in repeater logic');
  }

  return (getObjectProperty(___arguments.context.pageData, 'selectedInventoryTransactions'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/1666868ee0326486db02f43a3372418f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'transaction_date')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'transaction_date')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'transaction_date_generated')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/6f0fcf49914c3fc4dd1981a405025b0e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var startDate;


  startDate = (new Date(___arguments.value));
  startDate.setHours(0);
  startDate.setMinutes(0);
  ___arguments.context.pageData['startDate'] = startDate;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/fc9e6aa8bf4ff79af751787c3b7e2959/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var endDate;


  endDate = (new Date(___arguments.value));
  endDate.setHours(24);
  ___arguments.context.pageData['endDate'] = endDate;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/cd819b2dbbcfe98472f3071c98098504/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedLocationId'] = undefined;
  ___arguments.context.pageData['selectedProductId'] = undefined;
  ___arguments.context.pageData['startDate'] = undefined;
  ___arguments.context.pageData['startDateVal'] = undefined;
  ___arguments.context.pageData['endDate'] = undefined;
  ___arguments.context.pageData['endDateVal'] = undefined;
  ___arguments.context.pageData['endDateVal'] = undefined;
  ___arguments.context.pageData['selectedInventoryTransactions'] = (getObjectProperty(___arguments.context.pageData, 'allInventoryTransactions'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/8fc4c3242aa292dc17436c8ff82736fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var snObject, j, serialNumbers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  serialNumbers = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'serialNumbers')), async (item) => {


   return ((String(getObjectProperty(item, 'label'))).indexOf((String(___arguments.value))) !== -1);
  })).slice(0, 5);
  snObject = [];
  for (var j_index in serialNumbers) {
    j = serialNumbers[j_index];
    addItemToList(snObject, ({ 'serialNumber': (getObjectProperty(j, 'label')),'transObjId': (getObjectProperty(j, 'value')) }));
  }
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['filteredSerialNumbers'] = snObject;
  ___arguments.context.pageData['autoCompleteMenu'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/3b945e121711fdca065d257d27bbc184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedSerialNumber'] = (String(getObjectProperty(___arguments.context.dataModel, 'serialNumber')));
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['autoCompleteMenu'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/8d01c277f8f51ecb08abf60a7de8cec6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/ff64ce3e81d76ad291920ac92f4c0abc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedLocation')) && (getObjectProperty(___arguments.context.pageData, 'selectedProduct')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['startDate'] = (new Date(1679382000000));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory--transactions/components/01978537483111aab84b6d02b288d3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'runningTotal'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/97abb2a15a26c3bfdf5820573225f9e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) ? String('Total in inventory count: ') + String(getObjectProperty(___arguments.context.pageData, 'inventoryCount')) : null)

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) && (typeof (getObjectProperty(___arguments.context.pageData, 'inventoryCount')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'inventoryCount')))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/59a67b1b36084846c3eb11af053b9af9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) ? String('Number in stock: ') + String(getObjectProperty(___arguments.context.pageData, 'transactionCount')) : null)

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'runningTotal')) && (typeof (getObjectProperty(___arguments.context.pageData, 'transactionCount')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'transactionCount')))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/c29671cafacfe1722291c92f0576875c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['recalcRunning'] = true;
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(___arguments.context.pageData, 'selectedLocationId')), (getObjectProperty(___arguments.context.pageData, 'selectedProductId')), ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), null);
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['recalcRunning'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/8741cd4d6c2b9de4a2c9a6395b95f61c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'calcFinished')) && (getObjectProperty(___arguments.context.pageData, 'inventoryCount')) != (getObjectProperty(___arguments.context.pageData, 'transactionCount')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/a1c95d95f6b24dc240cc670ea0a524b8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1c95d95f6b24dc240cc670ea0a524b8'))['background'] = (getObjectProperty(___arguments.context.dataModel, 'background'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory--transactions/components/33929a683aafb6fcc781a7e75825d4c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['offset'] = (Math.min(Math.max((getObjectProperty(___arguments.context.pageData, 'offset')) + (getObjectProperty(___arguments.context.pageData, 'pageSize')), 0), (getObjectProperty(___arguments.context.pageData, 'recordCount'))));
  ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/27a63db69701403b3b428fe5cd5265d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'offset')) > 0) {
    ___arguments.context.pageData['offset'] = (Math.min(Math.max((getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'pageSize')), 0), (getObjectProperty(___arguments.context.pageData, 'recordCount'))));
    ___arguments.context.pageData['recalcFilter'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/47d46cdeb0e669ed907fb35bff85336a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8'), 'created')) > (new Date((new Date()).getTime() - ((30 * 86400) * 1000))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedTransaction'] = ___arguments.context.getComponentDataStoreByUid('a1c95d95f6b24dc240cc670ea0a524b8');
  ___arguments.context.pageData['showDeleteConfirmation'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/f5792afcef268aac736461490a9e8d28/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var objId, transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['recalcRunning'] = true;
  ___arguments.context.pageData['showDeleteConfirmation'] = false;
  transaction = (getObjectProperty(___arguments.context.pageData, 'selectedTransaction'));
  objId = (getObjectProperty(transaction, 'objectId'));
  transaction['office'] = (getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'office_name'));
  delete transaction['__class'];
  await Backendless.Data.of('deleted_transactions').save(transaction, true);
  await Backendless.Data.of((getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'productTransaction_table'))).remove( objId );
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(transaction, 'link_moved_from.objectId')), (getObjectProperty(transaction, 'link_product.objectId')), null);
  await BackendlessUI.Functions.Custom['fn_90fb765ea35541d287fb79730556c53a'](null, null, (getObjectProperty(transaction, 'link_moved_to.objectId')), (getObjectProperty(transaction, 'link_product.objectId')), null);
  ___arguments.context.pageData['recalcFilter'] = true;
  ___arguments.context.pageData['recalcRunning'] = false;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['selectedTransaction'] = undefined;
  ___arguments.context.pageData['showDeleteConfirmation'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory--transactions/components/f6a4165a1ed1ddc45b26270a0e421341/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--problemTransactions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory--transactions/components/610747849816d017b29713041d8d7753/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['recalcFilter'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-addBarcode/components/996ecb3745de8e16602c3efa1965f6a5/bundle.js', [], () => ({
  /* content */
  /* handler:onGetBarcode */
  ['onGetBarcode'](___arguments) {
      ___arguments.context.pageData['barcodeValue'] = ___arguments['barcode'];

  },
  /* handler:onGetBarcode */
  /* content */
}))

define('./pages/inventory-addBarcode/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var productOptions, j, products;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  products = (await Backendless.Data.of('Products').find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=\'TRUE\''))).setPageSize(100)));
  productOptions = [];
  for (var j_index in products) {
    j = products[j_index];
    addItemToList(productOptions, ({ 'label': (getObjectProperty(j, 'product_name')),'value': (getObjectProperty(j, 'objectId')) }));
  }
  console.log(productOptions);
  ___arguments.context.pageData['currentProducts'] = productOptions;
  ___arguments.context.pageData['barcodeValue'] = '';
  ___arguments.context.pageData['productId'] = '';
  ___arguments.context.pageData['productNameNew'] = '';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/inventory-addBarcode/components/9083e8fd384cdac2c486ee2a14097eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Products').save(({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'productId')),'barcode': (getObjectProperty(___arguments.context.pageData, 'barcodeValue')) }), true);
  ___arguments.context.pageData['existingText'] = (['Added barcode ',(getObjectProperty(___arguments.context.pageData, 'barcodeValue')),'to product ',(getObjectProperty(___arguments.context.pageData, 'productId'))].join(''));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'barcodeValue')) != '' && (getObjectProperty(___arguments.context.pageData, 'productId')) != '')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-addBarcode/components/a31e83a8989dd3bcdfa7de44c08b8871/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['productId'] = ___arguments.value;
  console.log(___arguments.value);
  ___arguments.context.pageData['productNameNew'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-addBarcode/components/32c1a2e3639f8475764e3fd8b6589fd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'barcodeValue')) != '' && (getObjectProperty(___arguments.context.pageData, 'productNameNew')) != '')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Products').save(({ 'product_name': (getObjectProperty(___arguments.context.pageData, 'productNameNew')),'barcode': (getObjectProperty(___arguments.context.pageData, 'barcodeValue')) }), true);
  ___arguments.context.pageData['newText'] = (['Added product ',(getObjectProperty(___arguments.context.pageData, 'productNameNew')),' with barcode ',(getObjectProperty(___arguments.context.pageData, 'barcodeValue'))].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-addBarcode/components/35bdc19d070fdbab4428cb77a7bd62cf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['productNameNew'] = ___arguments.value;
  ___arguments.context.pageData['productId'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-addBarcode/components/0928c74e23f5b1ed792fecf87a6c61b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['barcodeValue'] = '';
  ___arguments.context.pageData['productNameExisting'] = '';
  ___arguments.context.pageData['productNameNew'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/issue--report/components/aafe3e91ff47675bb259bcdb1665381e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/issue--report/components/66c95312e4f6a85cad5854ae013587d4/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Bug_reports').save(({ 'reported_name': (getObjectProperty(___arguments.context.dataModel, 'reportBug--name')),'reported_email': (getObjectProperty(___arguments.context.dataModel, 'reportBug--email')),'source_page': (getObjectProperty(___arguments.context.dataModel, 'reportBug--sourcePage')),'issue_description': (getObjectProperty(___arguments.context.dataModel, 'reportBug--bugDescription')),'issue_priority': (getObjectProperty(___arguments.context.dataModel, 'reportBug--bugPriority')),'issue_cause': (getObjectProperty(___arguments.context.dataModel, 'reportBug--causeBug')),'issue_what_happened': (getObjectProperty(___arguments.context.dataModel, 'reportBug--whatHappened')),'issue_expected_to_happen': (getObjectProperty(___arguments.context.dataModel, 'reportBug--expectToHappen')),'issue_error': (getObjectProperty(___arguments.context.dataModel, 'reportBug--errorCode')),'screenshot': (getObjectProperty(___arguments.context.dataModel, 'reportBug--uploadScreenshot')),'inform_user': (getObjectProperty(___arguments.context.dataModel, 'reportBug--keepInformed')),'full_error': (getObjectProperty(___arguments.context.dataModel, 'reportBug--fullError')) }), true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('131a6cab39bb24960fad5b6c687f0175');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/issue--report/components/131a6cab39bb24960fad5b6c687f0175/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Afterglow H20';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Afterglow H20';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'D207FF49-2099-452D-863D-D82B962D04A2\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'D207FF49-2099-452D-863D-D82B962D04A2\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--afterglowh20/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Polar_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'27F4F97D-68A4-4EFD-B791-B920B2AF4307\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'27F4F97D-68A4-4EFD-B791-B920B2AF4307\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--alaskaunlimited/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Alpha Systems';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Alpha Systems';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'CCCC7431-0A24-4D55-B0A4-AC156898CC01\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'CCCC7431-0A24-4D55-B0A4-AC156898CC01\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--alphasystems/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--alphasystems/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - AquaFlow Solutions';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - AquaFlow Solutions';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'47BF9112-F8DF-49B8-B5F9-C875BD9F694D\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 20000;
  ___arguments.context.pageData['compSliderTimer'] = 20000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group1active'] = true;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 10; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dealers/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - AquaFlow Solutions';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - AquaFlow Solutions';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'47BF9112-F8DF-49B8-B5F9-C875BD9F694D\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'47BF9112-F8DF-49B8-B5F9-C875BD9F694D\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 2;

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 120000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--aquaflow--dm/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Breathe Easy Idaho';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Breathe Easy Idaho';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'DF3593AC-277A-46E0-9EFE-18DDB92B6645\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  console.log(dealerRecords);
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'DF3593AC-277A-46E0-9EFE-18DDB92B6645\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--breatheeasy/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Afterglow H20';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Afterglow H20';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'8E0A1307-801D-4709-9E00-DCFA262FA434\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'8E0A1307-801D-4709-9E00-DCFA262FA434\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--cleanairbenefits/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'DCD8D805-7A7D-474F-B507-4C2AC9A5AA42\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 20000;
  ___arguments.context.pageData['compSliderTimer'] = 20000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group1active'] = true;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 10; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dealers/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'DCD8D805-7A7D-474F-B507-4C2AC9A5AA42\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'DCD8D805-7A7D-474F-B507-4C2AC9A5AA42\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 2;

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 120000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--cleanhealthyhomes--dm/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['allDealersRepeater'] = teamTotals;
  ___arguments.context.pageData['dealerPage1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealersRepeater')).slice(0, 8));
  ___arguments.context.pageData['dealerPage2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealersRepeater')).slice(8, 16));
  ___arguments.context.pageData['dealerPage3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealersRepeater')).slice(16, 24));
  ___arguments.context.pageData['dealerPage4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealersRepeater')).slice(24, 32));
  console.log('number of dealers');
  console.log((getObjectProperty(___arguments.context.pageData, 'allDealersRepeater')).length);
  console.log('page 1');
  console.log(getObjectProperty(___arguments.context.pageData, 'dealerPage1'));
  console.log('page 2');
  console.log(getObjectProperty(___arguments.context.pageData, 'dealerPage2'));
  console.log('page 3');
  console.log(getObjectProperty(___arguments.context.pageData, 'dealerPage3'));
  console.log('page 4');
  console.log(getObjectProperty(___arguments.context.pageData, 'dealerPage4'));
  ___arguments.context.pageData['numberDealers'] = ((getObjectProperty(___arguments.context.pageData, 'allDealersRepeater')).length);
  ___arguments.context.pageData['numberSlides'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'numberDealers')) / 8));
  console.log('number of slides');
  console.log(getObjectProperty(___arguments.context.pageData, 'numberSlides'));
  ___arguments.context.pageData['timePerSlide'] = (36000 / (getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  console.log('time per slide');
  console.log(getObjectProperty(___arguments.context.pageData, 'timePerSlide'));
  for (var count = 0; count < 10; count++) {
    ___arguments.context.pageData['slide4'] = false;
    ___arguments.context.pageData['slide1'] = true;
    await new Promise(r => setTimeout(r, 5000 || 0));
    ___arguments.context.pageData['slide1'] = false;
    ___arguments.context.pageData['slide2'] = true;
    await new Promise(r => setTimeout(r, 5000 || 0));
    ___arguments.context.pageData['slide2'] = false;
    ___arguments.context.pageData['slide3'] = true;
    await new Promise(r => setTimeout(r, 5000 || 0));
    ___arguments.context.pageData['slide3'] = false;
    ___arguments.context.pageData['slide4'] = true;
    await new Promise(r => setTimeout(r, 5000 || 0));
  }

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 600000;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  }
  ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
  console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
  ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
  }));
  console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
  ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
  ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
  ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
  ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
  console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--dashboard--pagination/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Dream Team Division';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Dream Team Division';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link in (\'DCD8D805-7A7D-474F-B507-4C2AC9A5AA42\' ,\'E4397413-FCFE-4053-BA95-71DC2C386897\',\'47BF9112-F8DF-49B8-B5F9-C875BD9F694D\')','and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  console.log(dealerRecords);
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'DCD8D805-7A7D-474F-B507-4C2AC9A5AA42\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 2;

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 120000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--dreamTeam--dm/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Indoor Rain';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Indoor Rain';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'EBE84AA4-F7B9-44E9-84F5-2D72338919B4\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  console.log(dealerRecords);
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'EBE84AA4-F7B9-44E9-84F5-2D72338919B4\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--indoorrain/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--indoorrain/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--master/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'DCD8D805-7A7D-474F-B507-4C2AC9A5AA42\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 3000;
  ___arguments.context.pageData['compSliderTimer'] = 3000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--master/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--master/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--master/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--master/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--master/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--master/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--master/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--master/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--master/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--master/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - Mother Natures Clean';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - Mother Natures Clean';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'E4397413-FCFE-4053-BA95-71DC2C386897\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 20000;
  ___arguments.context.pageData['compSliderTimer'] = 20000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group1active'] = true;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 10; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dealers/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Dream_Team_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'E4397413-FCFE-4053-BA95-71DC2C386897\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'E4397413-FCFE-4053-BA95-71DC2C386897\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 2;

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 120000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--mothernatures--dm/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser, item, allDealerAptTotals, teamTotals, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, i, dailyTotalScore, dailyscore, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dailyAppointmentTotal, j, dailyIndTotals, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, dealerScore, subs, sales, demos, apts, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competition Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
      console.log(getObjectProperty(j, 'dealer_name'));
      console.log(i);
      console.log(apts);
      console.log(allDealerAptTotals);
      console.log(dealerAppointmentsTotal);
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['cynthiaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['cynthiaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['roseTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['roseRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['joshTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['joshRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['warnerRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'BCB5F61B-690B-4AF4-BEC9-2A60122FC93D');
  }));
  ___arguments.context.pageData['erikaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['erikaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['emilieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['emilieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['jonTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['jonRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['vitaliyTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FD7720E0-435E-4755-8147-162C754A4F29');
  }));
  ___arguments.context.pageData['stephanieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20');
  }));
  ___arguments.context.pageData['stephanieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20' && (getObjectProperty(item, 'dealerObjectId')) != '2E0EEC74-2003-4080-BD91-3B0923786ED2' || (getObjectProperty(item, 'dealerObjectId')) == 'B5A14271-2E38-43EF-8649-595CDA51B9F1');
  }));
  ___arguments.context.pageData['taraTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['taraRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['neoOfficeLeader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/kpi--neodivision/components/14eea1a13be69f63140c2b7eae37d2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'appointmentsLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser, item, allDealerAptTotals, teamTotals, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, i, dailyTotalScore, dailyscore, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dailyAppointmentTotal, j, dailyIndTotals, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, dealerScore, subs, sales, demos, apts, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competition Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
      console.log(getObjectProperty(j, 'dealer_name'));
      console.log(i);
      console.log(apts);
      console.log(allDealerAptTotals);
      console.log(dealerAppointmentsTotal);
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['cynthiaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['cynthiaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['roseTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['roseRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['joshTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['joshRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['warnerRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'BCB5F61B-690B-4AF4-BEC9-2A60122FC93D');
  }));
  ___arguments.context.pageData['erikaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['erikaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['emilieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['emilieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['jonTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['jonRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['vitaliyTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FD7720E0-435E-4755-8147-162C754A4F29');
  }));
  ___arguments.context.pageData['stephanieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20');
  }));
  ___arguments.context.pageData['stephanieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20' && (getObjectProperty(item, 'dealerObjectId')) != '2E0EEC74-2003-4080-BD91-3B0923786ED2' || (getObjectProperty(item, 'dealerObjectId')) == 'B5A14271-2E38-43EF-8649-595CDA51B9F1');
  }));
  ___arguments.context.pageData['taraTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['taraRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['neoOfficeLeader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/14eea1a13be69f63140c2b7eae37d2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'appointmentsLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, femaleDealersWithScores, maleDealersWithScores, j, thisMonthsSubmissionsTotal, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, maleDealers, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ [`day`]: 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ [`day`]: 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ [`day`]: i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ [`day`]: i,[`appointments`]: apts,[`demos`]: demos,[`sales`]: sales,[`submissions`]: subs,[`recruits`]: subs }));
      } else {
        addItemToList(dealerScore, ({ [`day`]: i,[`appointments`]: undefined,[`demos`]: undefined,[`sales`]: undefined,[`submissions`]: undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ [`dealerName`]: (getObjectProperty(j, 'dealer_name')),[`recruitedBy`]: (getObjectProperty(j, 'recruited_by.objectId')),[`teamLeader`]: (getObjectProperty(j, 'team_leader.objectId')),[`dealerObjectId`]: (getObjectProperty(j, 'objectId')),[`scores`]: dealerScore,[`appointmentsTotal`]: dealerAppointmentsTotal,[`demosTotal`]: dealerDemosTotal,[`salesTotal`]: dealerSalesTotal,[`submissionsTotal`]: dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ [`appointments`]: allDealerAptTotals[(i - 1)],[`demos`]: allDealersDemosTotal[(i - 1)],[`sales`]: allDealersSalesTotals[(i - 1)],[`submissions`]: allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ [`day`]: 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['cynthiaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['cynthiaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['roseTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['roseRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['joshTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['joshRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['warnerRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'BCB5F61B-690B-4AF4-BEC9-2A60122FC93D');
  }));
  ___arguments.context.pageData['erikaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['erikaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['emilieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['emilieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['jonTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['jonRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['vitaliyTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FD7720E0-435E-4755-8147-162C754A4F29');
  }));
  ___arguments.context.pageData['stephanieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20');
  }));
  ___arguments.context.pageData['stephanieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20' && (getObjectProperty(item, 'dealerObjectId')) != '2E0EEC74-2003-4080-BD91-3B0923786ED2' || (getObjectProperty(item, 'dealerObjectId')) == 'B5A14271-2E38-43EF-8649-595CDA51B9F1');
  }));
  ___arguments.context.pageData['taraTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['taraRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['neoOfficeLeader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ [`year`]: 'numeric',[``]: undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`month`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ [`day`]: '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    j['dealerTotalAppointments'] = 0;
    j['dealerTotalDemos'] = 0;
    j['dealerTotalSales'] = 0;
    j['dealerTotalSubmissions'] = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  for (var j_index4 in dealersWithScores) {
    j = dealersWithScores[j_index4];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  maleDealersWithScores = (await asyncListFilter(dealersWithScores, async (item) => {


   return ((getObjectProperty(item, 'dealer_gender')) == 'Male');
  }));
  console.log(maleDealersWithScores);
  femaleDealersWithScores = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'dealer_gender')) == 'Female' && (getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  ___arguments.context.pageData['maleDealerDemos'] = ((maleDealersWithScores.map(item => item['dealerTotalDemos'])).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['maleDealerSales'] = ((maleDealersWithScores.map(item => item['dealerTotalSales'])).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['maleDealerSubmissions'] = ((maleDealersWithScores.map(item => item['dealerTotalSubmissions'])).reduce(function(x, y) {return x + y;}));
  console.log('######DEBUGFINAL####');
  console.log(getObjectProperty(___arguments.context.pageData, 'maleDealerDemos'));
  console.log(getObjectProperty(___arguments.context.pageData, 'maleDealerSales'));
  console.log(getObjectProperty(___arguments.context.pageData, 'maleDealerSubmissions'));
  ___arguments.context.pageData['femaleDealerDemos'] = ((femaleDealersWithScores.map(item => item['dealerTotalDemos'])).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['femaleDealerSales'] = ((femaleDealersWithScores.map(item => item['dealerTotalSales'])).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['femaleDealerSubmissions'] = ((femaleDealersWithScores.map(item => item['dealerTotalSubmissions'])).reduce(function(x, y) {return x + y;}));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['activeSlide'] = 2;

    };

    const timerId = 'slide2';
    const timerDelay = 80000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['activeSlide'] = 1;

    };

    const timerId = 'slide1';
    const timerDelay = 160000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 600000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--dark/components/4978c132390d9cd50c0ea54b611a670f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 3) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['cynthiaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['cynthiaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['roseTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['roseRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['joshTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['joshRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['warnerRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'BCB5F61B-690B-4AF4-BEC9-2A60122FC93D');
  }));
  ___arguments.context.pageData['erikaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['erikaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['emilieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['emilieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['jonTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['jonRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['vitaliyTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FD7720E0-435E-4755-8147-162C754A4F29');
  }));
  ___arguments.context.pageData['stephanieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20');
  }));
  ___arguments.context.pageData['stephanieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20' && (getObjectProperty(item, 'dealerObjectId')) != '2E0EEC74-2003-4080-BD91-3B0923786ED2' || (getObjectProperty(item, 'dealerObjectId')) == 'B5A14271-2E38-43EF-8649-595CDA51B9F1');
  }));
  ___arguments.context.pageData['taraTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['taraRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['neoOfficeLeader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'noActiveComps')) == true) {
  } else {
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['activeSlide'] = 2;

    };

    const timerId = 'slide2';
    const timerDelay = 80000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['activeSlide'] = 1;

    };

    const timerId = 'slide1';
    const timerDelay = 160000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 600000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['cynthiaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['cynthiaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['roseTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['roseRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['joshTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['joshRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['warnerRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'BCB5F61B-690B-4AF4-BEC9-2A60122FC93D');
  }));
  ___arguments.context.pageData['erikaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['erikaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['emilieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['emilieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['jonTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['jonRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['vitaliyTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FD7720E0-435E-4755-8147-162C754A4F29');
  }));
  ___arguments.context.pageData['stephanieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20');
  }));
  ___arguments.context.pageData['stephanieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20' && (getObjectProperty(item, 'dealerObjectId')) != '2E0EEC74-2003-4080-BD91-3B0923786ED2' || (getObjectProperty(item, 'dealerObjectId')) == 'B5A14271-2E38-43EF-8649-595CDA51B9F1');
  }));
  ___arguments.context.pageData['taraTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['taraRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['neoOfficeLeader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'C73B2210-82F4-4467-9AE1-4277517ADD54\''].join(''))).setPageSize(100)));
  console.log(getObjectProperty(___arguments.context.pageData, 'competitionsData'));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  }
  ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
  console.log(getObjectProperty(___arguments.context.pageData, 'featuredComp'));
  ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
  }));
  console.log(getObjectProperty(___arguments.context.pageData, 'otherComps'));
  ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
  ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
  ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
  ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
  console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['activeSlide'] = 2;

    };

    const timerId = 'slide2';
    const timerDelay = 80000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['activeSlide'] = 1;

    };

    const timerId = 'slide1';
    const timerDelay = 160000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  ;(function() {
    const callback = async () => {
        await (async function() {
    	location.reload()

    })();

    };

    const timerId = 'refreshPage';
    const timerDelay = 1800000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/9bcdcac24e5a9ef3c2c7e7a7f0eceebd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00a325435d84cf5bdfb1c536070923dc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/092954d54e973a039128c0cf5f86778a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35b127865f55efce4202fbcf9d569c13'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/0db124b78dfc159eb0fd8ea7aa19b18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b3ee3cb8388f80f561c331f9bed1a7ca'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/0f865654bc7b2bdea7112b93c4eb6c88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10eadabe0af2d8c395dd54037f84e0c3'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/f141fba8d5f2567fa3ea112f42425491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('32473369a4e402f6232fdbbf89a592c2'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/69cc14c3097c00ad333b59368e0a19a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c15edf8a42ac48e5433f1fbd3b35468f'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/ad1ba77ec4ffd7f6da7fed293dc4bd6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be29ef369d7caa13b0418ea5c9a11566'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/6d9641d8f2c4e94e590acc690b9ce052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7352a2656c33d168cfd72933e39312be'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/0f13d80bc3194a9f6d3410b48cedf0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c84a28b7d3c983b1b37ceedde5476bf'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/10ea0b44e92d16f58d16448eedf3d47e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b93efd07324d5059d41d3321e4f714a4'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/cb1433f9aedab0a7f1d2bd466ac85275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d27a1fe8fe01ada53ca56b8e3b5103bb'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/84fb6249d5a86fc85eee5748489e3faf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('123cb64dbb5a4e2d76fd0bb894f7e097'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/1813b1c4db6d982bd2cd22075babdf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d9e241e4aab18559f0bd23ff0e579da9'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/47683c7de5259a7cde2ae914c101257e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8179b4b49715e3f6b2b83be7e7dd1f03'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/3c99a22dd12d91f7c83a21629cc294af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e5ab4464fa970de1357301d458b1d8'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/880d07cec0c3078156a12fca12163d58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('df4791a990ba2fb2db788c6109b14d4b'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/aef82fab6bac5c18249ebdc4f66bf878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f5a539629e49311e0d803fe27c48141'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--1080p--light--test/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var loggedInUser, item, allDealerAptTotals, teamTotals, thisMonthsDemosTotal, thisMonthsSalesTotal, thisMonthsSubmissionsTotal, thisMonthsAppointmentsTotal, i, dailyTotalScore, dailyscore, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dailyAppointmentTotal, j, dailyIndTotals, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, dealerScore, subs, sales, demos, apts, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Competition Dashboard';
  ___arguments.context.pageData['breadCrumb'] = 'Competitions Dashboard';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Leaders_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'C73B2210-82F4-4467-9AE1-4277517ADD54\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
      console.log(getObjectProperty(j, 'dealer_name'));
      console.log(i);
      console.log(apts);
      console.log(allDealerAptTotals);
      console.log(dealerAppointmentsTotal);
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['allDealerScores'] = teamTotals;
  ___arguments.context.pageData['cynthiaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['cynthiaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '7B7628DE-9264-48B1-A377-596368A53052');
  }));
  ___arguments.context.pageData['roseTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['roseRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '73D68EF9-4226-4033-AD4D-7F0F531B7ED9');
  }));
  ___arguments.context.pageData['joshTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['joshRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '0470E031-25FB-4930-8649-71B14B65B6F1');
  }));
  ___arguments.context.pageData['warnerRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'BCB5F61B-690B-4AF4-BEC9-2A60122FC93D');
  }));
  ___arguments.context.pageData['erikaTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['erikaRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '32625AAB-4EF8-46D2-B28A-71672F59A9AB');
  }));
  ___arguments.context.pageData['emilieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['emilieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == 'E7CF2D4C-E77F-4A0E-ADEE-472973693E12');
  }));
  ___arguments.context.pageData['jonTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['jonRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'recruitedBy')) == '8E23740C-7D24-47BC-B04C-6964442D8FA4');
  }));
  ___arguments.context.pageData['vitaliyTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FD7720E0-435E-4755-8147-162C754A4F29');
  }));
  ___arguments.context.pageData['stephanieTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20');
  }));
  ___arguments.context.pageData['stephanieRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == 'EE8C27B9-B76A-4A96-ADA9-3A8E2B36DB20' && (getObjectProperty(item, 'dealerObjectId')) != '2E0EEC74-2003-4080-BD91-3B0923786ED2' || (getObjectProperty(item, 'dealerObjectId')) == 'B5A14271-2E38-43EF-8649-595CDA51B9F1');
  }));
  ___arguments.context.pageData['taraTeamleader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['taraRecruits'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'teamLeader')) == '2E0EEC74-2003-4080-BD91-3B0923786ED2');
  }));
  ___arguments.context.pageData['neoOfficeLeader'] = (await asyncListFilter(teamTotals, async (item) => {


   return ((getObjectProperty(item, 'dealerObjectId')) == 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/14eea1a13be69f63140c2b7eae37d2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'appointmentsLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--neodivision--4k/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Polar_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'81CDFF42-B637-44AF-9F8D-7139BEB6AB8C\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'81CDFF42-B637-44AF-9F8D-7139BEB6AB8C\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--polarcentral/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarcentral/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Polar_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'2ADD53A6-A300-4C89-AE6B-DFEB73446C39\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'2ADD53A6-A300-4C89-AE6B-DFEB73446C39\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--polarfresh/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarfresh/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Polar_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'27F4F97D-68A4-4EFD-B791-B920B2AF4307\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'27F4F97D-68A4-4EFD-B791-B920B2AF4307\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--polarfresno/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarfresno/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, dealersWithScores, thisMonthsSubmissionsTotal, j, thisMonthsSalesTotal, thisMonthsDemosTotal, thisMonthsAppointmentsTotal, k, dealerScoresList, teamTotals, thisMonthsRecruitsTotal, dailyIndTotals, i, allDealersSubTotal, allDealersSalesTotals, allDealersDemosTotal, allDealerAptTotals, dealerSubmissionsTotal, dealerSalesTotal, dealerDemosTotal, dealerAppointmentsTotal, dealerScore, dealerRecruitsTotal, apts, subs, sales, demos, recs, dailyscore, dealerRecords, days, endDateForRepeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['breadCrumb'] = 'KPI Dashboard - NEO Development';
  ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((new Date()))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((new Date()))),'-'].join(''));
  ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date()))));
  if ((getObjectProperty(___arguments.context.pageData, 'currentDay')) == '1') {
    endDateForRepeater = (new Date((new Date()).getTime() - ((1 * 86400) * 1000)));
    ___arguments.context.pageData['currentDay'] = (String(new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format(endDateForRepeater)));
    ___arguments.context.pageData['currentMonthYear'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format(endDateForRepeater)),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format(endDateForRepeater)),'-'].join(''));
  }
  days = [];
  var i_end = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(days, ({ 'day': i }));
  }
  ___arguments.context.pageData['days'] = days;
  dealerRecords = (await Backendless.Data.of('Dealers_Polar_Division').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_active = true',' and ','objectId != \'2175E1BF-C48C-4482-A6F8-58235E69947C\'',' and ','office_link = \'31733177-15F8-45D9-9BC7-E2D7BE8D0696\' and historic_comp_scores != null'].join(''))).setRelationsDepth(2).setSortBy('dealer_name ASC').setPageSize(50)));
  ___arguments.context.pageData['activeDealers'] = dealerRecords;
  thisMonthsAppointmentsTotal = 0;
  thisMonthsDemosTotal = 0;
  thisMonthsSalesTotal = 0;
  teamTotals = [];
  thisMonthsSubmissionsTotal = 0;
  allDealerAptTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersDemosTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSalesTotals = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  allDealersSubTotal = listsRepeat(0, (getObjectProperty(___arguments.context.pageData, 'currentDay')));
  for (var j_index in dealerRecords) {
    j = dealerRecords[j_index];
    dealerAppointmentsTotal = 0;
    dealerDemosTotal = 0;
    dealerSalesTotal = 0;
    dealerSubmissionsTotal = 0;
    dealerRecruitsTotal = 0;
    dealerScore = [];
    var i_end2 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
    var i_inc2 = 1;
    if (1 > i_end2) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
      dailyscore = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')).startsWith((String(getObjectProperty(___arguments.context.pageData, 'currentMonthYear')) + String(i < 10 ? String('0') + String(i) : i))));
      }));
      dailyscore = dailyscore[0];
      if (dailyscore !== null && !Array.isArray(dailyscore) && (typeof dailyscore === 'object')) {
        if (getObjectProperty(dailyscore, 'appointments')) {
          dealerAppointmentsTotal = (typeof dealerAppointmentsTotal == 'number' ? dealerAppointmentsTotal : 0) + (getObjectProperty(dailyscore, 'appointments'));
        }
        if (getObjectProperty(dailyscore, 'demos')) {
          dealerDemosTotal = (typeof dealerDemosTotal == 'number' ? dealerDemosTotal : 0) + (getObjectProperty(dailyscore, 'demos'));
        }
        if (getObjectProperty(dailyscore, 'sales')) {
          dealerSalesTotal = (typeof dealerSalesTotal == 'number' ? dealerSalesTotal : 0) + (getObjectProperty(dailyscore, 'sales'));
        }
        if (getObjectProperty(dailyscore, 'submissions')) {
          dealerSubmissionsTotal = (typeof dealerSubmissionsTotal == 'number' ? dealerSubmissionsTotal : 0) + (getObjectProperty(dailyscore, 'submissions'));
        }
        if (getObjectProperty(dailyscore, 'recruits')) {
          dealerRecruitsTotal = (typeof dealerRecruitsTotal == 'number' ? dealerRecruitsTotal : 0) + (getObjectProperty(dailyscore, 'recruits'));
        }
        apts = (getObjectProperty(dailyscore, 'appointments'));
        subs = (getObjectProperty(dailyscore, 'submissions'));
        demos = (getObjectProperty(dailyscore, 'demos'));
        sales = (getObjectProperty(dailyscore, 'sales'));
        recs = (getObjectProperty(dailyscore, 'recruits'));
        addItemToList(dealerScore, ({ 'day': i,'appointments': apts,'demos': demos,'sales': sales,'submissions': subs,'recruits': subs }));
      } else {
        addItemToList(dealerScore, ({ 'day': i,'appointments': undefined,'demos': undefined,'sales': undefined,'submissions': undefined }));
        apts = 0;
        demos = 0;
        sales = 0;
        subs = 0;
        recs = 0;
      }
      if ((typeof apts === 'undefined') || (apts === null)) {
        apts = 0;
      }
      if (typeof demos === 'undefined') {
        demos = 0;
      }
      if (typeof sales === 'undefined') {
        sales = 0;
      }
      if (typeof subs === 'undefined') {
        subs = 0;
      }
      if (typeof recs === 'undefined') {
        recs = 0;
      }
      allDealerAptTotals[(i - 1)] = allDealerAptTotals[(i - 1)] + apts;
      allDealersDemosTotal[(i - 1)] = allDealersDemosTotal[(i - 1)] + demos;
      allDealersSalesTotals[(i - 1)] = allDealersSalesTotals[(i - 1)] + sales;
      allDealersSubTotal[(i - 1)] = allDealersSubTotal[(i - 1)] + subs;
    }
    thisMonthsAppointmentsTotal = (typeof thisMonthsAppointmentsTotal == 'number' ? thisMonthsAppointmentsTotal : 0) + dealerAppointmentsTotal;
    thisMonthsDemosTotal = (typeof thisMonthsDemosTotal == 'number' ? thisMonthsDemosTotal : 0) + dealerDemosTotal;
    thisMonthsSalesTotal = (typeof thisMonthsSalesTotal == 'number' ? thisMonthsSalesTotal : 0) + dealerSalesTotal;
    thisMonthsSubmissionsTotal = (typeof thisMonthsSubmissionsTotal == 'number' ? thisMonthsSubmissionsTotal : 0) + dealerSubmissionsTotal;
    thisMonthsRecruitsTotal = (typeof thisMonthsRecruitsTotal == 'number' ? thisMonthsRecruitsTotal : 0) + dealerRecruitsTotal;
    addItemToList(teamTotals, ({ 'dealerName': (getObjectProperty(j, 'dealer_name')),'recruitedBy': (getObjectProperty(j, 'recruited_by.objectId')),'teamLeader': (getObjectProperty(j, 'team_leader.objectId')),'dealerObjectId': (getObjectProperty(j, 'objectId')),'scores': dealerScore,'appointmentsTotal': dealerAppointmentsTotal,'demosTotal': dealerDemosTotal,'salesTotal': dealerSalesTotal,'submissionsTotal': dealerSubmissionsTotal }));
  }
  dailyIndTotals = [];
  var i_end3 = (getObjectProperty(___arguments.context.pageData, 'currentDay'));
  var i_inc3 = 1;
  if (1 > i_end3) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= i_end3 : i >= i_end3; i += i_inc3) {
    addItemToList(dailyIndTotals, ({ 'appointments': allDealerAptTotals[(i - 1)],'demos': allDealersDemosTotal[(i - 1)],'sales': allDealersSalesTotals[(i - 1)],'submissions': allDealersSubTotal[(i - 1)] }));
  }
  console.log(dailyIndTotals);
  ___arguments.context.pageData['dailyIndTotals'] = dailyIndTotals;
  ___arguments.context.pageData['dealerTotalAppointment'] = thisMonthsAppointmentsTotal;
  ___arguments.context.pageData['dealerTotalDemo'] = thisMonthsDemosTotal;
  ___arguments.context.pageData['dealerTotalSale'] = thisMonthsSalesTotal;
  ___arguments.context.pageData['dealerTotalSubmission'] = thisMonthsSubmissionsTotal;
  ___arguments.context.pageData['dealerTotalRecruit'] = thisMonthsRecruitsTotal;
  ___arguments.context.pageData['dealerClosingAverage'] = (String(Math.round((thisMonthsSalesTotal / thisMonthsDemosTotal) * 100)) + String('%'));
  ___arguments.context.pageData['currentMonthTotalDays'] = (await (async function() {
  	const currentDate = new Date();
  	const currentYear = currentDate.getFullYear();
  	const currentMonth = currentDate.getMonth();

  	const currentMonthLastDate = (new Date(currentYear, currentMonth+1, 0)).getDate();

  	const daysLeftInMonth = currentMonthLastDate - currentDate.getDate();


  	console.log(currentMonthLastDate)
  	console.log(daysLeftInMonth)

  	// arguments.context.pageData['dealerTotalRecruits'] = daysLeftInMonth;

  	// pageData.dealerTotalRecruits = daysLeftInMonth;

  	return currentMonthLastDate
  })());
  ___arguments.context.pageData['currentDayOfMonthValue'] = (new Intl.DateTimeFormat('default', ({ 'day': 'numeric' })).format((new Date())));
  ___arguments.context.pageData['currentDayOfMonth'] = ((getObjectProperty(___arguments.context.pageData, 'currentDayOfMonthValue')) - 1);
  ___arguments.context.pageData['dailyAppointmentsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyAppointmentsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyAppointmentsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyDemosAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyDemosScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyDemosAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySalesAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySalesScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySalesAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailySubmissionsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlySubmissionsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailySubmissionsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['dailyRecruitsAverage'] = ((getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) / (getObjectProperty(___arguments.context.pageData, 'currentDayOfMonth')));
  ___arguments.context.pageData['monthlyRecruitsScaleTarget'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'dailyRecruitsAverage')) * (getObjectProperty(___arguments.context.pageData, 'currentMonthTotalDays'))));
  ___arguments.context.pageData['allDealerScores'] = (await asyncListFilter(teamTotals, async (item) => {


   return (!((getObjectProperty(item, 'appointmentsTotal')) == 0 && (getObjectProperty(item, 'demosTotal')) == 0 && (getObjectProperty(item, 'salesTotal')) == 0 && (getObjectProperty(item, 'submissionsTotal')) == 0));
  }));
  ___arguments.context.pageData['dealerRecordTotal'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).length);
  ___arguments.context.pageData['scoreboardGroup1'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(0, 8));
  ___arguments.context.pageData['numberSlides'] = 1;
  ___arguments.context.pageData['group1active'] = true;
  ___arguments.context.pageData['group2active'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 8) {
    ___arguments.context.pageData['numberSlides'] = 2;
    ___arguments.context.pageData['scoreboardGroup2'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(8, 16));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 16) {
    ___arguments.context.pageData['numberSlides'] = 3;
    ___arguments.context.pageData['scoreboardGroup3'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(16, 24));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 24) {
    ___arguments.context.pageData['numberSlides'] = 4;
    ___arguments.context.pageData['scoreboardGroup4'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(24, 32));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 32) {
    ___arguments.context.pageData['numberSlides'] = 5;
    ___arguments.context.pageData['scoreboardGroup5'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(32, 40));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 40) {
    ___arguments.context.pageData['numberSlides'] = 6;
    ___arguments.context.pageData['scoreboardGroup6'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(40, 48));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 48) {
    ___arguments.context.pageData['numberSlides'] = 7;
    ___arguments.context.pageData['scoreboardGroup7'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(48, 56));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 56) {
    ___arguments.context.pageData['numberSlides'] = 8;
    ___arguments.context.pageData['scoreboardGroup8'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(56, 64));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 64) {
    ___arguments.context.pageData['numberSlides'] = 9;
    ___arguments.context.pageData['scoreboardGroup9'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(64, 72));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dealerRecordTotal')) > 72) {
    ___arguments.context.pageData['numberSlides'] = 10;
    ___arguments.context.pageData['scoreboardGroup10'] = ((getObjectProperty(___arguments.context.pageData, 'allDealerScores')).slice(72, 80));
  }
  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setWhereClause((['competition_end_date >= \'',((new Date()).toISOString()),'\' AND competition_start_date <= \'',((new Date()).toISOString()),'\' AND related_office = \'31733177-15F8-45D9-9BC7-E2D7BE8D0696\''].join(''))).setPageSize(100)));
  if ((getObjectProperty(___arguments.context.pageData, 'competitionsData')).length == 0) {
    ___arguments.context.pageData['noActiveComps'] = true;
  } else {
    ___arguments.context.pageData['featuredComp'] = (listsGetRandomItem((getObjectProperty(___arguments.context.pageData, 'competitionsData')), false));
    ___arguments.context.pageData['otherComps'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'featuredComp.objectId')));
    }));
    ___arguments.context.pageData['competition_start_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))].join(''));
    ___arguments.context.pageData['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date')))).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['competition_end_date'] = ([(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.pageData, 'compEndDateModified'))))].join(''));
  }
  dealerScoresList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activeDealers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != 'FE897375-2D76-40FE-8FE3-DA9C51EB0262');
  }));
  ___arguments.context.pageData['monthlyScores'] = null;
  for (var j_index2 in dealerScoresList) {
    j = dealerScoresList[j_index2];
    if (getObjectProperty(j, 'monthlyScores')) {
      addItemToList((getObjectProperty(j, 'monthlyScores')), (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      })));
    } else {
      j['monthlyScores'] = (await asyncListFilter((getObjectProperty(j, 'historic_comp_scores')), async (item) => {


       return ((getObjectProperty(item, 'date')) >= (getObjectProperty(___arguments.context.pageData, 'competition_start_date')) && (getObjectProperty(item, 'date')) <= (getObjectProperty(___arguments.context.pageData, 'competition_end_date')));
      }));
    }
  }
  dealersWithScores = (await asyncListFilter(dealerScoresList, async (item) => {


   return ((getObjectProperty(item, 'monthlyScores')).length != 0);
  }));
  for (var j_index3 in dealersWithScores) {
    j = dealersWithScores[j_index3];
    thisMonthsAppointmentsTotal = 0;
    thisMonthsDemosTotal = 0;
    thisMonthsSalesTotal = 0;
    thisMonthsSubmissionsTotal = 0;
    var k_list = (getObjectProperty(j, 'monthlyScores'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (getObjectProperty(k, 'appointments')) {
        thisMonthsAppointmentsTotal = thisMonthsAppointmentsTotal + (getObjectProperty(k, 'appointments'));
      }
      if (getObjectProperty(k, 'demos')) {
        thisMonthsDemosTotal = thisMonthsDemosTotal + (getObjectProperty(k, 'demos'));
      }
      if (getObjectProperty(k, 'sales')) {
        thisMonthsSalesTotal = thisMonthsSalesTotal + (getObjectProperty(k, 'sales'));
      }
      if (getObjectProperty(k, 'submissions')) {
        thisMonthsSubmissionsTotal = thisMonthsSubmissionsTotal + (getObjectProperty(k, 'submissions'));
      }
    }
    j['dealerTotalAppointments'] = thisMonthsAppointmentsTotal;
    j['dealerTotalDemos'] = thisMonthsDemosTotal;
    j['dealerTotalSales'] = thisMonthsSalesTotal;
    j['dealerTotalSubmissions'] = thisMonthsSubmissionsTotal;
  }
  if (getObjectProperty(___arguments.context.pageData, 'featuredComp')) {
    delete (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))['target_closingAverage'];
    ___arguments.context.pageData['featuredCompNoTargets'] = ((Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets')))).length);
    console.log(Object.keys((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'featuredComp')), 'competition_targets'))));
  }
  ___arguments.context.pageData['competitionSubmissionsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSubmissions'));
  }));
  ___arguments.context.pageData['competitionAppointmentsTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalAppointments'));
  }));
  ___arguments.context.pageData['competitionDemosTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalDemos'));
  }));
  ___arguments.context.pageData['competitionSalesTotals'] = (await asyncListSort(dealersWithScores, -1, async (item) => {


   return (getObjectProperty(item, 'dealerTotalSales'));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) > 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 5));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 5));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'featuredCompNoTargets')) <= 2) {
    ___arguments.context.pageData['competitionLeaderboardSubmissions'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSubmissionsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardAppointments'] = ((getObjectProperty(___arguments.context.pageData, 'competitionAppointmentsTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardDemos'] = ((getObjectProperty(___arguments.context.pageData, 'competitionDemosTotals')).slice(0, 10));
    ___arguments.context.pageData['competitionLeaderboardSales'] = ((getObjectProperty(___arguments.context.pageData, 'competitionSalesTotals')).slice(0, 10));
  }
  ___arguments.context.pageData['activeSlide'] = 1;
  ___arguments.context.pageData['slideTimer'] = 120000;
  ___arguments.context.pageData['groupTimer'] = 25000;
  ___arguments.context.pageData['compSliderTimer'] = 25000;
  console.log(String('Number of Slides: ') + String(getObjectProperty(___arguments.context.pageData, 'numberSlides')));
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 1) {
    for (var count = 0; count < 10; count++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 2) {
    for (var count2 = 0; count2 < 5; count2++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 3) {
    for (var count3 = 0; count3 < 10; count3++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 4) {
    for (var count4 = 0; count4 < 10; count4++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 5) {
    for (var count5 = 0; count5 < 10; count5++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 6) {
    for (var count6 = 0; count6 < 10; count6++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 7) {
    for (var count7 = 0; count7 < 10; count7++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 8) {
    for (var count8 = 0; count8 < 10; count8++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 9) {
    for (var count9 = 0; count9 < 10; count9++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'numberSlides')) == 10) {
    for (var count10 = 0; count10 < 10; count10++) {
      ___arguments.context.pageData['group1active'] = true;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group2active'] = true;
      ___arguments.context.pageData['group1active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group3active'] = true;
      ___arguments.context.pageData['group2active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group4active'] = true;
      ___arguments.context.pageData['group3active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group5active'] = true;
      ___arguments.context.pageData['group4active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group6active'] = true;
      ___arguments.context.pageData['group5active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group7active'] = true;
      ___arguments.context.pageData['group6active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group8active'] = true;
      ___arguments.context.pageData['group7active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group9active'] = true;
      ___arguments.context.pageData['group8active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['group10active'] = true;
      ___arguments.context.pageData['group9active'] = false;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'groupTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 2;
      await new Promise(r => setTimeout(r, (getObjectProperty(___arguments.context.pageData, 'compSliderTimer')) || 0));
      ___arguments.context.pageData['activeSlide'] = 1;
      ___arguments.context.pageData['group2active'] = false;
      ___arguments.context.pageData['group3active'] = false;
      ___arguments.context.pageData['group4active'] = false;
      ___arguments.context.pageData['group5active'] = false;
      ___arguments.context.pageData['group6active'] = false;
      ___arguments.context.pageData['group7active'] = false;
      ___arguments.context.pageData['group8active'] = false;
      ___arguments.context.pageData['group9active'] = false;
      ___arguments.context.pageData['group10active'] = false;
    }
    await (async function() {
    	location.reload()

    })();
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['dealerTotalAppointment'] = 0;
  ___arguments.context.pageData['dealerTotalDemo'] = 0;
  ___arguments.context.pageData['dealerTotalSale'] = 0;
  ___arguments.context.pageData['dealerTotalSubmission'] = 0;
  ___arguments.context.pageData['dealerTotalRecruit'] = 0;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/kpi--polarnation/components/3384cbbaa6cbf8eb6dd9a0e59688310e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'demosLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/15b8449cd599626e9543c11fded77172/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/7be55c515908f5485feab5636f4665a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesLeaderboard'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/7ecd627f8445a899c3ee2efc147379a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/5cebdbec7de9c1e825f5da4430e87461/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/d8d16597ba65446ab826033ac5f24019/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/cfd471f9ecd2973bc1ea64d67fc298b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43f4926710aa6caecffba3238da799fc'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/1b85492f7c310956ab9a7f25f47d45e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSaleIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('524f17a4f47307e9a8fb0751f788e145'), 'sales')) > 0) {
    showSaleIcon = true;
  }

  return showSaleIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/739139e9d6046f8114fe9ad6ec4cd347/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSale')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/75f378a68c39562603c834be6fbb3f75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Sale Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/8d911ee654d86e5d045c460fc715626b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySalesScaleTarget')) + String(' Sales'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/7255b96ef9fc02cab84eb803c9df560e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalAppointment')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/0721a84e684de232fae30bc15d6ec48c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyDemosScaleTarget')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/0965561b65b6db81f5eac2a5eba9de03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyAppointmentsScaleTarget')) + String(' Appointments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/9c1aeac2caea00c142a86a2c3416a763/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlySubmissionsScaleTarget')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/ed9e61dc081e14e72b081e38697ed858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'monthlyRecruitsScaleTarget')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/5a97e6e9cb44a67df9dafb8aa83c46ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalSubmission')) + String(' Submissions'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/036c593ac312278577bfbacf718eb764/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalRecruit')) + String(' Recruits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/f1dccbe51463174d26b5ccb9d5ae2441/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'dealerTotalDemo')) + String(' Demos'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/b39be2bb656623c330fe2151718e2071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Demo Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/bd1b4b22a2caf509127728d7fb02b36b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Appointment Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/d6ad844236f349bf09948a268e62a45e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Recruit Stats for ') + String(new Intl.DateTimeFormat('default', ({ 'month': 'long','year': 'numeric' })).format((new Date()))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/53f6e5b5f252df1828cb29f3d3363c67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 1) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/4154a16b47250d2862a53c26b60d1e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSlide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activeSlide')) == 2) {
    showSlide = true;
  } else {
    showSlide = false;
  }

  return showSlide

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/bde10f68a21a6d02700f41b4380e569c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/38e2f1fc492ae703b3afb7881d8bc0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/90e57d5e825cd1335fbfea7c962c1571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_targets.target_closingAverage')) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/2e36a5d46c3af7d9fa4f6ee237278bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36a5d46c3af7d9fa4f6ee237278bfc'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'featuredComp.competition_featured_image')),'"'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/kpi--polarnation/components/7148f2a2d094172b71511c0498a28b98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7148f2a2d094172b71511c0498a28b98'))['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.dataModel, 'competition_featured_image')),'");'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/landing/components/6f2120a581044868e079f6654dabfe83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.Data.of('Person').save( ({ 'name': 'Joe','age': 30 }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/63dd3ad8d9d48fd4282da91f5d293ea9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['personObject'] = (await Backendless.Data.of('Person').findFirst());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/0dc308477552e1612e649139883ff224/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Person').save( (getObjectProperty(___arguments.context.pageData, 'personObject')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/e5a573f73e1638720dc1d0035e5aa25b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Person').remove( (getObjectProperty(___arguments.context.pageData, 'personObject')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/61b68752f0c43bcdb69148af8c7a2471/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.register( new Backendless.User({ 'email': (getObjectProperty(___arguments.context.pageData, 'emailAddress')),'password': (getObjectProperty(___arguments.context.pageData, 'password')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/c647760c17442b5e93f8564242f4e33d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userName = (getObjectProperty(___arguments.context.pageData, 'name'));

  return userName

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/login/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, stayLoggedIn, password, username, user, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    if (!(getObjectProperty(user, 'sectionAccess'))) {
      user['sectionAccess'] = ({ 'inventory': false });
      await Backendless.Data.of('Users').save( user );
    }
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('currentUser', JSON.stringify(user));
    localStorage.setItem('officeRecord', JSON.stringify((getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(user, 'objectId')), Backendless.DataQueryBuilder.create().setRelated('office_link'))), 'office_link'))));
    if ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()) {
      localStorage.setItem('officeObjId', JSON.stringify((getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'objectId'))));
    } else {
      localStorage.setItem('officeObjId', JSON.stringify());
    }
    if (((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) == '092A5EFC-C8D4-405E-8A13-C2D1845B6A2B') {
      localStorage.setItem('viewAs', JSON.stringify(false));
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--dashboard', undefined);
    } else {
      if ((getObjectProperty(user, 'userGroup')) == 'Dealer-inventory') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--moveProduct', undefined);
      } else if ((getObjectProperty(user, 'userGroup')) == 'Demo') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);
      } else if ((getObjectProperty(user, 'userGroup')) == 'Dealer') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);
      } else if ((getObjectProperty(user, 'userGroup')) == 'Office Manager') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);
      } else if ((getObjectProperty(user, 'userGroup')) == 'Division Manager') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);
      } else if ((getObjectProperty(user, 'userGroup')) == 'Region Manager') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionDashboard', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
      }
    }
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/messageBoyd/components/c655ec0bea898983f783e87ecf4da947/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': '+19492999976','message': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('444f0a74596f602da0330ce29d6ae00e'), 'message')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messageBoyd/components/3ef35dfda92ef0687086dc199eb3cc94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  await Backendless.Messaging.sendEmail('Your payslip is attached', new Backendless.Bodyparts({ textmessage: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('98f64d78681918e529f581963995ff0c'), 'message')) }), ensureArray('shane@tellus.business'), undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/newLogin/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var user, error, password, username, stayLoggedIn, logging, buttonLogin;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('currentUser', JSON.stringify(user));
    if ((getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(user, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(1))), 'office_link.objectId')) == '092A5EFC-C8D4-405E-8A13-C2D1845B6A2B') {
      localStorage.setItem('viewAs', JSON.stringify(false));
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--chooseOffice', undefined);
    } else {
      localStorage.setItem('officeObjId', JSON.stringify((getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(user, 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(1))), 'office_link.objectId'))));
      if ((getObjectProperty(user, 'userGroup')) == 'Demo') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);
      }
      if ((getObjectProperty(user, 'userGroup')) == 'Dealer') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);
      }
      if ((getObjectProperty(user, 'userGroup')) == 'Office Manager') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);
      }
      if ((getObjectProperty(user, 'userGroup')) == 'Division Manager') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);
      }
      if ((getObjectProperty(user, 'userGroup')) == 'Region Manager') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionDashboard', undefined);
      }
    }
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/orders--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Orders Dashboard';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/orders--dashboard/components/369542de09be6d2531a17031e63c6d34/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
    
  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/payroll--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, transactions, pay_date, unapproved_sales_this_period, approved_sales_this_period, totalCommission, j, k, getSales, end_date, start_date, pay_period, pay_periods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null);
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['payrollMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Payroll Dashboard';
  pay_periods = (await BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091'](null));
  ___arguments.context.pageData['payPeriods'] = pay_periods;
  pay_period = (await BackendlessUI.Functions.Custom['fn_8405d74e154be67776e70bfde74dbca2']());
  ___arguments.context.pageData['payPeriod'] = pay_period;
  start_date = (getObjectProperty(pay_period, 'startDate'));
  end_date = (getObjectProperty(pay_period, 'endDate'));
  pay_date = (getObjectProperty(pay_period, 'payDate'));
  getSales = (await BackendlessUI.Functions.Custom['fn_f403d444a75a2955804dd9adabbfe888'](1661983200000, start_date, end_date, pay_date));
  ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
  approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
  unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
  for (var j_index in approved_sales_this_period) {
    j = approved_sales_this_period[j_index];
    totalCommission = 0;
    var k_list = (getObjectProperty(j, 'link_to_calculations.commissions_detail'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      totalCommission = (typeof totalCommission == 'number' ? totalCommission : 0) + (getObjectProperty(k, 'amount'));
    }
    j['totalCommission'] = totalCommission;
  }
  ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
  ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
  transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6'](pay_date));
  ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'payment_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/payroll--dashboard/components/72a1df672b89de98462ed52abb06e0db/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/payroll--dashboard/components/f15ebef41c23f006b1656bdcd46150c2/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/payroll--dashboard/components/e352044bfd359885cb716f5b52bdbf5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'](___arguments.context.getComponentDataStoreByUid('278c690bf5adacd5687899dc57462ff2')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/b95bc65aa8e2b26c45e8675f30166621/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  ___arguments.context.pageData['modalLoading'] = true;
  saleRecord = (await BackendlessUI.Functions.Custom['fn_c65b588280452c4e9eb6152982cbb2cb'](___arguments.context.getComponentDataStoreByUid('b612fe73430873aae945988b9c466f3a')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;
  ___arguments.context.pageData['modalLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/8fdf313c1f09c4dc8cc37d26fd5d813a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, approved_sales_this_period, getSales, pay_date, end_date, start_date, pay_period;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  pay_period = (await Backendless.Data.of('Pay_periods').find(Backendless.DataQueryBuilder.create().setWhereClause((['start_date< \'',((new Date()).valueOf()),'\' AND end_date> \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(10)))[0];
  start_date = (getObjectProperty(pay_period, 'start_date'));
  ___arguments.context.pageData['startDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](start_date));
  end_date = (getObjectProperty(pay_period, 'end_date'));
  ___arguments.context.pageData['endDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](end_date));
  pay_date = (getObjectProperty(pay_period, 'pay_date'));
  ___arguments.context.pageData['payDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](pay_date));
  ___arguments.context.pageData['startDate'] = start_date;
  ___arguments.context.pageData['endDate'] = end_date;
  getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, start_date, end_date, pay_date));
  ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
  approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3acea913f2cfce4f35b5ab3ea98309bb')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3acea913f2cfce4f35b5ab3ea98309bb', approved_sales_this_period);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('97cc1c51621289d4e68b454f9a3b2e4a')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('97cc1c51621289d4e68b454f9a3b2e4a', (getObjectProperty(getSales, 'unapprovedSales')));
  }
  ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((approved_sales_this_period.length > 1 ? (await Promise.all(approved_sales_this_period.map(async item => {; return (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'commissionsTotal'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['openFinanceModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/0fce543221c2602655a3b0b6f9d69489/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--weeklySummary', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/289b90f869f85c66a8c7db25e9e9a99f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, transactions, payPeriod, unapproved_sales_this_period, approved_sales_this_period, totalCommission, j, k, getSales, index, allPayPeriods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allPayPeriods = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  payPeriod = (getObjectProperty(___arguments.context.pageData, 'payPeriod'));
  index = (getObjectProperty(payPeriod, 'index'));
  if (index < allPayPeriods.length) {
    payPeriod = allPayPeriods[((index + 1) - 1)];
    payPeriod['index'] = (index + 1);
    ___arguments.context.pageData['payPeriod'] = payPeriod;
    getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, (getObjectProperty(payPeriod, 'startDate')), (getObjectProperty(payPeriod, 'endDate')), (getObjectProperty(payPeriod, 'payDate'))));
    ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
    approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
    unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
    for (var j_index in approved_sales_this_period) {
      j = approved_sales_this_period[j_index];
      totalCommission = 0;
      var k_list = (getObjectProperty(j, 'link_to_calculations.commissions_detail'));
      for (var k_index in k_list) {
        k = k_list[k_index];
        totalCommission = (typeof totalCommission == 'number' ? totalCommission : 0) + (getObjectProperty(k, 'amount'));
      }
      j['totalCommission'] = totalCommission;
    }
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6']((getObjectProperty(payPeriod, 'payDate'))));
    ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (Number((getObjectProperty(item, 'payment_total'))));}))).reduce(function(x, y) {return x + y;}) : 0)));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/30aa1691b821dfd2ee0719724b9d7287/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--weeklySummary', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/ddabcb9cd8f1b3ca4f9d356b508d45be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, approved_sales_this_period, transactions, pay_date, unapproved_sales_this_period, totalCommission, j, k, getSales, payPeriod, index, allPayPeriods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allPayPeriods = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  payPeriod = (getObjectProperty(___arguments.context.pageData, 'payPeriod'));
  index = (getObjectProperty(payPeriod, 'index'));
  if (index > 0) {
    payPeriod = allPayPeriods[((index - 1) - 1)];
    payPeriod['index'] = (index - 1);
    ___arguments.context.pageData['payPeriod'] = payPeriod;
    getSales = (await BackendlessUI.Functions.Custom['fn_f403d444a75a2955804dd9adabbfe888'](1661983200000, (getObjectProperty(payPeriod, 'startDate')), (getObjectProperty(payPeriod, 'endDate')), (getObjectProperty(payPeriod, 'payDate'))));
    ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
    approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
    unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
    for (var j_index in approved_sales_this_period) {
      j = approved_sales_this_period[j_index];
      totalCommission = 0;
      var k_list = (getObjectProperty(j, 'link_to_calculations.commissions_detail'));
      for (var k_index in k_list) {
        k = k_list[k_index];
        totalCommission = (typeof totalCommission == 'number' ? totalCommission : 0) + (getObjectProperty(k, 'amount'));
      }
      j['totalCommission'] = totalCommission;
    }
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6']((getObjectProperty(payPeriod, 'payDate'))));
    ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (Number((getObjectProperty(item, 'payment_total'))));}))).reduce(function(x, y) {return x + y;}) : 0)));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/a529bae355edfd2cc41110df92b1a59d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--history', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/33f183cff98c1b41bfaa6008c6140a65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerHistory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/4ee73d012cba15572f73b0d3c015b4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var url, dealer, j, pay_records, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    pay_records = (await Backendless.Data.of('Payroll_transactions').find(Backendless.DataQueryBuilder.create().setWhereClause((['pay_date=\'',(getObjectProperty(___arguments.context.pageData, 'payDate')),'\''].join(''))).setPageSize(10)));
    for (var j_index in pay_records) {
      j = pay_records[j_index];
      console.log('creating payslip for ');
      console.log(getObjectProperty(j, 'dealer_name'));
      dealer = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name = \'',(getObjectProperty(j, 'dealer_name')),'\''].join(''))).setPageSize(10)))[0];
      url = (await Backendless.Request.get(`${Backendless.appPath}/services/PDFManager/createPayslip`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'payslip_objectID': JSON.stringify((getObjectProperty(j, 'objectId'))),'payperiod_objectID': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentPayPeriod')), 'objectId'))),'dealer_objectID': JSON.stringify((getObjectProperty(dealer, 'objectId'))) }).send());
      console.log(url.slice(38, url.length));
      console.log((await Backendless.Messaging.sendEmail('Pay slip', new Backendless.Bodyparts({ textmessage: 'Attached please find your payslip for the current pay period' }), ensureArray('alysha.reinard@gmail.com'), ensureArray([url.slice(38, url.length)]).filter(item => !!item))));
    }

  } catch (error) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('issue--report', ({ 'bugReport': ({ 'reportBug--name': 'Lock payroll failed','reportBug--sourcePage': 'lock and send payroll button on payroll--weeklySummary','reportBug--errorCode': [(getObjectProperty(error, 'code')),' ',(getObjectProperty(error, 'message'))].join(''),'reportBug--fullError': error }) }));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dashboard/components/3acea913f2cfce4f35b5ab3ea98309bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var unapproved_sales_this_period, approved_sales_this_period, item, transactions, pay_date, totalCommission, j, k, getSales;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    getSales = (await BackendlessUI.Functions.Custom['fn_f403d444a75a2955804dd9adabbfe888'](1661983200000, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'startDate')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'endDate')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'payDate'))));
    ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
    approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
    unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
    for (var j_index in approved_sales_this_period) {
      j = approved_sales_this_period[j_index];
      totalCommission = 0;
      var k_list = (getObjectProperty(j, 'link_to_calculations.commissions_detail'));
      for (var k_index in k_list) {
        k = k_list[k_index];
        totalCommission = (typeof totalCommission == 'number' ? totalCommission : 0) + (getObjectProperty(k, 'amount'));
      }
      j['totalCommission'] = totalCommission;
    }
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    pay_date = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'payDate'));
    transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6'](pay_date));
    ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'payment_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'approved_sales_this_period'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var dealerOptions, eachDealer, dealernames, j, PayrollTransactions;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['payrollMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Dealer Payroll History';
  ___arguments.context.pageData['isOpenModal'] = false;
  PayrollTransactions = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2323b91e50d986871adb90e4690f7b46')), null, null, null, 'pay_date desc', null));
  ___arguments.context.pageData['payrollHistory'] = PayrollTransactions;
  dealernames = [];
  dealerOptions = [];
  for (var j_index in PayrollTransactions) {
    j = PayrollTransactions[j_index];
    eachDealer = (getObjectProperty(j, 'dealer_name'));
    if (dealernames.indexOf(eachDealer) + 1 == 0) {
      addItemToList(dealernames, eachDealer);
      addItemToList(dealerOptions, ({ 'value': eachDealer,'label': eachDealer }));
    }
  }
  ___arguments.context.pageData['dealers'] = dealerOptions;

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var dealerOptions, eachDealer, dealernames, j, PayrollTransactions;


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null, null);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/e0c78a1a36ec7931b4191627c1263c93/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classesList, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/679d0fe7eb7e6b2b4631c2c47b5a23f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/06efca8e060b1437b24c83ad44f8b019/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/d06c591a41b5236d03e51096054675a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'pay_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/495b38d17815a3738768bd7917d4a794/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedDealerHistory, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  selectedDealerHistory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'payrollHistory')), async (item) => {


   return ((getObjectProperty(item, 'dealer_name')) == ___arguments.value);
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2323b91e50d986871adb90e4690f7b46', selectedDealerHistory);
  ___arguments.context.pageData['selectedDealerHistory'] = selectedDealerHistory;
  ___arguments.context.pageData['dealer_name'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/33416e8f81c79163483abf1f7f68d1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', ({ 'pay_date': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'pay_date')),'dealer_name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'dealer_name')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/f16e4031024ebc19558b7e8e13158259/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'pdf_file')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'pdf_file')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/payroll--dealerHistory/components/249ef538e297b405c1c52a72a61fd8f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, fileName, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  cleanTable = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'selectedDealerHistory'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(cleanTable, ({ 'Payroll ID': (getObjectProperty(j, 'payroll_ID')),'Dealer Name': (getObjectProperty(j, 'dealer_name')),'Pay Date': (getObjectProperty(j, 'pay_date')),'Total Payment': (getObjectProperty(j, 'payment_total')) }));
  }
  fileName = [(new Date((new Date())).getFullYear()),((getObjectProperty(___arguments.context.pageData, 'dealer_name')).replace((new RegExp('\\s', 'g')), '')),'Report'].join('');
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': fileName,'data': cleanTable,'csvOptions': ({ 'header': true,'filename': [(new Date((new Date())).getFullYear()),(getObjectProperty(___arguments.context.pageData, 'dealer_name')),'Report'].join('') }) })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var deductions, additions, j, payRecord, DealerRecord, total_commission, end_date, start_date, pay_date, DealerSales, getCommissions, pay_period;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null, null);
  if (!(getObjectProperty(___arguments.context.pageData, 'dealer_name'))) {
    ___arguments.context.pageData['dealer_name'] = ((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), null, null, 'current_matrix_level', null, null, null, null))[0]);
  }
  ___arguments.context.pageData['selectedDealerRecord'] = ((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_name = \'',(getObjectProperty(___arguments.context.pageData, 'dealer_name')),'\''].join('')), null, 'current_matrix_level', null, null, null, null))[0]);
  DealerRecord = (getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord'));
  if (getObjectProperty(___arguments.context.pageData, 'payPeriod')) {
    pay_period = (getObjectProperty(___arguments.context.pageData, 'payPeriod'));
  } else if (getObjectProperty(___arguments.context.pageData, 'pay_date')) {
    pay_period = (await BackendlessUI.Functions.Custom['fn_8942906e3188e54314e1b16ad2ddbe7c']((getObjectProperty(___arguments.context.pageData, 'pay_date'))));
    ___arguments.context.pageData['payPeriod'] = pay_period;
  } else {
    pay_period = (await BackendlessUI.Functions.Custom['fn_8405d74e154be67776e70bfde74dbca2']());
    ___arguments.context.pageData['payPeriod'] = pay_period;
  }
  start_date = (getObjectProperty(pay_period, 'startDate'));
  end_date = (getObjectProperty(pay_period, 'endDate'));
  pay_date = (getObjectProperty(pay_period, 'payDate'));
  ___arguments.context.pageData['pay_date'] = (getObjectProperty(pay_period, 'payDate'));
  DealerSales = (await BackendlessUI.Functions.Custom['fn_d83e9234cec8c604b9329622d4ea1807'](start_date, end_date, pay_date, (getObjectProperty(DealerRecord, 'dealer_name'))));
  total_commission = 0;
  var j_list = (getObjectProperty(DealerSales, 'approvedSales'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    total_commission = (typeof total_commission == 'number' ? total_commission : 0) + (getObjectProperty(j, 'amount'));
  }
  ___arguments.context.pageData['dealerSales'] = DealerSales;
  ___arguments.context.pageData['approvedSales'] = (getObjectProperty(DealerSales, 'approvedSales'));
  ___arguments.context.pageData['unapprovedSales'] = (getObjectProperty(DealerSales, 'unapprovedSales'));
  ___arguments.context.pageData['openFinanceModal'] = false;
  payRecord = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name=\'',(getObjectProperty(DealerRecord, 'dealer_name')),'\' and pay_date = ',pay_date,''].join(''))).setPageSize(100)));
  if (payRecord.length > 0) {
    payRecord = payRecord[0];
    payRecord['commissions_total'] = total_commission;
    payRecord['commissions_detail'] = (getObjectProperty(DealerSales, 'approvedSales'));
    payRecord['salary_total'] = (getObjectProperty(DealerRecord, 'salary_amount'));
    payRecord['payment_total'] = (await BackendlessUI.Functions.Custom['fn_939a67e91974f05cf52d3312ed768bb9'](total_commission, (getObjectProperty(DealerRecord, 'salary_amount')), (getObjectProperty(payRecord, 'additions_total')), (getObjectProperty(payRecord, 'reductions_total'))));
  } else {
    payRecord = ({ 'pay_date': pay_date,'payperiod_start': start_date,'payperiod_end': end_date,'dealer_name': (getObjectProperty(DealerRecord, 'dealer_name')),'reductions_detail': [],'reductions_total': 0,'additions_detail': [],'additions_total': 0,'commissions_detail': undefined,'commissions_total': total_commission,'payment_total': total_commission + (getObjectProperty(DealerRecord, 'salary_amount')),'salary_total': (getObjectProperty(DealerRecord, 'salary_amount')),'payroll_ID': (await BackendlessUI.Functions.Custom['fn_dfde89045fdd53560e581c5cc2bd3889'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))) });
  }
  additions = (getObjectProperty(payRecord, 'additions_detail'));
  if (additions == null) {
    additions = [];
  }
  for (var j_index2 in additions) {
    j = additions[j_index2];
    j['readOnly'] = false;
  }
  deductions = (getObjectProperty(payRecord, 'reductions_detail'));
  ___arguments.context.pageData['payRecord'] = payRecord;
  if (deductions == null) {
    deductions = [];
  }
  for (var j_index3 in deductions) {
    j = deductions[j_index3];
    j['readOnly'] = false;
  }
  ___arguments.context.pageData['additions'] = additions;
  ___arguments.context.pageData['subtractions'] = deductions;
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1afb40f297a108382a56c309e2dcea75')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1afb40f297a108382a56c309e2dcea75', additions);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2760039fd24fda5cf8d9dcb5337f465')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e2760039fd24fda5cf8d9dcb5337f465', deductions);
  }
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['payrollMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Dealer Payroll';

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Edit ',(getObjectProperty(___arguments.context.pageData, 'selectedDealerRecord.dealer_name')),'\'s Payroll - TellUS App'].join(''))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/e59a1f0b1df8bf3f5606a34eb708d182/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'newType')) != null && (getObjectProperty(___arguments.context.pageData, 'newAmount')) != null) {
    ___arguments.context.pageData['showError'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'newDescription')) == null) {
      ___arguments.context.pageData['newDescription'] = 'Not provided';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'newType')) == 'Bonus' || (getObjectProperty(___arguments.context.pageData, 'newType')) == 'Commission') {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'additions')), ({ 'type': (getObjectProperty(___arguments.context.pageData, 'newType')),'amount': (getObjectProperty(___arguments.context.pageData, 'newAmount')),'description': (getObjectProperty(___arguments.context.pageData, 'newDescription')),'readOnly': true }));
      (getObjectProperty(___arguments.context.pageData, 'payRecord'))['additions_detail'] = (getObjectProperty(___arguments.context.pageData, 'additions'));
      (getObjectProperty(___arguments.context.pageData, 'payRecord'))['additions_total'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'additions_total')) + (getObjectProperty(___arguments.context.pageData, 'newAmount')));
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'subtractions')), ({ 'type': (getObjectProperty(___arguments.context.pageData, 'newType')),'amount': (getObjectProperty(___arguments.context.pageData, 'newAmount')),'description': (getObjectProperty(___arguments.context.pageData, 'newDescription')),'readOnly': true }));
      (getObjectProperty(___arguments.context.pageData, 'payRecord'))['reductions_detail'] = (getObjectProperty(___arguments.context.pageData, 'subtractions'));
      (getObjectProperty(___arguments.context.pageData, 'payRecord'))['reductions_total'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'reductions_total')) + (getObjectProperty(___arguments.context.pageData, 'newAmount')));
    }
    (getObjectProperty(___arguments.context.pageData, 'payRecord'))['payment_total'] = (await BackendlessUI.Functions.Custom['fn_939a67e91974f05cf52d3312ed768bb9']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'commissions_total')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'salary_total')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'additions_total')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'reductions_total'))));
  } else {
    ___arguments.context.pageData['showError'] = true;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'payRecord'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/519603f3f6216e5ba8760995d66cb7ca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['newType'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/a424e0d9e475faf28ce23159ff7826e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['newAmount'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/47042837baf3d62dff37910192d45f89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['newDescription'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/da181e1e46ebb49ff89981b2834a4111/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save((getObjectProperty(___arguments.context.pageData, 'payRecord')), true);
  (function (message) { alert(message) })('Dealer payroll has been updated.');
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/fc6ad50f5625387f9cf1a3eeca0b4f24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'](((await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e94e433d02ebb7fd4b53304e679efc62'), 'invoiceObjectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0])));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/63f4ac71a7eaccca9245af3520d22104/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'](___arguments.context.getComponentDataStoreByUid('9bbcc084c3827ab286317dd1743683fb')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/c8570078d00dc77c154a80cfbde70b46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newAdditions, additions_total, j, typeMatch, descriptionMatch, amountMatch, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  newAdditions = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'additions')), async (item) => {
     amountMatch = (getObjectProperty(item, 'amount')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('90e7b17d17ee52cacac4bb4934c62aa3'), 'amount'));
    descriptionMatch = (getObjectProperty(item, 'description')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('90e7b17d17ee52cacac4bb4934c62aa3'), 'description'));
    typeMatch = (getObjectProperty(item, 'type')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('90e7b17d17ee52cacac4bb4934c62aa3'), 'type'));


   return (amountMatch && descriptionMatch && typeMatch ? false : true);
  }));
  ___arguments.context.pageData['additions'] = newAdditions;
  (getObjectProperty(___arguments.context.pageData, 'payRecord'))['additions_detail'] = (getObjectProperty(___arguments.context.pageData, 'additions'));
  additions_total = 0;
  for (var j_index in newAdditions) {
    j = newAdditions[j_index];
    additions_total = (typeof additions_total == 'number' ? additions_total : 0) + (getObjectProperty(j, 'amount'));
  }
  (getObjectProperty(___arguments.context.pageData, 'payRecord'))['additions_total'] = additions_total;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1afb40f297a108382a56c309e2dcea75', newAdditions);
  (getObjectProperty(___arguments.context.pageData, 'payRecord'))['payment_total'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'commissions_total')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'salary_total')) + ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'additions_total')) - (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'reductions_total'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/ce163a87babe4183c738dc041eaddfb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newSubtractions, subtractions_total, j, typeMatch, descriptionMatch, amountMatch, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  newSubtractions = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'subtractions')), async (item) => {
     amountMatch = (getObjectProperty(item, 'amount')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('db9c10a6e209fbb5d65cc21dd4afd02f'), 'amount'));
    descriptionMatch = (getObjectProperty(item, 'description')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('db9c10a6e209fbb5d65cc21dd4afd02f'), 'description'));
    typeMatch = (getObjectProperty(item, 'type')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('db9c10a6e209fbb5d65cc21dd4afd02f'), 'type'));


   return (amountMatch && descriptionMatch && typeMatch ? false : true);
  }));
  ___arguments.context.pageData['subtractions'] = newSubtractions;
  (getObjectProperty(___arguments.context.pageData, 'payRecord'))['subtractions_detail'] = (getObjectProperty(___arguments.context.pageData, 'subtractions'));
  subtractions_total = 0;
  for (var j_index in newSubtractions) {
    j = newSubtractions[j_index];
    subtractions_total = (typeof subtractions_total == 'number' ? subtractions_total : 0) + (getObjectProperty(j, 'amount'));
  }
  (getObjectProperty(___arguments.context.pageData, 'payRecord'))['reductions_total'] = subtractions_total;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e2760039fd24fda5cf8d9dcb5337f465', newSubtractions);
  (getObjectProperty(___arguments.context.pageData, 'payRecord'))['payment_total'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'commissions_total')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'salary_total')) + ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'additions_total')) - (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'reductions_total'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/5c05c104489251a91b9b8243f81bc2b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('90e7b17d17ee52cacac4bb4934c62aa3')['amount'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--dealerPayroll/components/d4c27a296e924bb64339e7bd3c636c2a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var unapproved_sales, DealerSales, approved_dealer_sales, total_commission, j, getCommissions, end_date, start_date, pay_period;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    ___arguments.context.pageData['refreshNeeded'] = false;
    pay_period = (await BackendlessUI.Functions.Custom['fn_8942906e3188e54314e1b16ad2ddbe7c']((getObjectProperty(___arguments.context.pageData, 'pay_date'))));
    start_date = (getObjectProperty(pay_period, 'startDate'));
    end_date = (getObjectProperty(pay_period, 'endDate'));
    DealerSales = (await BackendlessUI.Functions.Custom['fn_d83e9234cec8c604b9329622d4ea1807'](start_date, end_date, (getObjectProperty(___arguments.context.pageData, 'pay_date')), (getObjectProperty(___arguments.context.pageData, 'dealer_name'))));
    console.log('dealer sales');
    console.log(DealerSales);
    getCommissions = (await BackendlessUI.Functions.Custom['fn_1baceb836bea7c191ce442b123f6b177']((getObjectProperty(___arguments.context.pageData, 'dealer_name')), (getObjectProperty(DealerSales, 'approvedSales'))));
    console.log('getCommissions');
    console.log(getCommissions);
    total_commission = 0;
    var j_list = (getObjectProperty(DealerSales, 'approvedSales'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      total_commission = (typeof total_commission == 'number' ? total_commission : 0) + (getObjectProperty(j, 'amount'));
    }
    (getObjectProperty(___arguments.context.pageData, 'payRecord'))['payment_total'] = (await BackendlessUI.Functions.Custom['fn_939a67e91974f05cf52d3312ed768bb9'](total_commission, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'salary_total')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'additions_total')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payRecord')), 'reductions_total'))));
    (getObjectProperty(___arguments.context.pageData, 'payRecord'))['commissions_total'] = total_commission;
    (getObjectProperty(___arguments.context.pageData, 'payRecord'))['commissions_detail'] = (getObjectProperty(DealerSales, 'approvedSales'));
    approved_dealer_sales = (getObjectProperty(DealerSales, 'approvedSales'));
    ___arguments.context.pageData['approvedSales'] = approved_dealer_sales;
    unapproved_sales = (getObjectProperty(DealerSales, 'unapprovedSales'));
    ___arguments.context.pageData['unapprovedSales'] = unapproved_sales;
    await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  }

  return (getObjectProperty(___arguments.context.pageData, 'approvedSales'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/payroll--history/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--history/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['payrollMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Payroll History';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var payrollTransactionView, dealerOptions, eachDealer, dealernames, j, PayrollTransactions;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null, null);
  payrollTransactionView = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((String('pay_date is not null'))).setSortBy('pay_date DESC').setPageSize(100)));
  ___arguments.context.pageData['filteredPayrollHistory'] = payrollTransactionView;
  ___arguments.context.pageData['payrollHistory'] = payrollTransactionView;
  dealernames = [];
  dealerOptions = [];
  for (var j_index in payrollTransactionView) {
    j = payrollTransactionView[j_index];
    eachDealer = (getObjectProperty(j, 'dealer_name'));
    if (dealernames.indexOf(eachDealer) + 1 == 0) {
      addItemToList(dealernames, eachDealer);
      addItemToList(dealerOptions, ({ 'value': eachDealer,'label': eachDealer }));
    }
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', dealerOptions);
  ___arguments.context.pageData['dealers'] = dealerOptions;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8068f9e0a38b0c84182686e8abce25f', payrollTransactionView);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/payroll--history/components/e0c78a1a36ec7931b4191627c1263c93/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classesList, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/payroll--history/components/679d0fe7eb7e6b2b4631c2c47b5a23f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--history/components/06efca8e060b1437b24c83ad44f8b019/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--history/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--history/components/de542c5b795bf291829c26f2cfc8461c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['endDate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--history/components/708c360cd01bc602edd9da05525eb943/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('passing dealers to form "Payroll form" isn\'t working');
  ___arguments.context.dataModel['dealers'] = (getObjectProperty(___arguments.context.pageData, 'dealers'));
  console.log(getObjectProperty(___arguments.context.pageData, 'dealers'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/payroll--history/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var payroll_objects, whereClause, j, whereList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereList = [];
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealerName')) {
    addItemToList(whereList, [['dealer_name like \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealerName')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')) {
    addItemToList(whereList, [['pay_date >= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')) {
    addItemToList(whereList, [['pay_date <= \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'\''].join('')]);
  }
  whereClause = whereList[0];
  if (whereList.length > 1) {
    var j_list = whereList.slice(1, whereList.length);
    for (var j_index in j_list) {
      j = j_list[j_index];
      whereClause = [whereClause,' AND ',j].join('');
    }
  }
  ___arguments.context.pageData['whereClause'] = whereClause;
  payroll_objects = (await Backendless.Data.of('payroll_history_view').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setSortBy('pay_date DESC').setPageSize(100)));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = payroll_objects;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8068f9e0a38b0c84182686e8abce25f', payroll_objects);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--history/components/5963354568e10f02cefeef12fcfbbb38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--payrunView', ({ 'selectedPayrun': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8838d8ec4bfc373fc403521482b14849'), 'pay_date')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--history/components/8a6d1dc58f243026cef1c4afc8d8d41f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8838d8ec4bfc373fc403521482b14849'), 'pay_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--history/components/8f225be49e89487368dbdd4beca5a02e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8838d8ec4bfc373fc403521482b14849'), 'salary_total'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--history/components/cadde8b526e4877cb02968d63956a1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8838d8ec4bfc373fc403521482b14849'), 'reductions_total'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--history/components/8c828fe72d8cc8eda54af7e274f219cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8838d8ec4bfc373fc403521482b14849'), 'commissions_total'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--history/components/f9c38c58626fef0b174ac4390e0f32af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8838d8ec4bfc373fc403521482b14849'), 'payment_total'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--history/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8068f9e0a38b0c84182686e8abce25f', (getObjectProperty(___arguments.context.pageData, 'payrollHistory')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--payrunView/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--payrunView/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['pageTitle'] = 'Payrun View';
  ___arguments.context.pageData['payrollMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var dealerOptions, eachDealer, dealernames, j, PayrollTransactions, selectedPayrunDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  selectedPayrunDate = (getObjectProperty(___arguments.context.pageData, 'selectedPayrun'));
  PayrollTransactions = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['pay_date = \'',selectedPayrunDate,'\''].join(''))).setPageSize(100)));
  ___arguments.context.pageData['filteredPayrollHistory'] = PayrollTransactions;
  ___arguments.context.pageData['payrollHistory'] = PayrollTransactions;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2323b91e50d986871adb90e4690f7b46', PayrollTransactions);
  dealernames = [];
  dealerOptions = [];
  for (var j_index in PayrollTransactions) {
    j = PayrollTransactions[j_index];
    eachDealer = (getObjectProperty(j, 'dealer_name'));
    if (dealernames.indexOf(eachDealer) + 1 == 0) {
      addItemToList(dealernames, eachDealer);
      addItemToList(dealerOptions, ({ 'value': eachDealer,'label': eachDealer }));
    }
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', dealerOptions);
  ___arguments.context.pageData['dealers'] = dealerOptions;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/payroll--payrunView/components/e0c78a1a36ec7931b4191627c1263c93/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classesList, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/payroll--payrunView/components/679d0fe7eb7e6b2b4631c2c47b5a23f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--payrunView/components/06efca8e060b1437b24c83ad44f8b019/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--payrunView/components/d06c591a41b5236d03e51096054675a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'pay_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--payrunView/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--payrunView/components/de542c5b795bf291829c26f2cfc8461c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['endDate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--payrunView/components/708c360cd01bc602edd9da05525eb943/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('passing dealers to form "Payroll form" isn\'t working - payroll form on mounted');
  ___arguments.context.dataModel['dealers'] = (getObjectProperty(___arguments.context.pageData, 'dealers'));
  console.log(getObjectProperty(___arguments.context.pageData, 'dealers'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/payroll--payrunView/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var payroll_objects, whereClause, j, whereList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereList = [];
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealerName')) {
    addItemToList(whereList, [['dealer_name like \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealerName')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')) {
    addItemToList(whereList, [['payperiod_start >=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')) {
    addItemToList(whereList, [['payperiod_end<=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'\''].join('')]);
  }
  whereClause = whereList[0];
  if (whereList.length > 1) {
    var j_list = whereList.slice(1, whereList.length);
    for (var j_index in j_list) {
      j = j_list[j_index];
      whereClause = [whereClause,' AND ',j].join('');
    }
  }
  ___arguments.context.pageData['whereClause'] = whereClause;
  payroll_objects = (await Backendless.Data.of('Payroll_transactions').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setSortBy('pay_date DESC').setPageSize(100)));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = payroll_objects;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2323b91e50d986871adb90e4690f7b46', payroll_objects);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--payrunView/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2323b91e50d986871adb90e4690f7b46', (getObjectProperty(___arguments.context.pageData, 'payrollHistory')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--payrunView/components/5ccc0a44143cbdeacd390814384e1d4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['addPayrollNoteModal'] = true;
  ___arguments.context.pageData['selectedPayrollTransaction'] = ({ 'payDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'pay_date')),'dealerName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5aacd429c81186aacf0e7a1a2a8bb68d'), 'dealer_name')),'payrollID': undefined });
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, approved_sales_this_period, getSales, unapproved_sales_this_period, pay_date, end_date, start_date, pay_period, pay_periods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  pay_periods = (await Backendless.Data.of('Pay_periods').find(Backendless.DataQueryBuilder.create().setSortBy('pay_date').setPageSize(100)));
  ___arguments.context.pageData['payPeriods'] = pay_periods;
  pay_period = pay_periods.slice(-2)[0];
  ___arguments.context.pageData['currentPayPeriod'] = pay_period;
  start_date = (getObjectProperty(pay_period, 'start_date'));
  ___arguments.context.pageData['startDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](start_date));
  end_date = (getObjectProperty(pay_period, 'end_date'));
  ___arguments.context.pageData['endDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](end_date));
  pay_date = (getObjectProperty(pay_period, 'pay_date'));
  ___arguments.context.pageData['payDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](pay_date));
  ___arguments.context.pageData['payDate'] = pay_date;
  ___arguments.context.pageData['startDate'] = start_date;
  ___arguments.context.pageData['endDate'] = end_date;
  getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, start_date, end_date, pay_date));
  ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
  approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
  unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
  ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
  ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
  ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((approved_sales_this_period.length > 1 ? (await Promise.all(approved_sales_this_period.map(async item => {; return (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'commissionsTotal'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['showDealerOptions'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/payroll--reports/components/72a1df672b89de98462ed52abb06e0db/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/payroll--reports/components/f15ebef41c23f006b1656bdcd46150c2/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/payroll--reports/components/e352044bfd359885cb716f5b52bdbf5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  saleRecord = (await BackendlessUI.Functions.Custom['fn_c65b588280452c4e9eb6152982cbb2cb'](___arguments.context.getComponentDataStoreByUid('278c690bf5adacd5687899dc57462ff2')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/b95bc65aa8e2b26c45e8675f30166621/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  saleRecord = (await BackendlessUI.Functions.Custom['fn_c65b588280452c4e9eb6152982cbb2cb'](___arguments.context.getComponentDataStoreByUid('b612fe73430873aae945988b9c466f3a')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/8fdf313c1f09c4dc8cc37d26fd5d813a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, approved_sales_this_period, getSales, pay_date, end_date, start_date, pay_period;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  pay_period = (await Backendless.Data.of('Pay_periods').find(Backendless.DataQueryBuilder.create().setWhereClause((['start_date< \'',((new Date()).valueOf()),'\' AND end_date> \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(10)))[0];
  start_date = (getObjectProperty(pay_period, 'start_date'));
  ___arguments.context.pageData['startDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](start_date));
  end_date = (getObjectProperty(pay_period, 'end_date'));
  ___arguments.context.pageData['endDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](end_date));
  pay_date = (getObjectProperty(pay_period, 'pay_date'));
  ___arguments.context.pageData['payDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](pay_date));
  ___arguments.context.pageData['startDate'] = start_date;
  ___arguments.context.pageData['endDate'] = end_date;
  getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, start_date, end_date, pay_date));
  ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
  approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3acea913f2cfce4f35b5ab3ea98309bb')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3acea913f2cfce4f35b5ab3ea98309bb', approved_sales_this_period);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('97cc1c51621289d4e68b454f9a3b2e4a')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('97cc1c51621289d4e68b454f9a3b2e4a', (getObjectProperty(getSales, 'unapprovedSales')));
  }
  ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((approved_sales_this_period.length > 1 ? (await Promise.all(approved_sales_this_period.map(async item => {; return (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'commissionsTotal'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['openFinanceModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/0fce543221c2602655a3b0b6f9d69489/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--weeklySummary', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/289b90f869f85c66a8c7db25e9e9a99f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, approved_sales_this_period, getSales, unapproved_sales_this_period, pay_date, end_date, start_date, pay_period, index, pay_periods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  pay_periods = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  index = pay_periods.indexOf(getObjectProperty(___arguments.context.pageData, 'currentPayPeriod')) + 1;
  if (index < pay_periods.length) {
    pay_period = pay_periods[((index + 1) - 1)];
    ___arguments.context.pageData['currentPayPeriod'] = pay_period;
    start_date = (getObjectProperty(pay_period, 'start_date'));
    ___arguments.context.pageData['startDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](start_date));
    end_date = (getObjectProperty(pay_period, 'end_date'));
    ___arguments.context.pageData['endDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](end_date));
    pay_date = (getObjectProperty(pay_period, 'pay_date'));
    ___arguments.context.pageData['payDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](pay_date));
    ___arguments.context.pageData['startDate'] = start_date;
    ___arguments.context.pageData['endDate'] = end_date;
    ___arguments.context.pageData['payDate'] = pay_date;
    getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, start_date, end_date, pay_date));
    ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
    approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
    unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((approved_sales_this_period.length > 1 ? (await Promise.all(approved_sales_this_period.map(async item => {; return (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'commissionsTotal'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/30aa1691b821dfd2ee0719724b9d7287/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--weeklySummary', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/ddabcb9cd8f1b3ca4f9d356b508d45be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, approved_sales_this_period, getSales, pay_date, end_date, start_date, pay_period, index, pay_periods, unapproved_sales_this_period;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  pay_periods = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  index = pay_periods.indexOf(getObjectProperty(___arguments.context.pageData, 'currentPayPeriod')) + 1;
  if (index > 0) {
    pay_period = pay_periods[((index - 1) - 1)];
    ___arguments.context.pageData['currentPayPeriod'] = pay_period;
    start_date = (getObjectProperty(pay_period, 'start_date'));
    ___arguments.context.pageData['startDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](start_date));
    end_date = (getObjectProperty(pay_period, 'end_date'));
    ___arguments.context.pageData['endDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](end_date));
    pay_date = (getObjectProperty(pay_period, 'pay_date'));
    ___arguments.context.pageData['payDateDisplay'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf'](pay_date));
    ___arguments.context.pageData['startDate'] = start_date;
    ___arguments.context.pageData['endDate'] = end_date;
    ___arguments.context.pageData['payDate'] = pay_date;
    getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, start_date, end_date, pay_date));
    ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
    approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
    unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((approved_sales_this_period.length > 1 ? (await Promise.all(approved_sales_this_period.map(async item => {; return (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'commissionsTotal'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/efb54a5ffe92c6f25207732547dea51d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dealerNames, j, dealerTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerTable = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  dealerNames = [];
  for (var j_index in dealerTable) {
    j = dealerTable[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }
  ___arguments.context.pageData['dealers'] = dealerNames;
  ___arguments.context.pageData['showDealerOptions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/348bb0e1185753e2bd79fc79308d5318/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var dealerName;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', ({ 'dealer_name': ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--reports/components/77fd7d4beeea685ed62c6ac1552c5117/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dealerNames, j, dealerTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerTable = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  dealerNames = [];
  for (var j_index in dealerTable) {
    j = dealerTable[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }
  ___arguments.context.pageData['dealers'] = dealerNames;
  ___arguments.context.pageData['showDealerOptions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/a529bae355edfd2cc41110df92b1a59d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--history', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/33f183cff98c1b41bfaa6008c6140a65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerHistory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/4ee73d012cba15572f73b0d3c015b4e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var url, dealer, j, pay_records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  pay_records = (await Backendless.Data.of('Payroll_transactions').find(Backendless.DataQueryBuilder.create().setWhereClause((['pay_date=\'',(getObjectProperty(___arguments.context.pageData, 'payDate')),'\''].join(''))).setPageSize(10)));
  for (var j_index in pay_records) {
    j = pay_records[j_index];
    console.log('creating payslip for ');
    console.log(getObjectProperty(j, 'dealer_name'));
    dealer = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name = \'',(getObjectProperty(j, 'dealer_name')),'\''].join(''))).setPageSize(10)))[0];
    console.log('sending email');
    url = (await Backendless.Request.get(`${Backendless.appPath}/services/PDFManager/createPayslip`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'payslip_objectID': JSON.stringify((getObjectProperty(j, 'objectId'))),'payperiod_objectID': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentPayPeriod')), 'objectId'))),'dealer_objectID': JSON.stringify((getObjectProperty(dealer, 'objectId'))) }).send());
    console.log(url.slice(38, url.length));
    console.log((await Backendless.Messaging.sendEmail('Pay slip', new Backendless.Bodyparts({ textmessage: 'Attached please find your payslip for the current pay period' }), ensureArray('alysha.reinard@gmail.com'), ensureArray([url.slice(38, url.length)]).filter(item => !!item))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--reports/components/3acea913f2cfce4f35b5ab3ea98309bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var approved_sales_this_period, unapproved_sales_this_period, item, getSales;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    getSales = (await BackendlessUI.Functions.Custom['fn_830138742c16fc44bbfbebea238e3e19'](1661983200000, (getObjectProperty(___arguments.context.pageData, 'startDate')), (getObjectProperty(___arguments.context.pageData, 'endDate')), (getObjectProperty(___arguments.context.pageData, 'payDate'))));
    ___arguments.context.pageData['salesThisPeriod'] = (getObjectProperty(getSales, 'allSales'));
    approved_sales_this_period = (getObjectProperty(getSales, 'approvedSales'));
    unapproved_sales_this_period = (getObjectProperty(getSales, 'unapprovedSales'));
    ___arguments.context.pageData['payrollAmountDue'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((approved_sales_this_period.length > 1 ? (await Promise.all(approved_sales_this_period.map(async item => {; return (getObjectProperty((getObjectProperty(item, 'link_to_calculations')), 'commissionsTotal'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['approved_sales_this_period'] = approved_sales_this_period;
    ___arguments.context.pageData['unapproved_sales_this_period'] = unapproved_sales_this_period;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'approved_sales_this_period'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, transactions, pay_period, pay_periods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null, null);

  })();
  ___arguments.context.pageData['lockPayrollNotifications'] = false;
  ___arguments.context.pageData['PayrollPDFSummary'] = (String('<!--<h4>Preparing payroll</h4>-->'));
  ___arguments.context.pageData['showSummaryBlock'] = false;
  pay_periods = (await BackendlessUI.Functions.Custom['fn_d12e99a80bd1fd1fbc2ced1a87712091'](null));
  ___arguments.context.pageData['payPeriods'] = pay_periods;
  pay_period = (await BackendlessUI.Functions.Custom['fn_8405d74e154be67776e70bfde74dbca2']());
  ___arguments.context.pageData['payPeriod'] = pay_period;
  transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6']((getObjectProperty(pay_period, 'payDate'))));
  ___arguments.context.pageData['payrollTransactionsThisPeriod'] = transactions;
  ___arguments.context.pageData['totalCommissions'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'commissions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  ___arguments.context.pageData['totalBonuses'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'additions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  ___arguments.context.pageData['totalDeductions'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'reductions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  ___arguments.context.pageData['totalPayroll'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'payment_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
  ___arguments.context.pageData['payrollMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Payroll Summary';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/bb79fb8c1ea46eab51fce6f2dd9f81ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/acf13123ba7e5fabca1db4126fb75817/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var url, dealer, betterURL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  dealer = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_name = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'dealer_name')),'\''].join('')), null, null, null, null, null, null))[0];
  ___arguments.context.pageData['PayrollPDFSummary'] = ([(getObjectProperty(___arguments.context.pageData, 'PayrollPDFSummary')),'\n','<p class="payrollSummary--dealerEmail">','Sending payslip email to ',(getObjectProperty(dealer, 'dealer_email')),'</p>'].join(''));
  url = (await Backendless.Request.get(`${Backendless.appPath}/services/PDFManager/createPayslip`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'payslip_objectID': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId'))),'payperiod_objectID': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'objectId'))),'dealer_objectID': JSON.stringify((getObjectProperty(dealer, 'objectId'))),'office_objectID': JSON.stringify(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())),'payslip_table': JSON.stringify((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))),'payperiod_table': JSON.stringify((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payperiod_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))),'dealer_table': JSON.stringify((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))) }).send());
  betterURL = url.slice(32, url.length);
  ___arguments.context.pageData['PayrollPDFSummary'] = ([(getObjectProperty(___arguments.context.pageData, 'PayrollPDFSummary')),'<p class="payrollSummary--dealerPayslip">',['<a href="',url,'" target="_blank">','Download Payslip','</a>'].join(''),'</p>'].join(''));
  console.log((await Backendless.Messaging.sendEmail('Pay slip', new Backendless.Bodyparts({ htmlmessage: (String('Here is the link to your payslip for the current pay period.  ') + String(url)) }), ensureArray([(getObjectProperty(dealer, 'dealer_email')), null]), undefined)));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(url, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/289b90f869f85c66a8c7db25e9e9a99f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, transactions, payPeriod, index, allPayPeriods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allPayPeriods = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  payPeriod = (getObjectProperty(___arguments.context.pageData, 'payPeriod'));
  index = (getObjectProperty(payPeriod, 'index'));
  if (index <= allPayPeriods.length + 1) {
    payPeriod = allPayPeriods[((index + 1) - 1)];
    payPeriod['index'] = (index + 1);
    ___arguments.context.pageData['payPeriod'] = payPeriod;
    transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6']((getObjectProperty(payPeriod, 'payDate'))));
    ___arguments.context.pageData['payrollTransactionsThisPeriod'] = transactions;
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', transactions);
    }
    ___arguments.context.pageData['totalCommissions'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'commissions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['totalBonuses'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'additions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['totalDeductions'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'reductions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['totalPayroll'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'payment_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/ddabcb9cd8f1b3ca4f9d356b508d45be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, transactions, payPeriod, index, allPayPeriods;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allPayPeriods = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  payPeriod = (getObjectProperty(___arguments.context.pageData, 'payPeriod'));
  index = (getObjectProperty(payPeriod, 'index'));
  if (index > 0) {
    payPeriod = allPayPeriods[((index - 1) - 1)];
    payPeriod['index'] = (index - 1);
    ___arguments.context.pageData['payPeriod'] = payPeriod;
    transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6']((getObjectProperty(payPeriod, 'payDate'))));
    ___arguments.context.pageData['payrollTransactionsThisPeriod'] = transactions;
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', transactions);
    }
    ___arguments.context.pageData['totalCommissions'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'commissions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['totalBonuses'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'additions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['totalDeductions'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'reductions_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    ___arguments.context.pageData['totalPayroll'] = (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((transactions.length > 0 ? (await Promise.all(transactions.map(async item => {; return (getObjectProperty(item, 'payment_total'));}))).reduce(function(x, y) {return x + y;}) : 0)));
    await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/5a0e65fe535d21aa67a957d4bc78354e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dealerNames, j, dealerTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  dealerTable = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), 'dealer_active = true', 'dealer_nameLast ASC', null, null, null, null, true));
  dealerNames = [];
  for (var j_index in dealerTable) {
    j = dealerTable[j_index];
    addItemToList(dealerNames, ({ 'value': (getObjectProperty(j, 'dealer_name')),'label': (getObjectProperty(j, 'dealer_name')) }));
  }
  ___arguments.context.pageData['dealers'] = dealerNames;
  ___arguments.context.pageData['showDealerOptions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/fea1ca2c4c8f04b93e99ea044fa1fa98/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var payrollObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  payrollObject = ({ 'dealer_name': (getObjectProperty(___arguments.context.pageData, 'manualDealer')),'pay_date': ___arguments.value });
  await Backendless.Data.of('Payroll_transactions').save(payrollObject, true);
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', payrollObject);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/8f75deaca35a80e29db3e07a44b8e971/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dealer, url, betterURL, j, pay_records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  ___arguments.context.pageData['showSummaryBlock'] = true;
  pay_records = (getObjectProperty(___arguments.context.pageData, 'payrollTransactionsThisPeriod'));
  ___arguments.context.pageData['lockPayrollNotifications'] = true;
  for (var j_index in pay_records) {
    j = pay_records[j_index];
    ___arguments.context.pageData['PayrollPDFSummary'] = ([(getObjectProperty(___arguments.context.pageData, 'PayrollPDFSummary')),'<p class="payrollSummary--dealerName">','Creating payslip for ',(getObjectProperty(j, 'dealer_name')),'</p>'].join(''));
    dealer = (await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['dealer_name = \'',(getObjectProperty(j, 'dealer_name')),'\''].join('')), null, null, null, null, null, null))[0];
    ___arguments.context.pageData['PayrollPDFSummary'] = ([(getObjectProperty(___arguments.context.pageData, 'PayrollPDFSummary')),'\n','<p class="payrollSummary--dealerEmail">','Sending payslip email to ',(getObjectProperty(dealer, 'dealer_email')),'</p>'].join(''));
    url = (await Backendless.Request.get(`${Backendless.appPath}/services/PDFManager/createPayslip`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'payslip_objectID': JSON.stringify((getObjectProperty(j, 'objectId'))),'payperiod_objectID': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'objectId'))),'dealer_objectID': JSON.stringify((getObjectProperty(dealer, 'objectId'))),'office_objectID': JSON.stringify(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())),'payslip_table': JSON.stringify((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))),'payperiod_table': JSON.stringify((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payperiod_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))),'dealer_table': JSON.stringify((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('dealer_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))) }).send());
    betterURL = url.slice(32, url.length);
    ___arguments.context.pageData['PayrollPDFSummary'] = ([(getObjectProperty(___arguments.context.pageData, 'PayrollPDFSummary')),'<p class="payrollSummary--dealerPayslip">',['<a href="',url,'" target="_blank">','Download Payslip','</a>'].join(''),'</p>'].join(''));
    await Backendless.Messaging.sendEmail('Pay slip', new Backendless.Bodyparts({ htmlmessage: (String('Here is the link to your payslip for the current pay period.  ') + String(url)) }), ensureArray([(getObjectProperty(dealer, 'dealer_email')), null]), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/295afd544a7973ecc50ea7dd2b9d14ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'payment_total')) != 0)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var transactions;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Payroll_transactions').remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')) );
  transactions = (await BackendlessUI.Functions.Custom['fn_14b6721c0c625937cb12db1e89df10c6']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'payPeriod')), 'payDate'))));
  ___arguments.context.pageData['payrollTransactionsThisPeriod'] = transactions;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'payment_total')) != 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('295afd544a7973ecc50ea7dd2b9d14ab'))['background-color'] = '#ffd6db';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('295afd544a7973ecc50ea7dd2b9d14ab'))['cursor'] = 'not-allowed';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/9a63ab65ed7f1c1708138cf6ae0daa18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var paydates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['manualDealer'] = ___arguments.value;
  paydates = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(paydates, ({ 'value': (getObjectProperty(j, 'payDate')),'label': (getObjectProperty(j, 'payDateDisplay')) }));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'payPeriods'));
  console.log(paydates);
  ___arguments.context.pageData['paydates'] = paydates;
  ___arguments.context.pageData['showPaydateOptions'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/af85cdddf31c553d5051ea74193ab08f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Pay Date: ') + String(getObjectProperty(___arguments.context.pageData, 'payPeriod.payDateDisplay')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/payroll--weeklySummary/components/1a9668c88d546e444ba73aae1eb7de21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newRecord, payrollTransactions, j, match, item, activeDealerSalaries;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  activeDealerSalaries = (await BackendlessUI.Functions.Custom['fn_4204bf1a26e43ef7b1743ab56ce34a8e']());
  payrollTransactions = (getObjectProperty(___arguments.context.pageData, 'payrollTransactionsThisPeriod'));
  for (var j_index in activeDealerSalaries) {
    j = activeDealerSalaries[j_index];
    match = (await asyncListFilter(payrollTransactions, async (item) => {


     return ((getObjectProperty(item, 'dealer_name')) == (getObjectProperty(j, 'dealer_name')));
    }));
    if (match.length == 1) {
      match = match[0];
      match['salary_total'] = (getObjectProperty(j, 'salary'));
      match['payment_total'] = ((getObjectProperty(match, 'payment_total')) + (getObjectProperty(j, 'salary')));
      await Backendless.Data.of('Payroll_transactions').save(match, true);
    } else if (match.length == 0) {
      newRecord = ({ 'link_to_dealer': (getObjectProperty(j, 'objectId')),'dealer_name': (getObjectProperty(j, 'dealer_name')),'pay_date': (getObjectProperty(___arguments.context.pageData, 'payPeriod.payDate')),'salary_total': (getObjectProperty(j, 'salary')),'commissions_total': 0,'additions_total': 0,'reductions_total': 0,'payment_total': (getObjectProperty(j, 'salary')),'reductions_detail': [],'additions_detail': [],'commissions_detail': [],'payroll_ID': (await BackendlessUI.Functions.Custom['fn_dfde89045fdd53560e581c5cc2bd3889'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))) });
      newRecord['objectId'] = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('payrollTransaction_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(newRecord, true));
      addItemToList(payrollTransactions, newRecord);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addon_old/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addon_old/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['addonSaleModal'] = false;
  ___arguments.context.pageData['whereClause'] = (String('form_used = \'Add-on\''));
  ___arguments.context.pageData['filterChoice'] = (String('All add-ons'));
  ___arguments.context.pageData['pageTitle'] = 'Sales Addons';
  ___arguments.context.pageData['salesMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--addon_old/components/8a26ce4a1e7a819fe26cefaeb921e906/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var customer_name, possSalesList, likelySale, j, possibleSales, searchRangeStop, searchRangeStart, sales_date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedAddon'] = ___arguments.selectedRecord;
  customer_name = (getObjectProperty(___arguments.selectedRecord, 'customer_name'));
  sales_date = (getObjectProperty(___arguments.selectedRecord, 'sales_date'));
  searchRangeStart = ((new Date((new Date(sales_date)).getTime() - ((2 * 3600) * 1000))).valueOf());
  searchRangeStop = ((new Date((new Date(sales_date)).getTime() + ((7 * 86400) * 1000))).valueOf());
  possibleSales = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['sales_date>=',searchRangeStart,'AND sales_date<',searchRangeStop].join(''))).setSortBy('sales_date DESC').setPageSize(100)));
  likelySale = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['sales_date>=',searchRangeStart,'AND sales_date<',searchRangeStop,'AND cust_name = \'',customer_name,'\''].join(''))).setPageSize(10)))[0];
  if (likelySale == null) {
    likelySale = possibleSales[0];
  }
  possSalesList = [];
  for (var j_index in possibleSales) {
    j = possibleSales[j_index];
    addItemToList(possSalesList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': [(getObjectProperty(j, 'cust_name')),' ',(await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(j, 'sales_date'))))].join('') }));
  }
  ___arguments.context.pageData['selectedInvoice'] = (getObjectProperty(likelySale, 'objectId'));
  ___arguments.context.pageData['possibleSales'] = possSalesList;
  ___arguments.context.pageData['customerName'] = customer_name;
  ___arguments.context.pageData['orderNumber'] = (getObjectProperty(___arguments.selectedRecord, 'order_number'));
  ___arguments.context.pageData['addonSaleModal'] = true;

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'whereClause'))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTableNameAssignment */
  async ['onTableNameAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOther_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))

  },
  /* handler:onTableNameAssignment */
  /* content */
}))

define('./pages/sales--addon_old/components/0b930fb7a7a2b7f7900ce28531a8c702/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Orphan add-ons') {
    ___arguments.context.pageData['whereClause'] = (String('form_used = \'Add-on\' and connected_to_sale = false'));
  } else if (___arguments.value == 'Connected add-ons') {
    ___arguments.context.pageData['whereClause'] = (String('form_used = \'Add-on\' and connected_to_sale = true'));
  } else {
    ___arguments.context.pageData['whereClause'] = (String('form_used = \'Add-on\''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addons/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var sales_table, j, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('sales', null, null);
  ___arguments.context.pageData['pageTitle'] = 'Add-on Sales';
  ___arguments.context.pageData['salesMenuOpen'] = true;
  ___arguments.context.pageData['whereClause'] = (String('form_used LIKE \'demo\' OR form_used LIKE \'Demo\''));
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf4a68dbff19efd1724a5a13cadb5b7f')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', null));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](sales_table);
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--addons/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects, whereClause, j, whereList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereList = [];
  if (getObjectProperty(___arguments.context.pageData, 'flagged')) {
    addItemToList(whereList, ['link_to_calculations.red_flag = true']);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')) {
    addItemToList(whereList, [['order_num=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')) {
    addItemToList(whereList, [['sales_date>=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')) {
    addItemToList(whereList, [['sales_date<=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')) {
    addItemToList(whereList, [['dealer_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')) {
    addItemToList(whereList, [['cust_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.pageData, 'cancelled')) {
    addItemToList(whereList, [String('sale_cancelled=true')]);
  } else {
    addItemToList(whereList, [String('sale_cancelled=false')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')) {
    addItemToList(whereList, [['link_to_calculations.sale_type=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')),'\''].join('')]);
  }
  whereClause = whereList[0];
  if (whereList.length > 1) {
    var j_list = whereList.slice(1, whereList.length);
    for (var j_index in j_list) {
      j = j_list[j_index];
      whereClause = [whereClause,' AND ',j].join('');
    }
  }
  ___arguments.context.pageData['whereClause'] = whereClause;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addons/components/72ea530a22586916ed9544287529e324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['customer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  ___arguments.context.pageData['modalLoading'] = true;
  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;
  ___arguments.context.pageData['modalLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addons/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addons/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addons/components/e60d3ac83759bd74a71e5fd36734b2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['flagged'] = (!(getObjectProperty(___arguments.context.pageData, 'flagged')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'flagged')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#cccccc';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--addons/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var sales_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, null, null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in sales_table) {
      j = sales_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['sales_table'] = sales_table;
    ___arguments.context.pageData['filtered_sales_table'] = sales_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/sales--addons/components/dfabf62d756fda2b26b81466095b2fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['saleType'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.sale_type=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.sale_type=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--addons/components/85043e543db576c7e314c7a26ff89a2c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var saleType;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'setBackground')) && (getObjectProperty(___arguments.context.dataModel, 'link_to_calculations'))) {
    saleType = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'link_to_calculations')), 'sale_type'));
    ___arguments.context.dataModel['setBackground'] = false;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--addons/components/a8c7e1c17aeb0504da1e9e1cce898fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['cancelled'] = (!(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled'))), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'cancelled')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#cccccc';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sales--addons/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--addons/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--dashboard/components/097b9fa7f97e1a167d7c51d8e561e78a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--thisMonthsSales', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--dashboard/components/e5c6c583634d306cc55898fb558796af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--topGiveaway', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--dashboard/components/af5708bf24bfcf5d5d513fc4c92b9afd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--history', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--dashboard/components/a73ba6151135a2e3d521597337ef4302/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dealerSales', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var last_month_total, yearly_total, weekly_total, monthly_total, i, temp, group_total, where_lastmonth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  where_lastmonth = ['sales_YM=\'',(new Date((new Date())).getFullYear()),(new Date((new Date())).getMonth() + 1) - 1,'\''].join('');
  temp = (await Backendless.Data.of('Sales_invoice').find(Backendless.DataQueryBuilder.create().setWhereClause(where_lastmonth).setProperties('sale_total_with_tax').setPageSize(100)));
  group_total = (await Backendless.Data.of('Sales_invoice').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(where_lastmonth)));
  var i_inc = 1;
  if (1 > group_total) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= group_total : i >= group_total; i += i_inc) {
    last_month_total = (typeof last_month_total == 'number' ? last_month_total : 0) + (getObjectProperty((temp[(i - 1)]), 'sale_total_with_tax'));
    console.log(last_month_total);
    console.log(i);
  }
  monthly_total = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b']((getObjectProperty(((await Backendless.Data.of('this_month_sales_total_for_dashboard').find(Backendless.DataQueryBuilder.create().setPageSize(10)))[0]), 'sale_total_with_tax'))));
  weekly_total = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b']((getObjectProperty(((await Backendless.Data.of('this_weeks_sales_total_for_dashboard').find(Backendless.DataQueryBuilder.create().setPageSize(10)))[0]), 'sale_total_with_tax'))));
  yearly_total = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b']((getObjectProperty(((await Backendless.Data.of('this_years_sales_total_for_dashboard').find(Backendless.DataQueryBuilder.create().setPageSize(10)))[0]), 'sale_total_with_tax'))));
  ___arguments.context.pageData['monthly_total'] = monthly_total;
  ___arguments.context.pageData['weekly_total'] = weekly_total;
  ___arguments.context.pageData['yearly_total'] = yearly_total;
  ___arguments.context.pageData['last_month_total'] = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b'](last_month_total));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Sales Dashboard';
  ___arguments.context.pageData['salesMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--dealerSales/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Sales By Dealer';
  ___arguments.context.pageData['salesMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--dealerSales/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--demos_old/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--demos_old/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Sales Demos';
  ___arguments.context.pageData['salesMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--demos_old/components/8a26ce4a1e7a819fe26cefaeb921e906/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'filterDemos')) {
    whereClause = ['(form_used LIKE \'Demo\' OR form_used = \'Demo Only\')','AND sales_date >= \'',(getObjectProperty(___arguments.context.pageData, 'datesSelected.startDate')),'\' and sales_date <= \'',(getObjectProperty(___arguments.context.pageData, 'datesSelected.endDate')),'\''].join('');
  } else {
    whereClause = 'form_used LIKE \'Demo\' OR form_used = \'Demo Only\' ';
  }

  return whereClause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/sales--demos_old/components/01e6fba6a25aa201b30f8c880c6ff9a4/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.dataModel, 'startDate')) && (getObjectProperty(___arguments.context.dataModel, 'endDate'))) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7154b3af87eb323ca8924b9dfa3568e8')), 'fieldError', '');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('df2c71986febcdbd683d92d549f6577b')), 'fieldError', '');
    ___arguments.context.pageData['datesSelected'] = ({ 'startDate': (getObjectProperty(___arguments.context.dataModel, 'startDate')),'endDate': (getObjectProperty(___arguments.context.dataModel, 'endDate')) });
    ___arguments.context.pageData['filterDemos'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76ef52ac3c64412fc682bb9754f1cee7', true);
  } else if ((getObjectProperty(___arguments.context.dataModel, 'startDate')) && (getObjectProperty(___arguments.context.dataModel, 'endDate')) == null) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('df2c71986febcdbd683d92d549f6577b')), 'fieldError');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7154b3af87eb323ca8924b9dfa3568e8')), 'fieldError', '');
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2f7c58d30b44f51c8ad40f69402be323', undefined, undefined, undefined, undefined, undefined);
  } else if ((getObjectProperty(___arguments.context.dataModel, 'endDate')) && (getObjectProperty(___arguments.context.dataModel, 'startDate')) == null) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7154b3af87eb323ca8924b9dfa3568e8')), 'fieldError');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('df2c71986febcdbd683d92d549f6577b')), 'fieldError', '');
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2f7c58d30b44f51c8ad40f69402be323', undefined, undefined, undefined, undefined, undefined);
  } else {
    console.log('Conditions Not Met');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7154b3af87eb323ca8924b9dfa3568e8')), 'fieldError');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('df2c71986febcdbd683d92d549f6577b')), 'fieldError');
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2f7c58d30b44f51c8ad40f69402be323', undefined, undefined, undefined, undefined, undefined);
  }

  },
  /* handler:onSubmit */
  /* handler:onReset */
  ['onReset'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('01e6fba6a25aa201b30f8c880c6ff9a4');
  ___arguments.context.pageData['filterDemos'] = null;

  },
  /* handler:onReset */
  /* content */
}))

define('./pages/sales--flagged/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--flagged/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['sales_table'] = (await Backendless.Data.of('Sales_invoice').find(Backendless.DataQueryBuilder.create().setRelated('link_to_calculations').setSortBy('sales_date desc').setPageSize(100)));
  ___arguments.context.pageData['filtered_sales_table'] = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf4a68dbff19efd1724a5a13cadb5b7f')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--flagged/components/e0c78a1a36ec7931b4191627c1263c93/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'OpenFinanceModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sales--flagged/components/06efca8e060b1437b24c83ad44f8b019/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--flagged/components/8767c648fe39d38ee21ff4986c5ef18e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['selectedSale'] = ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--individualRecord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--flagged/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects, response, customer_name, item, dealer_name, end_date, start_date, order_num;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  order_num = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num'));
  start_date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date'));
  end_date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date'));
  dealer_name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name'));
  customer_name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name'));
  sales_objects = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  sales_objects = (await asyncListFilter(sales_objects, async (item) => {
     response = true;
    if (order_num) {
      if ((getObjectProperty(item, 'order_number')) != order_num) {
        response = false;
      }
    }
    if (start_date) {
      if ((getObjectProperty(item, 'sales_date')) < start_date) {
        response = false;
      }
    }
    if (end_date) {
      if ((getObjectProperty(item, 'sales_date')) > end_date) {
        response = false;
      }
    }
    if (dealer_name) {
      if ((getObjectProperty(item, 'dealer_name')) != dealer_name) {
        response = false;
      }
    }
    if (customer_name) {
      if ((getObjectProperty(item, 'cust_name')) != customer_name) {
        response = false;
      }
    }


   return response;
  }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', sales_objects);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--flagged/components/72ea530a22586916ed9544287529e324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['customer_name'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--flagged/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--flagged/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--flagged/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--flagged/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--flagged/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  saleRecord = (await BackendlessUI.Functions.Custom['fn_c65b588280452c4e9eb6152982cbb2cb'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--flagged/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_objects = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', sales_objects);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--flagged/components/d09d15686d444a14ca6864fb0dd2e9e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'ok2pay': ___arguments.value }), true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--flagged/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var flaggedSale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--flagged/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var sales_table, j, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('sales', null, null);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['pageTitle'] = 'Sales History';
  ___arguments.context.pageData['salesMenuOpen'] = true;
  ___arguments.context.pageData['whereClause'] = (String('sale_cancelled=') + String(false));
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf4a68dbff19efd1724a5a13cadb5b7f')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](sales_table);
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--history/components/8767c648fe39d38ee21ff4986c5ef18e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--individualRecord', ({ 'recordObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects, whereClause, j, whereList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereList = [];
  if (getObjectProperty(___arguments.context.pageData, 'flagged')) {
    addItemToList(whereList, ['link_to_calculations.red_flag = true']);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')) {
    addItemToList(whereList, [['order_num=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')) {
    addItemToList(whereList, [['sales_date>=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')) {
    addItemToList(whereList, [['sales_date<=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')) {
    addItemToList(whereList, [['dealer_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')) {
    addItemToList(whereList, [['cust_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.pageData, 'cancelled')) {
    addItemToList(whereList, [String('sale_cancelled=true')]);
  } else {
    addItemToList(whereList, [String('sale_cancelled=false')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')) {
    addItemToList(whereList, [['link_to_calculations.sale_type=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')),'\''].join('')]);
  }
  whereClause = whereList[0];
  if (whereList.length > 1) {
    var j_list = whereList.slice(1, whereList.length);
    for (var j_index in j_list) {
      j = j_list[j_index];
      whereClause = [whereClause,' AND ',j].join('');
    }
  }
  ___arguments.context.pageData['whereClause'] = whereClause;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/72ea530a22586916ed9544287529e324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['customer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['dealer_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['order_number like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  ___arguments.context.pageData['whereClause'] = (['sales_date>=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', 'link_to_calculations'));
  console.log(getObjectProperty(___arguments.context.pageData, 'whereClause'));
  console.log(sales_objects);
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['sales_date<=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  ___arguments.context.pageData['modalLoading'] = true;
  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;
  ___arguments.context.pageData['modalLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/d09d15686d444a14ca6864fb0dd2e9e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'ok2pay': ___arguments.value }), true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);
  ___arguments.context.pageData['refreshNeeded'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations.red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#d1d1d1';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFFFFF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--history/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/e60d3ac83759bd74a71e5fd36734b2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['flagged'] = (!(getObjectProperty(___arguments.context.pageData, 'flagged')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'flagged')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#cccccc';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--history/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var sales_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, null, null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in sales_table) {
      j = sales_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['sales_table'] = sales_table;
    ___arguments.context.pageData['filtered_sales_table'] = sales_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/sales--history/components/dfabf62d756fda2b26b81466095b2fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects;


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['saleType'] = ___arguments.value;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.sale_type=\'',___arguments.value,'\' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.sale_type=\'',___arguments.value,'\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history/components/0c06a9be5a8254bf37074edc995f1535/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'sale_type')) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sales--history/components/85043e543db576c7e314c7a26ff89a2c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var saleType;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'setBackground')) && (getObjectProperty(___arguments.context.dataModel, 'link_to_calculations'))) {
    saleType = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'link_to_calculations')), 'sale_type'));
    ___arguments.context.dataModel['setBackground'] = false;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--history/components/a8c7e1c17aeb0504da1e9e1cce898fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['cancelled'] = (!(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled'))), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'cancelled')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#cccccc';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sales--history/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var payDates, payobject, nicePayDate, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['sales_table'] = (await Backendless.Data.of('Sales_invoice').find(Backendless.DataQueryBuilder.create().setRelated('link_to_calculations').setSortBy('sales_date desc').setPageSize(100)));
  ___arguments.context.pageData['filtered_sales_table'] = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf4a68dbff19efd1724a5a13cadb5b7f')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/e0c78a1a36ec7931b4191627c1263c93/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'OpenFinanceModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/06efca8e060b1437b24c83ad44f8b019/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/8767c648fe39d38ee21ff4986c5ef18e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['selectedSale'] = ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--individualRecord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects, response, customer_name, item, dealer_name, end_date, start_date, order_num;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  order_num = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num'));
  start_date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date'));
  end_date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date'));
  dealer_name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name'));
  customer_name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name'));
  sales_objects = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  sales_objects = (await asyncListFilter(sales_objects, async (item) => {
     response = true;
    if (order_num) {
      if ((getObjectProperty(item, 'order_number')) != order_num) {
        response = false;
      }
    }
    if (start_date) {
      if ((getObjectProperty(item, 'sales_date')) < start_date) {
        response = false;
      }
    }
    if (end_date) {
      if ((getObjectProperty(item, 'sales_date')) > end_date) {
        response = false;
      }
    }
    if (dealer_name) {
      if ((getObjectProperty(item, 'dealer_name')) != dealer_name) {
        response = false;
      }
    }
    if (customer_name) {
      if ((getObjectProperty(item, 'cust_name')) != customer_name) {
        response = false;
      }
    }


   return response;
  }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', sales_objects);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/72ea530a22586916ed9544287529e324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['customer_name'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;


  ___arguments.context.pageData['modalLoading'] = true;
  saleRecord = (await BackendlessUI.Functions.Custom['fn_c65b588280452c4e9eb6152982cbb2cb'](___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c')));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;
  ___arguments.context.pageData['modalLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_objects = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('03b1b5a50581d8534b61c2b289e22b36', sales_objects);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/d09d15686d444a14ca6864fb0dd2e9e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'ok2pay': ___arguments.value }), true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/b7eb1dc368f38d7128930cde25623938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_calculations').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'objectId')),'red_flag': !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) }), true);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var flaggedSale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'link_to_calculations')), 'red_flag')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7eb1dc368f38d7128930cde25623938'))['color'] = '#b00020';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c'))['backgroundColor'] = '#FFEBEE';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--history--shaneDev/components/97442b83ef04e67167c530650196133a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openDealerModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--individualRecord/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var transactions, salesRecord, otherSales, itemNames, j, k, commissionDetail, totalCommission;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'recordObjectId')) {
    salesRecord = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).findById((getObjectProperty(___arguments.context.pageData, 'recordObjectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
  } else {
    salesRecord = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).findLast(Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    ___arguments.context.pageData['recordObjectId'] = (getObjectProperty(___arguments.context.pageData, 'objectId'));
  }
  commissionDetail = [];
  totalCommission = 0;
  var j_list = (getObjectProperty(salesRecord, 'link_to_calculations.commissions_detail'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    totalCommission = (typeof totalCommission == 'number' ? totalCommission : 0) + (getObjectProperty(j, 'amount'));
    if ((getObjectProperty(j, 'amount')) > 0) {
      addItemToList(commissionDetail, ({ 'roleTitle': (getObjectProperty(j, 'roleTitle')),'amount': (getObjectProperty(j, 'amount')) }));
    }
  }
  ___arguments.context.pageData['totalCommission'] = totalCommission;
  ___arguments.context.pageData['commissionDetail'] = commissionDetail;
  otherSales = (getObjectProperty(salesRecord, 'link_to_other_sales'));
  if (Array.isArray(otherSales)) {
    salesRecord['hasAddon'] = true;
    for (var j_index2 in otherSales) {
      j = otherSales[j_index2];
      itemNames = [];
      var k_list = (getObjectProperty(j, 'link_to_transactions'));
      for (var k_index in k_list) {
        k = k_list[k_index];
        addItemToList(itemNames, (getObjectProperty(k, 'Product_name')));
      }
      j['itemsSold'] = itemNames;
    }
    ___arguments.context.pageData['otherSales'] = otherSales;
  }
  salesRecord['formatted_first_payment_due'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty((getObjectProperty(salesRecord, 'link_to_calculations')), 'first_payment_due'))));
  if ((getObjectProperty(salesRecord, 'sale_cancelled')) == true) {
    salesRecord['displayCancelledSale'] = true;
  } else {
    salesRecord['displayCancelledSale'] = false;
  }
  ___arguments.context.pageData['selectedRecord'] = salesRecord;
  ___arguments.context.pageData['refreshNeeded'] = false;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0391fccb089b8b77f8f95d5c8019e0fe', (getObjectProperty((getObjectProperty(salesRecord, 'link_to_calculations')), 'finance_fees_detail')));
  ___arguments.context.pageData['salesDate'] = (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(salesRecord, 'sales_date'))));
  ___arguments.context.pageData['cancelDate'] = (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(salesRecord, 'cancel_date'))));
  transactions = (getObjectProperty(salesRecord, 'link_to_transactions'));
  salesRecord['showDown'] = ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'down_total')))) > 0);
  salesRecord['showAddOn'] = ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'add_products_total')))) > 0);
  ___arguments.context.pageData['transactions'] = transactions;

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['salesMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Sales Record';

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Sale #',(getObjectProperty(___arguments.context.pageData, 'selectedRecord.order_number')),' - TellUS App'].join(''))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/a6e1464d07b4cb58b948f9e158dc7e05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['modalLoading'] = true;
  saleRecord = (await BackendlessUI.Functions.Custom['fn_4132f1a1c82fb0e3740b9cafd68e4732']((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))));
  ___arguments.context.pageData['selectedSale'] = saleRecord;
  ___arguments.context.pageData['openFinanceModal'] = true;
  ___arguments.context.pageData['modalLoading'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--individualRecord/components/545d9df2d644e1badf584e78001ebed4/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ride_along_name')) != null)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/66f5d6e2061a6bab23bf10a68c89044e/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ride_along_name')) == null)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/ba1d50fcb8acc03be66f0415b69f3064/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'co_fname')) != null)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/efddf5f7ee5c71b9f3a6ad7f4d8ad5f5/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'co_fname')) == null)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/58738e022727cd4e61e9ef198c3d807c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'co_fname')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/7889fa995658d8ceb594688caeda6d99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ride_along_name')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sales--individualRecord/components/807c65c10c7a7e4b329d1a6f649d664a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var salesRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    salesRecord = (await Backendless.Data.of('Sales_invoice').findById((getObjectProperty(___arguments.context.pageData, 'recordObjectId')), Backendless.DataQueryBuilder.create().setRelated('link_to_calculations')));
    salesRecord['formatted_first_payment_due'] = (await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty((getObjectProperty(salesRecord, 'link_to_calculations')), 'first_payment_due'))));
    if ((getObjectProperty(salesRecord, 'sale_cancelled')) == true) {
      salesRecord['displayCancelledSale'] = true;
    } else {
      salesRecord['displayCancelledSale'] = false;
    }
    ___arguments.context.pageData['selectedRecord'] = salesRecord;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0391fccb089b8b77f8f95d5c8019e0fe', (getObjectProperty((getObjectProperty(salesRecord, 'link_to_calculations')), 'finance_fees_detail')));
    ___arguments.context.pageData['salesDate'] = (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(salesRecord, 'sales_date'))));
    ___arguments.context.pageData['cancelDate'] = (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(salesRecord, 'cancel_date'))));
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return 'Sales Invoice #'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sales--others/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--others/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var sales_table, saleType, salesSelector, j, holdsData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('sales', null, null);
  ___arguments.context.pageData['pageTitle'] = 'Other Sales';
  ___arguments.context.pageData['salesMenuOpen'] = true;
  ___arguments.context.pageData['whereClause'] = [];
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['numRecordsPerPage'] = 20;
  holdsData = [];
  sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf4a68dbff19efd1724a5a13cadb5b7f')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, 'sales_date desc', null));
  ___arguments.context.pageData['offset'] = 0;
  saleType = [];
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    if (!(saleType.includes((getObjectProperty(j, 'TypeofSale'))))) {
      addItemToList(saleType, (getObjectProperty(j, 'TypeofSale')));
    }
    j['setBackground'] = true;
  }
  salesSelector = [];
  for (var j_index2 in saleType) {
    j = saleType[j_index2];
    addItemToList(salesSelector, ({ 'value': j,'label': j }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'formsUsed': salesSelector }));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](salesSelector);
  ___arguments.context.pageData['formsUsed'] = saleType;
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--others/components/628e3f4b205301ad4e2a7ddea5bcee03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects, whereClause, j, whereList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_num','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })])));
  whereList = [];
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')) {
    addItemToList(whereList, [['order_num=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')) {
    addItemToList(whereList, [['sales_date>=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')) {
    addItemToList(whereList, [['sales_date<=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')) {
    addItemToList(whereList, [['dealer_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')) {
    addItemToList(whereList, [['cust_name like \'%',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'%\''].join('')]);
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')) {
    addItemToList(whereList, [['link_to_calculations.sale_type=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'saleType')),'\''].join('')]);
  }
  whereClause = whereList[0];
  if (whereList.length > 1) {
    var j_list = whereList.slice(1, whereList.length);
    for (var j_index in j_list) {
      j = j_list[j_index];
      whereClause = [whereClause,' AND ',j].join('');
    }
  }
  ___arguments.context.pageData['whereClause'] = whereClause;
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--others/components/72ea530a22586916ed9544287529e324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['customer_name'] = ___arguments.value;
  whereClause = (await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_num','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'dealer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'comparison': 'like' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })]));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', null));
  ___arguments.context.pageData['whereClause'] = (['cust_name like \'%',___arguments.value,'%\' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--others/components/20e95b99cc32c9b5b9b20d0c129f85e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['dealer_name'] = ___arguments.value;
  whereClause = (await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_number','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'dealer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'comparison': 'like' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })]));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', null));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--others/components/1c6932774a58ec0645792804a3fc0e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['order_num'] = ___arguments.value;
  whereClause = (await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_number','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'dealer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'comparison': 'like' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })]));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), whereClause, null, null, 'sales_date desc', null));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--others/components/78ba4b7711bd7884696bc79dc848e851/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['start_date'] = ___arguments.value;
  whereClause = (await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_num','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'dealer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'comparison': 'like' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })]));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), whereClause, null, null, 'sales_date desc', null));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--others/components/6a62100ca81ff1881973604d51af842c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['end_date'] = ___arguments.value;
  whereClause = (await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_num','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'dealer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'comparison': 'like' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })]));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03b1b5a50581d8534b61c2b289e22b36')), whereClause, null, null, 'sales_date desc', null));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--others/components/9386bd8759b2bd280e1592289fe4ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var saleRecord, customer_name, possSalesList, likelySale, j, possibleSales, searchRangeStop, searchRangeStart, sales_date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedAddon'] = ___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c');
  customer_name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'customer_name'));
  sales_date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'sales_date'));
  searchRangeStart = ((new Date((new Date(sales_date)).getTime() - ((2 * 3600) * 1000))).valueOf());
  searchRangeStop = ((new Date((new Date(sales_date)).getTime() + ((7 * 86400) * 1000))).valueOf());
  possibleSales = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['sales_date>=',searchRangeStart,'AND sales_date<',searchRangeStop].join(''))).setSortBy('sales_date DESC').setPageSize(100)));
  likelySale = (await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).find(Backendless.DataQueryBuilder.create().setWhereClause((['sales_date>=',searchRangeStart,'AND sales_date<',searchRangeStop,'AND cust_name = \'',customer_name,'\''].join(''))).setPageSize(10)))[0];
  if (likelySale == null) {
    likelySale = possibleSales[0];
  }
  possSalesList = [];
  for (var j_index in possibleSales) {
    j = possibleSales[j_index];
    addItemToList(possSalesList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': [(getObjectProperty(j, 'cust_name')),' ',(await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(j, 'sales_date'))))].join('') }));
  }
  ___arguments.context.pageData['selectedInvoice'] = (getObjectProperty(likelySale, 'objectId'));
  ___arguments.context.pageData['possibleSales'] = possSalesList;
  ___arguments.context.pageData['customerName'] = customer_name;
  ___arguments.context.pageData['orderNumber'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85043e543db576c7e314c7a26ff89a2c'), 'order_number'));
  ___arguments.context.pageData['addonSaleModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--others/components/3bbcec560a1b4a7e9a73148630cdd046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  sales_table = (getObjectProperty(___arguments.context.pageData, 'sales_table'));
  ___arguments.context.pageData['offset'] = 0;
  for (var j_index in sales_table) {
    j = sales_table[j_index];
    j['setBackground'] = true;
  }
  ___arguments.context.pageData['sales_table'] = sales_table;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;
  ___arguments.context.pageData['flagged'] = false;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('dfabf62d756fda2b26b81466095b2fd5', '');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('708c360cd01bc602edd9da05525eb943', ({ 'dealerName': '','customerName': '','startDate': '','endDate': '','orderNo': '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--others/components/c76b3bb5790f8625b63feef964e627cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cleanTable, filteredTable, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredTable = (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'));
  cleanTable = [({ 'Date': 'Sales Date','dealerName': 'Dealer Name','customerName': 'Customer Name','orderTotal': 'Order Total','saleType': 'Sale Type' })];
  for (var j_index in filteredTable) {
    j = filteredTable[j_index];
    console.log(j);
    addItemToList(cleanTable, ({ 'Date': (getObjectProperty(j, 'Sales_date_str')),'dealerName': (getObjectProperty(j, 'dealer_name')),'customerName': (getObjectProperty(j, 'cust_name')),'orderTotal': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'sale_total')),'saleType': (getObjectProperty((getObjectProperty(j, 'link_to_calculations')), 'saleType')) }));
  }
  console.log(cleanTable);
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'filtered_sales_history.csv','data': cleanTable })), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--others/components/e60d3ac83759bd74a71e5fd36734b2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['flagged'] = (!(getObjectProperty(___arguments.context.pageData, 'flagged')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join('')), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (['link_to_calculations.red_flag = ',(getObjectProperty(___arguments.context.pageData, 'flagged')),' and sale_cancelled = ',false].join(''));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'flagged')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e60d3ac83759bd74a71e5fd36734b2a4'))['color'] = '#cccccc';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--others/components/03b1b5a50581d8534b61c2b289e22b36/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var sales_table, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshNeeded')) {
    sales_table = (await BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85043e543db576c7e314c7a26ff89a2c')), (getObjectProperty(___arguments.context.pageData, 'whereClause')), null, null, null, null));
    ___arguments.context.pageData['offset'] = 0;
    for (var j_index in sales_table) {
      j = sales_table[j_index];
      j['setBackground'] = true;
    }
    ___arguments.context.pageData['sales_table'] = sales_table;
    ___arguments.context.pageData['filtered_sales_table'] = sales_table;
    ___arguments.context.pageData['flagged'] = false;
    ___arguments.context.pageData['refreshNeeded'] = false;
  }

  return (getObjectProperty(___arguments.context.pageData, 'filtered_sales_table'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/sales--others/components/dfabf62d756fda2b26b81466095b2fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sales_objects, whereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943')['form_used'] = ___arguments.value;
  whereClause = (await BackendlessUI.Functions.Custom['fn_c8584fefd6c6c4f49461f14bda9ff8f7']([({ 'property': 'order_number','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'order_num')),'comparison': 'like' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'start_date')),'comparison': '>=' }), ({ 'property': 'sales_date','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'end_date')),'comparison': '<=' }), ({ 'property': 'dealer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'dealer_name')),'comparison': 'like' }), ({ 'property': 'customer_name','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'customer_name')),'comparison': 'like' }), ({ 'property': 'form_used','value': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('708c360cd01bc602edd9da05525eb943'), 'form_used')),'comparison': 'like' })]));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesOthers_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), whereClause, null, null, 'sales_date desc', null));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sales--others/components/85043e543db576c7e314c7a26ff89a2c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var saleType;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'setBackground')) && (getObjectProperty(___arguments.context.dataModel, 'link_to_calculations'))) {
    saleType = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'link_to_calculations')), 'sale_type'));
    ___arguments.context.dataModel['setBackground'] = false;
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/sales--others/components/a8c7e1c17aeb0504da1e9e1cce898fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_objects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['cancelled'] = (!(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  sales_objects = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('salesInvoice_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled'))), null, null, 'sales_date desc', 'link_to_calculations'));
  ___arguments.context.pageData['whereClause'] = (String('sale_cancelled=') + String(getObjectProperty(___arguments.context.pageData, 'cancelled')));
  ___arguments.context.pageData['offset'] = 0;
  ___arguments.context.pageData['filtered_sales_table'] = sales_objects;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'cancelled')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#b00020';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8c7e1c17aeb0504da1e9e1cce898fe5'))['color'] = '#cccccc';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sales--others/components/37d12a740221da65b4313bef4ad64e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newOffset, sales_table;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'offset')) - (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage'));
  if (newOffset < 0) {
    newOffset = 0;
  }
  ___arguments.context.pageData['offset'] = newOffset;
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--others/components/442723f3c42225e440ba4083d85c925e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sales_table, newOffset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newOffset = (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')) + (getObjectProperty(___arguments.context.pageData, 'offset'));
  sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  if (sales_table.length == 0) {
    newOffset = (getObjectProperty(___arguments.context.pageData, 'offset'));
    sales_table = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/getSalesPage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'offset': newOffset,'numRecords': (getObjectProperty(___arguments.context.pageData, 'numRecordsPerPage')),'whereClause': (getObjectProperty(___arguments.context.pageData, 'whereClause')) }));
  }
  ___arguments.context.pageData['offset'] = newOffset;
  ___arguments.context.pageData['filtered_sales_table'] = sales_table;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--test/components/3ffed573bdede23f441d0036be0e5178/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var dealer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('11a5aef2ee1236a233ea5e1d25e9521d')) {
    dealer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('11a5aef2ee1236a233ea5e1d25e9521d'), 'dealer_name'));
  } else {
    dealer = null;
  }

  return dealer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sales--test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['sales_table'] = (await Backendless.Data.of('sales_invoice').find(Backendless.DataQueryBuilder.create().setPageSize(10)));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4af46736e8cd68e4062586c1124c25da')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4af46736e8cd68e4062586c1124c25da', (getObjectProperty(___arguments.context.pageData, 'sales_table')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--thisMonthsSales/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('sales', null);

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var products, lastYearsSales, lastMonthsSales, j, item, lastYearTransactions, prevMonthsSales, prevMonthTransactions, lastMonthTransactions, thisMonthTransactions, lastMonth, twoMonthsAgo, thisMonth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['showSpinner'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Monthly Sales';
  ___arguments.context.pageData['salesMenuOpen'] = true;
  thisMonth = (new Date((new Date())).getMonth() + 1);
  lastMonth = thisMonth - 1 > 0 ? thisMonth - 1 : 12;
  twoMonthsAgo = lastMonth - 1 > 0 ? lastMonth - 1 : 12;
  ___arguments.context.pageData['thisMonthText'] = (String((await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](thisMonth))) + String(' sales (so far)'));
  ___arguments.context.pageData['lastMonthText'] = (String((await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](lastMonth))) + String(' sales'));
  ___arguments.context.pageData['prevMonthText'] = (String((await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](twoMonthsAgo))) + String(' sales'));
  ___arguments.context.pageData['lastYearText'] = ([(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](lastMonth)),' ',(new Date((new Date())).getFullYear()) - 1,' sales'].join(''));
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](null, 'active=True', null, null));
  for (var j_index in products) {
    j = products[j_index];
    thisMonthTransactions = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (['transaction_date > \'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](thisMonth)),' 1, ',(new Date((new Date())).getFullYear()),''].join('')))).valueOf()),'\' AND link_product.objectId = \'',(getObjectProperty(j, 'objectId')),'\' and moved_to=\'Sold\'','',''].join('')), null, null, null, null, null, null, null, null, null));
    lastMonthTransactions = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (['transaction_date >= \'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](lastMonth)),' 1, ',(new Date((new Date())).getFullYear()),''].join('')))).valueOf()),'\' AND link_product.objectId = \'',(getObjectProperty(j, 'objectId')),'\' and moved_to=\'Sold\' AND transaction_date<\'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](thisMonth)),' 1, ',(new Date((new Date())).getFullYear()),''].join('')))).valueOf()),'\''].join('')), null, null, null, null, null, null, null, null, null));
    lastYearTransactions = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (['transaction_date >= \'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](lastMonth)),' 1, ',(new Date((new Date())).getFullYear()) - 1,''].join('')))).valueOf()),'\' AND link_product.objectId = \'',(getObjectProperty(j, 'objectId')),'\' and moved_to=\'Sold\' AND transaction_date<\'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](thisMonth)),' 1, ',(new Date((new Date())).getFullYear()) - 1,''].join('')))).valueOf()),'\''].join('')), null, null, null, null, null, null, null, null, null));
    prevMonthTransactions = (await BackendlessUI.Functions.Custom['fn_dfc86f0d2a6af0c4ad864a1bc8453cb1'](null, (['transaction_date >= \'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](twoMonthsAgo)),' 1, ',(new Date((new Date())).getFullYear()),''].join('')))).valueOf()),'\' AND link_product.objectId = \'',(getObjectProperty(j, 'objectId')),'\' and moved_to=\'Sold\' AND transaction_date<\'',((new Date((['',(await BackendlessUI.Functions.Custom['fn_4d936d77c3b5ec66207f8e6bed44a3cd'](lastMonth)),' 1, ',(new Date((new Date())).getFullYear()),''].join('')))).valueOf()),'\''].join('')), null, null, null, null, null, null, null, null, null));
    j['thisMonthsSales'] = ((await Promise.all((thisMonthTransactions.length > 0 ? thisMonthTransactions : [({ 'num_items': 0 })]).map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;}));
    lastMonthsSales = (await Promise.all((lastMonthTransactions.length > 0 ? lastMonthTransactions : [({ 'num_items': 0 })]).map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
    j['lastMonthsSales'] = lastMonthsSales;
    prevMonthsSales = (await Promise.all((prevMonthTransactions.length > 0 ? prevMonthTransactions : [({ 'num_items': 0 })]).map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;});
    j['prevMonthsSales'] = prevMonthsSales;
    j['percLast2months'] = (prevMonthsSales > 0 ? String((await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((100 * ((lastMonthsSales - prevMonthsSales) / prevMonthsSales))))) + String('%') : '-');
    lastYearsSales = lastYearTransactions.length > 0 ? (await Promise.all(lastYearTransactions.map(async item => {; return (getObjectProperty(item, 'num_items'));}))).reduce(function(x, y) {return x + y;}) : '-';
    j['lastYearsSales'] = lastYearsSales;
    j['percYearOverYear'] = (lastYearsSales > 0 ? String((await BackendlessUI.Functions.Custom['fn_57eee5b8f873bb91e844e66589ed7d8a']((100 * ((lastMonthsSales - lastYearsSales) / lastYearsSales))))) + String('%') : '-');
  }
  ___arguments.context.pageData['productList'] = products;
  ___arguments.context.pageData['showSpinner'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--thisMonthsSales/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sales--topGiveaway/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Sales Giveaway';
  ___arguments.context.pageData['salesMenuOpen'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sales--topGiveaway/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Dashboard';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('settings', null, null);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/settings--dashboard/components/e158bedc95c687a4bada4547d697fb87/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeOptions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--dashboard/components/bad8b3abab33d79c9e8906f728bea5e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--matrixLevels', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--dashboard/components/5241bc4e0ac1f23492ce8497ad36f8b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--manageUsers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--dashboard/components/8f189314f37cb41d4b5c01b77f55d0b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeCompanies', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--dashboard/components/fa87e288996fc9fc60519ba3102ab289/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--managers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--financeCompanies/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Finance Companies';
  ___arguments.context.pageData['financeCompanies'] = (await Promise.all((await Backendless.Data.of('Finance_companies').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'company_name')),'value': (getObjectProperty(item, 'company_name')) });})));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/settings--financeCompanies/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('940d6199b5e4432709f67fb61c03bdaa');

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/settings--financeCompanies/components/940d6199b5e4432709f67fb61c03bdaa/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('940d6199b5e4432709f67fb61c03bdaa');

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/settings--financeCompanies/components/d67ffaa6027959dae98380765bef990a/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var financeCompanyObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  financeCompanyObject = ({ 'company_name': (getObjectProperty(___arguments.context.dataModel, 'company_name')),'company_website': (getObjectProperty(___arguments.context.dataModel, 'company_website')),'description': (getObjectProperty(___arguments.context.dataModel, 'company_description')),'active': true });
  await Backendless.Data.of('Finance_companies').save(financeCompanyObject, true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('940d6199b5e4432709f67fb61c03bdaa');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('d67ffaa6027959dae98380765bef990a', ({ 'company_name': '','company_website': '','company_description': '' }));
  (function (message) { alert(message) })('Finance Company successfully added.');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/settings--financeCompanies/components/ac5644bf4246ab2e12a7336ce9687791/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeOptions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--financeOptions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Finance Options';
  ___arguments.context.pageData['financeCompanies'] = (await Promise.all((await Backendless.Data.of('Finance_companies').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'company_name')),'value': (getObjectProperty(item, 'company_name')) });})));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/settings--financeOptions/components/bf8faa82e12a97088507b0c3c5ae16d9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financeCompanies'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/settings--financeOptions/components/c4fb5128d24cc91948846808013fd8f8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var financeLevelObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  financeLevelObject = ({ 'Company': (getObjectProperty(___arguments.context.dataModel, 'finance_company')),'Fee_percentage': (getObjectProperty(___arguments.context.dataModel, 'finance_percentage')),'Terms': (getObjectProperty(___arguments.context.dataModel, 'finance_terms')),'Active': true });
  await Backendless.Data.of('Finance_fees').save(financeLevelObject, true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4fb5128d24cc91948846808013fd8f8', ({ 'finance_company': '','finance_percentage': '','finance_terms': '' }));
  (function (message) { alert(message) })('Finance Level successfully added.');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/settings--financeOptions/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('940d6199b5e4432709f67fb61c03bdaa');

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/settings--financeOptions/components/940d6199b5e4432709f67fb61c03bdaa/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  ['onObjectUpdate'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('940d6199b5e4432709f67fb61c03bdaa');

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/settings--financeOptions/components/d67ffaa6027959dae98380765bef990a/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var item, financeCompanyObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  financeCompanyObject = ({ 'company_name': (getObjectProperty(___arguments.context.dataModel, 'company_name')),'company_website': (getObjectProperty(___arguments.context.dataModel, 'company_website')),'description': (getObjectProperty(___arguments.context.dataModel, 'company_description')),'active': true });
  await Backendless.Data.of('Finance_companies').save(financeCompanyObject, true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('940d6199b5e4432709f67fb61c03bdaa');
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('d67ffaa6027959dae98380765bef990a', ({ 'company_name': '','company_website': '','company_description': '' }));
  ___arguments.context.pageData['financeCompanies'] = (await Promise.all((await Backendless.Data.of('Finance_companies').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'company_name')),'value': (getObjectProperty(item, 'company_name')) });})));
  (function (message) { alert(message) })('Finance Company successfully added.');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/settings--financeOptions/components/ac5644bf4246ab2e12a7336ce9687791/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeCompanies', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--manageUsers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Manage Users';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/settings--manageUsers/components/11520865aaca7cd5b5379df8b6f57376/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openAddUserModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--manageUsers/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
      return (['office_link = \'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    var selectedRecord;


  selectedRecord = ___arguments.selectedRecord;
  delete ___arguments.selectedRecord['created'];
  delete ___arguments.selectedRecord['updated'];
  ___arguments.context.pageData['selectedRecord'] = selectedRecord;
  ___arguments.context.pageData['openAddUserModal'] = true;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/settings--manageUsers/components/88c35c3f904cc0c52f46b15b83ba432a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshUsersTable')) {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/settings--manageUsersNew/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Manage Users';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/settings--manageUsersNew/components/11520865aaca7cd5b5379df8b6f57376/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openNewAddUserModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--manageUsersNew/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
      return (['office_link = \'',((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    var selectedRecord;


  selectedRecord = ___arguments.selectedRecord;
  delete ___arguments.selectedRecord['created'];
  delete ___arguments.selectedRecord['updated'];
  ___arguments.context.pageData['selectedRecord'] = selectedRecord;
  ___arguments.context.pageData['openNewAddUserModal'] = true;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/settings--manageUsersNew/components/88c35c3f904cc0c52f46b15b83ba432a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'refreshUsersTable')) {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4fd839c79fac6f6a5e319d9b6802a17d');
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/settings--managers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Managers';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('settings', null, null);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/settings--managers/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    
  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/settings--managers/components/c4fb5128d24cc91948846808013fd8f8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var managerObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  managerObject = ({ 'dealer_nameFirst': (getObjectProperty(___arguments.context.dataModel, 'managerFirstName')),'dealer_nameLast': (getObjectProperty(___arguments.context.dataModel, 'managerLastName')),'dealer_email': (getObjectProperty(___arguments.context.dataModel, 'managerEmail')),'dealer_phone': (getObjectProperty(___arguments.context.dataModel, 'managerPhone')),'isManager': true });
  await Backendless.Data.of('Dealers').save( managerObject );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('067cee7ed233079bd6a9cb885441d232', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4fb5128d24cc91948846808013fd8f8', ({ 'managerFirstName': '','managerLastName': '','managerEmail': '','managerPhone': '' }));

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/settings--matrixLevels/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Matrix Levels';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/settings--matrixLevels/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    
  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/settings--matrixLevels/components/11520865aaca7cd5b5379df8b6f57376/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openMatrixLevelModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings--matrixSetup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['settingsMenuOpen'] = true;
  ___arguments.context.pageData['pageTitle'] = 'Settings Matrix Levels';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/settings--matrixSetup/components/4fd839c79fac6f6a5e319d9b6802a17d/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    
  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/settings--matrixSetup/components/11520865aaca7cd5b5379df8b6f57376/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openMatrixLevelModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/temp-inventorymovement/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var fromRecord, item, locationList, chosenProduct, productsList, groupedLocations, otherMin, dealersMin, officesMin, suppliersMin, other, dealers, offices, suppliers, j, locations, dealerRecord, mainOffice, products, officeObjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', null, null);
  ___arguments.context.pageData['mobileQuickAction'] = true;
  ___arguments.context.pageData['inventoryDir'] = (['/officeSpecificSaveFiles/',(getObjectProperty((await Backendless.Data.of('Offices').findById(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), )), 'company_short_identifier')),'/inventory/'].join(''));
  officeObjectId = ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})());
  locations = (await BackendlessUI.Functions.Custom['fn_e1eb11d474628804694665d6d2dbbd47'](officeObjectId, (String('active = ') + String(true)), 'name'));
  products = (await BackendlessUI.Functions.Custom['fn_9bda0c6ad7532ccffbe898ca6634d14e'](officeObjectId, (String('active = ') + String(true)), 'product_name'));
  locationList = [];
  productsList = [];
  dealers = [];
  dealersMin = [];
  suppliers = [];
  suppliersMin = [];
  offices = [];
  officesMin = [];
  other = [];
  otherMin = [];
  ___arguments.context.pageData['numCartons'] = undefined;
  ___arguments.context.pageData['numItems'] = 1;
  ___arguments.context.pageData['transferDate'] = (new Date());
  for (var j_index in products) {
    j = products[j_index];
    addItemToList(productsList, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'product_name')),'serialNumRequired': (getObjectProperty(j, 'sn_required')),'product_barcode': (getObjectProperty(j, 'product_barcode')),'carton_barcode': (getObjectProperty(j, 'carton_barcode')),'itemsPerCarton': (getObjectProperty(j, 'items_per_carton')) }));
  }
  ___arguments.context.pageData['productList'] = productsList;
  if ((await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'moveTOonlyULAI', true))) {
    mainOffice = (await Backendless.Data.of('ULAI_locations').findById('8AC6CF25-58F1-4530-A313-49361EE044DE', ));
    mainOffice['value'] = (getObjectProperty(mainOffice, 'objectId'));
    ___arguments.context.pageData['fromRecord'] = mainOffice;
    ___arguments.context.pageData['fromInventory'] = (getObjectProperty(mainOffice, 'inventory'));
    ___arguments.context.pageData['fromTrack'] = (getObjectProperty(mainOffice, 'track'));
    ___arguments.context.pageData['movedFrom'] = (getObjectProperty(mainOffice, 'name'));
    dealerRecord = (await asyncListFilter(locations, async (item) => {


     return ((getObjectProperty(item, 'name')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')));
    }));
    if (dealerRecord.length == 0) {
      dealerRecord = (await Backendless.Data.of('ULAI_locations').findById('D9EDE19F-F2D7-4D77-B21D-23A5F5D297A4', ));
    } else {
      dealerRecord = dealerRecord[0];
    }
    dealerRecord['value'] = (getObjectProperty(dealerRecord, 'objectId'));
    ___arguments.context.pageData['toRecord'] = dealerRecord;
    ___arguments.context.pageData['toTrack'] = (getObjectProperty(dealerRecord, 'track'));
    ___arguments.context.pageData['movedTo'] = (getObjectProperty(dealerRecord, 'name'));
    ___arguments.context.pageData['firstLocationList'] = [({ 'value': (getObjectProperty(mainOffice, 'objectId')),'label': (getObjectProperty(mainOffice, 'name')),'inventory': (getObjectProperty(mainOffice, 'inventory')),'track': (getObjectProperty(mainOffice, 'isTracked')),'type': 'Office' })];
    ___arguments.context.pageData['secondLocationList'] = [({ 'value': (getObjectProperty(dealerRecord, 'objectId')),'label': (getObjectProperty(dealerRecord, 'name')),'inventory': (getObjectProperty(dealerRecord, 'inventory')),'track': (getObjectProperty(dealerRecord, 'isTracked')),'type': 'Dealer' })];
    ___arguments.context.pageData['allSNs'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (['location=\'',(getObjectProperty(mainOffice, 'name')),'\''].join('')), null, null, null, 'link_location'));
    ___arguments.context.pageData['movedFromId'] = (getObjectProperty(mainOffice, 'objectId'));
    ___arguments.context.pageData['movedToId'] = (getObjectProperty(dealerRecord, 'objectId'));
  } else {
    for (var j_index2 in locations) {
      j = locations[j_index2];
      if ((getObjectProperty(j, 'type')) == 'Dealer') {
        addItemToList(dealers, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Dealer' }));
        addItemToList(dealersMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      } else if ((getObjectProperty(j, 'type')) == 'Office') {
        addItemToList(offices, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Office' }));
        addItemToList(officesMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      } else if ((getObjectProperty(j, 'type')) == 'Supplier') {
        addItemToList(suppliers, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Supplier' }));
        addItemToList(suppliersMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      } else {
        addItemToList(other, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')),'inventory': (getObjectProperty(j, 'inventory')),'track': (getObjectProperty(j, 'isTracked')),'type': 'Other' }));
        addItemToList(otherMin, ({ 'value': (getObjectProperty(j, 'objectId')),'label': (getObjectProperty(j, 'name')) }));
      }
    }
    locationList = (suppliers.concat((offices.concat((dealers.concat(other))))));
    ___arguments.context.pageData['firstLocationList'] = locationList;
    ___arguments.context.pageData['firstLocationListGrouped'] = groupedLocations;
    ___arguments.context.pageData['secondLocationList'] = locationList;
    if (getObjectProperty(___arguments.context.pageData, 'selectedProductId')) {
      ___arguments.context.pageData['productId'] = (getObjectProperty(___arguments.context.pageData, 'selectedProductId'));
      chosenProduct = (await asyncListFilter(productsList, async (item) => {


       return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'selectedProductId')));
      }))[0];
      ___arguments.context.pageData['productName'] = (getObjectProperty(chosenProduct, 'label'));
      ___arguments.context.pageData['serialNumRequired'] = (getObjectProperty(chosenProduct, 'serialNumRequired'));
      ___arguments.context.pageData['itemsPerCarton'] = (getObjectProperty(chosenProduct, 'itemsPerCarton'));
    } else {
      ___arguments.context.pageData['productId'] = undefined;
    }
    if (getObjectProperty(___arguments.context.pageData, 'movedFromId')) {
      fromRecord = (await asyncListFilter(locationList, async (item) => {


       return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'movedFromId')));
      }))[0];
      ___arguments.context.pageData['secondLocationList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'firstLocationList')), async (item) => {


       return ((getObjectProperty(item, 'value')) != (getObjectProperty(___arguments.context.pageData, 'movedFromId')));
      }));
      ___arguments.context.pageData['fromRecord'] = fromRecord;
      ___arguments.context.pageData['fromInventory'] = (getObjectProperty(fromRecord, 'inventory'));
      ___arguments.context.pageData['fromTrack'] = (getObjectProperty(fromRecord, 'track'));
      ___arguments.context.pageData['movedFrom'] = (getObjectProperty(fromRecord, 'label'));
    } else {
      ___arguments.context.pageData['movedFromId'] = undefined;
    }
    ___arguments.context.pageData['allSNs'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('SN_tracking_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()))), (String('location!=\'Sold\'')), null, null, null, 'link_location'));
  }
  ___arguments.context.pageData['signatureConfirmed'] = false;
  ___arguments.context.pageData['serialNumRequired'] = false;
  ___arguments.context.pageData['movementList'] = [];
  ___arguments.context.pageData['barcodeValue'] = '';
  ___arguments.context.pageData['openScanner'] = false;

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['pageTitle'] = 'Move Products';
  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  ___arguments.context.pageData['showItems'] = true;
  ___arguments.context.pageData['showItemCartonChecks'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 839) {
    ___arguments.context.pageData['showSideMenu'] = false;
    ___arguments.context.pageData['inventoryFormVisible'] = false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 840) {
    ___arguments.context.pageData['showSideMenu'] = true;
    ___arguments.context.pageData['inventoryFormVisible'] = true;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/temp-inventorymovement/components/873364cb3397e3be952b5f4d147efb76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryFormVisible'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/temp-inventorymovement/components/5a72ba32a2818e628aa43b13b01acff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryFormVisible'] = true;
  ___arguments.context.pageData['mobileQuickAction'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/temp-inventorymovement/components/f8ce745a3cfd1af1245e9ddde31113a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryFormVisible'] = true;
  ___arguments.context.pageData['mobileQuickAction'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/temp-inventorymovement/components/e395437b96bcbdd97d316b2e43be8829/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.Request.post(`${Backendless.appPath}/services/createTable/basicTable`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testing--highcharts/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var dates, salesCount, startDate, endDate, movements, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dataReady'] = false;
  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  ___arguments.context.pageData['pageTitle'] = 'test';
  movements = [];
  salesCount = [];
  dates = [];
  ___arguments.context.pageData['salesOverTime'] = salesCount;
  ___arguments.context.pageData['dateStrings'] = dates;
  ___arguments.context.pageData['xtitle'] = 'Date';
  ___arguments.context.pageData['ytitle'] = 'Sales';
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'salesOverTime')));
  ___arguments.context.pageData['dataReady'] = true;
  console.log('end of load page');

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/testing--highcharts/components/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testing--highcharts/components/f7a3facc2784c72f354b43e8ca3386d2/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesOverTime'))

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/userGroup--content/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var temp, monthlyTotal, j, thisMonthsSales;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  thisMonthsSales = (await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findSalesWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((String('sales_date>') + String((new Date(([(new Date((new Date())).getMonth() + 1),'\'/01/\'',(new Date((new Date())).getFullYear())].join('')))).valueOf())))));
  console.log(thisMonthsSales);
  monthlyTotal = 0;
  for (var j_index in thisMonthsSales) {
    j = thisMonthsSales[j_index];
    monthlyTotal = monthlyTotal + (getObjectProperty(j, 'sale_total_wo_tax'));
  }
  console.log(monthlyTotal);
  ___arguments.context.pageData['currentMonthSales'] = (await BackendlessUI.Functions.Custom['fn_e86ec673167f0faee157a449f9dd845b'](monthlyTotal));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_b2ee32db10714ec4625687ae269b7496']();
  ___arguments.context.pageData['dealerMenuOpen'] = false;
  ___arguments.context.pageData['payrollMenuOpen'] = false;
  ___arguments.context.pageData['salesMenuOpen'] = false;
  ___arguments.context.pageData['settingsMenuOpen'] = false;
  ___arguments.context.pageData['inventoryMenuOpen'] = false;
  ___arguments.context.pageData['pageTitle'] = 'Dashboard';
  currentUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  console.log(currentUser);
  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ___arguments.context.pageData['currentUserRole'] = 'No Group';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', ({ 'showLoginAlert': true }));
  } else {
    ___arguments.context.pageData['currentUserRole'] = (getObjectProperty(currentUser, 'userGroup'));
  }

  },
  /* handler:onEnter */
  /* handler:onPageQuery */
  ['onPageQuery'](___arguments) {
      ___arguments.context.pageData['pageTitle'] = 'Dashboard';

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/userGroup--content/components/0d8b29b421dc23ed23c28b613d3204ed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUserRole')) == 'Office Manager') {
    officeManagerLoggedIn = true;
  } else {
    officeManagerLoggedIn = false;
  }

  return officeManagerLoggedIn

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/userGroup--content/components/a46b95be500a654a0f3abb56706d78e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var inventoryManagerLoggedIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUserRole')) == 'Inventory Manager') {
    inventoryManagerLoggedIn = true;
  } else {
    inventoryManagerLoggedIn = false;
  }

  return inventoryManagerLoggedIn

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/userGroup--content/components/bb8b5b6af1f279471cc1f3d2252500cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var adminLoggedIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUserRole')) == 'Admin') {
    adminLoggedIn = true;
  } else {
    adminLoggedIn = false;
  }

  return adminLoggedIn

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/userGroup--content/components/b8330e54bd5914dc69a79fdbaf94204e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesManagerLoggedIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUserRole')) == 'Sales Manager') {
    salesManagerLoggedIn = true;
  } else {
    salesManagerLoggedIn = false;
  }

  return salesManagerLoggedIn

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/userGroup--content/components/975146d25fb2e22d07ea5f0dc5fc8a36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var eCommerceManagerLoggedIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUserRole')) == 'eCommerce Manager') {
    eCommerceManagerLoggedIn = true;
  } else {
    eCommerceManagerLoggedIn = false;
  }

  return eCommerceManagerLoggedIn

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/userLogin/components/61b68752f0c43bcdb69148af8c7a2471/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  loggedInUser = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'emailAddress')), (getObjectProperty(___arguments.context.pageData, 'password')), true  ));
  ___arguments.context.pageData['loggedInUserObjectId'] = (getObjectProperty(loggedInUser, 'objectId'));
  ___arguments.context.appData['officeObjId'] = (getObjectProperty(loggedInUser, 'office_link.objectId'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bfd1a3dc69113f6512fb96af92168ae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3c46b9a66f9a8c54e883be17948d74d2/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openMatrixLevelModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_3c46b9a66f9a8c54e883be17948d74d2/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      ___arguments.context.pageData['userList'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(10)));

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_3c46b9a66f9a8c54e883be17948d74d2/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openMatrixLevelModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3c46b9a66f9a8c54e883be17948d74d2/logic/ae6fba03b0041e1d4e62bdcc52336d81/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var matrixLevelObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  matrixLevelObject = ({ 'Title': (getObjectProperty(___arguments.context.dataModel, 'matrixName')),'dealer_commission_on_AB_sale': (getObjectProperty(___arguments.context.dataModel, 'dealerABCommission')),'dealer_commission_on_C_sale': (getObjectProperty(___arguments.context.dataModel, 'dealerCCommission')),'manager_commission_on_AB_sale': (getObjectProperty(___arguments.context.dataModel, 'managerABCommission')),'manager_commission_on_C_sale': (getObjectProperty(___arguments.context.dataModel, 'managerCCommission')),'monthy_bonus_on_4AB_sales': (getObjectProperty(___arguments.context.dataModel, 'matrixMonthlyBonus')),'override_whoclosedbonus': (getObjectProperty(___arguments.context.dataModel, 'matrixWhoClosedBonus')),'weekly_salary': (getObjectProperty(___arguments.context.dataModel, 'matrixWeeklySalary')) });
  await Backendless.Data.of('Payroll_matrix').save( matrixLevelObject );
  (function (message) { alert(message) })('Matrix Level Successfully Added!');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openNewAddUserModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      ___arguments.context.pageData['userList'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Users', null, null, null, null, null));

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openNewAddUserModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/ae6fba03b0041e1d4e62bdcc52336d81/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var userObjId, createdUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('submitting');
  if ((getObjectProperty(___arguments.context.dataModel, 'password')) != (getObjectProperty(___arguments.context.dataModel, 'userConfirmPassword'))) {
    ___arguments.context.dataModel['passwordMessage'] = 'Passwords do not match.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe9fead10cd90a2b07fcb3a60eb79ba', true);
  } else {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('in else');
    createdUser = ___arguments.context.dataModel;
    createdUser['name'] = ([(getObjectProperty(___arguments.context.dataModel, 'fName')),' ',(getObjectProperty(___arguments.context.dataModel, 'lName'))].join(''));
    createdUser['sectionAccess'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess'));
    createdUser['sectionAccess_dealers'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_dealers'));
    createdUser['sectionAccessInventory'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_inventory'));
    createdUser['sectionAccessPayroll'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_payroll'));
    createdUser['sectionAccessSales'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_sales'));
    createdUser['sectionAccessSettings'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_settings'));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('officeobid');
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](createdUser);
    userObjId = (await Backendless.Data.of('Users').addRelation((await Backendless.Data.of('Users').save(createdUser, true)), 'office_link', [((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]));
    if (userObjId) {
      await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2562105277b28524cbcf3e0513e77a82', undefined, undefined, undefined, undefined, undefined);
    }
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('ae6fba03b0041e1d4e62bdcc52336d81', undefined);
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['refreshUsersTable'] = true;
    ___arguments.context.pageData['openAddUserModal'] = false;
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/d0e6271f20f212acc5a10b99fd427ef8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var toggleDealers;


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d0e6271f20f212acc5a10b99fd427ef8')) == 'value-1') {
    toggleDealers = true;
    ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['toggleDealers'] = true;
  } else {
    toggleDealers = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/2534b01cc0cbe8b1a60e24169b21b6b8/bundle.js', [], () => ({
  /* content */
  /* handler:onRequiredStateAssignment */
  ['onRequiredStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81'), 'objectId')))

  },
  /* handler:onRequiredStateAssignment */
  /* content */
}))

define('./components/reusable/r_31947199c00dfcaec05ebbed7389dc27/logic/a553d9ce2f66b4a5cb3d92ebaf5c3031/bundle.js', [], () => ({
  /* content */
  /* handler:onRequiredStateAssignment */
  ['onRequiredStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81'), 'objectId')))

  },
  /* handler:onRequiredStateAssignment */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openAddUserModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('adding user in dev container');
  ___arguments.context.pageData['userList'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Users', null, null, null, null, null));

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openAddUserModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/ae6fba03b0041e1d4e62bdcc52336d81/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var userObjId, createdUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('submitting');
  if ((getObjectProperty(___arguments.context.dataModel, 'password')) != (getObjectProperty(___arguments.context.dataModel, 'userConfirmPassword'))) {
    ___arguments.context.dataModel['passwordMessage'] = 'Passwords do not match.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe9fead10cd90a2b07fcb3a60eb79ba', true);
  } else {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('in else');
    createdUser = ({ 'email': (getObjectProperty(___arguments.context.dataModel, 'email')),'password': (getObjectProperty(___arguments.context.dataModel, 'password')) });
    createdUser['objectId'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
    createdUser['name'] = ([(getObjectProperty(___arguments.context.dataModel, 'fName')).trim(),' ',(getObjectProperty(___arguments.context.dataModel, 'lName')).trim()].join(''));
    createdUser['sectionAccess'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess'));
    createdUser['sectionAccess_dealers'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_dealers'));
    createdUser['sectionAccess_inventory'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_inventory'));
    createdUser['sectionAccess_payroll'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_payroll'));
    createdUser['sectionAccess_sales'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_sales'));
    createdUser['sectionAccess_settings'] = (getObjectProperty(___arguments.context.dataModel, 'sectionAccess_settings'));
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](createdUser);
    userObjId = (await Backendless.Data.of('Users').addRelation((await Backendless.Data.of('Users').save(createdUser, true)), 'office_link', [((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())]));
    if (userObjId) {
      await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('2562105277b28524cbcf3e0513e77a82', undefined, undefined, undefined, undefined, undefined);
    }
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('ae6fba03b0041e1d4e62bdcc52336d81', undefined);
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['refreshUsersTable'] = true;
    ___arguments.context.pageData['openAddUserModal'] = false;
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/d0e6271f20f212acc5a10b99fd427ef8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var toggleDealers;


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d0e6271f20f212acc5a10b99fd427ef8')) == 'value-1') {
    toggleDealers = true;
    ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['toggleDealers'] = true;
  } else {
    toggleDealers = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/ddd3c3ebe4215831cebea45819dcbf42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/417d950dcc1dbdc84f316017d80cc99f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['sectionAccess_inventory.noPricing'] = false;
  ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['sectionAccess_inventory.limitedPricing'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/5b99b14a9ff982076bb4407d60894588/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['sectionAccess_inventory.noPricing'] = false;
  ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['sectionAccess_inventory.allPricing'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/d2ab7e93be191113ab76a0aa7992abc3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['sectionAccess_inventory.allPricing'] = false;
  ___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81')['sectionAccess_inventory.limitedPricing'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/2534b01cc0cbe8b1a60e24169b21b6b8/bundle.js', [], () => ({
  /* content */
  /* handler:onRequiredStateAssignment */
  ['onRequiredStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81'), 'objectId')))

  },
  /* handler:onRequiredStateAssignment */
  /* content */
}))

define('./components/reusable/r_e3c8c9b1b4cb2aae630974cbe0bcdb33/logic/a553d9ce2f66b4a5cb3d92ebaf5c3031/bundle.js', [], () => ({
  /* content */
  /* handler:onRequiredStateAssignment */
  ['onRequiredStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ae6fba03b0041e1d4e62bdcc52336d81'), 'objectId')))

  },
  /* handler:onRequiredStateAssignment */
  /* content */
}))

define('./components/reusable/r_06cb794d5e0b001fa121c03eaef13611/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openDealerModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_06cb794d5e0b001fa121c03eaef13611/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_06cb794d5e0b001fa121c03eaef13611/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openAddUserModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_06cb794d5e0b001fa121c03eaef13611/logic/ae6fba03b0041e1d4e62bdcc52336d81/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var userObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userObject = ({ 'name': [(getObjectProperty(___arguments.context.dataModel, 'userFirstName')),' ',(getObjectProperty(___arguments.context.dataModel, 'userLastName'))].join(''),'email': (getObjectProperty(___arguments.context.dataModel, 'userEmail')),'userGroup': (getObjectProperty(___arguments.context.dataModel, 'userType')),'password': (getObjectProperty(___arguments.context.dataModel, 'userPassword')) });
  await Backendless.Data.of('Users').save( userObject );

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_06cb794d5e0b001fa121c03eaef13611/logic/5249c16b143d875d5934763cb1d2e2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['dealerTable'] = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setPageSize(10)));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/7e05f572905ea86cf2633316b33695b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/6c2b7c0429ed1585dfcc7eafe4c90ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/27d552ed3f8b7b2d652d4851f32cb648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/0c98beb5a64ce2b1adc8bec2c38cf13f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--history', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/2a7cf38464fbd7dab3eb7229a488c3fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('orders--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/9b794f76617e9b2508f3d29df2048604/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/482e3759876558a8d2e8312d05dcd45d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/7502a242df74eb5f8d9539921f2364c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/5c034738fcb17ecc90d71803a7fac1a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/980238850d9b9922b1616043c202f913/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--thisMonthsSales', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/9bb2afcabb18014a411111355fe4b4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--topGiveaway', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/8f1fcb187c611d8f7927211818013a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dealerSales', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/feba0f51511ffc1196b391d9d06ebe24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('feedback--submitFeedback', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/798b0d35ff93e8a1cae4ae3247344064/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--demos', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_408e06cf6bb51bfc0ff453f161e6c1aa/logic/71b3b54a4306eaca7053749bdc8b0699/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--addonSales', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_89b21bcce0e42f12f3c31b23a552d90b/logic/9d57e27e3f1a7a4aa9aef54ea5ea9f8b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'defaultView') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locations', undefined);
  }
  if (___arguments.value == 'dealersView') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locationsDealers', undefined);
  }
  if (___arguments.value == 'dealersPurchasePowerView') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locationsDealersPurchasePower', undefined);
  }
  if (___arguments.value == 'warehousesView') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locationsWarehouses', undefined);
  }
  if (___arguments.value == 'noLongerTrackedView') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locationsNotTracked', undefined);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_0621f0dd4dcd8c09b9225f23aad6df78/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'addonSaleModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_0621f0dd4dcd8c09b9225f23aad6df78/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['addonSaleModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0621f0dd4dcd8c09b9225f23aad6df78/logic/eb29d43f86b271b81274fbfdfaeaeb46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Sales_invoice').addRelation((getObjectProperty(___arguments.context.pageData, 'selectedInvoice')), 'link_to_other_sales', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedAddon')), 'objectId'))]);
  await Backendless.Data.of('Sales_invoice').save(({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'selectedInvoice')),'product_cost': (getObjectProperty((await BackendlessUI.Functions.Custom['fn_28d64cea9a03167e67c1c5c26fde2bc4']((getObjectProperty(___arguments.context.pageData, 'selectedInvoice')))), 'totalProductCost')) }), true);
  await Backendless.Data.of('Sales_others').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedAddon')), 'objectId')),'connected_to_sale': true }), true);
  ___arguments.context.pageData['whereClause'] = (String('form_used = \'Add-on\''));
  ___arguments.context.pageData['filterChoice'] = (String('All add-ons'));
  ___arguments.context.pageData['addonSaleModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0621f0dd4dcd8c09b9225f23aad6df78/logic/731c98ce558d72f303770587246c729d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Assign Sale # ',(getObjectProperty(___arguments.context.pageData, 'orderNumber')),' for customer ',(getObjectProperty(___arguments.context.pageData, 'customerName'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_0621f0dd4dcd8c09b9225f23aad6df78/logic/80a712c5a0d94e59dc9cbec41a895b92/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedInvoice'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e278662dde71e9f5d6c11783a22ae5ef/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'lockPayrollNotifications')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_e278662dde71e9f5d6c11783a22ae5ef/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['lockPayrollNotifications'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/98651a7be6751cbf3ad4809fb5ce3b85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('orders--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/d645318c5257cd081368726eb76ab88f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--history', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/d94c5c96a1ba5b764ada3d035abacc9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/b7a21e39fa6898afb34c8445f0cd712a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/88edc95a57448edf274d8ab5ab684c0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/48bfa9d40bf454152be9bab5fa2e3bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/49d167eed8a8184a46e6a01f88770807/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/29ade11b22820604b6a2125b834c1ba9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/98517149d2b575114044e7a5447c22d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/c1d2abc915566d55bdefa8f34e1c62cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('feedback--submitFeedback', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/729edcbc9b4781ddb81943cd684b7cfe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/f4e98d8368bc28ab2ed4b7818a9b74fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerHistory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_696cd52e0431dfb559cce227d59c27ca/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUserGroup')) == 'Demo') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94c5c96a1ba5b764ada3d035abacc9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7a21e39fa6898afb34c8445f0cd712a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('88edc95a57448edf274d8ab5ab684c0e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98651a7be6751cbf3ad4809fb5ce3b85', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'addPayrollNoteModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['addPayrollNoteModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/ae6fba03b0041e1d4e62bdcc52336d81/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var payrollNotes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['dealerNotes'] = ({ 'payrollID': (getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.payrollID')),'payDate': (getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.payDate')),'dealerName': (getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.dealerName')),'timeStamp': (new Date()),'noteContent': (getObjectProperty(___arguments.context.dataModel, 'noteContent')) });
  console.log(getObjectProperty(___arguments.context.pageData, 'dealerNotes'));
  ___arguments.context.pageData['dealerTransactionRecord'] = (await Backendless.Data.of('Payroll_transactions').find(Backendless.DataQueryBuilder.create().setWhereClause((['dealer_name = \'',(getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.dealerName')),'\' AND pay_date = \'',(getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.payDate')),'\''].join(''))).setPageSize(1)));
  console.log(getObjectProperty(___arguments.context.pageData, 'dealerTransactionRecord'));
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerTransactionRecord')), '0.payroll_notes')) == null) {
    payrollNotes = [(getObjectProperty(___arguments.context.pageData, 'dealerNotes'))];
  } else {
    ___arguments.context.pageData['currentPayrollNotes'] = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerTransactionRecord')), '0.payroll_notes'))];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'currentPayrollNotes')), (getObjectProperty(___arguments.context.pageData, 'dealerNotes')));
    console.log(getObjectProperty(___arguments.context.pageData, 'currentPayrollNotes'));
    payrollNotes = (getObjectProperty(___arguments.context.pageData, 'currentPayrollNotes'));
  }
  await Backendless.Data.of('Payroll_transactions').save(({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerTransactionRecord')), '0.objectId')),'payroll_notes': payrollNotes }), true);
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'dealerTransactionRecord')), '0.payroll_notes')) == null) {
    ___arguments.context.pageData['payrollNotes'] = (getObjectProperty(___arguments.context.pageData, 'dealerNotes'));
    console.log(getObjectProperty(___arguments.context.pageData, 'payrollNotes'));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'payRecord'))['reductions_detail'] = (getObjectProperty(___arguments.context.pageData, 'subtractions'));
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/5249c16b143d875d5934763cb1d2e2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['dealerTable'] = (await Backendless.Data.of('Dealers').find(Backendless.DataQueryBuilder.create().setPageSize(10)));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/3166267ec03cfa176c965a6575c972ca/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.dealerName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/1df397e7ed8eb8a877a6b4c10d1c852d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dealerName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/92f7393e087780fbd5f7033c6cf8a63e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.payDate'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_19082db795bb85bb2142dfe97fb77021/logic/731c98ce558d72f303770587246c729d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Add a note to ',(getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.dealerName')),'\'s Payroll for ',(await BackendlessUI.Functions.Custom['fn_2385e1f7a515353f3439ad6f663dc5cf']((getObjectProperty(___arguments.context.pageData, 'selectedPayrollTransaction.payDate'))))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openFinanceModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      ___arguments.context.pageData['userList'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(10)));

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/3d6733757e3b4de5a632ee4596c7387e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openFinanceModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/f5945e543fbbcbda6feec9d6f13821c7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['financeCompany'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['financeTermsOptions'] = (await Promise.all((await Backendless.Data.of('Finance_fees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Company=\'',___arguments.value,'\' AND Active = True'].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Terms')),'value': (getObjectProperty(item, 'Terms')) });})));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/8fd23b42851c97db7d36c1b2a328c65c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedTerm'] = ___arguments.value;
  ___arguments.context.pageData['feePercentage'] = (getObjectProperty(((await Backendless.Data.of('Finance_fees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Company=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeCompany')),'\' AND Terms=\'',___arguments.value,'\''].join(''))).setPageSize(10)))[0]), 'Fee_percentage'));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/7734ee2b19a36a7705015ae23c18a122/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'feePercentage')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'feePercentage')))) {
    updatedRecord = (getObjectProperty(___arguments.context.pageData, 'selectedSale'));
    updatedRecord['financeFees'] = (await BackendlessUI.Functions.Custom['fn_a0837f297641414fd0bcf123e39278df']((getObjectProperty(___arguments.context.pageData, 'feePercentage')), (getObjectProperty(___arguments.context.pageData, 'selectedTerm')), (getObjectProperty(___arguments.context.pageData, 'selectedSale'))));
    updatedRecord = (await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d'](updatedRecord));
    console.log('before update');
    console.log(updatedRecord);
    updatedRecord = (await BackendlessUI.Functions.Custom['fn_d3828f6bb624eb8418cbf8fd6d9b5fd3'](updatedRecord));
    console.log('after update');
    console.log(updatedRecord);
    ___arguments.context.pageData['selectedSale'] = updatedRecord;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/7d280b6ffafc7fa7894d5d3aabfefd9f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var feeName, feeAmount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  feeAmount = ___arguments.value;
  feeName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e6df6c4ef022bc78007a865130cb2764'), 'feeName'));
  removeItemInList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeFees')), ___arguments.context.getComponentDataStoreByUid('e6df6c4ef022bc78007a865130cb2764'), '=');
  ___arguments.context.pageData['selectedSale'] = (await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((await BackendlessUI.Functions.Custom['fn_a0837f297641414fd0bcf123e39278df'](feeAmount, feeName, (getObjectProperty(___arguments.context.pageData, 'selectedSale'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/501682a5cc6284924a25ca711537fdfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newFinanceFees, item, financeFees;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  financeFees = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeFees'));
  newFinanceFees = (await asyncListFilter(financeFees, async (item) => {


   return (item != ___arguments.context.getComponentDataStoreByUid('e6df6c4ef022bc78007a865130cb2764'));
  }));
  if (newFinanceFees.length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['bumpPercentage'] = 0;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['bumpAmount'] = 0;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['financeFees'] = newFinanceFees;
  ___arguments.context.pageData['selectedSale'] = (await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/ae51da077bc7e66c3eb6a5137465c4b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/29d7b68bcfa80f0bd8ba4fb7fbfbf971/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['currentPayDate'] = (Number(___arguments.value));
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['message'] = '';

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedSale.ok2pay'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/01cf639534ea410db0d909ca55e8be77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Sale #') + String(getObjectProperty(___arguments.context.pageData, 'selectedSale.orderNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/9ee666a756795fcc716f15a34e74894b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedSale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'ok2pay')) == true && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'currentPayDate')) == null) {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['message'] = 'Pay date is required if okay to pay is selected';
  } else {
    selectedSale = (await BackendlessUI.Functions.Custom['fn_177f043f238da488ad6d782f16e299c9']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));
    ___arguments.context.pageData['selectedSale'] = undefined;
    ___arguments.context.pageData['openFinanceModal'] = false;
    ___arguments.context.pageData['refreshNeeded'] = true;
    ___arguments.context.pageData['modalSaved'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/d0bd28726df6557db39eb6b5afc42a34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var val;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  val = true;
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needFinance')) && !___arguments.value) {
    val = false;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needDown')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'receivedDown'))) {
    val = false;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needPayment')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'receivedPayment'))) {
    val = false;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['allowOk'] = (!val);
  if (val == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = false;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['receivedFinance'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/90d770fba1bd1f85944bf3db7417e46c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var val;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  val = true;
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needFinance')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'receivedFinance'))) {
    val = false;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needDown')) && !___arguments.value) {
    val = false;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needPayment')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'receivedPayment'))) {
    val = false;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['allowOk'] = (!val);
  if (val == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = false;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['receivedDown'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/cf313965a8f4129a91c997b352360e44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['dateReceivedDown'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/296dea81541b9849db83bfe9b34bdefd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['dateReceivedFinance'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/80ffdd73841179083db43841fae7e85a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var updatedRecord, bumpAmount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  updatedRecord = (getObjectProperty(___arguments.context.pageData, 'selectedSale'));
  bumpAmount = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeAmount')) * ___arguments.value) / 100;
  updatedRecord['bumpAmount'] = (Math.round(bumpAmount * 100) / 100);
  updatedRecord['bumpPercentage'] = ___arguments.value;
  updatedRecord = (await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d'](updatedRecord));
  ___arguments.context.pageData['selectedSale'] = updatedRecord;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedSale')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedSale'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedSale')) === 'object')) && (Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeFees')))) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeFees')).length == 0)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/45f326d6fec2d5d5a114a02ff3e34f34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var val;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  val = true;
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needFinance')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'receivedFinance'))) {
    val = false;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needDown')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'receivedDown'))) {
    val = false;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'needPayment')) && !___arguments.value) {
    val = false;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['allowOk'] = (!val);
  if (val == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = false;
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['receivedPayment'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/1b7bbe5265bb006f18f499885b451fd7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedSale')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedSale'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedSale')) === 'object')) && (Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeFees')))) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'financeFees')).length == 0)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['bumpAmount'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/a3bef2b3601bc89cebdb2f84e15e0894/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var addonItems, invoice, selectedSale, soldItems;


  ___arguments.context.pageData['openCancelSaleModal'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/80c24872abfc13e705c3eef91aef7048/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var updatedRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  updatedRecord = (await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));
  ___arguments.context.pageData['selectedSale'] = updatedRecord;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/a3ab59abd4afe8f24f8eddfe56f6766a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['lockSalesEdit'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/8ceb0a66b01d355ada5e4c7354b31c6d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['lockSalesEdit'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'selectedSale')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'selectedSale'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'selectedSale')) === 'object')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'lockSalesEdit')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/f61562abf73160ee7aa39412f22db2cf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['rainbowPrice'] = ___arguments.value;
  ___arguments.context.pageData['selectedSale'] = (await BackendlessUI.Functions.Custom['fn_69b6270c3b58921aacf2640ade249787']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/164998cf11b2a3af3824b5e6278ce369/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['addonPrice'] = ___arguments.value;
  ___arguments.context.pageData['selectedSale'] = (await BackendlessUI.Functions.Custom['fn_69b6270c3b58921aacf2640ade249787']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/a19b2809cc1dce0efb4c0fa9a22ac425/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['productCost'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/bf3d4d791f0724c5ce7250b48efb677f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['downTotal'] = ___arguments.value;
  ___arguments.context.pageData['selectedSale'] = (await BackendlessUI.Functions.Custom['fn_69b6270c3b58921aacf2640ade249787']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/6aeb4c332d5ecf21e21c7e72d5564a08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_42acfa086f4f063596c721e72a65dc1b']((((getObjectProperty(___arguments.context.pageData, 'selectedSale.financeAmount')) - (getObjectProperty(___arguments.context.pageData, 'selectedSale.totalFinanceFee'))) - (getObjectProperty(___arguments.context.pageData, 'selectedSale.deferredFee')))))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/25df0ac550f221eeda0fd2514cd5caaa/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var D3Commission;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'D3Update')) === 'string') && (getObjectProperty(___arguments.context.pageData, 'D3Update')).length > 4) {
    D3Commission = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9']((getObjectProperty(___arguments.context.pageData, 'selectedSale.D3info')), (getObjectProperty(___arguments.context.pageData, 'selectedSale.numRainbows')))), (getObjectProperty(___arguments.context.pageData, 'selectedSale.paidPercentage'))));
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['D3info'] = D3Commission;
    await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((getObjectProperty(___arguments.context.pageData, 'selectedSale')));
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['D3Update'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/4aa553f8e31ca783b4c5e2fa014f2619/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dealerUpdate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var D1Commissioninfo, D2Commissioninfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'D1Update')) === 'string') && (getObjectProperty(___arguments.context.pageData, 'D1Update')).length > 4) {
    D1Commissioninfo = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9']((getObjectProperty(___arguments.context.pageData, 'selectedSale.D1info')), (getObjectProperty(___arguments.context.pageData, 'selectedSale.numRainbows')))), (getObjectProperty(___arguments.context.pageData, 'selectedSale.paidPercentage'))));
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['D1info'] = D1Commissioninfo;
    await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((getObjectProperty(___arguments.context.pageData, 'selectedSale')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/60df5387099c6b0577d4c1f802697fa4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['D2Update'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var D2Commissioninfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'D2Update')) === 'string') && (getObjectProperty(___arguments.context.pageData, 'D2Update')).length > 4) {
    D2Commissioninfo = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9']((getObjectProperty(___arguments.context.pageData, 'selectedSale.D2info')), (getObjectProperty(___arguments.context.pageData, 'selectedSale.numRainbows')))), (getObjectProperty(___arguments.context.pageData, 'selectedSale.paidPercentage'))));
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['D2info'] = D2Commissioninfo;
    await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((getObjectProperty(___arguments.context.pageData, 'selectedSale')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/d44d321daa92e70198e85fbb6995d49b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Finance') {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['paymentAmount'] = 0;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['financeAmount'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'total_w_tax')) - (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'downTotal')));
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needPayment'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needFinance'] = true;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['displayFinance'] = true;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = false;
  } else {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['paymentAmount'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedSale')), 'total_w_tax'));
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['financeAmount'] = 0;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['displayFinance'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['downTotal'] = 0;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['downMethod'] = 'None';
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['financeFees'] = [];
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needPayment'] = true;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needDown'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needFinance'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/0ece418d2684774761f56b63459d3f94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['D4Update'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var D4Commission;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'D4Update')) === 'string') && (getObjectProperty(___arguments.context.pageData, 'D4Update')).length > 4) {
    D4Commission = (await BackendlessUI.Functions.Custom['fn_dd8a1dbc881553c7b0417d8fefd3c35d']((await BackendlessUI.Functions.Custom['fn_9b1ead8d38642b24f233555a576b4ba9']((getObjectProperty(___arguments.context.pageData, 'selectedSale.D4info')), (getObjectProperty(___arguments.context.pageData, 'selectedSale.numRainbows')))), (getObjectProperty(___arguments.context.pageData, 'selectedSale.paidPercentage'))));
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['D4info'] = D4Commission;
    await BackendlessUI.Functions.Custom['fn_27f244a375346731e998cec94022c87d']((getObjectProperty(___arguments.context.pageData, 'selectedSale')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/e64f76894de6e11b94d2bbca7b120597/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'None') {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needDown'] = false;
  } else {
    (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['needDown'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/300867b38c95e13778c39179774d9706/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['custFname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ffc79ea926d5034e7323b8776a858c07/logic/3e3d3bc6133cb32b9703551fb7166d79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['custLname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openDiscrepancyModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/263fc32c058aceaba42d897232b950a5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var dealerObject;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/0a42b893a12ba9febe2a02ce348240aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var discrepancyRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  discrepancyRecord = (getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'signatureFile'));
  discrepancyRecord['signature'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'signatureFile'));
  discrepancyRecord['resolved'] = true;
  await Backendless.Data.of((await BackendlessUI.Functions.Custom['fn_728115de6413fe6895d592ebe63d687b']('discrepancy_table', ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})())))).save(discrepancyRecord, true);
  ___arguments.context.pageData['openDiscrepancyModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/9412b48d410a0eb859f6bd9a51a5333a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.system_count')) - (getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.manual_count')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/bc03e0a6af657e8b0b3a3e67659b15a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.product_cost')) * ((getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.system_count')) - (getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.manual_count'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      ___arguments.context.pageData['userList'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(10)));

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/8afcc1c59a271fcbd289709ce9e16196/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Location: ') + String(getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.link_location.name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/dc98aa215dadc98ba085168f8fb492fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Product: ') + String(getObjectProperty(___arguments.context.pageData, 'selectedDiscrepancy.link_product.product_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/5d384d7b99ca77db41568c24139d2f5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openDiscrepancyModal'] = false;
  ___arguments.context.pageData['signatureFile'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/e8959606ebcd8147d1ca89bdea78c945/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openDiscrepancyModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/1974408c1483c7289f36d5a9ddb7ff2e/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == '27') {
    ___arguments.context.pageData['openDiscrepancyModal'] = false;
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./components/reusable/r_502e7e5df6f766099c1f1d6bcbb9f345/logic/781fdcee36b6dc56ab0c83c29ff1eb2f/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['signatureFile'] = (await Backendless.Files.saveFile(encodePath((getObjectProperty(___arguments.context.pageData, 'discrepancyDir'))), (String((new Date()).toISOString()) + String('_signature.png')), ___arguments['signature'], true));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5'), 'signatureFile'));
  ___arguments.context.getComponentDataStoreByUid('263fc32c058aceaba42d897232b950a5')['signatureConfirmed'] = true;

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./components/reusable/r_eb52dfbafe9c2f1852f88a3c964eb581/logic/2f1538e282735552168e40524689849a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/7e05f572905ea86cf2633316b33695b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/6c2b7c0429ed1585dfcc7eafe4c90ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inventoryManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('500ff7c56663ea01a9a9059886c18237'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Add Product') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('500ff7c56663ea01a9a9059886c18237'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/1058388bd0d2e55b6cdd03b2c4e95883/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/d87bb2eee56904d468f6f3f2b18397c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/12d5c75d5a3e3e96e5a870574559073f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['inventoryMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/500ff7c56663ea01a9a9059886c18237/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/26d27eaca784825d8c3ab93fc01ce328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/7f5e0cf494a79ba18df5bbd2236cd0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--currentInventory', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'inventoryTotals', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/7a1ee6a567cea758234c78f3a34f8c49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--products', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewProducts', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/4576fd11bb6aba0cff646b6a6b59fc89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewTransactions', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/efdcb6f357e92f182aac99095571898c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locations', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewLocations', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/d018c1b4276b309d78edb0472d9fac27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--discrepancies', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'discrepancies', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/6be4e125fa2844bbe144c6fd9bad8af5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--stockCount', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/27d552ed3f8b7b2d652d4851f32cb648/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var salesManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('sales', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5dc1b91c2c5939fb98036dd2300f2f98'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/1986b13c495e88529f9f5f2875654cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/26144c6361780815c24274bada6b8577/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/dce77f9d12114cfe33835e1bccbb8a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['salesMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/5dc1b91c2c5939fb98036dd2300f2f98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['salesMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'salesMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/682cf91d6543f701925d781332955cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/57dfe008a2ced342886c2b34253526b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--history', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales History') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f709ef18dcb65bbd16096a5ec6da78fa'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f2d5e33f0881e4d6e5349e95847e783'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Record') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/773ba1aad441b7e81838c3071ec71329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--thisMonthsSales', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales This Month') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92e6c69b7bdb43cb530afb58cf79ab4f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2bdeee360eb462b1b3110f252140a33'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/4609ec482ba89b1c416d1bfa30ff1fbb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--topGiveaway', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Giveaway') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b19583ad31b9f857494c76232c3dfe76'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e96f7978b6f738652bbd98e9801ff4c'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/75d8978d364f6a5cd0b54e04f3cd3c82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dealerSales', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales By Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d61ca832f553c7f0a97765c57c10628'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6287d1396b2c3d5772d50e86a8e5e7cb'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/d3ffc7c20bfbced8f26a24dce97765a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--others', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Demos') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('282f1bf24648f938c9d2f8b206bf09b1'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec74f44de0de2b93dd332517856f39ae'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'objectId')) == '4FB81D20-3A72-4FDA-BADA-9A829BF2E585')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/2a7cf38464fbd7dab3eb7229a488c3fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('orders--dashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var eCommerceManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('orders', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Orders Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a7cf38464fbd7dab3eb7229a488c3fc'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023f0fdd451d84d9b001d9316e5c9e12'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ac6acc10ea20d3b618a33a61e4708dd'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/482e3759876558a8d2e8312d05dcd45d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('dealers', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealers Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/af625bd5cd45aa567a8296cb6719fc22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/92482e8cc8d4ce2c60f29755d1be9896/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/fd87b5b9d26fa8a2c0b46a1224c8b667/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dealersMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('66f6a2efbef9ca0cf0238abc1bd9e969')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['dealersMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/8a69318bc44ce6073bc8173a5ec6fafb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['dealersMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('66f6a2efbef9ca0cf0238abc1bd9e969')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('66f6a2efbef9ca0cf0238abc1bd9e969')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'dealersMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/66f6a2efbef9ca0cf0238abc1bd9e969/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dealersMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/b27644f384c84c8b05ee3be7e7784ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--addDealer', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Add Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('70c21443cf9e119944c26da48d0d647c'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6baf62f2bf5837b80ffa3e94689f7786'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealer Profile') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Edit Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/86abf77c6b9a7e235ecab40c2e9c2483/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--manageDealers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Manage Dealers') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63dba9f21b2c58ede7ae4a1fc7d6947'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99295c92c893e47a2b64e1affe2a5ad4'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/9b794f76617e9b2508f3d29df2048604/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn, userRoleFound;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var officeManagerLoggedIn, userRoleFound;

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/a2b9e4ead6d792be69e6c63547cdd7c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/fe9a0c5b36c81cc1b0a59dfd8f661696/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/e5035df9e1038cf2d10d3e19677ed693/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['payrollMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/2cc47487777283caab0f028d43f86a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['payrollMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/6e53d91140cdb702cc56cdc648527b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/6cf833e5fd266ac54262ceffa94b9279/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--history', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/0e3634422da67088b5362f5eb404ccd9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerHistory', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/c625f39b53635b6ca869fc155ba1e644/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/8daf184f84a831dfc4a77df4e171c5f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('settings', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/a7c3a1e67b192d3c2dfa95afb1426a72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/0d5253abdf7da291d1f566377b3ab402/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/2ed9b8f6be1be24c34f7e4b17ed1b559/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['settingsMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/6f126d379ff4f898fba9a494e0e83f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['settingsMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/092ceb3372ebc8028e9fcf89af88941b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/f4588d3d1237c3a3e7cdf94d37518aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--manageUsers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Manage Users') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('40b50ed37d68bd4769c2dd9201b26bf4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd37199397fffb267fbd3fb28675c73'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/c56cb9ebf07d879266fe5dabff1d71e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--managers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Managers') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('538849299b0463168e96f2ee2c28cd1e'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('547cfd3947b45beaa092e0bd3d546f09'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/c45f68166e1aca22e6ee194928a237bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeOptions', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Finance Options') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('790fa01da8afe9ff544ba081a3cc9716'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('117571dbf8edbaa74e7c5e1d40ba3378'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/aad93eca8d8660a55bed470871182b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeCompanies', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Finance Companies') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed084e433f883858011c7558967af891'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dca893aa174db2dbf4629346d4b10a53'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/e47fc3271ebb88e95eaf1b914c1c27fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--matrixLevels', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Matrix Levels') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fcee59f728db1d591c9e087964fb1d87'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2df41684d213ffc11382f70c6c15e82d'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/5667a462092b7a65ca65949bd5f4fa82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('feedback--submitFeedback', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/7d566b055cbd5293838769d7869de49b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  localStorage.removeItem('currentUser');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['loggedInUser'] = loggedInUser;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/cbec50ccec7e340500c91e88700d2e82/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUserGroup')) == 'Demo') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e05f572905ea86cf2633316b33695b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2b7c0429ed1585dfcc7eafe4c90ab3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a7cf38464fbd7dab3eb7229a488c3fc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27d552ed3f8b7b2d652d4851f32cb648', false);
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/bf78c8af297fe3cab561794cbb63e178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['sidebarClosed'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a8e291c90ac96640fb6eec2c6770bbc')), 'closedSidebar', '');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('329d30b69ecd56030d867acb683a5dae', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/fa2c8aa4b1412d6e394574a94bc9603b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['sidebarClosed'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a8e291c90ac96640fb6eec2c6770bbc')), 'closedSidebar');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('329d30b69ecd56030d867acb683a5dae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/3a4b7edc1e3ad051c1f2d5686d729a11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/b22e6bce670ef6081cd2918ac0e95f7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Competition Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4b7edc1e3ad051c1f2d5686d729a11'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3670e2e2a2e82f70fd1c3034a47562f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a'))['background-color'] = '#009fe2';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/5a3f114ddb2c6d6ddc0e658e91560951/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'compMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/b3670e2e2a2e82f70fd1c3034a47562f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var showElement;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/2ecebea9bcfbba498c3c5bfaafb28c5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var showElement;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('competitionsManager', null, true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/156279c61cb55091a36a761e1827367f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--listings', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/f6f1497efd16ab7f751f588604578c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var showElement;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('competitionsManager', null, true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/4d6c09c1325174fbe4dc3dcda1cc44d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'compMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['compMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/a26460bd441403183122e35d45539a1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'compMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['compMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/a9a681a127cc47c58f58ad5ad31a9163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var showElement;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('competitionsManager', null, true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/a4e4d8b86d6699a8a0dc09aa2d92ebec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var showElement;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('competitionsManager', null, true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/3227a0df41f35ba993081e2e7d6596b2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Move Products') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99f63ca6a2dfe2a4c481201f64cdf681'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('da7c692c740dfa5ca07bbcb133670c4a'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--moveProduct', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'moveItems', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/60fa9aba53412153c03b1ff8a20e0c28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--products', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/da7c692c740dfa5ca07bbcb133670c4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--currentInventory', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/6744f4ec1d9d4a461884d1d867fbb8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--snTracking', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'snTracking', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/8ec8599be8d3cbbbaaeaf2be8ef53e08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/f2a811bc86a4a0f5f4614d68589c9b55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/432cac783d943bd2063943e5e154a37b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/52020c985f35f5c9cc75a9da08159a76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--history', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/9481c136d7e8b15d73a56e84c1533aaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--teamLeaderboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' && (getObjectProperty(___arguments.context.pageData, 'relatedDealer.is_team_leader')) == true) {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/b7e25b7550db32d9a8e952b3224d4fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var showElement;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('competitionsManager', null, true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/dac18e955281be3ffe5a92e2acb7d4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDealerLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/d0eb3e585354a4b3631cbc2493bf151d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionOfficeLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/77ffa528312f849948068a6a38b59ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/51071524bf75990c8f9e94382ec90759/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionalDivisionLeaderboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/8738c53e8e0fa63828ee4e0c2203fd13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards--ld', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/2accd63c2097c7ea127c62e201f10e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionOfficeLeaderboards--ld', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/53d9039fabeb582296f91c3b17b4c8fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/bd22c3d96e5ed68a14f21feb673d17aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--manageDealers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var showElement;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('competitionsManager', null, true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/91d26af5d7fd36dbc5f44f443dc47c08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_fb1a63e38aeda4981acc1ef67d28b238']())

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/3e124f1d6bd16214a77ac40d2a98f049/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/45111388d73e05fcff8a79bdbf160e0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--manageLocations', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0086f7784769d12691d4584ebcb4028c/logic/2a560a21eea26b5a0f02dfd15b361e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--manageProducts', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsUpcomingData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_00af20aacc01f12c0c34a6894d6aeaa5/logic/d90ab99d7e1dca81a23f7e53f515edec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--editCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showEditButton;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')) == 'Time to Shine') {
    showEditButton = false;
  } else {
    showEditButton = true;
  }

  return showEditButton

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsHistoricData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_691259f3e4fb3ee3f59bb9189909d438/logic/d90ab99d7e1dca81a23f7e53f515edec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--finishedCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/d90ab99d7e1dca81a23f7e53f515edec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--editCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showEditButton;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')) == 'Time to Shine' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')) == 'Chase the Challenge') {
    showEditButton = false;
  } else {
    showEditButton = true;
  }

  return showEditButton

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_483793ef0779d4dab59c83981e032f2a/logic/8c355451ce1c382452b6e39e364f7f4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeCompetitionView', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/13ad43563465f62143de97a40754cdee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--viewCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/609a9c1e8fc71543062f1406e639627c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var endDateDealerScore, compEndDateFriendly, item, dealerScoresList, dealersWithScores, j, currentDealerRecord, submissionsFinalTotal, salesFinalTotal, demosFinalTotal, appointmentsFinalTotal, dealerCompetitionScoreList, compEndDate, compStartDate, compStartDateFriendly;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.dataModel['compEndDateModified'] = (new Date((new Date((getObjectProperty(___arguments.context.dataModel, 'competition_end_date')))).getTime() + (86400 * 1000)));
  compStartDate = [(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.dataModel, 'competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.dataModel, 'competition_start_date')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.dataModel, 'competition_start_date'))))].join('');
  compEndDate = [(new Intl.DateTimeFormat('default', ({ 'year': 'numeric','': undefined })).format((getObjectProperty(___arguments.context.dataModel, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'month': '2-digit' })).format((getObjectProperty(___arguments.context.dataModel, 'compEndDateModified')))),'-',(new Intl.DateTimeFormat('default', ({ 'day': '2-digit' })).format((getObjectProperty(___arguments.context.dataModel, 'compEndDateModified'))))].join('');
  dealerCompetitionScoreList = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentDealerRecord')), 'historic_comp_scores')), async (item) => {


   return ((getObjectProperty(item, 'date')) >= compStartDate && (getObjectProperty(item, 'date')) <= compEndDate);
  }));
  appointmentsFinalTotal = 0;
  demosFinalTotal = 0;
  salesFinalTotal = 0;
  submissionsFinalTotal = 0;
  for (var j_index in dealerCompetitionScoreList) {
    j = dealerCompetitionScoreList[j_index];
    if (getObjectProperty(j, 'appointments')) {
      appointmentsFinalTotal = appointmentsFinalTotal + (getObjectProperty(j, 'appointments'));
    }
    if (getObjectProperty(j, 'demos')) {
      demosFinalTotal = demosFinalTotal + (getObjectProperty(j, 'demos'));
    }
    if (getObjectProperty(j, 'sales')) {
      salesFinalTotal = salesFinalTotal + (getObjectProperty(j, 'sales'));
    }
    if (getObjectProperty(j, 'submissions')) {
      submissionsFinalTotal = submissionsFinalTotal + (getObjectProperty(j, 'submissions'));
    }
  }
  ___arguments.context.dataModel['dealerTotalAppointments'] = appointmentsFinalTotal;
  ___arguments.context.dataModel['dealerTotalDemos'] = demosFinalTotal;
  ___arguments.context.dataModel['dealerTotalSales'] = salesFinalTotal;
  ___arguments.context.dataModel['dealerTotalSubmissions'] = submissionsFinalTotal;
  ___arguments.context.dataModel['appointmentProgress'] = (Math.round(((getObjectProperty(___arguments.context.dataModel, 'dealerTotalAppointments')) / (getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_appointments'))) * 100));
  ___arguments.context.dataModel['demoProgress'] = (Math.round(((getObjectProperty(___arguments.context.dataModel, 'dealerTotalDemos')) / (getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_demos'))) * 100));
  ___arguments.context.dataModel['saleProgress'] = (Math.round(((getObjectProperty(___arguments.context.dataModel, 'dealerTotalSales')) / (getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_sales'))) * 100));
  ___arguments.context.dataModel['submissionProgress'] = (Math.round(((getObjectProperty(___arguments.context.dataModel, 'dealerTotalSubmissions')) / (getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_submissions'))) * 100));
  if ((getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_appointments')) == null) {
    ___arguments.context.dataModel['appointmentTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'appointmentProgress')) >= 100) {
    ___arguments.context.dataModel['appointmentTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_demos')) == null) {
    ___arguments.context.dataModel['demoTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'demoProgress')) >= 100) {
    ___arguments.context.dataModel['demoTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_sales')) == null) {
    ___arguments.context.dataModel['saleTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'saleProgress')) >= 100) {
    ___arguments.context.dataModel['saleTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'competition_targets.target_submissions')) == null) {
    ___arguments.context.dataModel['submissionTargetComplete'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'submissionProgress')) >= 100) {
    ___arguments.context.dataModel['submissionTargetComplete'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'competition_target_operator')) == 'OR') {
    if ((getObjectProperty(___arguments.context.dataModel, 'appointmentProgress')) >= 100 || (getObjectProperty(___arguments.context.dataModel, 'demoProgress')) >= 100 || (getObjectProperty(___arguments.context.dataModel, 'saleProgress')) >= 100 || (getObjectProperty(___arguments.context.dataModel, 'submissionProgress')) >= 100) {
      ___arguments.context.dataModel['targetComplete'] = true;
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'competition_target_operator')) == 'AND') {
    if ((getObjectProperty(___arguments.context.dataModel, 'appointmentTargetComplete')) == true && (getObjectProperty(___arguments.context.dataModel, 'demoTargetComplete')) == true && (getObjectProperty(___arguments.context.dataModel, 'saleTargetComplete')) == true && (getObjectProperty(___arguments.context.dataModel, 'submissionTargetComplete')) == true) {
      ___arguments.context.dataModel['targetComplete'] = true;
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/5de7b871a2130aa3752c11426afa2ecc/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var appointmentOutput, appointmentProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  appointmentProgress = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'appointmentProgress'));
  if (appointmentProgress >= 100) {
    appointmentOutput = 100;
    ___arguments.context.pageData['appointmentTargetAchieved'] = true;
  } else {
    appointmentOutput = appointmentProgress;
  }

  return appointmentOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/1f6fe0a712da4778481f34bc2d0ab2d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showAppointment;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_appointments')) == null) {
    showAppointment = false;
  } else {
    showAppointment = true;
  }

  return showAppointment

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/58223fb183ab94e40f0a649faad7e051/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showDemo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_demos')) == null) {
    showDemo = false;
  } else {
    showDemo = true;
  }

  return showDemo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/e7132e43d20e07771038779bee1e27d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_sales')) == null) {
    showSale = false;
  } else {
    showSale = true;
  }

  return showSale

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/4b435be259c9159b44625437556f2aa3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSubmission;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_submissions')) == null) {
    showSubmission = false;
  } else {
    showSubmission = true;
  }

  return showSubmission

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/d6710c3b4b5cb7088f181a1649c40fad/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var demoOutput, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  demoProgress = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'demoProgress'));
  if (demoProgress >= 100) {
    demoOutput = 100;
    ___arguments.context.pageData['demoTargetAchieved'] = true;
  } else {
    demoOutput = demoProgress;
  }

  return demoOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/234310a953e5f48647c9b8f6fad7140f/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var saleOutput, saleProgress, demoProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  saleProgress = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'saleProgress'));
  if (saleProgress >= 100) {
    saleOutput = 100;
    ___arguments.context.pageData['saleTargetAchieved'] = true;
  } else {
    saleOutput = saleProgress;
  }

  return saleOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/e5b5a5fd37ebddad12fe702caea11285/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    var submissionOutput, submissionProgress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  submissionProgress = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'submissionProgress'));
  if (submissionProgress >= 100) {
    submissionOutput = 100;
    ___arguments.context.pageData['submissionTargetAchieved'] = true;
  } else {
    submissionOutput = submissionProgress;
  }

  return submissionOutput

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/f0ba15170bee275b6a16a96d56ae5efe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'dealerTotalAppointments')),' / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_appointments')),' Appointments'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/a2eba5eaf0de1a04e98c3781618a9289/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'dealerTotalDemos')),' / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_demos')),' Demos'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/45d202c3e709096bc263dae9ed07d84a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'dealerTotalSales')),' / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_sales')),' Sales'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/33e9273b12b345d39bab9ba27674c8ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'dealerTotalSubmissions')),' / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_targets.target_submissions')),' Submissions'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/8ae56ee95be16eeab0697d14a5195609/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'targetComplete')) != true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/68ca0b0cfe14ff7c41fec9bac4d40649/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_target_operator')) == 'AND')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_87e9c475e273a5a3d73c6f876e981461/logic/402108e4a0cff4111bc5f0a33d67c6af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_target_operator')) == 'OR')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['competitionsData'] = (await Backendless.Data.of('Competitions').find(Backendless.DataQueryBuilder.create().setPageSize(30)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4e8bfc1974cdb1ce310121495d18e92b', (getObjectProperty(___arguments.context.pageData, 'competitionsData')));
  ___arguments.context.pageData['historicCompetitions'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


   return ((getObjectProperty(item, 'competition_end_date')) <= (new Date()));
  }));
  console.log('abc');
  ___arguments.context.pageData['upcomingCompetitions'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


   return ((getObjectProperty(item, 'competition_start_date')) >= (new Date()));
  }));
  console.log('abc');
  ___arguments.context.pageData['activeCompetitions'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'competitionsData')), async (item) => {


   return ((getObjectProperty(item, 'competition_start_date')) <= (new Date()) && (getObjectProperty(item, 'competition_end_date')) >= (new Date()));
  }));
  console.log('abc');
  ___arguments.context.pageData['historicCompetitionStat'] = ((getObjectProperty(___arguments.context.pageData, 'historicCompetitions')).length);
  ___arguments.context.pageData['upcomingCompetitionStat'] = ((getObjectProperty(___arguments.context.pageData, 'upcomingCompetitions')).length);
  ___arguments.context.pageData['activeCompetitionStat'] = ((getObjectProperty(___arguments.context.pageData, 'activeCompetitions')).length);

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/bf4847ba975c9bfb3f0cffd188ad4513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--viewCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));
  await (async function() {
  	location.reload()

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_1bd637ee3b8d54f14a6e7e1e218a1f05/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsUpcomingData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/d90ab99d7e1dca81a23f7e53f515edec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--finishedCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_304752e32cfada27966c109a0787998e/logic/04e4b5da2d25d1e579cfe07bee38ccf7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsHistoricData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/d90ab99d7e1dca81a23f7e53f515edec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--finishedCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1191da4210338c63357c795379c4981f/logic/3e398ce17a39e54f2a0c946c4499eb0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/d90ab99d7e1dca81a23f7e53f515edec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionCompetitionView', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/77bb43c57754ccb436577796fc5b2b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_44cb8b27468ae666d652529d8ff6123e/logic/d6b456b2dda2f3c6399fd0dc98030d47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showOfficeTab;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')) == 'Time to Shine') {
    showOfficeTab = false;
  } else {
    showOfficeTab = true;
  }

  return showOfficeTab

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/7e05f572905ea86cf2633316b33695b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e05f572905ea86cf2633316b33695b2'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('33f3cbd93635b43a04b97589def8fa06'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8388991d3462b7360f0a8d2ae287a04f'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/6c2b7c0429ed1585dfcc7eafe4c90ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var inventoryManagerLoggedIn;


  inventoryManagerLoggedIn = true;

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('500ff7c56663ea01a9a9059886c18237'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/1058388bd0d2e55b6cdd03b2c4e95883/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/d87bb2eee56904d468f6f3f2b18397c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/12d5c75d5a3e3e96e5a870574559073f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['inventoryMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/500ff7c56663ea01a9a9059886c18237/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/26d27eaca784825d8c3ab93fc01ce328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/7f5e0cf494a79ba18df5bbd2236cd0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--currentInventory', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Current Inventory') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3729f24504cfb0261310abe21fef325'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1afde301c6973b8b10216dcad968a572'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Current Inventory Location') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1afde301c6973b8b10216dcad968a572'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3729f24504cfb0261310abe21fef325'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1afde301c6973b8b10216dcad968a572'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Current Inventory Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3729f24504cfb0261310abe21fef325'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1afde301c6973b8b10216dcad968a572'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Current Inventory Serial Number') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3729f24504cfb0261310abe21fef325'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1afde301c6973b8b10216dcad968a572'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Current Inventory Product') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3729f24504cfb0261310abe21fef325'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1afde301c6973b8b10216dcad968a572'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/7a1ee6a567cea758234c78f3a34f8c49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--products', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Products') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a082ce72e9dafc6cf24a760b5888cb38'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('60fa9aba53412153c03b1ff8a20e0c28'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/4576fd11bb6aba0cff646b6a6b59fc89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions By Product') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions By Order') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Sold Items') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Demo Items') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Booked Items') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Adjustments') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Rainbowmates') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Scotts') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Tyler In') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions Tyler Out') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Transactions This Week') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57df9ed901fc4791916afbda2f4935d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4a64a6405d94fd73286840b41b3c7f5'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/efdcb6f357e92f182aac99095571898c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locations', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Locations') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c4e89220a17efbd97792a5c414740c7'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c9de237dc328de6e36db28bf89caa91'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Location Dealers') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c4e89220a17efbd97792a5c414740c7'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c9de237dc328de6e36db28bf89caa91'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Location Dealers Power') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c4e89220a17efbd97792a5c414740c7'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c9de237dc328de6e36db28bf89caa91'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Location Warehouses') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c4e89220a17efbd97792a5c414740c7'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c9de237dc328de6e36db28bf89caa91'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Location No Longer Tracked') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c4e89220a17efbd97792a5c414740c7'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c9de237dc328de6e36db28bf89caa91'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/d018c1b4276b309d78edb0472d9fac27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--locationSRX', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Rainbow SRX Lookup') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('68a5605d17a81ba6312e97a8e922b0ab'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('366c725c0ea2ddde572c37ae3431e3ef'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/6be4e125fa2844bbe144c6fd9bad8af5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--forms', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Book Items') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Dealer Inventory') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Dealer Update') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Initial Inventory') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Item Returns') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Office Inventory') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Product Checkout') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Purchase Request') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Reconcile Discrepancy') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Reconcile SRX Discrepancy') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Rexair Shipment') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms SRX Lookup') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms SRX Adjustment') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Dealer Transfer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Forms Office Transfer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5d82d7c31696818e2a2d52e9aec25bd8'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9517f5c98c082ecc6e6d506a5e2d0643'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/27d552ed3f8b7b2d652d4851f32cb648/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var salesManagerLoggedIn;


  salesManagerLoggedIn = true;

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5dc1b91c2c5939fb98036dd2300f2f98'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/1986b13c495e88529f9f5f2875654cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/26144c6361780815c24274bada6b8577/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/dce77f9d12114cfe33835e1bccbb8a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['salesMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/5dc1b91c2c5939fb98036dd2300f2f98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['salesMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'salesMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/682cf91d6543f701925d781332955cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/57dfe008a2ced342886c2b34253526b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--history', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales History') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f709ef18dcb65bbd16096a5ec6da78fa'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f2d5e33f0881e4d6e5349e95847e783'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Record') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/773ba1aad441b7e81838c3071ec71329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--thisMonthsSales', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales This Month') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92e6c69b7bdb43cb530afb58cf79ab4f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2bdeee360eb462b1b3110f252140a33'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/4609ec482ba89b1c416d1bfa30ff1fbb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--topGiveaway', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Giveaway') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b19583ad31b9f857494c76232c3dfe76'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e96f7978b6f738652bbd98e9801ff4c'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/75d8978d364f6a5cd0b54e04f3cd3c82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dealerSales', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales By Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d61ca832f553c7f0a97765c57c10628'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6287d1396b2c3d5772d50e86a8e5e7cb'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/d3ffc7c20bfbced8f26a24dce97765a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--demos', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Demos') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('282f1bf24648f938c9d2f8b206bf09b1'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec74f44de0de2b93dd332517856f39ae'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/f702afb763c59336199649f43d81a8d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--addonSales', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Addons') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c0fc81b4b8d7fe31d455a2a5af9e3752'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ad5f0b92622c472ae673a968882cd78'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/2a7cf38464fbd7dab3eb7229a488c3fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('orders--dashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var eCommerceManagerLoggedIn;



  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Orders Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a7cf38464fbd7dab3eb7229a488c3fc'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023f0fdd451d84d9b001d9316e5c9e12'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ac6acc10ea20d3b618a33a61e4708dd'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/482e3759876558a8d2e8312d05dcd45d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn;



  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealers Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/af625bd5cd45aa567a8296cb6719fc22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/92482e8cc8d4ce2c60f29755d1be9896/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/fd87b5b9d26fa8a2c0b46a1224c8b667/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dealersMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('66f6a2efbef9ca0cf0238abc1bd9e969')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['dealersMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/8a69318bc44ce6073bc8173a5ec6fafb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['dealersMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('66f6a2efbef9ca0cf0238abc1bd9e969')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('66f6a2efbef9ca0cf0238abc1bd9e969')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'dealersMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/66f6a2efbef9ca0cf0238abc1bd9e969/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dealersMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/b27644f384c84c8b05ee3be7e7784ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--addDealer', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Add Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('70c21443cf9e119944c26da48d0d647c'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6baf62f2bf5837b80ffa3e94689f7786'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealer Profile') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Edit Dealer') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/86abf77c6b9a7e235ecab40c2e9c2483/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dealers--manageDealers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Manage Dealers') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92482e8cc8d4ce2c60f29755d1be9896'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('af625bd5cd45aa567a8296cb6719fc22'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('482e3759876558a8d2e8312d05dcd45d'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd87b5b9d26fa8a2c0b46a1224c8b667'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63dba9f21b2c58ede7ae4a1fc7d6947'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('99295c92c893e47a2b64e1affe2a5ad4'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/9b794f76617e9b2508f3d29df2048604/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn, userRoleFound;



  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Payroll Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2b9e4ead6d792be69e6c63547cdd7c5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fe9a0c5b36c81cc1b0a59dfd8f661696'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5035df9e1038cf2d10d3e19677ed693'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/a2b9e4ead6d792be69e6c63547cdd7c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/fe9a0c5b36c81cc1b0a59dfd8f661696/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/e5035df9e1038cf2d10d3e19677ed693/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['payrollMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/2cc47487777283caab0f028d43f86a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['payrollMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/6e53d91140cdb702cc56cdc648527b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/6cf833e5fd266ac54262ceffa94b9279/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--history', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Payroll Summary') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2b9e4ead6d792be69e6c63547cdd7c5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fe9a0c5b36c81cc1b0a59dfd8f661696'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5035df9e1038cf2d10d3e19677ed693'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Payroll History') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2b9e4ead6d792be69e6c63547cdd7c5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fe9a0c5b36c81cc1b0a59dfd8f661696'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5035df9e1038cf2d10d3e19677ed693'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6f1fed3378d8d9644f16d263a1a47fa'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('06c6d91aa3e6ee38e771d031f88771c2'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Payrun View') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2b9e4ead6d792be69e6c63547cdd7c5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fe9a0c5b36c81cc1b0a59dfd8f661696'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5035df9e1038cf2d10d3e19677ed693'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/0e3634422da67088b5362f5eb404ccd9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerHistory', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealer Payroll History') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2b9e4ead6d792be69e6c63547cdd7c5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fe9a0c5b36c81cc1b0a59dfd8f661696'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5035df9e1038cf2d10d3e19677ed693'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('82a53ae3222172cc5f0f32f997629bad'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7388e3962e0172a732f90d1309de2a04'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/c625f39b53635b6ca869fc155ba1e644/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('payroll--dealerPayroll', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealer Payroll') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2b9e4ead6d792be69e6c63547cdd7c5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fe9a0c5b36c81cc1b0a59dfd8f661696'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5035df9e1038cf2d10d3e19677ed693'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0bf41f881073e479fcec2bd6d4adedd5'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6f9e0ec2c23f46a1807e94bca52de8e6'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/8daf184f84a831dfc4a77df4e171c5f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn;



  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/a7c3a1e67b192d3c2dfa95afb1426a72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/0d5253abdf7da291d1f566377b3ab402/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/2ed9b8f6be1be24c34f7e4b17ed1b559/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['settingsMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/6f126d379ff4f898fba9a494e0e83f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['settingsMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/092ceb3372ebc8028e9fcf89af88941b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/f4588d3d1237c3a3e7cdf94d37518aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--manageUsers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Manage Users') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('40b50ed37d68bd4769c2dd9201b26bf4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd37199397fffb267fbd3fb28675c73'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/c56cb9ebf07d879266fe5dabff1d71e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--managers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Managers') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('538849299b0463168e96f2ee2c28cd1e'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('547cfd3947b45beaa092e0bd3d546f09'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/c45f68166e1aca22e6ee194928a237bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeOptions', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Finance Options') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('790fa01da8afe9ff544ba081a3cc9716'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('117571dbf8edbaa74e7c5e1d40ba3378'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/aad93eca8d8660a55bed470871182b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeCompanies', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Finance Companies') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed084e433f883858011c7558967af891'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dca893aa174db2dbf4629346d4b10a53'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/e47fc3271ebb88e95eaf1b914c1c27fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--matrixLevels', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Matrix Levels') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fcee59f728db1d591c9e087964fb1d87'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2df41684d213ffc11382f70c6c15e82d'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/5667a462092b7a65ca65949bd5f4fa82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('feedback--submitFeedback', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/7d566b055cbd5293838769d7869de49b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  localStorage.removeItem('currentUser');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['loggedInUser'] = loggedInUser;
  ___arguments.context.pageData['relatedDealer'] = ((await BackendlessUI.Functions.Custom['fn_eb42ea476121086caadc8b67091aea2d'](((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), (['user_link = \'',(getObjectProperty(loggedInUser, 'objectId')),'\''].join('')), null, null, 2, null, null, null))[0]);
  if ((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()) {
    ___arguments.context.pageData['currentOffice'] = (await Backendless.Data.of('Offices').findById(((function(){ try { return JSON.parse(localStorage.getItem('officeObjId')) } catch(e){ return null }})()), ));
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentOffice')), 'office_logo')) {
      ___arguments.context.pageData['officeLogoURL'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentOffice')), 'office_logo'));
    } else {
      ___arguments.context.pageData['officeLogoURL'] = 'https://demo.tellusapps.net/api/files/TellUS-logo-white.png';
    }
  } else {
    ___arguments.context.pageData['officeLogoURL'] = 'https://demo.tellusapps.net/api/files/TellUS-logo-white.png';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/cbec50ccec7e340500c91e88700d2e82/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUserGroup')) == 'Demo') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e05f572905ea86cf2633316b33695b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2b7c0429ed1585dfcc7eafe4c90ab3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a7cf38464fbd7dab3eb7229a488c3fc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27d552ed3f8b7b2d652d4851f32cb648', false);
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/bf78c8af297fe3cab561794cbb63e178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['sidebarClosed'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a8e291c90ac96640fb6eec2c6770bbc')), 'closedSidebar', '');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('329d30b69ecd56030d867acb683a5dae', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/fa2c8aa4b1412d6e394574a94bc9603b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['sidebarClosed'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a8e291c90ac96640fb6eec2c6770bbc')), 'closedSidebar');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('329d30b69ecd56030d867acb683a5dae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/3a4b7edc1e3ad051c1f2d5686d729a11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/b22e6bce670ef6081cd2918ac0e95f7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Competition Dashboard') {
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/5a3f114ddb2c6d6ddc0e658e91560951/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Time to Shine Dealers Leaderboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b34edf28d0ecb9d9ff445e6570f2f3c'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('682fcb4c0d7fe4c5b783e95aea7fd5aa'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Time to Shine Office Leaderboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e09dd5c62f24ca1ada01dee14a569134'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15927ded4d744c0b945bd4c69cf2456c'))['color'] = '#fff';
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Competitions Dashboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57470be186397f37e42700ec127695ac'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f6d1039beaf9cec11b0b597663e9f8'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Add Competition') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8da8dce91d21b2e97551922e8df13f'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20f92e3f0b63e12c5425f51f19935208'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Update Scores') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3583119cc9196a362883cd7feaddca6'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('901da46a57bbff67fb4d80dbb1bcccaa'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Add Dealer') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0191cab6a4ba8c4b4e9d0297e9ad16e1'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('13c582920cd5daab4d5cd2a805ef4a84'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Manage Dealers') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b3fad3ac52b61c5f63f2bf2508d1214'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ac2c7e31c930b681a8500716c4d03b3'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealer Leaderboards') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dec9b2da438e85239c317ecb1bb11605'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c92e62312965f205a49477d944cf17cb'))['color'] = '#fff';
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Dealer Competitions Dashboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e50ccfbe148df037cd9657b988f1e10e'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('69099b0b0ed534e448d6c8c192e5a1f1'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Competitions History') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9e536dd19254f26cb44bb654e9981783'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6036c2d7ca2452f7a6a715b84ec3841e'))['color'] = '#fff';
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Division Leaderboards') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49068e2b075ec2eb904f49e52d14f8ad'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f477de550025a62982512aa6e05bdffe'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Division Leaderboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c043f3c4436100f1c8320e3df40561d6'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a0a20ac83edc3ffde3bd1118292a8a06'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Competitions Division Dashboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a713c206fec6f4d54a2dc8656c65a5dd'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6f2cb94c95d1e77541ef83a81a2d8dd9'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Office Leaderboards') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8e187ec80bf8f134b7932761fb1f9c8c'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96f4bc0f6b4d65d674f6616e6bd4680f'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Manage Division Dealers') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17631613edffb4f2b30e94c396bc3129'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3f4183cb1da2124a0134febc2743eb7'))['color'] = '#fff';
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Region Leaderboards') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4eec032b67af4432358a347cdedb9b61'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('653187450de423a81ef2b151375e3809'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Region Dashboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffe7370c49ee5be6c338c38691f95bdf'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa85475b4abe2c280798242ef12d247b'))['color'] = '#fff';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Region Division Leaderboard') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ccf7bf8e0f94cc81517341532a3b1325'))['color'] = '#fff';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58dc40e635c23bef7a4a298d2061190c'))['color'] = '#fff';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/b3670e2e2a2e82f70fd1c3034a47562f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var showElement;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/2ecebea9bcfbba498c3c5bfaafb28c5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/156279c61cb55091a36a761e1827367f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--listings', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/f6f1497efd16ab7f751f588604578c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/4d6c09c1325174fbe4dc3dcda1cc44d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'compMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['compMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/a26460bd441403183122e35d45539a1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'compMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['compMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/a9a681a127cc47c58f58ad5ad31a9163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/a4e4d8b86d6699a8a0dc09aa2d92ebec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/52020c985f35f5c9cc75a9da08159a76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--history', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/69099b0b0ed534e448d6c8c192e5a1f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/8ec8599be8d3cbbbaaeaf2be8ef53e08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/bd22c3d96e5ed68a14f21feb673d17aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--manageDealers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/f2a811bc86a4a0f5f4614d68589c9b55/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/dac18e955281be3ffe5a92e2acb7d4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDealerLeaderboards', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/432cac783d943bd2063943e5e154a37b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var showElement;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionDashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/77ffa528312f849948068a6a38b59ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/d0eb3e585354a4b3631cbc2493bf151d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionOfficeLeaderboards', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/b7e25b7550db32d9a8e952b3224d4fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/53d9039fabeb582296f91c3b17b4c8fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/51071524bf75990c8f9e94382ec90759/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionalDivisionLeaderboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/8738c53e8e0fa63828ee4e0c2203fd13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards--ld', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/2accd63c2097c7ea127c62e201f10e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionOfficeLeaderboards--ld', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/af83928cf4d4ce6728296f2d1423f929/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var competitionLogo, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['activeUser'] = (getObjectProperty(currentUser, 'userGroup'));
  ___arguments.context.pageData['divisionRecord'] = ((await Backendless.Data.of('Divisions').find(Backendless.DataQueryBuilder.create().setWhereClause((['division_manager = \'',(getObjectProperty(currentUser, 'objectId')),'\''].join(''))).setRelationsDepth(2).setPageSize(10)))[0]);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'userGroup')) == 'Division Manager') {
    competitionLogo = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'divisionRecord')), 'division_logo'));
  } else {
    competitionLogo = (getObjectProperty(___arguments.context.pageData, 'officeLogoURL'));
  }

  return competitionLogo

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/9481c136d7e8b15d73a56e84c1533aaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--teamLeaderboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' && (getObjectProperty(___arguments.context.pageData, 'relatedDealer.is_team_leader')) == true) {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/f458fa5b48b3a223632167659dffd3c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Team Leader Stats') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ab01f4cbb9d41d1a63cf8db25f6cd7d6'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f458fa5b48b3a223632167659dffd3c4'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/6bf2d389d7f3e42e214f7b8236f80feb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--manageDivisionDealers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5ffbf50da424f5ddc13faec36809db1c/logic/e90684a7d9aeb2813fb5715d1b5d0484/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newDivisionCompetition', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/a898680eda3c9d2e11618f8336f2895d/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_progress'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/e923e7a1a63e13ec167de0e214593b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e923e7a1a63e13ec167de0e214593b6c'))['backgroundImage'] = (['url(\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'\')'].join(''));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/4e8bfc1974cdb1ce310121495d18e92b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'competitionsData'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/a38bc3727b127cb1c2b701a8ef661cad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/f89e95d9db73c6769513216226b65999/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_c0128ed7920ab883576b8d79a0dac2cb']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_db0c9b72c6d2f553c161b2420ac13017/logic/13ad43563465f62143de97a40754cdee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedCompetition'] = ({ 'compName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_name')),'compSlogan': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_slogan')),'compDesc': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_description')),'compStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_start_date')),'compEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_end_date')),'compFeaturedImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_featured_image')),'compPosterImage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'competition_poster_image')) });
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--viewCompetition', ({ 'competitionObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609a9c1e8fc71543062f1406e639627c'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_60f4cc19d6a6516dfef6d47fab0d826a/logic/832b60836994226bf48bd42783de128f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['mobileMenuOpen'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5c071c954d395af9735995a64ba387d6')), 'menu-open');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('832b60836994226bf48bd42783de128f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bbac082f8c6f83c5b7b9a6df8bb6ea37', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_60f4cc19d6a6516dfef6d47fab0d826a/logic/bbac082f8c6f83c5b7b9a6df8bb6ea37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['menuOpen'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('832b60836994226bf48bd42783de128f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bbac082f8c6f83c5b7b9a6df8bb6ea37', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5c071c954d395af9735995a64ba387d6')), 'menu-open', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_60f4cc19d6a6516dfef6d47fab0d826a/logic/019e5a1fff68b68c52d6f90159b31dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showSidebar'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('019e5a1fff68b68c52d6f90159b31dfa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f91a03c343198fe600f0467762efe56', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_60f4cc19d6a6516dfef6d47fab0d826a/logic/7f91a03c343198fe600f0467762efe56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showSidebar'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('019e5a1fff68b68c52d6f90159b31dfa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f91a03c343198fe600f0467762efe56', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_5a979bafa8d41d4a1b271f658995d174/logic/776a6a26f7adcdd37e117a1c49f3850c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_595c8ee3b78fd6a5477e3dd324bde26a/logic/832b60836994226bf48bd42783de128f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['mobileMenuOpen'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5c071c954d395af9735995a64ba387d6')), 'menu-open');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('832b60836994226bf48bd42783de128f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bbac082f8c6f83c5b7b9a6df8bb6ea37', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_595c8ee3b78fd6a5477e3dd324bde26a/logic/bbac082f8c6f83c5b7b9a6df8bb6ea37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['menuOpen'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('832b60836994226bf48bd42783de128f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bbac082f8c6f83c5b7b9a6df8bb6ea37', false);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5c071c954d395af9735995a64ba387d6')), 'menu-open', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_595c8ee3b78fd6a5477e3dd324bde26a/logic/019e5a1fff68b68c52d6f90159b31dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showSidebar'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('019e5a1fff68b68c52d6f90159b31dfa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f91a03c343198fe600f0467762efe56', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showSidebarIcon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'hideSidebarIcon')) == true) {
    showSidebarIcon = false;
  } else {
    showSidebarIcon = true;
  }

  return showSidebarIcon

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_595c8ee3b78fd6a5477e3dd324bde26a/logic/7f91a03c343198fe600f0467762efe56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showSidebar'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('019e5a1fff68b68c52d6f90159b31dfa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f91a03c343198fe600f0467762efe56', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_f68c30a5638b495664a8f8f863786a1b/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'openCancelSaleModal')) {
    addItemToList(classesList, 'open');
    addItemToList(classesList, 'bringToFront');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_f68c30a5638b495664a8f8f863786a1b/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['openCancelSaleModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_f68c30a5638b495664a8f8f863786a1b/logic/eb29d43f86b271b81274fbfdfaeaeb46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedSale;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['sale_cancelled'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedSale'))['ok2pay'] = false;
  selectedSale = (await BackendlessUI.Functions.Custom['fn_177f043f238da488ad6d782f16e299c9']((getObjectProperty(___arguments.context.pageData, 'selectedSale'))));
  ___arguments.context.pageData['openFinanceModal'] = false;
  ___arguments.context.pageData['openCancelSaleModal'] = false;
  ___arguments.context.pageData['refreshNeeded'] = true;
  (function (message) { alert(message) })('Sales successfully cancelled.');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_f68c30a5638b495664a8f8f863786a1b/logic/731c98ce558d72f303770587246c729d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Cancel Sale #') + String(getObjectProperty(___arguments.context.pageData, 'selectedSale.orderNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'addPCI')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['addPCI'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/eb29d43f86b271b81274fbfdfaeaeb46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newCode, rand, paddingVal, padding, existingCodes, j, officeRecord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  officeRecord = (getObjectProperty(___arguments.context.pageData, 'selectedOffice'));
  if (!(getObjectProperty(___arguments.context.pageData, 'selectedOffice.six_digit_office_code'))) {
    existingCodes = [];
    var j_list = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', (String('six_digit_office_code is not null')), null, null, null, null));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (getObjectProperty(j, 'six_digit_office_code')) {
        addItemToList(existingCodes, (getObjectProperty(j, 'six_digit_office_code')));
      }
    }
    newCode = existingCodes[0];
    while (existingCodes.includes(newCode)) {
      rand = String(mathRandomInt(1, 100000));
      paddingVal = '0';
      if (rand.length < 5) {
        paddingVal = '0';
        padding = 5 - rand.length;
        rand = String(padding * paddingVal) + String(rand);
      }
      newCode = String('T') + String(rand);
    }
    (getObjectProperty(___arguments.context.pageData, 'selectedOffice'))['six_digit_office_code'] = newCode;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'selectedOffice.dealer_table'))) {
    (getObjectProperty(___arguments.context.pageData, 'selectedOffice'))['dealer_table'] = 'Dealers';
  }
  await Backendless.Data.of('Offices').save((getObjectProperty(___arguments.context.pageData, 'selectedOffice')), true);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](newCode);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/bd34f137a0bb1f0a71939a4344a2fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedOffice.six_digit_office_code')) ? String('Office code is: ') + String(getObjectProperty(___arguments.context.pageData, 'selectedOffice.six_digit_office_code')) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/3e786f3c089f42dc807ea27c20790107/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedOffice.dealer_table')) ? String('Dealers will be uploaded to table: ') + String(getObjectProperty(___arguments.context.pageData, 'selectedOffice.dealer_table')) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/666788f8ce5c0fbad27f2aa967f7eaba/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, numFields, csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](___arguments.uploadedFiles);
    csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2list`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'csvURL': ___arguments.uploadedFiles }));
    numFields = csvFile[0].length;
    if (numFields != 2) {
      throw (new Error('Upload file should have two columns, NameOfDealer and Login.'))
    }
    ___arguments.context.pageData['uploadResponse'] = (await BackendlessUI.Functions.Custom['fn_e33ecc11abe7ceeb1cead543d30a2203']((getObjectProperty(___arguments.context.pageData, 'selectedOffice')), csvFile));

  } catch (error) {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](error);
    ___arguments.context.pageData['uploadResponse'] = error;

  } finally {
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](___arguments.uploadedFiles);

  }

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/f1cc3aeba8fd5a455da4fe9dca6c1d6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'selectedOffice'))['module_PCI'] = 'Ready for Tech Team';
  await Backendless.Data.of('Offices').save( (getObjectProperty(___arguments.context.pageData, 'selectedOffice')) );

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_PCI.goodBarberAddedToZapier')) && (getObjectProperty(___arguments.context.pageData, 'selectedOffice.six_digit_office_code'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./components/reusable/r_087b30494629d367b8726565e1785712/logic/731c98ce558d72f303770587246c729d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['PCI setup for ',(getObjectProperty(___arguments.context.pageData, 'selectedOffice.office_name')),'',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/1cd78865d9344ebb5076c1c1f1879464/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'addInventory')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['allowOnboarding'] = false;
  ___arguments.context.pageData['testsRunning'] = false;
  ___arguments.context.pageData['inventoryTestResponse'] = '';
  ___arguments.context.pageData['cognitoFormsResponse'] = '';
  ___arguments.context.pageData['zapierResponse'] = '';
  ___arguments.context.pageData['eventHandlerResponse'] = '';
  ___arguments.context.pageData['finalResponse'] = '';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/296f33e40e8c704ddc64a5fc608cbafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Offices').save( (getObjectProperty(___arguments.context.pageData, 'selectedOffice')) );
  ___arguments.context.pageData['inventoryTestResponse'] = undefined;
  ___arguments.context.pageData['cognitoFormsResponse'] = undefined;
  ___arguments.context.pageData['zapierResponse'] = undefined;
  ___arguments.context.pageData['eventHandlerResponse'] = undefined;
  ___arguments.context.pageData['finalResponse'] = undefined;
  ___arguments.context.pageData['addInventory'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/731c98ce558d72f303770587246c729d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Inventory checklist for ',(getObjectProperty(___arguments.context.pageData, 'selectedOffice.office_name')),'',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/eb29d43f86b271b81274fbfdfaeaeb46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, nextSteps, officeRecord, shortIdentifier, tablesNeeded;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_inventory.backendlessSaleForm')) == null) {
    ___arguments.context.pageData['selectedOffice.checklist_inventory.backendlessSaleForm'] = false;
  }
  await Backendless.Data.of('Offices').save((getObjectProperty(___arguments.context.pageData, 'selectedOffice')), true);
  officeRecord = (getObjectProperty(___arguments.context.pageData, 'selectedOffice'));
  if (!((getObjectProperty(___arguments.context.pageData, 'selectedOffice.company_short_identifier')) && !(getObjectProperty(___arguments.context.pageData, 'needShortCode')))) {
    ___arguments.context.pageData['finalResponse'] = 'Short code is required';
  }
  shortIdentifier = (getObjectProperty(___arguments.context.pageData, 'selectedOffice.company_short_identifier'));
  tablesNeeded = (await BackendlessUI.Functions.Custom['fn_dc9a708af549b58a4d75cae9feffd116'](['Inventory'], shortIdentifier, officeRecord));
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](tablesNeeded);
  nextSteps = [];
  var j_list = (getObjectProperty(tablesNeeded, 'tableObj'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8'](j);
    if ((getObjectProperty(j, 'tableType')) == 'dealer_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_afc28d72ffbe4d877f09ad3d7ab58e88']((getObjectProperty(j, 'tableName')), nextSteps));
    } else if ((getObjectProperty(j, 'tableType')) == 'discrepancy_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_7a94cfbce49a1c6602cc208d1acada83']((getObjectProperty(j, 'tableName')), nextSteps, shortIdentifier, (getObjectProperty(officeRecord, 'location_table')), (getObjectProperty(officeRecord, 'product_table'))));
    } else if ((getObjectProperty(j, 'tableType')) == 'location_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_6cb2904b74d2fbb8562279f3de2bcbdf']((getObjectProperty(j, 'tableName')), nextSteps, (getObjectProperty(officeRecord, 'dealer_table'))));
    } else if ((getObjectProperty(j, 'tableType')) == 'product_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_123f917f708ba155fa5e7d62e17cbe75'](shortIdentifier, nextSteps, (getObjectProperty(j, 'tableName'))));
    } else if ((getObjectProperty(j, 'tableType')) == 'productTransaction_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_6fc9e39e65d8fbfb6dc2f45e1136fc52'](shortIdentifier, nextSteps, (getObjectProperty(j, 'tableName')), (getObjectProperty(officeRecord, 'product_table')), (getObjectProperty(officeRecord, 'location_table'))));
    } else if ((getObjectProperty(j, 'tableType')) == 'salesInvoice_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_840a0634a41a4e1b55691e3c685386ae'](shortIdentifier, nextSteps, (getObjectProperty(j, 'tableName')), (getObjectProperty(officeRecord, 'salesCalculations_table')), (getObjectProperty(officeRecord, 'productTransaction_table')), (getObjectProperty(officeRecord, 'dealer_table'))));
    } else if ((getObjectProperty(j, 'tableType')) == 'salesCalculations_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_6ced27bc6ce9165697ec7b45cf6aba85'](shortIdentifier, nextSteps, (getObjectProperty(j, 'tableName')), (getObjectProperty(officeRecord, 'product_table')), (getObjectProperty(officeRecord, 'location_table'))));
    } else if ((getObjectProperty(j, 'tableType')) == 'SN_tracking_table') {
      officeRecord[(getObjectProperty(j, 'tableType'))] = (getObjectProperty(j, 'tableName'));
      nextSteps = (await BackendlessUI.Functions.Custom['fn_3b9b17025a262ba71d93f31226730135'](shortIdentifier, nextSteps, (getObjectProperty(j, 'tableName')), (getObjectProperty(officeRecord, 'product_table')), (getObjectProperty(officeRecord, 'location_table')), (getObjectProperty(officeRecord, 'productTransaction_table'))));
    } else {
      nextSteps = [nextSteps,'</br>','no process in submit for table ',(getObjectProperty(j, 'tableType'))].join('');
    }
  }
  await Backendless.Data.of('Offices').save((getObjectProperty(___arguments.context.pageData, 'selectedOffice')), true);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']('End prepare tables (button click)');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/ac06c84edc02787cb9745fef88b8043b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inventoryTablesTest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['testsRunning'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_inventory.backendlessSaleForm')) == null) {
    ___arguments.context.pageData['selectedOffice.checklist_inventory.backendlessSaleForm'] = false;
  }
  await Backendless.Data.of('Offices').save((getObjectProperty(___arguments.context.pageData, 'selectedOffice')), true);
  await BackendlessUI.Functions.Custom['fn_4757c24166a2324905bc73c7c0a4a3b8']((getObjectProperty(___arguments.context.pageData, 'testsRunning')));
  inventoryTablesTest = (await BackendlessUI.Functions.Custom['fn_aec65d423c67f1aafe1934852e0c9d6a']((getObjectProperty(___arguments.context.pageData, 'selectedOffice'))));
  ___arguments.context.pageData['inventoryTestResponse'] = (getObjectProperty(inventoryTablesTest, 'response'));
  ___arguments.context.pageData['passedCheck'] = (getObjectProperty(inventoryTablesTest, 'passedCheck'));
  if (getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_inventory.cognitoSalesForm')) {
    ___arguments.context.pageData['cognitoFormsKnown'] = true;
    ___arguments.context.pageData['cognitoFormsResponse'] = 'Cognito Forms known';
  } else {
    ___arguments.context.pageData['cognitoFormsKnown'] = false;
    ___arguments.context.pageData['passedCheck'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'passedCheck')) {
    if (!(getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_inventory.zapCognito2BackendlessInvoice'))) {
      ___arguments.context.pageData['zapierResponse'] = 'Zapier connection needed';
      ___arguments.context.pageData['passedCheck'] = false;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_inventory.eventHandlerTransactions'))) {
      ___arguments.context.pageData['eventHandlerResponse'] = 'Event handlers needed';
      ___arguments.context.pageData['passedCheck'] = false;
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'passedCheck')) {
    if ((await BackendlessUI.Functions.Custom['fn_e5f530f101da378e128b7fe346268e6e']())) {
      ___arguments.context.pageData['allowOnboarding'] = true;
      ___arguments.context.pageData['finalResponse'] = 'Ready to go';
    } else {
      ___arguments.context.pageData['finalResponse'] = 'Problem with Serial number update';
    }
  } else {
    if (getObjectProperty(___arguments.context.pageData, 'selectedOffice.checklist_inventory.cognitoSalesForm')) {
      ___arguments.context.pageData['finalResponse'] = 'Submit to tech team to complete process using the button to the left.';
      ___arguments.context.pageData['allowForward'] = true;
    } else {
      ___arguments.context.pageData['finalResponse'] = 'Fill in cognito form URLs and try again.';
    }
  }
  ___arguments.context.pageData['testsRunning'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/ebe722d43bccef19825ba90b5695586b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  await Backendless.Messaging.sendEmail('TellUs: Office ready for Inventory setup', new Backendless.Bodyparts({ textmessage: (String(getObjectProperty(___arguments.context.pageData, 'selectedOffice.office_name')) + String(' is ready for inventory setup')) }), ensureArray('alysha.reinard@gmail.com'), undefined);
  (getObjectProperty(___arguments.context.pageData, 'selectedOffice'))['module_inventory'] = 'Ready for Tech Team';
  await Backendless.Data.of('Offices').save( (getObjectProperty(___arguments.context.pageData, 'selectedOffice')) );

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'allowForward'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedOffice.module_inventory')) != 'Ready for Tech Team')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/800ed1fb0dfd1d5fb2eb7db3d6ab7b66/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedOffice.company_short_identifier'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedOffice.company_short_identifier')) ? (getObjectProperty(___arguments.context.pageData, 'selectedOffice.company_short_identifier')) : (getObjectProperty(___arguments.context.pageData, 'shortCode')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/ec4bb4a8b19381e7affd3a1dc8459dd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'needShortCode')) ? 'That short code is already in use. Please enter another' : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/d85f6c9cb6d6b24d160ea543dffbe4e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var duplicateShortIDs;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  duplicateShortIDs = (await Backendless.Data.of('Offices').find(Backendless.DataQueryBuilder.create().setWhereClause((['company_short_identifier = \'',(getObjectProperty(___arguments.context.pageData, 'shortCode')),'\''].join(''))).setPageSize(10)));
  if (duplicateShortIDs.length > 0) {
    ___arguments.context.pageData['needShortCode'] = true;
  } else {
    ___arguments.context.pageData['needShortCode'] = false;
    ___arguments.context.pageData['selectedOffice.company_short_identifier'] = (getObjectProperty(___arguments.context.pageData, 'shortCode'));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'selectedOffice.company_short_identifier')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/3314e94b0d81f9b153c3807262959e96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inventoryTestResponse'] = undefined;
  ___arguments.context.pageData['cognitoFormsResponse'] = undefined;
  ___arguments.context.pageData['zapierResponse'] = undefined;
  ___arguments.context.pageData['eventHandlerResponse'] = undefined;
  ___arguments.context.pageData['finalResponse'] = undefined;
  ___arguments.context.pageData['addInventory'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0209087e42b91aa9173f54dfb913e6d3/logic/734d933497396ec7cc1d3d3eb6cdcd01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  (getObjectProperty(___arguments.context.pageData, 'selectedOffice'))['module_inventory'] = 'Onboarding';
  await Backendless.Messaging.sendEmail((String(getObjectProperty(___arguments.context.pageData, 'selectedOffice.office_name')) + String(' is ready for onboarding')), new Backendless.Bodyparts({ textmessage: (['We\'ve completed the setup for: ',(getObjectProperty(___arguments.context.pageData, 'selectedOffice.office_name')),'',' Let us know if there are any issues.'].join('')) }), ensureArray('boyd@tellus.business'), undefined);
  ___arguments.context.pageData['addInventory'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7acb32950e9a980597ce159da587278f/logic/fa045794e50a00bb07792672ee423963/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((Backendless.getCurrentUserToken()) ? ((await BackendlessUI.Functions.Custom['fn_fb1a63e38aeda4981acc1ef67d28b238']()) && (getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'objectId')) != '092A5EFC-C8D4-405E-8A13-C2D1845B6A2B' ? ['Hello ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'fName')),' (viewing ',(getObjectProperty(((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()), 'office_name')),')'].join('') : String('Hello ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'fName'))) : 'Hello')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7acb32950e9a980597ce159da587278f/logic/00b56f2e01030626b72e3698757b7826/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value, currentUserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((Backendless.getCurrentUserToken()) ? String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) : 'User Name')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7acb32950e9a980597ce159da587278f/logic/4aff19693daa9b6fa76e4672864fa858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var currentUserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((Backendless.getCurrentUserToken()) ? String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) : 'Hello')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7acb32950e9a980597ce159da587278f/logic/878797b9b851da9c2898a65773bdcc1e/bundle.js', [], () => ({
  /* content */
  /* handler:onBadgeClick */
  ['onBadgeClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b437efeda4fd0e98753a2ca79f12d45d', true);

  },
  /* handler:onBadgeClick */
  /* handler:onContentClick */
  ['onContentClick'](___arguments) {
    var notificationMenuOpen;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b437efeda4fd0e98753a2ca79f12d45d', true);
  notificationMenuOpen = ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('48c6e6fbdc9d798766cd1d1f52b51687'));

  },
  /* handler:onContentClick */
  /* handler:badgeLabelLogic */
  ['badgeLabelLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'notifications')) ? (getObjectProperty(___arguments.context.pageData, 'notifications')).length : null)

  },
  /* handler:badgeLabelLogic */
  /* content */
}))

define('./components/reusable/r_7acb32950e9a980597ce159da587278f/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['notifications'] = (await BackendlessUI.Functions.Custom['fn_554407add264c20230a69c383ca4ee9c']());

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_7acb32950e9a980597ce159da587278f/logic/a5cc061273e6a5b2b9b65defce9a57b7/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('92dd1942206502be5b032141471f8bdd'), 'show')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/7e05f572905ea86cf2633316b33695b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--dashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/6c2b7c0429ed1585dfcc7eafe4c90ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inventoryManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Inventory Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('500ff7c56663ea01a9a9059886c18237'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Add Product') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1058388bd0d2e55b6cdd03b2c4e95883'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d87bb2eee56904d468f6f3f2b18397c2'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12d5c75d5a3e3e96e5a870574559073f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('500ff7c56663ea01a9a9059886c18237'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/1058388bd0d2e55b6cdd03b2c4e95883/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/12d5c75d5a3e3e96e5a870574559073f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['inventoryMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/500ff7c56663ea01a9a9059886c18237/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['inventoryMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c2b7c0429ed1585dfcc7eafe4c90ab3')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('26d27eaca784825d8c3ab93fc01ce328')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/26d27eaca784825d8c3ab93fc01ce328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'inventoryMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/7a1ee6a567cea758234c78f3a34f8c49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewProducts', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/4576fd11bb6aba0cff646b6a6b59fc89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--transactions', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewTransactions', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/efdcb6f357e92f182aac99095571898c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'viewLocations', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/d018c1b4276b309d78edb0472d9fac27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory--discrepancies', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'discrepancies', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/27d552ed3f8b7b2d652d4851f32cb648/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var salesManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('sales', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5dc1b91c2c5939fb98036dd2300f2f98'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/1986b13c495e88529f9f5f2875654cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/26144c6361780815c24274bada6b8577/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/dce77f9d12114cfe33835e1bccbb8a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['salesMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/5dc1b91c2c5939fb98036dd2300f2f98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['salesMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('682cf91d6543f701925d781332955cdc')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'salesMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/682cf91d6543f701925d781332955cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'salesMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/57dfe008a2ced342886c2b34253526b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sales--history', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales History') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f709ef18dcb65bbd16096a5ec6da78fa'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f2d5e33f0881e4d6e5349e95847e783'))['color'] = '#fff';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Record') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/773ba1aad441b7e81838c3071ec71329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales This Month') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92e6c69b7bdb43cb530afb58cf79ab4f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2bdeee360eb462b1b3110f252140a33'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/4609ec482ba89b1c416d1bfa30ff1fbb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Sales Giveaway') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1986b13c495e88529f9f5f2875654cc4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('26144c6361780815c24274bada6b8577'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27d552ed3f8b7b2d652d4851f32cb648'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce77f9d12114cfe33835e1bccbb8a1b'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b19583ad31b9f857494c76232c3dfe76'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e96f7978b6f738652bbd98e9801ff4c'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/2a7cf38464fbd7dab3eb7229a488c3fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var eCommerceManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('orders', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Orders Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a7cf38464fbd7dab3eb7229a488c3fc'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023f0fdd451d84d9b001d9316e5c9e12'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ac6acc10ea20d3b618a33a61e4708dd'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/9b794f76617e9b2508f3d29df2048604/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn, userRoleFound;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('payroll', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var officeManagerLoggedIn, userRoleFound;

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/e5035df9e1038cf2d10d3e19677ed693/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6e53d91140cdb702cc56cdc648527b1d')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9b794f76617e9b2508f3d29df2048604')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['payrollMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/2cc47487777283caab0f028d43f86a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/6e53d91140cdb702cc56cdc648527b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'payrollMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/6cf833e5fd266ac54262ceffa94b9279/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/8daf184f84a831dfc4a77df4e171c5f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var officeManagerLoggedIn;



  return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('settings', null, true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    
  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/0d5253abdf7da291d1f566377b3ab402/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/2ed9b8f6be1be24c34f7e4b17ed1b559/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['settingsMenuOpen'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/6f126d379ff4f898fba9a494e0e83f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['settingsMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('092ceb3372ebc8028e9fcf89af88941b')).pop();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/092ceb3372ebc8028e9fcf89af88941b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'settingsMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/f4588d3d1237c3a3e7cdf94d37518aef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--manageUsers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Manage Users') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('40b50ed37d68bd4769c2dd9201b26bf4'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd37199397fffb267fbd3fb28675c73'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/c56cb9ebf07d879266fe5dabff1d71e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--managers', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Managers') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('538849299b0463168e96f2ee2c28cd1e'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('547cfd3947b45beaa092e0bd3d546f09'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/c45f68166e1aca22e6ee194928a237bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeOptions', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Finance Options') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('790fa01da8afe9ff544ba081a3cc9716'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('117571dbf8edbaa74e7c5e1d40ba3378'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/aad93eca8d8660a55bed470871182b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings--financeCompanies', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Finance Companies') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed084e433f883858011c7558967af891'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dca893aa174db2dbf4629346d4b10a53'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/e47fc3271ebb88e95eaf1b914c1c27fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Settings Matrix Levels') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0d5253abdf7da291d1f566377b3ab402'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c3a1e67b192d3c2dfa95afb1426a72'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8daf184f84a831dfc4a77df4e171c5f6'))['background-color'] = '#009fe2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2ed9b8f6be1be24c34f7e4b17ed1b559'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fcee59f728db1d591c9e087964fb1d87'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2df41684d213ffc11382f70c6c15e82d'))['color'] = '#fff';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/5667a462092b7a65ca65949bd5f4fa82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin--bugReports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/7d566b055cbd5293838769d7869de49b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  localStorage.removeItem('currentUser');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeRecords'] = (await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Offices', null, null, null, 'office_name', null));
  ___arguments.context.pageData['officeSelected'] = false;
  ___arguments.context.pageData['officeSelector'] = (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((getObjectProperty(___arguments.context.pageData, 'officeRecords')), 'objectId', 'office_name'));
  loggedInUser = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
  ___arguments.context.pageData['loggedInUserGroup'] = (getObjectProperty(loggedInUser, 'userGroup'));
  ___arguments.context.pageData['loggedInUser'] = loggedInUser;

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/cbec50ccec7e340500c91e88700d2e82/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'loggedInUserGroup')) == 'Demo') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e05f572905ea86cf2633316b33695b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2b7c0429ed1585dfcc7eafe4c90ab3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a7cf38464fbd7dab3eb7229a488c3fc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27d552ed3f8b7b2d652d4851f32cb648', false);
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/bf78c8af297fe3cab561794cbb63e178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['sidebarClosed'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a8e291c90ac96640fb6eec2c6770bbc')), 'closedSidebar', '');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('329d30b69ecd56030d867acb683a5dae', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/fa2c8aa4b1412d6e394574a94bc9603b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['sidebarClosed'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a8e291c90ac96640fb6eec2c6770bbc')), 'closedSidebar');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('329d30b69ecd56030d867acb683a5dae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/3a4b7edc1e3ad051c1f2d5686d729a11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/b22e6bce670ef6081cd2918ac0e95f7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageTitle')) == 'Competition Dashboard') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a4b7edc1e3ad051c1f2d5686d729a11'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3670e2e2a2e82f70fd1c3034a47562f'))['color'] = '#fff';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a'))['background-color'] = '#009fe2';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/5a3f114ddb2c6d6ddc0e658e91560951/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager' || (getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'compMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/b3670e2e2a2e82f70fd1c3034a47562f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var showElement;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/2ecebea9bcfbba498c3c5bfaafb28c5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--newCompetition', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/156279c61cb55091a36a761e1827367f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--listings', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/f6f1497efd16ab7f751f588604578c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--updateScores', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/4d6c09c1325174fbe4dc3dcda1cc44d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'compMenuOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')), 'fadeOut');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')), 'activeItem');
  }
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['compMenuOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/a26460bd441403183122e35d45539a1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'compMenuOpen')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['compMenuOpen'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).includes('activeItem')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b22e6bce670ef6081cd2918ac0e95f7a')), 'activeItem');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')).includes('fadeOut')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a3f114ddb2c6d6ddc0e658e91560951')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/a9a681a127cc47c58f58ad5ad31a9163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/a4e4d8b86d6699a8a0dc09aa2d92ebec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--addDealer', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/6744f4ec1d9d4a461884d1d867fbb8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin--inventoryTransactions', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_2712b5e25d0111028c99b3af654e562d']('inventory', 'snTracking', true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/8ec8599be8d3cbbbaaeaf2be8ef53e08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/f2a811bc86a4a0f5f4614d68589c9b55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/432cac783d943bd2063943e5e154a37b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionDashboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/52020c985f35f5c9cc75a9da08159a76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--history', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/9481c136d7e8b15d73a56e84c1533aaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--teamLeaderboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Dealer' && (getObjectProperty(___arguments.context.pageData, 'relatedDealer.is_team_leader')) == true) {
      showElement = true;
    } else {
      showElement = false;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/b7e25b7550db32d9a8e952b3224d4fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--officeLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/dac18e955281be3ffe5a92e2acb7d4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionDealerLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/d0eb3e585354a4b3631cbc2493bf151d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionOfficeLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/77ffa528312f849948068a6a38b59ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/51071524bf75990c8f9e94382ec90759/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionalDivisionLeaderboard', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Region Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/8738c53e8e0fa63828ee4e0c2203fd13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionLeaderboards--ld', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/2accd63c2097c7ea127c62e201f10e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--regionOfficeLeaderboards--ld', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager' && (getObjectProperty(___arguments.context.pageData, 'loggedInUser.email')) == 'leadersdivision@tellusapps.net') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/53d9039fabeb582296f91c3b17b4c8fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--divisionLeaderboards', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Division Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/bd22c3d96e5ed68a14f21feb673d17aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('competitions--manageDealers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var showElement;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  showElement = null;
  if (getObjectProperty(___arguments.context.pageData, 'loggedInUser.name')) {
    if ((getObjectProperty(___arguments.context.pageData, 'loggedInUser.userGroup')) == 'Office Manager') {
      showElement = true;
    }
  }

  return showElement

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/8929553290a903a17baa8693618b0f55/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var loggedInUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['officeSelected'] = true;
  localStorage.setItem('officeRecord', JSON.stringify((await Backendless.Data.of('Offices').findById(___arguments.value, ))));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--officeDashboard', ({ 'selectedOffice': ((function(){ try { return JSON.parse(localStorage.getItem('officeRecord')) } catch(e){ return null }})()),'userList': (await BackendlessUI.Functions.Custom['fn_be1ad52fd21ec3d76e23635da0e6aca6']((await BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02']('Users', (['office_link.objectId=\'',___arguments.value,'\''].join('')), null, null, null, null)), 'objectId', 'name')),'officeSelector': (getObjectProperty(___arguments.context.pageData, 'officeSelector')) }));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/f267d6fa1c92dfdca16926293b18c8ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--testPCI', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/60fc6b581965934480b2cbc6ecddd7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--createOffice', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/e8da7661230eba9589ac1ab8410d0045/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--problemTransactions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_1bb11d41f0654e49be2901a6d0461138/logic/068176d7aec206a2aa4239886063a498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Admin--problemSns', undefined);

  },
  /* handler:onClick */
  /* content */
}))

